/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const vertexvis = $root.vertexvis = (() => {

    /**
     * Namespace vertexvis.
     * @exports vertexvis
     * @namespace
     */
    const vertexvis = {};

    vertexvis.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof vertexvis
         * @namespace
         */
        const protobuf = {};

        protobuf.stream = (function() {

            /**
             * Namespace stream.
             * @memberof vertexvis.protobuf
             * @namespace
             */
            const stream = {};

            stream.PerspectiveCamera = (function() {

                /**
                 * Properties of a PerspectiveCamera.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPerspectiveCamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [position] PerspectiveCamera position
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] PerspectiveCamera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] PerspectiveCamera up
                 * @property {google.protobuf.IFloatValue|null} [fovY] PerspectiveCamera fovY
                 */

                /**
                 * Constructs a new PerspectiveCamera.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PerspectiveCamera.
                 * @implements IPerspectiveCamera
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPerspectiveCamera=} [properties] Properties to set
                 */
                function PerspectiveCamera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PerspectiveCamera position.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} position
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.position = null;

                /**
                 * PerspectiveCamera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.lookAt = null;

                /**
                 * PerspectiveCamera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.up = null;

                /**
                 * PerspectiveCamera fovY.
                 * @member {google.protobuf.IFloatValue|null|undefined} fovY
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.fovY = null;

                /**
                 * Creates a new PerspectiveCamera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerspectiveCamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PerspectiveCamera} PerspectiveCamera instance
                 */
                PerspectiveCamera.create = function create(properties) {
                    return new PerspectiveCamera(properties);
                };

                /**
                 * Encodes the specified PerspectiveCamera message. Does not implicitly {@link vertexvis.protobuf.stream.PerspectiveCamera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerspectiveCamera} message PerspectiveCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerspectiveCamera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.position, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.fovY != null && Object.hasOwnProperty.call(message, "fovY"))
                        $root.google.protobuf.FloatValue.encode(message.fovY, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PerspectiveCamera message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PerspectiveCamera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerspectiveCamera} message PerspectiveCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerspectiveCamera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PerspectiveCamera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PerspectiveCamera} PerspectiveCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerspectiveCamera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PerspectiveCamera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.position = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.fovY = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PerspectiveCamera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PerspectiveCamera} PerspectiveCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerspectiveCamera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PerspectiveCamera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PerspectiveCamera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.position != null && message.hasOwnProperty("position")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.position);
                        if (error)
                            return "position." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.fovY != null && message.hasOwnProperty("fovY")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.fovY);
                        if (error)
                            return "fovY." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PerspectiveCamera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PerspectiveCamera} PerspectiveCamera
                 */
                PerspectiveCamera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PerspectiveCamera)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PerspectiveCamera();
                    if (object.position != null) {
                        if (typeof object.position !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PerspectiveCamera.position: object expected");
                        message.position = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.position);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PerspectiveCamera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PerspectiveCamera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.fovY != null) {
                        if (typeof object.fovY !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PerspectiveCamera.fovY: object expected");
                        message.fovY = $root.google.protobuf.FloatValue.fromObject(object.fovY);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PerspectiveCamera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.PerspectiveCamera} message PerspectiveCamera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PerspectiveCamera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.position = null;
                        object.lookAt = null;
                        object.up = null;
                        object.fovY = null;
                    }
                    if (message.position != null && message.hasOwnProperty("position"))
                        object.position = $root.vertexvis.protobuf.core.Vector3f.toObject(message.position, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.fovY != null && message.hasOwnProperty("fovY"))
                        object.fovY = $root.google.protobuf.FloatValue.toObject(message.fovY, options);
                    return object;
                };

                /**
                 * Converts this PerspectiveCamera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PerspectiveCamera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PerspectiveCamera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PerspectiveCamera;
            })();

            stream.OrthographicCamera = (function() {

                /**
                 * Properties of an OrthographicCamera.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IOrthographicCamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [viewVector] OrthographicCamera viewVector
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] OrthographicCamera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] OrthographicCamera up
                 * @property {number|null} [fovHeight] OrthographicCamera fovHeight
                 */

                /**
                 * Constructs a new OrthographicCamera.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an OrthographicCamera.
                 * @implements IOrthographicCamera
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IOrthographicCamera=} [properties] Properties to set
                 */
                function OrthographicCamera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OrthographicCamera viewVector.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} viewVector
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.viewVector = null;

                /**
                 * OrthographicCamera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.lookAt = null;

                /**
                 * OrthographicCamera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.up = null;

                /**
                 * OrthographicCamera fovHeight.
                 * @member {number} fovHeight
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.fovHeight = 0;

                /**
                 * Creates a new OrthographicCamera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrthographicCamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.OrthographicCamera} OrthographicCamera instance
                 */
                OrthographicCamera.create = function create(properties) {
                    return new OrthographicCamera(properties);
                };

                /**
                 * Encodes the specified OrthographicCamera message. Does not implicitly {@link vertexvis.protobuf.stream.OrthographicCamera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrthographicCamera} message OrthographicCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrthographicCamera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.viewVector != null && Object.hasOwnProperty.call(message, "viewVector"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.viewVector, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.fovHeight != null && Object.hasOwnProperty.call(message, "fovHeight"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.fovHeight);
                    return writer;
                };

                /**
                 * Encodes the specified OrthographicCamera message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.OrthographicCamera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrthographicCamera} message OrthographicCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrthographicCamera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OrthographicCamera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.OrthographicCamera} OrthographicCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrthographicCamera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.OrthographicCamera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.viewVector = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.fovHeight = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OrthographicCamera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.OrthographicCamera} OrthographicCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrthographicCamera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OrthographicCamera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OrthographicCamera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.viewVector != null && message.hasOwnProperty("viewVector")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.viewVector);
                        if (error)
                            return "viewVector." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.fovHeight != null && message.hasOwnProperty("fovHeight"))
                        if (typeof message.fovHeight !== "number")
                            return "fovHeight: number expected";
                    return null;
                };

                /**
                 * Creates an OrthographicCamera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.OrthographicCamera} OrthographicCamera
                 */
                OrthographicCamera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.OrthographicCamera)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.OrthographicCamera();
                    if (object.viewVector != null) {
                        if (typeof object.viewVector !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OrthographicCamera.viewVector: object expected");
                        message.viewVector = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.viewVector);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OrthographicCamera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OrthographicCamera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.fovHeight != null)
                        message.fovHeight = Number(object.fovHeight);
                    return message;
                };

                /**
                 * Creates a plain object from an OrthographicCamera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.stream.OrthographicCamera} message OrthographicCamera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OrthographicCamera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.viewVector = null;
                        object.lookAt = null;
                        object.up = null;
                        object.fovHeight = 0;
                    }
                    if (message.viewVector != null && message.hasOwnProperty("viewVector"))
                        object.viewVector = $root.vertexvis.protobuf.core.Vector3f.toObject(message.viewVector, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.fovHeight != null && message.hasOwnProperty("fovHeight"))
                        object.fovHeight = options.json && !isFinite(message.fovHeight) ? String(message.fovHeight) : message.fovHeight;
                    return object;
                };

                /**
                 * Converts this OrthographicCamera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.OrthographicCamera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OrthographicCamera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OrthographicCamera;
            })();

            stream.Camera = (function() {

                /**
                 * Properties of a Camera.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ICamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [position] Camera position
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] Camera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] Camera up
                 * @property {vertexvis.protobuf.stream.IPerspectiveCamera|null} [perspective] Camera perspective
                 * @property {vertexvis.protobuf.stream.IOrthographicCamera|null} [orthographic] Camera orthographic
                 */

                /**
                 * Constructs a new Camera.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Camera.
                 * @implements ICamera
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ICamera=} [properties] Properties to set
                 */
                function Camera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Camera position.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} position
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Camera.prototype.position = null;

                /**
                 * Camera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Camera.prototype.lookAt = null;

                /**
                 * Camera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Camera.prototype.up = null;

                /**
                 * Camera perspective.
                 * @member {vertexvis.protobuf.stream.IPerspectiveCamera|null|undefined} perspective
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Camera.prototype.perspective = null;

                /**
                 * Camera orthographic.
                 * @member {vertexvis.protobuf.stream.IOrthographicCamera|null|undefined} orthographic
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Camera.prototype.orthographic = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * Camera type.
                 * @member {"perspective"|"orthographic"|undefined} type
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 */
                Object.defineProperty(Camera.prototype, "type", {
                    get: $util.oneOfGetter($oneOfFields = ["perspective", "orthographic"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Camera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {vertexvis.protobuf.stream.ICamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Camera} Camera instance
                 */
                Camera.create = function create(properties) {
                    return new Camera(properties);
                };

                /**
                 * Encodes the specified Camera message. Does not implicitly {@link vertexvis.protobuf.stream.Camera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {vertexvis.protobuf.stream.ICamera} message Camera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Camera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.position, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.perspective != null && Object.hasOwnProperty.call(message, "perspective"))
                        $root.vertexvis.protobuf.stream.PerspectiveCamera.encode(message.perspective, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.orthographic != null && Object.hasOwnProperty.call(message, "orthographic"))
                        $root.vertexvis.protobuf.stream.OrthographicCamera.encode(message.orthographic, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Camera message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Camera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {vertexvis.protobuf.stream.ICamera} message Camera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Camera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Camera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Camera} Camera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Camera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Camera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.position = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.perspective = $root.vertexvis.protobuf.stream.PerspectiveCamera.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.orthographic = $root.vertexvis.protobuf.stream.OrthographicCamera.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Camera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Camera} Camera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Camera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Camera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Camera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.position != null && message.hasOwnProperty("position")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.position);
                        if (error)
                            return "position." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.perspective != null && message.hasOwnProperty("perspective")) {
                        properties.type = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PerspectiveCamera.verify(message.perspective);
                            if (error)
                                return "perspective." + error;
                        }
                    }
                    if (message.orthographic != null && message.hasOwnProperty("orthographic")) {
                        if (properties.type === 1)
                            return "type: multiple values";
                        properties.type = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.OrthographicCamera.verify(message.orthographic);
                            if (error)
                                return "orthographic." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Camera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Camera} Camera
                 */
                Camera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Camera)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Camera();
                    if (object.position != null) {
                        if (typeof object.position !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Camera.position: object expected");
                        message.position = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.position);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Camera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Camera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.perspective != null) {
                        if (typeof object.perspective !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Camera.perspective: object expected");
                        message.perspective = $root.vertexvis.protobuf.stream.PerspectiveCamera.fromObject(object.perspective);
                    }
                    if (object.orthographic != null) {
                        if (typeof object.orthographic !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Camera.orthographic: object expected");
                        message.orthographic = $root.vertexvis.protobuf.stream.OrthographicCamera.fromObject(object.orthographic);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Camera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @static
                 * @param {vertexvis.protobuf.stream.Camera} message Camera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Camera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.position = null;
                        object.lookAt = null;
                        object.up = null;
                    }
                    if (message.position != null && message.hasOwnProperty("position"))
                        object.position = $root.vertexvis.protobuf.core.Vector3f.toObject(message.position, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.perspective != null && message.hasOwnProperty("perspective")) {
                        object.perspective = $root.vertexvis.protobuf.stream.PerspectiveCamera.toObject(message.perspective, options);
                        if (options.oneofs)
                            object.type = "perspective";
                    }
                    if (message.orthographic != null && message.hasOwnProperty("orthographic")) {
                        object.orthographic = $root.vertexvis.protobuf.stream.OrthographicCamera.toObject(message.orthographic, options);
                        if (options.oneofs)
                            object.type = "orthographic";
                    }
                    return object;
                };

                /**
                 * Converts this Camera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Camera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Camera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Camera;
            })();

            stream.ImageAttributes = (function() {

                /**
                 * Properties of an ImageAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IImageAttributes
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [frameDimensions] ImageAttributes frameDimensions
                 * @property {vertexvis.protobuf.stream.IRectangle|null} [imageRect] ImageAttributes imageRect
                 * @property {number|null} [scaleFactor] ImageAttributes scaleFactor
                 */

                /**
                 * Constructs a new ImageAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an ImageAttributes.
                 * @implements IImageAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IImageAttributes=} [properties] Properties to set
                 */
                function ImageAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ImageAttributes frameDimensions.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} frameDimensions
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @instance
                 */
                ImageAttributes.prototype.frameDimensions = null;

                /**
                 * ImageAttributes imageRect.
                 * @member {vertexvis.protobuf.stream.IRectangle|null|undefined} imageRect
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @instance
                 */
                ImageAttributes.prototype.imageRect = null;

                /**
                 * ImageAttributes scaleFactor.
                 * @member {number} scaleFactor
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @instance
                 */
                ImageAttributes.prototype.scaleFactor = 0;

                /**
                 * Creates a new ImageAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IImageAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ImageAttributes} ImageAttributes instance
                 */
                ImageAttributes.create = function create(properties) {
                    return new ImageAttributes(properties);
                };

                /**
                 * Encodes the specified ImageAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.ImageAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IImageAttributes} message ImageAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ImageAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameDimensions != null && Object.hasOwnProperty.call(message, "frameDimensions"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.frameDimensions, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.imageRect != null && Object.hasOwnProperty.call(message, "imageRect"))
                        $root.vertexvis.protobuf.stream.Rectangle.encode(message.imageRect, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.scaleFactor != null && Object.hasOwnProperty.call(message, "scaleFactor"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.scaleFactor);
                    return writer;
                };

                /**
                 * Encodes the specified ImageAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ImageAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IImageAttributes} message ImageAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ImageAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ImageAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ImageAttributes} ImageAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ImageAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ImageAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameDimensions = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.imageRect = $root.vertexvis.protobuf.stream.Rectangle.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.scaleFactor = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ImageAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ImageAttributes} ImageAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ImageAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ImageAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ImageAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.frameDimensions != null && message.hasOwnProperty("frameDimensions")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.frameDimensions);
                        if (error)
                            return "frameDimensions." + error;
                    }
                    if (message.imageRect != null && message.hasOwnProperty("imageRect")) {
                        let error = $root.vertexvis.protobuf.stream.Rectangle.verify(message.imageRect);
                        if (error)
                            return "imageRect." + error;
                    }
                    if (message.scaleFactor != null && message.hasOwnProperty("scaleFactor"))
                        if (typeof message.scaleFactor !== "number")
                            return "scaleFactor: number expected";
                    return null;
                };

                /**
                 * Creates an ImageAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ImageAttributes} ImageAttributes
                 */
                ImageAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ImageAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ImageAttributes();
                    if (object.frameDimensions != null) {
                        if (typeof object.frameDimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ImageAttributes.frameDimensions: object expected");
                        message.frameDimensions = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.frameDimensions);
                    }
                    if (object.imageRect != null) {
                        if (typeof object.imageRect !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ImageAttributes.imageRect: object expected");
                        message.imageRect = $root.vertexvis.protobuf.stream.Rectangle.fromObject(object.imageRect);
                    }
                    if (object.scaleFactor != null)
                        message.scaleFactor = Number(object.scaleFactor);
                    return message;
                };

                /**
                 * Creates a plain object from an ImageAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ImageAttributes} message ImageAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ImageAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.frameDimensions = null;
                        object.imageRect = null;
                        object.scaleFactor = 0;
                    }
                    if (message.frameDimensions != null && message.hasOwnProperty("frameDimensions"))
                        object.frameDimensions = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.frameDimensions, options);
                    if (message.imageRect != null && message.hasOwnProperty("imageRect"))
                        object.imageRect = $root.vertexvis.protobuf.stream.Rectangle.toObject(message.imageRect, options);
                    if (message.scaleFactor != null && message.hasOwnProperty("scaleFactor"))
                        object.scaleFactor = options.json && !isFinite(message.scaleFactor) ? String(message.scaleFactor) : message.scaleFactor;
                    return object;
                };

                /**
                 * Converts this ImageAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ImageAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ImageAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ImageAttributes;
            })();

            stream.ItemSetSummary = (function() {

                /**
                 * Properties of an ItemSetSummary.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IItemSetSummary
                 * @property {number|null} [count] ItemSetSummary count
                 * @property {vertexvis.protobuf.core.IBoundingBox3f|null} [boundingBox] ItemSetSummary boundingBox
                 */

                /**
                 * Constructs a new ItemSetSummary.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an ItemSetSummary.
                 * @implements IItemSetSummary
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IItemSetSummary=} [properties] Properties to set
                 */
                function ItemSetSummary(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemSetSummary count.
                 * @member {number} count
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @instance
                 */
                ItemSetSummary.prototype.count = 0;

                /**
                 * ItemSetSummary boundingBox.
                 * @member {vertexvis.protobuf.core.IBoundingBox3f|null|undefined} boundingBox
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @instance
                 */
                ItemSetSummary.prototype.boundingBox = null;

                /**
                 * Creates a new ItemSetSummary instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemSetSummary=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ItemSetSummary} ItemSetSummary instance
                 */
                ItemSetSummary.create = function create(properties) {
                    return new ItemSetSummary(properties);
                };

                /**
                 * Encodes the specified ItemSetSummary message. Does not implicitly {@link vertexvis.protobuf.stream.ItemSetSummary.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemSetSummary} message ItemSetSummary message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSetSummary.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                    if (message.boundingBox != null && Object.hasOwnProperty.call(message, "boundingBox"))
                        $root.vertexvis.protobuf.core.BoundingBox3f.encode(message.boundingBox, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ItemSetSummary message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ItemSetSummary.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemSetSummary} message ItemSetSummary message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemSetSummary.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemSetSummary message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ItemSetSummary} ItemSetSummary
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSetSummary.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ItemSetSummary();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.count = reader.int32();
                            break;
                        case 2:
                            message.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemSetSummary message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ItemSetSummary} ItemSetSummary
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemSetSummary.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemSetSummary message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemSetSummary.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.count != null && message.hasOwnProperty("count"))
                        if (!$util.isInteger(message.count))
                            return "count: integer expected";
                    if (message.boundingBox != null && message.hasOwnProperty("boundingBox")) {
                        let error = $root.vertexvis.protobuf.core.BoundingBox3f.verify(message.boundingBox);
                        if (error)
                            return "boundingBox." + error;
                    }
                    return null;
                };

                /**
                 * Creates an ItemSetSummary message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ItemSetSummary} ItemSetSummary
                 */
                ItemSetSummary.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ItemSetSummary)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ItemSetSummary();
                    if (object.count != null)
                        message.count = object.count | 0;
                    if (object.boundingBox != null) {
                        if (typeof object.boundingBox !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ItemSetSummary.boundingBox: object expected");
                        message.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.fromObject(object.boundingBox);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ItemSetSummary message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.ItemSetSummary} message ItemSetSummary
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemSetSummary.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.count = 0;
                        object.boundingBox = null;
                    }
                    if (message.count != null && message.hasOwnProperty("count"))
                        object.count = message.count;
                    if (message.boundingBox != null && message.hasOwnProperty("boundingBox"))
                        object.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.toObject(message.boundingBox, options);
                    return object;
                };

                /**
                 * Converts this ItemSetSummary to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ItemSetSummary
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemSetSummary.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ItemSetSummary;
            })();

            stream.DisplayListSummary = (function() {

                /**
                 * Properties of a DisplayListSummary.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IDisplayListSummary
                 * @property {vertexvis.protobuf.stream.IItemSetSummary|null} [visibleSummary] DisplayListSummary visibleSummary
                 * @property {vertexvis.protobuf.stream.IItemSetSummary|null} [selectedVisibleSummary] DisplayListSummary selectedVisibleSummary
                 */

                /**
                 * Constructs a new DisplayListSummary.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a DisplayListSummary.
                 * @implements IDisplayListSummary
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IDisplayListSummary=} [properties] Properties to set
                 */
                function DisplayListSummary(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DisplayListSummary visibleSummary.
                 * @member {vertexvis.protobuf.stream.IItemSetSummary|null|undefined} visibleSummary
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @instance
                 */
                DisplayListSummary.prototype.visibleSummary = null;

                /**
                 * DisplayListSummary selectedVisibleSummary.
                 * @member {vertexvis.protobuf.stream.IItemSetSummary|null|undefined} selectedVisibleSummary
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @instance
                 */
                DisplayListSummary.prototype.selectedVisibleSummary = null;

                /**
                 * Creates a new DisplayListSummary instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IDisplayListSummary=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.DisplayListSummary} DisplayListSummary instance
                 */
                DisplayListSummary.create = function create(properties) {
                    return new DisplayListSummary(properties);
                };

                /**
                 * Encodes the specified DisplayListSummary message. Does not implicitly {@link vertexvis.protobuf.stream.DisplayListSummary.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IDisplayListSummary} message DisplayListSummary message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisplayListSummary.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.visibleSummary != null && Object.hasOwnProperty.call(message, "visibleSummary"))
                        $root.vertexvis.protobuf.stream.ItemSetSummary.encode(message.visibleSummary, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.selectedVisibleSummary != null && Object.hasOwnProperty.call(message, "selectedVisibleSummary"))
                        $root.vertexvis.protobuf.stream.ItemSetSummary.encode(message.selectedVisibleSummary, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DisplayListSummary message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.DisplayListSummary.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.IDisplayListSummary} message DisplayListSummary message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisplayListSummary.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DisplayListSummary message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.DisplayListSummary} DisplayListSummary
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisplayListSummary.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.DisplayListSummary();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.visibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.selectedVisibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DisplayListSummary message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.DisplayListSummary} DisplayListSummary
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisplayListSummary.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DisplayListSummary message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DisplayListSummary.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.visibleSummary != null && message.hasOwnProperty("visibleSummary")) {
                        let error = $root.vertexvis.protobuf.stream.ItemSetSummary.verify(message.visibleSummary);
                        if (error)
                            return "visibleSummary." + error;
                    }
                    if (message.selectedVisibleSummary != null && message.hasOwnProperty("selectedVisibleSummary")) {
                        let error = $root.vertexvis.protobuf.stream.ItemSetSummary.verify(message.selectedVisibleSummary);
                        if (error)
                            return "selectedVisibleSummary." + error;
                    }
                    return null;
                };

                /**
                 * Creates a DisplayListSummary message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.DisplayListSummary} DisplayListSummary
                 */
                DisplayListSummary.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.DisplayListSummary)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.DisplayListSummary();
                    if (object.visibleSummary != null) {
                        if (typeof object.visibleSummary !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DisplayListSummary.visibleSummary: object expected");
                        message.visibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.fromObject(object.visibleSummary);
                    }
                    if (object.selectedVisibleSummary != null) {
                        if (typeof object.selectedVisibleSummary !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DisplayListSummary.selectedVisibleSummary: object expected");
                        message.selectedVisibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.fromObject(object.selectedVisibleSummary);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DisplayListSummary message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @static
                 * @param {vertexvis.protobuf.stream.DisplayListSummary} message DisplayListSummary
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DisplayListSummary.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.visibleSummary = null;
                        object.selectedVisibleSummary = null;
                    }
                    if (message.visibleSummary != null && message.hasOwnProperty("visibleSummary"))
                        object.visibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.toObject(message.visibleSummary, options);
                    if (message.selectedVisibleSummary != null && message.hasOwnProperty("selectedVisibleSummary"))
                        object.selectedVisibleSummary = $root.vertexvis.protobuf.stream.ItemSetSummary.toObject(message.selectedVisibleSummary, options);
                    return object;
                };

                /**
                 * Converts this DisplayListSummary to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.DisplayListSummary
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DisplayListSummary.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DisplayListSummary;
            })();

            stream.SceneAttributes = (function() {

                /**
                 * Properties of a SceneAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneAttributes
                 * @property {vertexvis.protobuf.stream.ICamera|null} [camera] SceneAttributes camera
                 * @property {vertexvis.protobuf.core.IBoundingBox3f|null} [visibleBoundingBox] SceneAttributes visibleBoundingBox
                 * @property {vertexvis.protobuf.stream.ICrossSectioning|null} [crossSectioning] SceneAttributes crossSectioning
                 * @property {boolean|null} [hasChanged] SceneAttributes hasChanged
                 * @property {vertexvis.protobuf.stream.IDisplayListSummary|null} [displayListSummary] SceneAttributes displayListSummary
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [modelViewId] SceneAttributes modelViewId
                 */

                /**
                 * Constructs a new SceneAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneAttributes.
                 * @implements ISceneAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneAttributes=} [properties] Properties to set
                 */
                function SceneAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneAttributes camera.
                 * @member {vertexvis.protobuf.stream.ICamera|null|undefined} camera
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.camera = null;

                /**
                 * SceneAttributes visibleBoundingBox.
                 * @member {vertexvis.protobuf.core.IBoundingBox3f|null|undefined} visibleBoundingBox
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.visibleBoundingBox = null;

                /**
                 * SceneAttributes crossSectioning.
                 * @member {vertexvis.protobuf.stream.ICrossSectioning|null|undefined} crossSectioning
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.crossSectioning = null;

                /**
                 * SceneAttributes hasChanged.
                 * @member {boolean} hasChanged
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.hasChanged = false;

                /**
                 * SceneAttributes displayListSummary.
                 * @member {vertexvis.protobuf.stream.IDisplayListSummary|null|undefined} displayListSummary
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.displayListSummary = null;

                /**
                 * SceneAttributes modelViewId.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} modelViewId
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 */
                SceneAttributes.prototype.modelViewId = null;

                /**
                 * Creates a new SceneAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneAttributes} SceneAttributes instance
                 */
                SceneAttributes.create = function create(properties) {
                    return new SceneAttributes(properties);
                };

                /**
                 * Encodes the specified SceneAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.SceneAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneAttributes} message SceneAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                        $root.vertexvis.protobuf.stream.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.visibleBoundingBox != null && Object.hasOwnProperty.call(message, "visibleBoundingBox"))
                        $root.vertexvis.protobuf.core.BoundingBox3f.encode(message.visibleBoundingBox, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.crossSectioning != null && Object.hasOwnProperty.call(message, "crossSectioning"))
                        $root.vertexvis.protobuf.stream.CrossSectioning.encode(message.crossSectioning, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.hasChanged != null && Object.hasOwnProperty.call(message, "hasChanged"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hasChanged);
                    if (message.displayListSummary != null && Object.hasOwnProperty.call(message, "displayListSummary"))
                        $root.vertexvis.protobuf.stream.DisplayListSummary.encode(message.displayListSummary, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.modelViewId != null && Object.hasOwnProperty.call(message, "modelViewId"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.modelViewId, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneAttributes} message SceneAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneAttributes} SceneAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.camera = $root.vertexvis.protobuf.stream.Camera.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.visibleBoundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.hasChanged = reader.bool();
                            break;
                        case 5:
                            message.displayListSummary = $root.vertexvis.protobuf.stream.DisplayListSummary.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneAttributes} SceneAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        let error = $root.vertexvis.protobuf.stream.Camera.verify(message.camera);
                        if (error)
                            return "camera." + error;
                    }
                    if (message.visibleBoundingBox != null && message.hasOwnProperty("visibleBoundingBox")) {
                        let error = $root.vertexvis.protobuf.core.BoundingBox3f.verify(message.visibleBoundingBox);
                        if (error)
                            return "visibleBoundingBox." + error;
                    }
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning")) {
                        let error = $root.vertexvis.protobuf.stream.CrossSectioning.verify(message.crossSectioning);
                        if (error)
                            return "crossSectioning." + error;
                    }
                    if (message.hasChanged != null && message.hasOwnProperty("hasChanged"))
                        if (typeof message.hasChanged !== "boolean")
                            return "hasChanged: boolean expected";
                    if (message.displayListSummary != null && message.hasOwnProperty("displayListSummary")) {
                        let error = $root.vertexvis.protobuf.stream.DisplayListSummary.verify(message.displayListSummary);
                        if (error)
                            return "displayListSummary." + error;
                    }
                    if (message.modelViewId != null && message.hasOwnProperty("modelViewId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.modelViewId);
                        if (error)
                            return "modelViewId." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneAttributes} SceneAttributes
                 */
                SceneAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneAttributes();
                    if (object.camera != null) {
                        if (typeof object.camera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneAttributes.camera: object expected");
                        message.camera = $root.vertexvis.protobuf.stream.Camera.fromObject(object.camera);
                    }
                    if (object.visibleBoundingBox != null) {
                        if (typeof object.visibleBoundingBox !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneAttributes.visibleBoundingBox: object expected");
                        message.visibleBoundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.fromObject(object.visibleBoundingBox);
                    }
                    if (object.crossSectioning != null) {
                        if (typeof object.crossSectioning !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneAttributes.crossSectioning: object expected");
                        message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.fromObject(object.crossSectioning);
                    }
                    if (object.hasChanged != null)
                        message.hasChanged = Boolean(object.hasChanged);
                    if (object.displayListSummary != null) {
                        if (typeof object.displayListSummary !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneAttributes.displayListSummary: object expected");
                        message.displayListSummary = $root.vertexvis.protobuf.stream.DisplayListSummary.fromObject(object.displayListSummary);
                    }
                    if (object.modelViewId != null) {
                        if (typeof object.modelViewId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneAttributes.modelViewId: object expected");
                        message.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.modelViewId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneAttributes} message SceneAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.camera = null;
                        object.visibleBoundingBox = null;
                        object.crossSectioning = null;
                        object.hasChanged = false;
                        object.displayListSummary = null;
                        object.modelViewId = null;
                    }
                    if (message.camera != null && message.hasOwnProperty("camera"))
                        object.camera = $root.vertexvis.protobuf.stream.Camera.toObject(message.camera, options);
                    if (message.visibleBoundingBox != null && message.hasOwnProperty("visibleBoundingBox"))
                        object.visibleBoundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.toObject(message.visibleBoundingBox, options);
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning"))
                        object.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.toObject(message.crossSectioning, options);
                    if (message.hasChanged != null && message.hasOwnProperty("hasChanged"))
                        object.hasChanged = message.hasChanged;
                    if (message.displayListSummary != null && message.hasOwnProperty("displayListSummary"))
                        object.displayListSummary = $root.vertexvis.protobuf.stream.DisplayListSummary.toObject(message.displayListSummary, options);
                    if (message.modelViewId != null && message.hasOwnProperty("modelViewId"))
                        object.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.modelViewId, options);
                    return object;
                };

                /**
                 * Converts this SceneAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneAttributes;
            })();

            stream.HitItemAncestor = (function() {

                /**
                 * Properties of a HitItemAncestor.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IHitItemAncestor
                 * @property {vertexvis.protobuf.core.IUuid|null} [itemId] HitItemAncestor itemId
                 * @property {vertexvis.protobuf.stream.ISceneItemOverride|null} [itemOverride] HitItemAncestor itemOverride
                 */

                /**
                 * Constructs a new HitItemAncestor.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a HitItemAncestor.
                 * @implements IHitItemAncestor
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IHitItemAncestor=} [properties] Properties to set
                 */
                function HitItemAncestor(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HitItemAncestor itemId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} itemId
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @instance
                 */
                HitItemAncestor.prototype.itemId = null;

                /**
                 * HitItemAncestor itemOverride.
                 * @member {vertexvis.protobuf.stream.ISceneItemOverride|null|undefined} itemOverride
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @instance
                 */
                HitItemAncestor.prototype.itemOverride = null;

                /**
                 * Creates a new HitItemAncestor instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemAncestor=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.HitItemAncestor} HitItemAncestor instance
                 */
                HitItemAncestor.create = function create(properties) {
                    return new HitItemAncestor(properties);
                };

                /**
                 * Encodes the specified HitItemAncestor message. Does not implicitly {@link vertexvis.protobuf.stream.HitItemAncestor.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemAncestor} message HitItemAncestor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemAncestor.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.itemId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.itemOverride != null && Object.hasOwnProperty.call(message, "itemOverride"))
                        $root.vertexvis.protobuf.stream.SceneItemOverride.encode(message.itemOverride, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HitItemAncestor message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.HitItemAncestor.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemAncestor} message HitItemAncestor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemAncestor.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HitItemAncestor message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.HitItemAncestor} HitItemAncestor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemAncestor.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.HitItemAncestor();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.itemId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.itemOverride = $root.vertexvis.protobuf.stream.SceneItemOverride.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HitItemAncestor message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.HitItemAncestor} HitItemAncestor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemAncestor.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HitItemAncestor message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HitItemAncestor.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.itemId != null && message.hasOwnProperty("itemId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.itemId);
                        if (error)
                            return "itemId." + error;
                    }
                    if (message.itemOverride != null && message.hasOwnProperty("itemOverride")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemOverride.verify(message.itemOverride);
                        if (error)
                            return "itemOverride." + error;
                    }
                    return null;
                };

                /**
                 * Creates a HitItemAncestor message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.HitItemAncestor} HitItemAncestor
                 */
                HitItemAncestor.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.HitItemAncestor)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.HitItemAncestor();
                    if (object.itemId != null) {
                        if (typeof object.itemId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.HitItemAncestor.itemId: object expected");
                        message.itemId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.itemId);
                    }
                    if (object.itemOverride != null) {
                        if (typeof object.itemOverride !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.HitItemAncestor.itemOverride: object expected");
                        message.itemOverride = $root.vertexvis.protobuf.stream.SceneItemOverride.fromObject(object.itemOverride);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HitItemAncestor message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @static
                 * @param {vertexvis.protobuf.stream.HitItemAncestor} message HitItemAncestor
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HitItemAncestor.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.itemId = null;
                        object.itemOverride = null;
                    }
                    if (message.itemId != null && message.hasOwnProperty("itemId"))
                        object.itemId = $root.vertexvis.protobuf.core.Uuid.toObject(message.itemId, options);
                    if (message.itemOverride != null && message.hasOwnProperty("itemOverride"))
                        object.itemOverride = $root.vertexvis.protobuf.stream.SceneItemOverride.toObject(message.itemOverride, options);
                    return object;
                };

                /**
                 * Converts this HitItemAncestor to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.HitItemAncestor
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HitItemAncestor.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HitItemAncestor;
            })();

            stream.Hit = (function() {

                /**
                 * Properties of a Hit.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IHit
                 * @property {vertexvis.protobuf.core.IUuid|null} [itemId] Hit itemId
                 * @property {google.protobuf.IStringValue|null} [itemSuppliedId] Hit itemSuppliedId
                 * @property {vertexvis.protobuf.core.IVector3f|null} [hitNormal] Hit hitNormal
                 * @property {vertexvis.protobuf.core.IVector3f|null} [hitPoint] Hit hitPoint
                 * @property {vertexvis.protobuf.core.IUuid|null} [partRevisionId] Hit partRevisionId
                 * @property {vertexvis.protobuf.core.IUuid|null} [partId] Hit partId
                 * @property {google.protobuf.IStringValue|null} [suppliedPartRevisionId] Hit suppliedPartRevisionId
                 * @property {Array.<vertexvis.protobuf.stream.IHitItemAncestor>|null} [ancestors] Hit ancestors
                 * @property {Array.<vertexvis.protobuf.stream.IMetadataProperty>|null} [metadataProperties] Hit metadataProperties
                 * @property {vertexvis.protobuf.core.IModelEntity|null} [modelEntity] Hit modelEntity
                 * @property {vertexvis.protobuf.core.IUuid|null} [leafItemId] Hit leafItemId
                 * @property {vertexvis.protobuf.core.IUuid|null} [annotationId] Hit annotationId
                 */

                /**
                 * Constructs a new Hit.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Hit.
                 * @implements IHit
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IHit=} [properties] Properties to set
                 */
                function Hit(properties) {
                    this.ancestors = [];
                    this.metadataProperties = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Hit itemId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} itemId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.itemId = null;

                /**
                 * Hit itemSuppliedId.
                 * @member {google.protobuf.IStringValue|null|undefined} itemSuppliedId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.itemSuppliedId = null;

                /**
                 * Hit hitNormal.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} hitNormal
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.hitNormal = null;

                /**
                 * Hit hitPoint.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} hitPoint
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.hitPoint = null;

                /**
                 * Hit partRevisionId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} partRevisionId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.partRevisionId = null;

                /**
                 * Hit partId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} partId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.partId = null;

                /**
                 * Hit suppliedPartRevisionId.
                 * @member {google.protobuf.IStringValue|null|undefined} suppliedPartRevisionId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.suppliedPartRevisionId = null;

                /**
                 * Hit ancestors.
                 * @member {Array.<vertexvis.protobuf.stream.IHitItemAncestor>} ancestors
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.ancestors = $util.emptyArray;

                /**
                 * Hit metadataProperties.
                 * @member {Array.<vertexvis.protobuf.stream.IMetadataProperty>} metadataProperties
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.metadataProperties = $util.emptyArray;

                /**
                 * Hit modelEntity.
                 * @member {vertexvis.protobuf.core.IModelEntity|null|undefined} modelEntity
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.modelEntity = null;

                /**
                 * Hit leafItemId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} leafItemId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.leafItemId = null;

                /**
                 * Hit annotationId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} annotationId
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 */
                Hit.prototype.annotationId = null;

                /**
                 * Creates a new Hit instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {vertexvis.protobuf.stream.IHit=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Hit} Hit instance
                 */
                Hit.create = function create(properties) {
                    return new Hit(properties);
                };

                /**
                 * Encodes the specified Hit message. Does not implicitly {@link vertexvis.protobuf.stream.Hit.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {vertexvis.protobuf.stream.IHit} message Hit message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Hit.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.itemId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.itemSuppliedId != null && Object.hasOwnProperty.call(message, "itemSuppliedId"))
                        $root.google.protobuf.StringValue.encode(message.itemSuppliedId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.hitNormal != null && Object.hasOwnProperty.call(message, "hitNormal"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.hitNormal, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.hitPoint != null && Object.hasOwnProperty.call(message, "hitPoint"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.hitPoint, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.partRevisionId != null && Object.hasOwnProperty.call(message, "partRevisionId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.partRevisionId, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.partId != null && Object.hasOwnProperty.call(message, "partId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.partId, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.suppliedPartRevisionId != null && Object.hasOwnProperty.call(message, "suppliedPartRevisionId"))
                        $root.google.protobuf.StringValue.encode(message.suppliedPartRevisionId, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.ancestors != null && message.ancestors.length)
                        for (let i = 0; i < message.ancestors.length; ++i)
                            $root.vertexvis.protobuf.stream.HitItemAncestor.encode(message.ancestors[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.metadataProperties != null && message.metadataProperties.length)
                        for (let i = 0; i < message.metadataProperties.length; ++i)
                            $root.vertexvis.protobuf.stream.MetadataProperty.encode(message.metadataProperties[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.modelEntity != null && Object.hasOwnProperty.call(message, "modelEntity"))
                        $root.vertexvis.protobuf.core.ModelEntity.encode(message.modelEntity, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.leafItemId != null && Object.hasOwnProperty.call(message, "leafItemId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.leafItemId, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.annotationId != null && Object.hasOwnProperty.call(message, "annotationId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.annotationId, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Hit message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Hit.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {vertexvis.protobuf.stream.IHit} message Hit message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Hit.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Hit message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Hit} Hit
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Hit.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Hit();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.itemId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.itemSuppliedId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.hitNormal = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.hitPoint = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.partRevisionId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.partId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.suppliedPartRevisionId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 9:
                            if (!(message.ancestors && message.ancestors.length))
                                message.ancestors = [];
                            message.ancestors.push($root.vertexvis.protobuf.stream.HitItemAncestor.decode(reader, reader.uint32()));
                            break;
                        case 10:
                            if (!(message.metadataProperties && message.metadataProperties.length))
                                message.metadataProperties = [];
                            message.metadataProperties.push($root.vertexvis.protobuf.stream.MetadataProperty.decode(reader, reader.uint32()));
                            break;
                        case 11:
                            message.modelEntity = $root.vertexvis.protobuf.core.ModelEntity.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.leafItemId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.annotationId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Hit message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Hit} Hit
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Hit.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Hit message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Hit.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.itemId != null && message.hasOwnProperty("itemId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.itemId);
                        if (error)
                            return "itemId." + error;
                    }
                    if (message.itemSuppliedId != null && message.hasOwnProperty("itemSuppliedId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.itemSuppliedId);
                        if (error)
                            return "itemSuppliedId." + error;
                    }
                    if (message.hitNormal != null && message.hasOwnProperty("hitNormal")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.hitNormal);
                        if (error)
                            return "hitNormal." + error;
                    }
                    if (message.hitPoint != null && message.hasOwnProperty("hitPoint")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.hitPoint);
                        if (error)
                            return "hitPoint." + error;
                    }
                    if (message.partRevisionId != null && message.hasOwnProperty("partRevisionId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.partRevisionId);
                        if (error)
                            return "partRevisionId." + error;
                    }
                    if (message.partId != null && message.hasOwnProperty("partId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.partId);
                        if (error)
                            return "partId." + error;
                    }
                    if (message.suppliedPartRevisionId != null && message.hasOwnProperty("suppliedPartRevisionId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.suppliedPartRevisionId);
                        if (error)
                            return "suppliedPartRevisionId." + error;
                    }
                    if (message.ancestors != null && message.hasOwnProperty("ancestors")) {
                        if (!Array.isArray(message.ancestors))
                            return "ancestors: array expected";
                        for (let i = 0; i < message.ancestors.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.HitItemAncestor.verify(message.ancestors[i]);
                            if (error)
                                return "ancestors." + error;
                        }
                    }
                    if (message.metadataProperties != null && message.hasOwnProperty("metadataProperties")) {
                        if (!Array.isArray(message.metadataProperties))
                            return "metadataProperties: array expected";
                        for (let i = 0; i < message.metadataProperties.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.MetadataProperty.verify(message.metadataProperties[i]);
                            if (error)
                                return "metadataProperties." + error;
                        }
                    }
                    if (message.modelEntity != null && message.hasOwnProperty("modelEntity")) {
                        let error = $root.vertexvis.protobuf.core.ModelEntity.verify(message.modelEntity);
                        if (error)
                            return "modelEntity." + error;
                    }
                    if (message.leafItemId != null && message.hasOwnProperty("leafItemId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.leafItemId);
                        if (error)
                            return "leafItemId." + error;
                    }
                    if (message.annotationId != null && message.hasOwnProperty("annotationId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.annotationId);
                        if (error)
                            return "annotationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Hit message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Hit} Hit
                 */
                Hit.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Hit)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Hit();
                    if (object.itemId != null) {
                        if (typeof object.itemId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.itemId: object expected");
                        message.itemId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.itemId);
                    }
                    if (object.itemSuppliedId != null) {
                        if (typeof object.itemSuppliedId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.itemSuppliedId: object expected");
                        message.itemSuppliedId = $root.google.protobuf.StringValue.fromObject(object.itemSuppliedId);
                    }
                    if (object.hitNormal != null) {
                        if (typeof object.hitNormal !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.hitNormal: object expected");
                        message.hitNormal = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.hitNormal);
                    }
                    if (object.hitPoint != null) {
                        if (typeof object.hitPoint !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.hitPoint: object expected");
                        message.hitPoint = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.hitPoint);
                    }
                    if (object.partRevisionId != null) {
                        if (typeof object.partRevisionId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.partRevisionId: object expected");
                        message.partRevisionId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.partRevisionId);
                    }
                    if (object.partId != null) {
                        if (typeof object.partId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.partId: object expected");
                        message.partId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.partId);
                    }
                    if (object.suppliedPartRevisionId != null) {
                        if (typeof object.suppliedPartRevisionId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.suppliedPartRevisionId: object expected");
                        message.suppliedPartRevisionId = $root.google.protobuf.StringValue.fromObject(object.suppliedPartRevisionId);
                    }
                    if (object.ancestors) {
                        if (!Array.isArray(object.ancestors))
                            throw TypeError(".vertexvis.protobuf.stream.Hit.ancestors: array expected");
                        message.ancestors = [];
                        for (let i = 0; i < object.ancestors.length; ++i) {
                            if (typeof object.ancestors[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.Hit.ancestors: object expected");
                            message.ancestors[i] = $root.vertexvis.protobuf.stream.HitItemAncestor.fromObject(object.ancestors[i]);
                        }
                    }
                    if (object.metadataProperties) {
                        if (!Array.isArray(object.metadataProperties))
                            throw TypeError(".vertexvis.protobuf.stream.Hit.metadataProperties: array expected");
                        message.metadataProperties = [];
                        for (let i = 0; i < object.metadataProperties.length; ++i) {
                            if (typeof object.metadataProperties[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.Hit.metadataProperties: object expected");
                            message.metadataProperties[i] = $root.vertexvis.protobuf.stream.MetadataProperty.fromObject(object.metadataProperties[i]);
                        }
                    }
                    if (object.modelEntity != null) {
                        if (typeof object.modelEntity !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.modelEntity: object expected");
                        message.modelEntity = $root.vertexvis.protobuf.core.ModelEntity.fromObject(object.modelEntity);
                    }
                    if (object.leafItemId != null) {
                        if (typeof object.leafItemId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.leafItemId: object expected");
                        message.leafItemId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.leafItemId);
                    }
                    if (object.annotationId != null) {
                        if (typeof object.annotationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Hit.annotationId: object expected");
                        message.annotationId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.annotationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Hit message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @static
                 * @param {vertexvis.protobuf.stream.Hit} message Hit
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Hit.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.ancestors = [];
                        object.metadataProperties = [];
                    }
                    if (options.defaults) {
                        object.itemId = null;
                        object.itemSuppliedId = null;
                        object.hitNormal = null;
                        object.hitPoint = null;
                        object.partRevisionId = null;
                        object.partId = null;
                        object.suppliedPartRevisionId = null;
                        object.modelEntity = null;
                        object.leafItemId = null;
                        object.annotationId = null;
                    }
                    if (message.itemId != null && message.hasOwnProperty("itemId"))
                        object.itemId = $root.vertexvis.protobuf.core.Uuid.toObject(message.itemId, options);
                    if (message.itemSuppliedId != null && message.hasOwnProperty("itemSuppliedId"))
                        object.itemSuppliedId = $root.google.protobuf.StringValue.toObject(message.itemSuppliedId, options);
                    if (message.hitNormal != null && message.hasOwnProperty("hitNormal"))
                        object.hitNormal = $root.vertexvis.protobuf.core.Vector3f.toObject(message.hitNormal, options);
                    if (message.hitPoint != null && message.hasOwnProperty("hitPoint"))
                        object.hitPoint = $root.vertexvis.protobuf.core.Vector3f.toObject(message.hitPoint, options);
                    if (message.partRevisionId != null && message.hasOwnProperty("partRevisionId"))
                        object.partRevisionId = $root.vertexvis.protobuf.core.Uuid.toObject(message.partRevisionId, options);
                    if (message.partId != null && message.hasOwnProperty("partId"))
                        object.partId = $root.vertexvis.protobuf.core.Uuid.toObject(message.partId, options);
                    if (message.suppliedPartRevisionId != null && message.hasOwnProperty("suppliedPartRevisionId"))
                        object.suppliedPartRevisionId = $root.google.protobuf.StringValue.toObject(message.suppliedPartRevisionId, options);
                    if (message.ancestors && message.ancestors.length) {
                        object.ancestors = [];
                        for (let j = 0; j < message.ancestors.length; ++j)
                            object.ancestors[j] = $root.vertexvis.protobuf.stream.HitItemAncestor.toObject(message.ancestors[j], options);
                    }
                    if (message.metadataProperties && message.metadataProperties.length) {
                        object.metadataProperties = [];
                        for (let j = 0; j < message.metadataProperties.length; ++j)
                            object.metadataProperties[j] = $root.vertexvis.protobuf.stream.MetadataProperty.toObject(message.metadataProperties[j], options);
                    }
                    if (message.modelEntity != null && message.hasOwnProperty("modelEntity"))
                        object.modelEntity = $root.vertexvis.protobuf.core.ModelEntity.toObject(message.modelEntity, options);
                    if (message.leafItemId != null && message.hasOwnProperty("leafItemId"))
                        object.leafItemId = $root.vertexvis.protobuf.core.Uuid.toObject(message.leafItemId, options);
                    if (message.annotationId != null && message.hasOwnProperty("annotationId"))
                        object.annotationId = $root.vertexvis.protobuf.core.Uuid.toObject(message.annotationId, options);
                    return object;
                };

                /**
                 * Converts this Hit to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Hit
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Hit.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Hit;
            })();

            stream.SceneItemOverride = (function() {

                /**
                 * Properties of a SceneItemOverride.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemOverride
                 * @property {vertexvis.protobuf.core.IUuid|null} [id] SceneItemOverride id
                 * @property {vertexvis.protobuf.core.IMatrix4x4f|null} [transform] SceneItemOverride transform
                 * @property {google.protobuf.IBoolValue|null} [isVisible] SceneItemOverride isVisible
                 * @property {vertexvis.protobuf.core.IColorMaterial|null} [colorMaterialOverride] SceneItemOverride colorMaterialOverride
                 * @property {vertexvis.protobuf.core.IColorMaterial|null} [selected] SceneItemOverride selected
                 * @property {google.protobuf.IBoolValue|null} [selectedState] SceneItemOverride selectedState
                 * @property {vertexvis.protobuf.core.IMaterialOverride|null} [materialOverride] SceneItemOverride materialOverride
                 */

                /**
                 * Constructs a new SceneItemOverride.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemOverride.
                 * @implements ISceneItemOverride
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemOverride=} [properties] Properties to set
                 */
                function SceneItemOverride(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemOverride id.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} id
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.id = null;

                /**
                 * SceneItemOverride transform.
                 * @member {vertexvis.protobuf.core.IMatrix4x4f|null|undefined} transform
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.transform = null;

                /**
                 * SceneItemOverride isVisible.
                 * @member {google.protobuf.IBoolValue|null|undefined} isVisible
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.isVisible = null;

                /**
                 * SceneItemOverride colorMaterialOverride.
                 * @member {vertexvis.protobuf.core.IColorMaterial|null|undefined} colorMaterialOverride
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.colorMaterialOverride = null;

                /**
                 * SceneItemOverride selected.
                 * @member {vertexvis.protobuf.core.IColorMaterial|null|undefined} selected
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.selected = null;

                /**
                 * SceneItemOverride selectedState.
                 * @member {google.protobuf.IBoolValue|null|undefined} selectedState
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.selectedState = null;

                /**
                 * SceneItemOverride materialOverride.
                 * @member {vertexvis.protobuf.core.IMaterialOverride|null|undefined} materialOverride
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 */
                SceneItemOverride.prototype.materialOverride = null;

                /**
                 * Creates a new SceneItemOverride instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOverride=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemOverride} SceneItemOverride instance
                 */
                SceneItemOverride.create = function create(properties) {
                    return new SceneItemOverride(properties);
                };

                /**
                 * Encodes the specified SceneItemOverride message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOverride.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOverride} message SceneItemOverride message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOverride.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.Matrix4x4f.encode(message.transform, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.isVisible != null && Object.hasOwnProperty.call(message, "isVisible"))
                        $root.google.protobuf.BoolValue.encode(message.isVisible, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.colorMaterialOverride != null && Object.hasOwnProperty.call(message, "colorMaterialOverride"))
                        $root.vertexvis.protobuf.core.ColorMaterial.encode(message.colorMaterialOverride, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.selected != null && Object.hasOwnProperty.call(message, "selected"))
                        $root.vertexvis.protobuf.core.ColorMaterial.encode(message.selected, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.selectedState != null && Object.hasOwnProperty.call(message, "selectedState"))
                        $root.google.protobuf.BoolValue.encode(message.selectedState, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.materialOverride != null && Object.hasOwnProperty.call(message, "materialOverride"))
                        $root.vertexvis.protobuf.core.MaterialOverride.encode(message.materialOverride, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemOverride message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOverride.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOverride} message SceneItemOverride message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOverride.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemOverride message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemOverride} SceneItemOverride
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOverride.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemOverride();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.transform = $root.vertexvis.protobuf.core.Matrix4x4f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.isVisible = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.colorMaterialOverride = $root.vertexvis.protobuf.core.ColorMaterial.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.selected = $root.vertexvis.protobuf.core.ColorMaterial.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.selectedState = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemOverride message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemOverride} SceneItemOverride
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOverride.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemOverride message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemOverride.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.id);
                        if (error)
                            return "id." + error;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.Matrix4x4f.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    if (message.isVisible != null && message.hasOwnProperty("isVisible")) {
                        let error = $root.google.protobuf.BoolValue.verify(message.isVisible);
                        if (error)
                            return "isVisible." + error;
                    }
                    if (message.colorMaterialOverride != null && message.hasOwnProperty("colorMaterialOverride")) {
                        let error = $root.vertexvis.protobuf.core.ColorMaterial.verify(message.colorMaterialOverride);
                        if (error)
                            return "colorMaterialOverride." + error;
                    }
                    if (message.selected != null && message.hasOwnProperty("selected")) {
                        let error = $root.vertexvis.protobuf.core.ColorMaterial.verify(message.selected);
                        if (error)
                            return "selected." + error;
                    }
                    if (message.selectedState != null && message.hasOwnProperty("selectedState")) {
                        let error = $root.google.protobuf.BoolValue.verify(message.selectedState);
                        if (error)
                            return "selectedState." + error;
                    }
                    if (message.materialOverride != null && message.hasOwnProperty("materialOverride")) {
                        let error = $root.vertexvis.protobuf.core.MaterialOverride.verify(message.materialOverride);
                        if (error)
                            return "materialOverride." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemOverride message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemOverride} SceneItemOverride
                 */
                SceneItemOverride.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemOverride)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemOverride();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid.fromObject(object.id);
                    }
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.Matrix4x4f.fromObject(object.transform);
                    }
                    if (object.isVisible != null) {
                        if (typeof object.isVisible !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.isVisible: object expected");
                        message.isVisible = $root.google.protobuf.BoolValue.fromObject(object.isVisible);
                    }
                    if (object.colorMaterialOverride != null) {
                        if (typeof object.colorMaterialOverride !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.colorMaterialOverride: object expected");
                        message.colorMaterialOverride = $root.vertexvis.protobuf.core.ColorMaterial.fromObject(object.colorMaterialOverride);
                    }
                    if (object.selected != null) {
                        if (typeof object.selected !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.selected: object expected");
                        message.selected = $root.vertexvis.protobuf.core.ColorMaterial.fromObject(object.selected);
                    }
                    if (object.selectedState != null) {
                        if (typeof object.selectedState !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.selectedState: object expected");
                        message.selectedState = $root.google.protobuf.BoolValue.fromObject(object.selectedState);
                    }
                    if (object.materialOverride != null) {
                        if (typeof object.materialOverride !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOverride.materialOverride: object expected");
                        message.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.fromObject(object.materialOverride);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemOverride message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemOverride} message SceneItemOverride
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemOverride.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = null;
                        object.transform = null;
                        object.isVisible = null;
                        object.colorMaterialOverride = null;
                        object.selected = null;
                        object.selectedState = null;
                        object.materialOverride = null;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = $root.vertexvis.protobuf.core.Uuid.toObject(message.id, options);
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.Matrix4x4f.toObject(message.transform, options);
                    if (message.isVisible != null && message.hasOwnProperty("isVisible"))
                        object.isVisible = $root.google.protobuf.BoolValue.toObject(message.isVisible, options);
                    if (message.colorMaterialOverride != null && message.hasOwnProperty("colorMaterialOverride"))
                        object.colorMaterialOverride = $root.vertexvis.protobuf.core.ColorMaterial.toObject(message.colorMaterialOverride, options);
                    if (message.selected != null && message.hasOwnProperty("selected"))
                        object.selected = $root.vertexvis.protobuf.core.ColorMaterial.toObject(message.selected, options);
                    if (message.selectedState != null && message.hasOwnProperty("selectedState"))
                        object.selectedState = $root.google.protobuf.BoolValue.toObject(message.selectedState, options);
                    if (message.materialOverride != null && message.hasOwnProperty("materialOverride"))
                        object.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.toObject(message.materialOverride, options);
                    return object;
                };

                /**
                 * Converts this SceneItemOverride to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemOverride
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemOverride.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemOverride;
            })();

            stream.SceneItemQuery = (function() {

                /**
                 * Properties of a SceneItemQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemQuery
                 * @property {vertexvis.protobuf.core.IUuid|null} [id] SceneItemQuery id
                 * @property {string|null} [suppliedId] SceneItemQuery suppliedId
                 */

                /**
                 * Constructs a new SceneItemQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemQuery.
                 * @implements ISceneItemQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemQuery=} [properties] Properties to set
                 */
                function SceneItemQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemQuery id.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} id
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @instance
                 */
                SceneItemQuery.prototype.id = null;

                /**
                 * SceneItemQuery suppliedId.
                 * @member {string|null|undefined} suppliedId
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @instance
                 */
                SceneItemQuery.prototype.suppliedId = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneItemQuery itemQuery.
                 * @member {"id"|"suppliedId"|undefined} itemQuery
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @instance
                 */
                Object.defineProperty(SceneItemQuery.prototype, "itemQuery", {
                    get: $util.oneOfGetter($oneOfFields = ["id", "suppliedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneItemQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemQuery} SceneItemQuery instance
                 */
                SceneItemQuery.create = function create(properties) {
                    return new SceneItemQuery(properties);
                };

                /**
                 * Encodes the specified SceneItemQuery message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQuery} message SceneItemQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.suppliedId != null && Object.hasOwnProperty.call(message, "suppliedId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.suppliedId);
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQuery} message SceneItemQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemQuery} SceneItemQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.suppliedId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemQuery} SceneItemQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        properties.itemQuery = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.id);
                            if (error)
                                return "id." + error;
                        }
                    }
                    if (message.suppliedId != null && message.hasOwnProperty("suppliedId")) {
                        if (properties.itemQuery === 1)
                            return "itemQuery: multiple values";
                        properties.itemQuery = 1;
                        if (!$util.isString(message.suppliedId))
                            return "suppliedId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemQuery} SceneItemQuery
                 */
                SceneItemQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemQuery();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQuery.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid.fromObject(object.id);
                    }
                    if (object.suppliedId != null)
                        message.suppliedId = String(object.suppliedId);
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemQuery} message SceneItemQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        object.id = $root.vertexvis.protobuf.core.Uuid.toObject(message.id, options);
                        if (options.oneofs)
                            object.itemQuery = "id";
                    }
                    if (message.suppliedId != null && message.hasOwnProperty("suppliedId")) {
                        object.suppliedId = message.suppliedId;
                        if (options.oneofs)
                            object.itemQuery = "suppliedId";
                    }
                    return object;
                };

                /**
                 * Converts this SceneItemQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemQuery;
            })();

            stream.AllQuery = (function() {

                /**
                 * Properties of an AllQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IAllQuery
                 */

                /**
                 * Constructs a new AllQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an AllQuery.
                 * @implements IAllQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IAllQuery=} [properties] Properties to set
                 */
                function AllQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new AllQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAllQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.AllQuery} AllQuery instance
                 */
                AllQuery.create = function create(properties) {
                    return new AllQuery(properties);
                };

                /**
                 * Encodes the specified AllQuery message. Does not implicitly {@link vertexvis.protobuf.stream.AllQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAllQuery} message AllQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AllQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified AllQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.AllQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAllQuery} message AllQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AllQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AllQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.AllQuery} AllQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AllQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.AllQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AllQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.AllQuery} AllQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AllQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AllQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AllQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an AllQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.AllQuery} AllQuery
                 */
                AllQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.AllQuery)
                        return object;
                    return new $root.vertexvis.protobuf.stream.AllQuery();
                };

                /**
                 * Creates a plain object from an AllQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.AllQuery} message AllQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AllQuery.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this AllQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.AllQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AllQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AllQuery;
            })();

            stream.RootQuery = (function() {

                /**
                 * Properties of a RootQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRootQuery
                 */

                /**
                 * Constructs a new RootQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a RootQuery.
                 * @implements IRootQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRootQuery=} [properties] Properties to set
                 */
                function RootQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new RootQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IRootQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.RootQuery} RootQuery instance
                 */
                RootQuery.create = function create(properties) {
                    return new RootQuery(properties);
                };

                /**
                 * Encodes the specified RootQuery message. Does not implicitly {@link vertexvis.protobuf.stream.RootQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IRootQuery} message RootQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RootQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified RootQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.RootQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IRootQuery} message RootQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RootQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RootQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.RootQuery} RootQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RootQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.RootQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RootQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.RootQuery} RootQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RootQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RootQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RootQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a RootQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.RootQuery} RootQuery
                 */
                RootQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.RootQuery)
                        return object;
                    return new $root.vertexvis.protobuf.stream.RootQuery();
                };

                /**
                 * Creates a plain object from a RootQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.RootQuery} message RootQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RootQuery.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this RootQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.RootQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RootQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RootQuery;
            })();

            stream.PointQuery = (function() {

                /**
                 * Properties of a PointQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPointQuery
                 * @property {vertexvis.protobuf.stream.IPoint|null} [point] PointQuery point
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [viewport] PointQuery viewport
                 */

                /**
                 * Constructs a new PointQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PointQuery.
                 * @implements IPointQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPointQuery=} [properties] Properties to set
                 */
                function PointQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PointQuery point.
                 * @member {vertexvis.protobuf.stream.IPoint|null|undefined} point
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @instance
                 */
                PointQuery.prototype.point = null;

                /**
                 * PointQuery viewport.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} viewport
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @instance
                 */
                PointQuery.prototype.viewport = null;

                /**
                 * Creates a new PointQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPointQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PointQuery} PointQuery instance
                 */
                PointQuery.create = function create(properties) {
                    return new PointQuery(properties);
                };

                /**
                 * Encodes the specified PointQuery message. Does not implicitly {@link vertexvis.protobuf.stream.PointQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPointQuery} message PointQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PointQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                        $root.vertexvis.protobuf.stream.Point.encode(message.point, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.viewport != null && Object.hasOwnProperty.call(message, "viewport"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.viewport, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PointQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PointQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPointQuery} message PointQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PointQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PointQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PointQuery} PointQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PointQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PointQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.point = $root.vertexvis.protobuf.stream.Point.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.viewport = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PointQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PointQuery} PointQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PointQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PointQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PointQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.point != null && message.hasOwnProperty("point")) {
                        let error = $root.vertexvis.protobuf.stream.Point.verify(message.point);
                        if (error)
                            return "point." + error;
                    }
                    if (message.viewport != null && message.hasOwnProperty("viewport")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.viewport);
                        if (error)
                            return "viewport." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PointQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PointQuery} PointQuery
                 */
                PointQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PointQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PointQuery();
                    if (object.point != null) {
                        if (typeof object.point !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PointQuery.point: object expected");
                        message.point = $root.vertexvis.protobuf.stream.Point.fromObject(object.point);
                    }
                    if (object.viewport != null) {
                        if (typeof object.viewport !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PointQuery.viewport: object expected");
                        message.viewport = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.viewport);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PointQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.PointQuery} message PointQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PointQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.point = null;
                        object.viewport = null;
                    }
                    if (message.point != null && message.hasOwnProperty("point"))
                        object.point = $root.vertexvis.protobuf.stream.Point.toObject(message.point, options);
                    if (message.viewport != null && message.hasOwnProperty("viewport"))
                        object.viewport = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.viewport, options);
                    return object;
                };

                /**
                 * Converts this PointQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PointQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PointQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PointQuery;
            })();

            stream.FrustumByRectangle = (function() {

                /**
                 * Properties of a FrustumByRectangle.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFrustumByRectangle
                 * @property {vertexvis.protobuf.stream.IRectangle|null} [rectangle] FrustumByRectangle rectangle
                 */

                /**
                 * Constructs a new FrustumByRectangle.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FrustumByRectangle.
                 * @implements IFrustumByRectangle
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFrustumByRectangle=} [properties] Properties to set
                 */
                function FrustumByRectangle(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FrustumByRectangle rectangle.
                 * @member {vertexvis.protobuf.stream.IRectangle|null|undefined} rectangle
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @instance
                 */
                FrustumByRectangle.prototype.rectangle = null;

                /**
                 * Creates a new FrustumByRectangle instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrustumByRectangle=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FrustumByRectangle} FrustumByRectangle instance
                 */
                FrustumByRectangle.create = function create(properties) {
                    return new FrustumByRectangle(properties);
                };

                /**
                 * Encodes the specified FrustumByRectangle message. Does not implicitly {@link vertexvis.protobuf.stream.FrustumByRectangle.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrustumByRectangle} message FrustumByRectangle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FrustumByRectangle.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.rectangle != null && Object.hasOwnProperty.call(message, "rectangle"))
                        $root.vertexvis.protobuf.stream.Rectangle.encode(message.rectangle, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FrustumByRectangle message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FrustumByRectangle.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrustumByRectangle} message FrustumByRectangle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FrustumByRectangle.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FrustumByRectangle message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FrustumByRectangle} FrustumByRectangle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FrustumByRectangle.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FrustumByRectangle();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.rectangle = $root.vertexvis.protobuf.stream.Rectangle.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FrustumByRectangle message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FrustumByRectangle} FrustumByRectangle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FrustumByRectangle.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FrustumByRectangle message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FrustumByRectangle.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.rectangle != null && message.hasOwnProperty("rectangle")) {
                        let error = $root.vertexvis.protobuf.stream.Rectangle.verify(message.rectangle);
                        if (error)
                            return "rectangle." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FrustumByRectangle message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FrustumByRectangle} FrustumByRectangle
                 */
                FrustumByRectangle.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FrustumByRectangle)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FrustumByRectangle();
                    if (object.rectangle != null) {
                        if (typeof object.rectangle !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FrustumByRectangle.rectangle: object expected");
                        message.rectangle = $root.vertexvis.protobuf.stream.Rectangle.fromObject(object.rectangle);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FrustumByRectangle message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.FrustumByRectangle} message FrustumByRectangle
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FrustumByRectangle.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.rectangle = null;
                    if (message.rectangle != null && message.hasOwnProperty("rectangle"))
                        object.rectangle = $root.vertexvis.protobuf.stream.Rectangle.toObject(message.rectangle, options);
                    return object;
                };

                /**
                 * Converts this FrustumByRectangle to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FrustumByRectangle
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FrustumByRectangle.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FrustumByRectangle;
            })();

            stream.VolumeIntersectionQuery = (function() {

                /**
                 * Properties of a VolumeIntersectionQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IVolumeIntersectionQuery
                 * @property {vertexvis.protobuf.stream.IFrustumByRectangle|null} [frustumByRectangle] VolumeIntersectionQuery frustumByRectangle
                 * @property {boolean|null} [exclusive] VolumeIntersectionQuery exclusive
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [viewport] VolumeIntersectionQuery viewport
                 */

                /**
                 * Constructs a new VolumeIntersectionQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a VolumeIntersectionQuery.
                 * @implements IVolumeIntersectionQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IVolumeIntersectionQuery=} [properties] Properties to set
                 */
                function VolumeIntersectionQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VolumeIntersectionQuery frustumByRectangle.
                 * @member {vertexvis.protobuf.stream.IFrustumByRectangle|null|undefined} frustumByRectangle
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @instance
                 */
                VolumeIntersectionQuery.prototype.frustumByRectangle = null;

                /**
                 * VolumeIntersectionQuery exclusive.
                 * @member {boolean} exclusive
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @instance
                 */
                VolumeIntersectionQuery.prototype.exclusive = false;

                /**
                 * VolumeIntersectionQuery viewport.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} viewport
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @instance
                 */
                VolumeIntersectionQuery.prototype.viewport = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * VolumeIntersectionQuery volume.
                 * @member {"frustumByRectangle"|undefined} volume
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @instance
                 */
                Object.defineProperty(VolumeIntersectionQuery.prototype, "volume", {
                    get: $util.oneOfGetter($oneOfFields = ["frustumByRectangle"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new VolumeIntersectionQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVolumeIntersectionQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.VolumeIntersectionQuery} VolumeIntersectionQuery instance
                 */
                VolumeIntersectionQuery.create = function create(properties) {
                    return new VolumeIntersectionQuery(properties);
                };

                /**
                 * Encodes the specified VolumeIntersectionQuery message. Does not implicitly {@link vertexvis.protobuf.stream.VolumeIntersectionQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVolumeIntersectionQuery} message VolumeIntersectionQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VolumeIntersectionQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frustumByRectangle != null && Object.hasOwnProperty.call(message, "frustumByRectangle"))
                        $root.vertexvis.protobuf.stream.FrustumByRectangle.encode(message.frustumByRectangle, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.exclusive != null && Object.hasOwnProperty.call(message, "exclusive"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.exclusive);
                    if (message.viewport != null && Object.hasOwnProperty.call(message, "viewport"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.viewport, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VolumeIntersectionQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.VolumeIntersectionQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVolumeIntersectionQuery} message VolumeIntersectionQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VolumeIntersectionQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VolumeIntersectionQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.VolumeIntersectionQuery} VolumeIntersectionQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VolumeIntersectionQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.VolumeIntersectionQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frustumByRectangle = $root.vertexvis.protobuf.stream.FrustumByRectangle.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.exclusive = reader.bool();
                            break;
                        case 3:
                            message.viewport = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VolumeIntersectionQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.VolumeIntersectionQuery} VolumeIntersectionQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VolumeIntersectionQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VolumeIntersectionQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VolumeIntersectionQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.frustumByRectangle != null && message.hasOwnProperty("frustumByRectangle")) {
                        properties.volume = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.FrustumByRectangle.verify(message.frustumByRectangle);
                            if (error)
                                return "frustumByRectangle." + error;
                        }
                    }
                    if (message.exclusive != null && message.hasOwnProperty("exclusive"))
                        if (typeof message.exclusive !== "boolean")
                            return "exclusive: boolean expected";
                    if (message.viewport != null && message.hasOwnProperty("viewport")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.viewport);
                        if (error)
                            return "viewport." + error;
                    }
                    return null;
                };

                /**
                 * Creates a VolumeIntersectionQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.VolumeIntersectionQuery} VolumeIntersectionQuery
                 */
                VolumeIntersectionQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.VolumeIntersectionQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.VolumeIntersectionQuery();
                    if (object.frustumByRectangle != null) {
                        if (typeof object.frustumByRectangle !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.VolumeIntersectionQuery.frustumByRectangle: object expected");
                        message.frustumByRectangle = $root.vertexvis.protobuf.stream.FrustumByRectangle.fromObject(object.frustumByRectangle);
                    }
                    if (object.exclusive != null)
                        message.exclusive = Boolean(object.exclusive);
                    if (object.viewport != null) {
                        if (typeof object.viewport !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.VolumeIntersectionQuery.viewport: object expected");
                        message.viewport = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.viewport);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VolumeIntersectionQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.VolumeIntersectionQuery} message VolumeIntersectionQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VolumeIntersectionQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.exclusive = false;
                        object.viewport = null;
                    }
                    if (message.frustumByRectangle != null && message.hasOwnProperty("frustumByRectangle")) {
                        object.frustumByRectangle = $root.vertexvis.protobuf.stream.FrustumByRectangle.toObject(message.frustumByRectangle, options);
                        if (options.oneofs)
                            object.volume = "frustumByRectangle";
                    }
                    if (message.exclusive != null && message.hasOwnProperty("exclusive"))
                        object.exclusive = message.exclusive;
                    if (message.viewport != null && message.hasOwnProperty("viewport"))
                        object.viewport = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.viewport, options);
                    return object;
                };

                /**
                 * Converts this VolumeIntersectionQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.VolumeIntersectionQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VolumeIntersectionQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return VolumeIntersectionQuery;
            })();

            stream.SceneTreeRangeQuery = (function() {

                /**
                 * Properties of a SceneTreeRangeQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneTreeRangeQuery
                 * @property {number|null} [start] SceneTreeRangeQuery start
                 * @property {number|null} [end] SceneTreeRangeQuery end
                 */

                /**
                 * Constructs a new SceneTreeRangeQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneTreeRangeQuery.
                 * @implements ISceneTreeRangeQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneTreeRangeQuery=} [properties] Properties to set
                 */
                function SceneTreeRangeQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneTreeRangeQuery start.
                 * @member {number} start
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @instance
                 */
                SceneTreeRangeQuery.prototype.start = 0;

                /**
                 * SceneTreeRangeQuery end.
                 * @member {number} end
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @instance
                 */
                SceneTreeRangeQuery.prototype.end = 0;

                /**
                 * Creates a new SceneTreeRangeQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneTreeRangeQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneTreeRangeQuery} SceneTreeRangeQuery instance
                 */
                SceneTreeRangeQuery.create = function create(properties) {
                    return new SceneTreeRangeQuery(properties);
                };

                /**
                 * Encodes the specified SceneTreeRangeQuery message. Does not implicitly {@link vertexvis.protobuf.stream.SceneTreeRangeQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneTreeRangeQuery} message SceneTreeRangeQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneTreeRangeQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.end);
                    return writer;
                };

                /**
                 * Encodes the specified SceneTreeRangeQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneTreeRangeQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneTreeRangeQuery} message SceneTreeRangeQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneTreeRangeQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneTreeRangeQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneTreeRangeQuery} SceneTreeRangeQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneTreeRangeQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneTreeRangeQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.uint32();
                            break;
                        case 2:
                            message.end = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneTreeRangeQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneTreeRangeQuery} SceneTreeRangeQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneTreeRangeQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneTreeRangeQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneTreeRangeQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                /**
                 * Creates a SceneTreeRangeQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneTreeRangeQuery} SceneTreeRangeQuery
                 */
                SceneTreeRangeQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneTreeRangeQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneTreeRangeQuery();
                    if (object.start != null)
                        message.start = object.start >>> 0;
                    if (object.end != null)
                        message.end = object.end >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SceneTreeRangeQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneTreeRangeQuery} message SceneTreeRangeQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneTreeRangeQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                /**
                 * Converts this SceneTreeRangeQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneTreeRangeQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneTreeRangeQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneTreeRangeQuery;
            })();

            stream.ItemQuery = (function() {

                /**
                 * Properties of an ItemQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IItemQuery
                 * @property {vertexvis.protobuf.stream.ISceneItemQuery|null} [sceneItemQuery] ItemQuery sceneItemQuery
                 */

                /**
                 * Constructs a new ItemQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an ItemQuery.
                 * @implements IItemQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IItemQuery=} [properties] Properties to set
                 */
                function ItemQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemQuery sceneItemQuery.
                 * @member {vertexvis.protobuf.stream.ISceneItemQuery|null|undefined} sceneItemQuery
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @instance
                 */
                ItemQuery.prototype.sceneItemQuery = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * ItemQuery value.
                 * @member {"sceneItemQuery"|undefined} value
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @instance
                 */
                Object.defineProperty(ItemQuery.prototype, "value", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneItemQuery"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ItemQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ItemQuery} ItemQuery instance
                 */
                ItemQuery.create = function create(properties) {
                    return new ItemQuery(properties);
                };

                /**
                 * Encodes the specified ItemQuery message. Does not implicitly {@link vertexvis.protobuf.stream.ItemQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemQuery} message ItemQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sceneItemQuery != null && Object.hasOwnProperty.call(message, "sceneItemQuery"))
                        $root.vertexvis.protobuf.stream.SceneItemQuery.encode(message.sceneItemQuery, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ItemQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ItemQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IItemQuery} message ItemQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ItemQuery} ItemQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ItemQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sceneItemQuery = $root.vertexvis.protobuf.stream.SceneItemQuery.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ItemQuery} ItemQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.sceneItemQuery != null && message.hasOwnProperty("sceneItemQuery")) {
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemQuery.verify(message.sceneItemQuery);
                            if (error)
                                return "sceneItemQuery." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ItemQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ItemQuery} ItemQuery
                 */
                ItemQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ItemQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ItemQuery();
                    if (object.sceneItemQuery != null) {
                        if (typeof object.sceneItemQuery !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ItemQuery.sceneItemQuery: object expected");
                        message.sceneItemQuery = $root.vertexvis.protobuf.stream.SceneItemQuery.fromObject(object.sceneItemQuery);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ItemQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ItemQuery} message ItemQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.sceneItemQuery != null && message.hasOwnProperty("sceneItemQuery")) {
                        object.sceneItemQuery = $root.vertexvis.protobuf.stream.SceneItemQuery.toObject(message.sceneItemQuery, options);
                        if (options.oneofs)
                            object.value = "sceneItemQuery";
                    }
                    return object;
                };

                /**
                 * Converts this ItemQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ItemQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ItemQuery;
            })();

            stream.MetadataFilterQuery = (function() {

                /**
                 * Properties of a MetadataFilterQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IMetadataFilterQuery
                 * @property {string|null} [valueFilter] MetadataFilterQuery valueFilter
                 * @property {Array.<string>|null} [keys] MetadataFilterQuery keys
                 * @property {boolean|null} [exactMatch] MetadataFilterQuery exactMatch
                 */

                /**
                 * Constructs a new MetadataFilterQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a MetadataFilterQuery.
                 * @implements IMetadataFilterQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IMetadataFilterQuery=} [properties] Properties to set
                 */
                function MetadataFilterQuery(properties) {
                    this.keys = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataFilterQuery valueFilter.
                 * @member {string} valueFilter
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @instance
                 */
                MetadataFilterQuery.prototype.valueFilter = "";

                /**
                 * MetadataFilterQuery keys.
                 * @member {Array.<string>} keys
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @instance
                 */
                MetadataFilterQuery.prototype.keys = $util.emptyArray;

                /**
                 * MetadataFilterQuery exactMatch.
                 * @member {boolean} exactMatch
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @instance
                 */
                MetadataFilterQuery.prototype.exactMatch = false;

                /**
                 * Creates a new MetadataFilterQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataFilterQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.MetadataFilterQuery} MetadataFilterQuery instance
                 */
                MetadataFilterQuery.create = function create(properties) {
                    return new MetadataFilterQuery(properties);
                };

                /**
                 * Encodes the specified MetadataFilterQuery message. Does not implicitly {@link vertexvis.protobuf.stream.MetadataFilterQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataFilterQuery} message MetadataFilterQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataFilterQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.valueFilter != null && Object.hasOwnProperty.call(message, "valueFilter"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.valueFilter);
                    if (message.keys != null && message.keys.length)
                        for (let i = 0; i < message.keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.keys[i]);
                    if (message.exactMatch != null && Object.hasOwnProperty.call(message, "exactMatch"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.exactMatch);
                    return writer;
                };

                /**
                 * Encodes the specified MetadataFilterQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.MetadataFilterQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataFilterQuery} message MetadataFilterQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataFilterQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataFilterQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.MetadataFilterQuery} MetadataFilterQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataFilterQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.MetadataFilterQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.valueFilter = reader.string();
                            break;
                        case 3:
                            if (!(message.keys && message.keys.length))
                                message.keys = [];
                            message.keys.push(reader.string());
                            break;
                        case 4:
                            message.exactMatch = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataFilterQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.MetadataFilterQuery} MetadataFilterQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataFilterQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataFilterQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataFilterQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.valueFilter != null && message.hasOwnProperty("valueFilter"))
                        if (!$util.isString(message.valueFilter))
                            return "valueFilter: string expected";
                    if (message.keys != null && message.hasOwnProperty("keys")) {
                        if (!Array.isArray(message.keys))
                            return "keys: array expected";
                        for (let i = 0; i < message.keys.length; ++i)
                            if (!$util.isString(message.keys[i]))
                                return "keys: string[] expected";
                    }
                    if (message.exactMatch != null && message.hasOwnProperty("exactMatch"))
                        if (typeof message.exactMatch !== "boolean")
                            return "exactMatch: boolean expected";
                    return null;
                };

                /**
                 * Creates a MetadataFilterQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.MetadataFilterQuery} MetadataFilterQuery
                 */
                MetadataFilterQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.MetadataFilterQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.MetadataFilterQuery();
                    if (object.valueFilter != null)
                        message.valueFilter = String(object.valueFilter);
                    if (object.keys) {
                        if (!Array.isArray(object.keys))
                            throw TypeError(".vertexvis.protobuf.stream.MetadataFilterQuery.keys: array expected");
                        message.keys = [];
                        for (let i = 0; i < object.keys.length; ++i)
                            message.keys[i] = String(object.keys[i]);
                    }
                    if (object.exactMatch != null)
                        message.exactMatch = Boolean(object.exactMatch);
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataFilterQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.MetadataFilterQuery} message MetadataFilterQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataFilterQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.keys = [];
                    if (options.defaults) {
                        object.valueFilter = "";
                        object.exactMatch = false;
                    }
                    if (message.valueFilter != null && message.hasOwnProperty("valueFilter"))
                        object.valueFilter = message.valueFilter;
                    if (message.keys && message.keys.length) {
                        object.keys = [];
                        for (let j = 0; j < message.keys.length; ++j)
                            object.keys[j] = message.keys[j];
                    }
                    if (message.exactMatch != null && message.hasOwnProperty("exactMatch"))
                        object.exactMatch = message.exactMatch;
                    return object;
                };

                /**
                 * Converts this MetadataFilterQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.MetadataFilterQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataFilterQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return MetadataFilterQuery;
            })();

            stream.QueryCollection = (function() {

                /**
                 * Properties of a QueryCollection.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IQueryCollection
                 * @property {Array.<vertexvis.protobuf.stream.IItemQuery>|null} [queries] QueryCollection queries
                 */

                /**
                 * Constructs a new QueryCollection.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a QueryCollection.
                 * @implements IQueryCollection
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IQueryCollection=} [properties] Properties to set
                 */
                function QueryCollection(properties) {
                    this.queries = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * QueryCollection queries.
                 * @member {Array.<vertexvis.protobuf.stream.IItemQuery>} queries
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @instance
                 */
                QueryCollection.prototype.queries = $util.emptyArray;

                /**
                 * Creates a new QueryCollection instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryCollection=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.QueryCollection} QueryCollection instance
                 */
                QueryCollection.create = function create(properties) {
                    return new QueryCollection(properties);
                };

                /**
                 * Encodes the specified QueryCollection message. Does not implicitly {@link vertexvis.protobuf.stream.QueryCollection.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryCollection} message QueryCollection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryCollection.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.queries != null && message.queries.length)
                        for (let i = 0; i < message.queries.length; ++i)
                            $root.vertexvis.protobuf.stream.ItemQuery.encode(message.queries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified QueryCollection message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.QueryCollection.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryCollection} message QueryCollection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryCollection.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a QueryCollection message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.QueryCollection} QueryCollection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryCollection.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.QueryCollection();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.queries && message.queries.length))
                                message.queries = [];
                            message.queries.push($root.vertexvis.protobuf.stream.ItemQuery.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a QueryCollection message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.QueryCollection} QueryCollection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryCollection.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a QueryCollection message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                QueryCollection.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.queries != null && message.hasOwnProperty("queries")) {
                        if (!Array.isArray(message.queries))
                            return "queries: array expected";
                        for (let i = 0; i < message.queries.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.ItemQuery.verify(message.queries[i]);
                            if (error)
                                return "queries." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a QueryCollection message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.QueryCollection} QueryCollection
                 */
                QueryCollection.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.QueryCollection)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.QueryCollection();
                    if (object.queries) {
                        if (!Array.isArray(object.queries))
                            throw TypeError(".vertexvis.protobuf.stream.QueryCollection.queries: array expected");
                        message.queries = [];
                        for (let i = 0; i < object.queries.length; ++i) {
                            if (typeof object.queries[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.QueryCollection.queries: object expected");
                            message.queries[i] = $root.vertexvis.protobuf.stream.ItemQuery.fromObject(object.queries[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a QueryCollection message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @static
                 * @param {vertexvis.protobuf.stream.QueryCollection} message QueryCollection
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                QueryCollection.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.queries = [];
                    if (message.queries && message.queries.length) {
                        object.queries = [];
                        for (let j = 0; j < message.queries.length; ++j)
                            object.queries[j] = $root.vertexvis.protobuf.stream.ItemQuery.toObject(message.queries[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this QueryCollection to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.QueryCollection
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                QueryCollection.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return QueryCollection;
            })();

            stream.SelectionQuery = (function() {

                /**
                 * Properties of a SelectionQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISelectionQuery
                 */

                /**
                 * Constructs a new SelectionQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SelectionQuery.
                 * @implements ISelectionQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISelectionQuery=} [properties] Properties to set
                 */
                function SelectionQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new SelectionQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SelectionQuery} SelectionQuery instance
                 */
                SelectionQuery.create = function create(properties) {
                    return new SelectionQuery(properties);
                };

                /**
                 * Encodes the specified SelectionQuery message. Does not implicitly {@link vertexvis.protobuf.stream.SelectionQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionQuery} message SelectionQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectionQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified SelectionQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SelectionQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionQuery} message SelectionQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectionQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SelectionQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SelectionQuery} SelectionQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectionQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SelectionQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SelectionQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SelectionQuery} SelectionQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectionQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SelectionQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SelectionQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a SelectionQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SelectionQuery} SelectionQuery
                 */
                SelectionQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SelectionQuery)
                        return object;
                    return new $root.vertexvis.protobuf.stream.SelectionQuery();
                };

                /**
                 * Creates a plain object from a SelectionQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.SelectionQuery} message SelectionQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SelectionQuery.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this SelectionQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SelectionQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SelectionQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SelectionQuery;
            })();

            stream.VisibilityQuery = (function() {

                /**
                 * Properties of a VisibilityQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IVisibilityQuery
                 * @property {boolean|null} [visibilityState] VisibilityQuery visibilityState
                 */

                /**
                 * Constructs a new VisibilityQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a VisibilityQuery.
                 * @implements IVisibilityQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IVisibilityQuery=} [properties] Properties to set
                 */
                function VisibilityQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VisibilityQuery visibilityState.
                 * @member {boolean} visibilityState
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @instance
                 */
                VisibilityQuery.prototype.visibilityState = false;

                /**
                 * Creates a new VisibilityQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVisibilityQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.VisibilityQuery} VisibilityQuery instance
                 */
                VisibilityQuery.create = function create(properties) {
                    return new VisibilityQuery(properties);
                };

                /**
                 * Encodes the specified VisibilityQuery message. Does not implicitly {@link vertexvis.protobuf.stream.VisibilityQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVisibilityQuery} message VisibilityQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VisibilityQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.visibilityState != null && Object.hasOwnProperty.call(message, "visibilityState"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.visibilityState);
                    return writer;
                };

                /**
                 * Encodes the specified VisibilityQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.VisibilityQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IVisibilityQuery} message VisibilityQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VisibilityQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VisibilityQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.VisibilityQuery} VisibilityQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VisibilityQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.VisibilityQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.visibilityState = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VisibilityQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.VisibilityQuery} VisibilityQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VisibilityQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VisibilityQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VisibilityQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.visibilityState != null && message.hasOwnProperty("visibilityState"))
                        if (typeof message.visibilityState !== "boolean")
                            return "visibilityState: boolean expected";
                    return null;
                };

                /**
                 * Creates a VisibilityQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.VisibilityQuery} VisibilityQuery
                 */
                VisibilityQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.VisibilityQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.VisibilityQuery();
                    if (object.visibilityState != null)
                        message.visibilityState = Boolean(object.visibilityState);
                    return message;
                };

                /**
                 * Creates a plain object from a VisibilityQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.VisibilityQuery} message VisibilityQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VisibilityQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.visibilityState = false;
                    if (message.visibilityState != null && message.hasOwnProperty("visibilityState"))
                        object.visibilityState = message.visibilityState;
                    return object;
                };

                /**
                 * Converts this VisibilityQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.VisibilityQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VisibilityQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return VisibilityQuery;
            })();

            stream.OverrideQuery = (function() {

                /**
                 * Properties of an OverrideQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IOverrideQuery
                 * @property {vertexvis.protobuf.stream.ISelectionQuery|null} [selection] OverrideQuery selection
                 * @property {vertexvis.protobuf.stream.IVisibilityQuery|null} [visibility] OverrideQuery visibility
                 */

                /**
                 * Constructs a new OverrideQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an OverrideQuery.
                 * @implements IOverrideQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IOverrideQuery=} [properties] Properties to set
                 */
                function OverrideQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OverrideQuery selection.
                 * @member {vertexvis.protobuf.stream.ISelectionQuery|null|undefined} selection
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @instance
                 */
                OverrideQuery.prototype.selection = null;

                /**
                 * OverrideQuery visibility.
                 * @member {vertexvis.protobuf.stream.IVisibilityQuery|null|undefined} visibility
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @instance
                 */
                OverrideQuery.prototype.visibility = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * OverrideQuery override.
                 * @member {"selection"|"visibility"|undefined} override
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @instance
                 */
                Object.defineProperty(OverrideQuery.prototype, "override", {
                    get: $util.oneOfGetter($oneOfFields = ["selection", "visibility"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new OverrideQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IOverrideQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.OverrideQuery} OverrideQuery instance
                 */
                OverrideQuery.create = function create(properties) {
                    return new OverrideQuery(properties);
                };

                /**
                 * Encodes the specified OverrideQuery message. Does not implicitly {@link vertexvis.protobuf.stream.OverrideQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IOverrideQuery} message OverrideQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OverrideQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.selection != null && Object.hasOwnProperty.call(message, "selection"))
                        $root.vertexvis.protobuf.stream.SelectionQuery.encode(message.selection, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.visibility != null && Object.hasOwnProperty.call(message, "visibility"))
                        $root.vertexvis.protobuf.stream.VisibilityQuery.encode(message.visibility, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OverrideQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.OverrideQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IOverrideQuery} message OverrideQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OverrideQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OverrideQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.OverrideQuery} OverrideQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OverrideQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.OverrideQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.selection = $root.vertexvis.protobuf.stream.SelectionQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OverrideQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.OverrideQuery} OverrideQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OverrideQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OverrideQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OverrideQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.selection != null && message.hasOwnProperty("selection")) {
                        properties.override = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SelectionQuery.verify(message.selection);
                            if (error)
                                return "selection." + error;
                        }
                    }
                    if (message.visibility != null && message.hasOwnProperty("visibility")) {
                        if (properties.override === 1)
                            return "override: multiple values";
                        properties.override = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.VisibilityQuery.verify(message.visibility);
                            if (error)
                                return "visibility." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OverrideQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.OverrideQuery} OverrideQuery
                 */
                OverrideQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.OverrideQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.OverrideQuery();
                    if (object.selection != null) {
                        if (typeof object.selection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OverrideQuery.selection: object expected");
                        message.selection = $root.vertexvis.protobuf.stream.SelectionQuery.fromObject(object.selection);
                    }
                    if (object.visibility != null) {
                        if (typeof object.visibility !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OverrideQuery.visibility: object expected");
                        message.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.fromObject(object.visibility);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OverrideQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.OverrideQuery} message OverrideQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OverrideQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.selection != null && message.hasOwnProperty("selection")) {
                        object.selection = $root.vertexvis.protobuf.stream.SelectionQuery.toObject(message.selection, options);
                        if (options.oneofs)
                            object.override = "selection";
                    }
                    if (message.visibility != null && message.hasOwnProperty("visibility")) {
                        object.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.toObject(message.visibility, options);
                        if (options.oneofs)
                            object.override = "visibility";
                    }
                    return object;
                };

                /**
                 * Converts this OverrideQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.OverrideQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OverrideQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OverrideQuery;
            })();

            stream.ChangeMaterialOperation = (function() {

                /**
                 * Properties of a ChangeMaterialOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangeMaterialOperation
                 * @property {vertexvis.protobuf.core.IColorMaterial|null} [material] ChangeMaterialOperation material
                 * @property {vertexvis.protobuf.core.IMaterialOverride|null} [materialOverride] ChangeMaterialOperation materialOverride
                 */

                /**
                 * Constructs a new ChangeMaterialOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangeMaterialOperation.
                 * @implements IChangeMaterialOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangeMaterialOperation=} [properties] Properties to set
                 */
                function ChangeMaterialOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangeMaterialOperation material.
                 * @member {vertexvis.protobuf.core.IColorMaterial|null|undefined} material
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @instance
                 */
                ChangeMaterialOperation.prototype.material = null;

                /**
                 * ChangeMaterialOperation materialOverride.
                 * @member {vertexvis.protobuf.core.IMaterialOverride|null|undefined} materialOverride
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @instance
                 */
                ChangeMaterialOperation.prototype.materialOverride = null;

                /**
                 * Creates a new ChangeMaterialOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeMaterialOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangeMaterialOperation} ChangeMaterialOperation instance
                 */
                ChangeMaterialOperation.create = function create(properties) {
                    return new ChangeMaterialOperation(properties);
                };

                /**
                 * Encodes the specified ChangeMaterialOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangeMaterialOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeMaterialOperation} message ChangeMaterialOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeMaterialOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.material != null && Object.hasOwnProperty.call(message, "material"))
                        $root.vertexvis.protobuf.core.ColorMaterial.encode(message.material, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.materialOverride != null && Object.hasOwnProperty.call(message, "materialOverride"))
                        $root.vertexvis.protobuf.core.MaterialOverride.encode(message.materialOverride, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ChangeMaterialOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangeMaterialOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeMaterialOperation} message ChangeMaterialOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeMaterialOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangeMaterialOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangeMaterialOperation} ChangeMaterialOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeMaterialOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangeMaterialOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.material = $root.vertexvis.protobuf.core.ColorMaterial.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangeMaterialOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangeMaterialOperation} ChangeMaterialOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeMaterialOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangeMaterialOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangeMaterialOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.material != null && message.hasOwnProperty("material")) {
                        let error = $root.vertexvis.protobuf.core.ColorMaterial.verify(message.material);
                        if (error)
                            return "material." + error;
                    }
                    if (message.materialOverride != null && message.hasOwnProperty("materialOverride")) {
                        let error = $root.vertexvis.protobuf.core.MaterialOverride.verify(message.materialOverride);
                        if (error)
                            return "materialOverride." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ChangeMaterialOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangeMaterialOperation} ChangeMaterialOperation
                 */
                ChangeMaterialOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangeMaterialOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangeMaterialOperation();
                    if (object.material != null) {
                        if (typeof object.material !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ChangeMaterialOperation.material: object expected");
                        message.material = $root.vertexvis.protobuf.core.ColorMaterial.fromObject(object.material);
                    }
                    if (object.materialOverride != null) {
                        if (typeof object.materialOverride !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ChangeMaterialOperation.materialOverride: object expected");
                        message.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.fromObject(object.materialOverride);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ChangeMaterialOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangeMaterialOperation} message ChangeMaterialOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangeMaterialOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.material = null;
                        object.materialOverride = null;
                    }
                    if (message.material != null && message.hasOwnProperty("material"))
                        object.material = $root.vertexvis.protobuf.core.ColorMaterial.toObject(message.material, options);
                    if (message.materialOverride != null && message.hasOwnProperty("materialOverride"))
                        object.materialOverride = $root.vertexvis.protobuf.core.MaterialOverride.toObject(message.materialOverride, options);
                    return object;
                };

                /**
                 * Converts this ChangeMaterialOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangeMaterialOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangeMaterialOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangeMaterialOperation;
            })();

            stream.ClearMaterialOperation = (function() {

                /**
                 * Properties of a ClearMaterialOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IClearMaterialOperation
                 */

                /**
                 * Constructs a new ClearMaterialOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ClearMaterialOperation.
                 * @implements IClearMaterialOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IClearMaterialOperation=} [properties] Properties to set
                 */
                function ClearMaterialOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ClearMaterialOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearMaterialOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ClearMaterialOperation} ClearMaterialOperation instance
                 */
                ClearMaterialOperation.create = function create(properties) {
                    return new ClearMaterialOperation(properties);
                };

                /**
                 * Encodes the specified ClearMaterialOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ClearMaterialOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearMaterialOperation} message ClearMaterialOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearMaterialOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ClearMaterialOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ClearMaterialOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearMaterialOperation} message ClearMaterialOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearMaterialOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClearMaterialOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ClearMaterialOperation} ClearMaterialOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearMaterialOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ClearMaterialOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClearMaterialOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ClearMaterialOperation} ClearMaterialOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearMaterialOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClearMaterialOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClearMaterialOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ClearMaterialOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ClearMaterialOperation} ClearMaterialOperation
                 */
                ClearMaterialOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ClearMaterialOperation)
                        return object;
                    return new $root.vertexvis.protobuf.stream.ClearMaterialOperation();
                };

                /**
                 * Creates a plain object from a ClearMaterialOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ClearMaterialOperation} message ClearMaterialOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClearMaterialOperation.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ClearMaterialOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ClearMaterialOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClearMaterialOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ClearMaterialOperation;
            })();

            stream.ChangeVisibilityOperation = (function() {

                /**
                 * Properties of a ChangeVisibilityOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangeVisibilityOperation
                 * @property {boolean|null} [visible] ChangeVisibilityOperation visible
                 */

                /**
                 * Constructs a new ChangeVisibilityOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangeVisibilityOperation.
                 * @implements IChangeVisibilityOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangeVisibilityOperation=} [properties] Properties to set
                 */
                function ChangeVisibilityOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangeVisibilityOperation visible.
                 * @member {boolean} visible
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @instance
                 */
                ChangeVisibilityOperation.prototype.visible = false;

                /**
                 * Creates a new ChangeVisibilityOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeVisibilityOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangeVisibilityOperation} ChangeVisibilityOperation instance
                 */
                ChangeVisibilityOperation.create = function create(properties) {
                    return new ChangeVisibilityOperation(properties);
                };

                /**
                 * Encodes the specified ChangeVisibilityOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangeVisibilityOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeVisibilityOperation} message ChangeVisibilityOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeVisibilityOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.visible != null && Object.hasOwnProperty.call(message, "visible"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.visible);
                    return writer;
                };

                /**
                 * Encodes the specified ChangeVisibilityOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangeVisibilityOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeVisibilityOperation} message ChangeVisibilityOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeVisibilityOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangeVisibilityOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangeVisibilityOperation} ChangeVisibilityOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeVisibilityOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangeVisibilityOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.visible = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangeVisibilityOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangeVisibilityOperation} ChangeVisibilityOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeVisibilityOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangeVisibilityOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangeVisibilityOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.visible != null && message.hasOwnProperty("visible"))
                        if (typeof message.visible !== "boolean")
                            return "visible: boolean expected";
                    return null;
                };

                /**
                 * Creates a ChangeVisibilityOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangeVisibilityOperation} ChangeVisibilityOperation
                 */
                ChangeVisibilityOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangeVisibilityOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangeVisibilityOperation();
                    if (object.visible != null)
                        message.visible = Boolean(object.visible);
                    return message;
                };

                /**
                 * Creates a plain object from a ChangeVisibilityOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangeVisibilityOperation} message ChangeVisibilityOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangeVisibilityOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.visible = false;
                    if (message.visible != null && message.hasOwnProperty("visible"))
                        object.visible = message.visible;
                    return object;
                };

                /**
                 * Converts this ChangeVisibilityOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangeVisibilityOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangeVisibilityOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangeVisibilityOperation;
            })();

            stream.ChangeTransformOperation = (function() {

                /**
                 * Properties of a ChangeTransformOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangeTransformOperation
                 * @property {vertexvis.protobuf.core.IMatrix4x4f|null} [transform] ChangeTransformOperation transform
                 */

                /**
                 * Constructs a new ChangeTransformOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangeTransformOperation.
                 * @implements IChangeTransformOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangeTransformOperation=} [properties] Properties to set
                 */
                function ChangeTransformOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangeTransformOperation transform.
                 * @member {vertexvis.protobuf.core.IMatrix4x4f|null|undefined} transform
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @instance
                 */
                ChangeTransformOperation.prototype.transform = null;

                /**
                 * Creates a new ChangeTransformOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeTransformOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangeTransformOperation} ChangeTransformOperation instance
                 */
                ChangeTransformOperation.create = function create(properties) {
                    return new ChangeTransformOperation(properties);
                };

                /**
                 * Encodes the specified ChangeTransformOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangeTransformOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeTransformOperation} message ChangeTransformOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeTransformOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.Matrix4x4f.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ChangeTransformOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangeTransformOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeTransformOperation} message ChangeTransformOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeTransformOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangeTransformOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangeTransformOperation} ChangeTransformOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeTransformOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangeTransformOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.core.Matrix4x4f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangeTransformOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangeTransformOperation} ChangeTransformOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeTransformOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangeTransformOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangeTransformOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.Matrix4x4f.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ChangeTransformOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangeTransformOperation} ChangeTransformOperation
                 */
                ChangeTransformOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangeTransformOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangeTransformOperation();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ChangeTransformOperation.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.Matrix4x4f.fromObject(object.transform);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ChangeTransformOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangeTransformOperation} message ChangeTransformOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangeTransformOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.transform = null;
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.Matrix4x4f.toObject(message.transform, options);
                    return object;
                };

                /**
                 * Converts this ChangeTransformOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangeTransformOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangeTransformOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangeTransformOperation;
            })();

            stream.ChangeSelectionOperation = (function() {

                /**
                 * Properties of a ChangeSelectionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangeSelectionOperation
                 * @property {vertexvis.protobuf.core.IColorMaterial|null} [material] ChangeSelectionOperation material
                 * @property {boolean|null} [selected] ChangeSelectionOperation selected
                 */

                /**
                 * Constructs a new ChangeSelectionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangeSelectionOperation.
                 * @implements IChangeSelectionOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangeSelectionOperation=} [properties] Properties to set
                 */
                function ChangeSelectionOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangeSelectionOperation material.
                 * @member {vertexvis.protobuf.core.IColorMaterial|null|undefined} material
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @instance
                 */
                ChangeSelectionOperation.prototype.material = null;

                /**
                 * ChangeSelectionOperation selected.
                 * @member {boolean} selected
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @instance
                 */
                ChangeSelectionOperation.prototype.selected = false;

                /**
                 * Creates a new ChangeSelectionOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeSelectionOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangeSelectionOperation} ChangeSelectionOperation instance
                 */
                ChangeSelectionOperation.create = function create(properties) {
                    return new ChangeSelectionOperation(properties);
                };

                /**
                 * Encodes the specified ChangeSelectionOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangeSelectionOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeSelectionOperation} message ChangeSelectionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeSelectionOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.material != null && Object.hasOwnProperty.call(message, "material"))
                        $root.vertexvis.protobuf.core.ColorMaterial.encode(message.material, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.selected != null && Object.hasOwnProperty.call(message, "selected"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.selected);
                    return writer;
                };

                /**
                 * Encodes the specified ChangeSelectionOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangeSelectionOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeSelectionOperation} message ChangeSelectionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeSelectionOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangeSelectionOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangeSelectionOperation} ChangeSelectionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeSelectionOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangeSelectionOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.material = $root.vertexvis.protobuf.core.ColorMaterial.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.selected = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangeSelectionOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangeSelectionOperation} ChangeSelectionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeSelectionOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangeSelectionOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangeSelectionOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.material != null && message.hasOwnProperty("material")) {
                        let error = $root.vertexvis.protobuf.core.ColorMaterial.verify(message.material);
                        if (error)
                            return "material." + error;
                    }
                    if (message.selected != null && message.hasOwnProperty("selected"))
                        if (typeof message.selected !== "boolean")
                            return "selected: boolean expected";
                    return null;
                };

                /**
                 * Creates a ChangeSelectionOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangeSelectionOperation} ChangeSelectionOperation
                 */
                ChangeSelectionOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangeSelectionOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangeSelectionOperation();
                    if (object.material != null) {
                        if (typeof object.material !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ChangeSelectionOperation.material: object expected");
                        message.material = $root.vertexvis.protobuf.core.ColorMaterial.fromObject(object.material);
                    }
                    if (object.selected != null)
                        message.selected = Boolean(object.selected);
                    return message;
                };

                /**
                 * Creates a plain object from a ChangeSelectionOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangeSelectionOperation} message ChangeSelectionOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangeSelectionOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.material = null;
                        object.selected = false;
                    }
                    if (message.material != null && message.hasOwnProperty("material"))
                        object.material = $root.vertexvis.protobuf.core.ColorMaterial.toObject(message.material, options);
                    if (message.selected != null && message.hasOwnProperty("selected"))
                        object.selected = message.selected;
                    return object;
                };

                /**
                 * Converts this ChangeSelectionOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangeSelectionOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangeSelectionOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangeSelectionOperation;
            })();

            stream.ClearTransformOperation = (function() {

                /**
                 * Properties of a ClearTransformOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IClearTransformOperation
                 * @property {boolean|null} [cascade] ClearTransformOperation cascade
                 */

                /**
                 * Constructs a new ClearTransformOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ClearTransformOperation.
                 * @implements IClearTransformOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IClearTransformOperation=} [properties] Properties to set
                 */
                function ClearTransformOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClearTransformOperation cascade.
                 * @member {boolean} cascade
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @instance
                 */
                ClearTransformOperation.prototype.cascade = false;

                /**
                 * Creates a new ClearTransformOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearTransformOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ClearTransformOperation} ClearTransformOperation instance
                 */
                ClearTransformOperation.create = function create(properties) {
                    return new ClearTransformOperation(properties);
                };

                /**
                 * Encodes the specified ClearTransformOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ClearTransformOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearTransformOperation} message ClearTransformOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearTransformOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.cascade != null && Object.hasOwnProperty.call(message, "cascade"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.cascade);
                    return writer;
                };

                /**
                 * Encodes the specified ClearTransformOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ClearTransformOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearTransformOperation} message ClearTransformOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearTransformOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClearTransformOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ClearTransformOperation} ClearTransformOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearTransformOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ClearTransformOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.cascade = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClearTransformOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ClearTransformOperation} ClearTransformOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearTransformOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClearTransformOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClearTransformOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.cascade != null && message.hasOwnProperty("cascade"))
                        if (typeof message.cascade !== "boolean")
                            return "cascade: boolean expected";
                    return null;
                };

                /**
                 * Creates a ClearTransformOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ClearTransformOperation} ClearTransformOperation
                 */
                ClearTransformOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ClearTransformOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ClearTransformOperation();
                    if (object.cascade != null)
                        message.cascade = Boolean(object.cascade);
                    return message;
                };

                /**
                 * Creates a plain object from a ClearTransformOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ClearTransformOperation} message ClearTransformOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClearTransformOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.cascade = false;
                    if (message.cascade != null && message.hasOwnProperty("cascade"))
                        object.cascade = message.cascade;
                    return object;
                };

                /**
                 * Converts this ClearTransformOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ClearTransformOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClearTransformOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ClearTransformOperation;
            })();

            stream.ChangePhantomOperation = (function() {

                /**
                 * Properties of a ChangePhantomOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangePhantomOperation
                 * @property {boolean|null} [phantom] ChangePhantomOperation phantom
                 */

                /**
                 * Constructs a new ChangePhantomOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangePhantomOperation.
                 * @implements IChangePhantomOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangePhantomOperation=} [properties] Properties to set
                 */
                function ChangePhantomOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangePhantomOperation phantom.
                 * @member {boolean} phantom
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @instance
                 */
                ChangePhantomOperation.prototype.phantom = false;

                /**
                 * Creates a new ChangePhantomOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangePhantomOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangePhantomOperation} ChangePhantomOperation instance
                 */
                ChangePhantomOperation.create = function create(properties) {
                    return new ChangePhantomOperation(properties);
                };

                /**
                 * Encodes the specified ChangePhantomOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangePhantomOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangePhantomOperation} message ChangePhantomOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangePhantomOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.phantom != null && Object.hasOwnProperty.call(message, "phantom"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.phantom);
                    return writer;
                };

                /**
                 * Encodes the specified ChangePhantomOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangePhantomOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangePhantomOperation} message ChangePhantomOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangePhantomOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangePhantomOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangePhantomOperation} ChangePhantomOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangePhantomOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangePhantomOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.phantom = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangePhantomOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangePhantomOperation} ChangePhantomOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangePhantomOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangePhantomOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangePhantomOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.phantom != null && message.hasOwnProperty("phantom"))
                        if (typeof message.phantom !== "boolean")
                            return "phantom: boolean expected";
                    return null;
                };

                /**
                 * Creates a ChangePhantomOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangePhantomOperation} ChangePhantomOperation
                 */
                ChangePhantomOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangePhantomOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangePhantomOperation();
                    if (object.phantom != null)
                        message.phantom = Boolean(object.phantom);
                    return message;
                };

                /**
                 * Creates a plain object from a ChangePhantomOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangePhantomOperation} message ChangePhantomOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangePhantomOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.phantom = false;
                    if (message.phantom != null && message.hasOwnProperty("phantom"))
                        object.phantom = message.phantom;
                    return object;
                };

                /**
                 * Converts this ChangePhantomOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangePhantomOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangePhantomOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangePhantomOperation;
            })();

            stream.ChangeEndItemOperation = (function() {

                /**
                 * Properties of a ChangeEndItemOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IChangeEndItemOperation
                 * @property {boolean|null} [endItem] ChangeEndItemOperation endItem
                 */

                /**
                 * Constructs a new ChangeEndItemOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ChangeEndItemOperation.
                 * @implements IChangeEndItemOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IChangeEndItemOperation=} [properties] Properties to set
                 */
                function ChangeEndItemOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChangeEndItemOperation endItem.
                 * @member {boolean} endItem
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @instance
                 */
                ChangeEndItemOperation.prototype.endItem = false;

                /**
                 * Creates a new ChangeEndItemOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeEndItemOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ChangeEndItemOperation} ChangeEndItemOperation instance
                 */
                ChangeEndItemOperation.create = function create(properties) {
                    return new ChangeEndItemOperation(properties);
                };

                /**
                 * Encodes the specified ChangeEndItemOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ChangeEndItemOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeEndItemOperation} message ChangeEndItemOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeEndItemOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.endItem != null && Object.hasOwnProperty.call(message, "endItem"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.endItem);
                    return writer;
                };

                /**
                 * Encodes the specified ChangeEndItemOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ChangeEndItemOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IChangeEndItemOperation} message ChangeEndItemOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChangeEndItemOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ChangeEndItemOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ChangeEndItemOperation} ChangeEndItemOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeEndItemOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ChangeEndItemOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.endItem = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ChangeEndItemOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ChangeEndItemOperation} ChangeEndItemOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChangeEndItemOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChangeEndItemOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChangeEndItemOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.endItem != null && message.hasOwnProperty("endItem"))
                        if (typeof message.endItem !== "boolean")
                            return "endItem: boolean expected";
                    return null;
                };

                /**
                 * Creates a ChangeEndItemOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ChangeEndItemOperation} ChangeEndItemOperation
                 */
                ChangeEndItemOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ChangeEndItemOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ChangeEndItemOperation();
                    if (object.endItem != null)
                        message.endItem = Boolean(object.endItem);
                    return message;
                };

                /**
                 * Creates a plain object from a ChangeEndItemOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ChangeEndItemOperation} message ChangeEndItemOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChangeEndItemOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.endItem = false;
                    if (message.endItem != null && message.hasOwnProperty("endItem"))
                        object.endItem = message.endItem;
                    return object;
                };

                /**
                 * Converts this ChangeEndItemOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ChangeEndItemOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChangeEndItemOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ChangeEndItemOperation;
            })();

            stream.ViewRenditionOperation = (function() {

                /**
                 * Properties of a ViewRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IViewRenditionOperation
                 * @property {vertexvis.protobuf.core.IUuid|null} [id] ViewRenditionOperation id
                 * @property {string|null} [suppliedId] ViewRenditionOperation suppliedId
                 */

                /**
                 * Constructs a new ViewRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ViewRenditionOperation.
                 * @implements IViewRenditionOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IViewRenditionOperation=} [properties] Properties to set
                 */
                function ViewRenditionOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ViewRenditionOperation id.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} id
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @instance
                 */
                ViewRenditionOperation.prototype.id = null;

                /**
                 * ViewRenditionOperation suppliedId.
                 * @member {string|null|undefined} suppliedId
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @instance
                 */
                ViewRenditionOperation.prototype.suppliedId = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * ViewRenditionOperation rendition.
                 * @member {"id"|"suppliedId"|undefined} rendition
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @instance
                 */
                Object.defineProperty(ViewRenditionOperation.prototype, "rendition", {
                    get: $util.oneOfGetter($oneOfFields = ["id", "suppliedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ViewRenditionOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRenditionOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ViewRenditionOperation} ViewRenditionOperation instance
                 */
                ViewRenditionOperation.create = function create(properties) {
                    return new ViewRenditionOperation(properties);
                };

                /**
                 * Encodes the specified ViewRenditionOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ViewRenditionOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRenditionOperation} message ViewRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewRenditionOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.suppliedId != null && Object.hasOwnProperty.call(message, "suppliedId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.suppliedId);
                    return writer;
                };

                /**
                 * Encodes the specified ViewRenditionOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ViewRenditionOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRenditionOperation} message ViewRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewRenditionOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ViewRenditionOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ViewRenditionOperation} ViewRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewRenditionOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ViewRenditionOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.suppliedId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ViewRenditionOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ViewRenditionOperation} ViewRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewRenditionOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ViewRenditionOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ViewRenditionOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        properties.rendition = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.id);
                            if (error)
                                return "id." + error;
                        }
                    }
                    if (message.suppliedId != null && message.hasOwnProperty("suppliedId")) {
                        if (properties.rendition === 1)
                            return "rendition: multiple values";
                        properties.rendition = 1;
                        if (!$util.isString(message.suppliedId))
                            return "suppliedId: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a ViewRenditionOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ViewRenditionOperation} ViewRenditionOperation
                 */
                ViewRenditionOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ViewRenditionOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ViewRenditionOperation();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ViewRenditionOperation.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid.fromObject(object.id);
                    }
                    if (object.suppliedId != null)
                        message.suppliedId = String(object.suppliedId);
                    return message;
                };

                /**
                 * Creates a plain object from a ViewRenditionOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ViewRenditionOperation} message ViewRenditionOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ViewRenditionOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        object.id = $root.vertexvis.protobuf.core.Uuid.toObject(message.id, options);
                        if (options.oneofs)
                            object.rendition = "id";
                    }
                    if (message.suppliedId != null && message.hasOwnProperty("suppliedId")) {
                        object.suppliedId = message.suppliedId;
                        if (options.oneofs)
                            object.rendition = "suppliedId";
                    }
                    return object;
                };

                /**
                 * Converts this ViewRenditionOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ViewRenditionOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ViewRenditionOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ViewRenditionOperation;
            })();

            stream.ViewDefaultRenditionOperation = (function() {

                /**
                 * Properties of a ViewDefaultRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IViewDefaultRenditionOperation
                 */

                /**
                 * Constructs a new ViewDefaultRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ViewDefaultRenditionOperation.
                 * @implements IViewDefaultRenditionOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IViewDefaultRenditionOperation=} [properties] Properties to set
                 */
                function ViewDefaultRenditionOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ViewDefaultRenditionOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewDefaultRenditionOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ViewDefaultRenditionOperation} ViewDefaultRenditionOperation instance
                 */
                ViewDefaultRenditionOperation.create = function create(properties) {
                    return new ViewDefaultRenditionOperation(properties);
                };

                /**
                 * Encodes the specified ViewDefaultRenditionOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ViewDefaultRenditionOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewDefaultRenditionOperation} message ViewDefaultRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewDefaultRenditionOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ViewDefaultRenditionOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ViewDefaultRenditionOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewDefaultRenditionOperation} message ViewDefaultRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewDefaultRenditionOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ViewDefaultRenditionOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ViewDefaultRenditionOperation} ViewDefaultRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewDefaultRenditionOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ViewDefaultRenditionOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ViewDefaultRenditionOperation} ViewDefaultRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewDefaultRenditionOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ViewDefaultRenditionOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ViewDefaultRenditionOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ViewDefaultRenditionOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ViewDefaultRenditionOperation} ViewDefaultRenditionOperation
                 */
                ViewDefaultRenditionOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation)
                        return object;
                    return new $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation();
                };

                /**
                 * Creates a plain object from a ViewDefaultRenditionOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ViewDefaultRenditionOperation} message ViewDefaultRenditionOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ViewDefaultRenditionOperation.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ViewDefaultRenditionOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ViewDefaultRenditionOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ViewDefaultRenditionOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ViewDefaultRenditionOperation;
            })();

            stream.ClearRenditionOperation = (function() {

                /**
                 * Properties of a ClearRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IClearRenditionOperation
                 */

                /**
                 * Constructs a new ClearRenditionOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ClearRenditionOperation.
                 * @implements IClearRenditionOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IClearRenditionOperation=} [properties] Properties to set
                 */
                function ClearRenditionOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ClearRenditionOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRenditionOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ClearRenditionOperation} ClearRenditionOperation instance
                 */
                ClearRenditionOperation.create = function create(properties) {
                    return new ClearRenditionOperation(properties);
                };

                /**
                 * Encodes the specified ClearRenditionOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ClearRenditionOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRenditionOperation} message ClearRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearRenditionOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ClearRenditionOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ClearRenditionOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRenditionOperation} message ClearRenditionOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearRenditionOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClearRenditionOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ClearRenditionOperation} ClearRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearRenditionOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ClearRenditionOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClearRenditionOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ClearRenditionOperation} ClearRenditionOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearRenditionOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClearRenditionOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClearRenditionOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ClearRenditionOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ClearRenditionOperation} ClearRenditionOperation
                 */
                ClearRenditionOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ClearRenditionOperation)
                        return object;
                    return new $root.vertexvis.protobuf.stream.ClearRenditionOperation();
                };

                /**
                 * Creates a plain object from a ClearRenditionOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ClearRenditionOperation} message ClearRenditionOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClearRenditionOperation.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ClearRenditionOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ClearRenditionOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClearRenditionOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ClearRenditionOperation;
            })();

            /**
             * RepresentationPredefinedId enum.
             * @name vertexvis.protobuf.stream.RepresentationPredefinedId
             * @enum {number}
             * @property {number} REPRESENTATION_PREDEFINED_ID_INVALID=0 REPRESENTATION_PREDEFINED_ID_INVALID value
             * @property {number} REPRESENTATION_PREDEFINED_ID_EMPTY=1 REPRESENTATION_PREDEFINED_ID_EMPTY value
             * @property {number} REPRESENTATION_PREDEFINED_ID_ENTIRE_PART=2 REPRESENTATION_PREDEFINED_ID_ENTIRE_PART value
             */
            stream.RepresentationPredefinedId = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "REPRESENTATION_PREDEFINED_ID_INVALID"] = 0;
                values[valuesById[1] = "REPRESENTATION_PREDEFINED_ID_EMPTY"] = 1;
                values[valuesById[2] = "REPRESENTATION_PREDEFINED_ID_ENTIRE_PART"] = 2;
                return values;
            })();

            stream.ViewRepresentationOperation = (function() {

                /**
                 * Properties of a ViewRepresentationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IViewRepresentationOperation
                 * @property {vertexvis.protobuf.core.IUuid|null} [id] ViewRepresentationOperation id
                 * @property {vertexvis.protobuf.stream.RepresentationPredefinedId|null} [predefinedId] ViewRepresentationOperation predefinedId
                 */

                /**
                 * Constructs a new ViewRepresentationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ViewRepresentationOperation.
                 * @implements IViewRepresentationOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IViewRepresentationOperation=} [properties] Properties to set
                 */
                function ViewRepresentationOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ViewRepresentationOperation id.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} id
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @instance
                 */
                ViewRepresentationOperation.prototype.id = null;

                /**
                 * ViewRepresentationOperation predefinedId.
                 * @member {vertexvis.protobuf.stream.RepresentationPredefinedId|null|undefined} predefinedId
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @instance
                 */
                ViewRepresentationOperation.prototype.predefinedId = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * ViewRepresentationOperation representation.
                 * @member {"id"|"predefinedId"|undefined} representation
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @instance
                 */
                Object.defineProperty(ViewRepresentationOperation.prototype, "representation", {
                    get: $util.oneOfGetter($oneOfFields = ["id", "predefinedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ViewRepresentationOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRepresentationOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ViewRepresentationOperation} ViewRepresentationOperation instance
                 */
                ViewRepresentationOperation.create = function create(properties) {
                    return new ViewRepresentationOperation(properties);
                };

                /**
                 * Encodes the specified ViewRepresentationOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ViewRepresentationOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRepresentationOperation} message ViewRepresentationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewRepresentationOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.predefinedId != null && Object.hasOwnProperty.call(message, "predefinedId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.predefinedId);
                    return writer;
                };

                /**
                 * Encodes the specified ViewRepresentationOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ViewRepresentationOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IViewRepresentationOperation} message ViewRepresentationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ViewRepresentationOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ViewRepresentationOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ViewRepresentationOperation} ViewRepresentationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewRepresentationOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ViewRepresentationOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.predefinedId = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ViewRepresentationOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ViewRepresentationOperation} ViewRepresentationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ViewRepresentationOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ViewRepresentationOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ViewRepresentationOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        properties.representation = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.id);
                            if (error)
                                return "id." + error;
                        }
                    }
                    if (message.predefinedId != null && message.hasOwnProperty("predefinedId")) {
                        if (properties.representation === 1)
                            return "representation: multiple values";
                        properties.representation = 1;
                        switch (message.predefinedId) {
                        default:
                            return "predefinedId: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ViewRepresentationOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ViewRepresentationOperation} ViewRepresentationOperation
                 */
                ViewRepresentationOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ViewRepresentationOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ViewRepresentationOperation();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ViewRepresentationOperation.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid.fromObject(object.id);
                    }
                    switch (object.predefinedId) {
                    case "REPRESENTATION_PREDEFINED_ID_INVALID":
                    case 0:
                        message.predefinedId = 0;
                        break;
                    case "REPRESENTATION_PREDEFINED_ID_EMPTY":
                    case 1:
                        message.predefinedId = 1;
                        break;
                    case "REPRESENTATION_PREDEFINED_ID_ENTIRE_PART":
                    case 2:
                        message.predefinedId = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ViewRepresentationOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ViewRepresentationOperation} message ViewRepresentationOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ViewRepresentationOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.id != null && message.hasOwnProperty("id")) {
                        object.id = $root.vertexvis.protobuf.core.Uuid.toObject(message.id, options);
                        if (options.oneofs)
                            object.representation = "id";
                    }
                    if (message.predefinedId != null && message.hasOwnProperty("predefinedId")) {
                        object.predefinedId = options.enums === String ? $root.vertexvis.protobuf.stream.RepresentationPredefinedId[message.predefinedId] : message.predefinedId;
                        if (options.oneofs)
                            object.representation = "predefinedId";
                    }
                    return object;
                };

                /**
                 * Converts this ViewRepresentationOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ViewRepresentationOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ViewRepresentationOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ViewRepresentationOperation;
            })();

            stream.ClearRepresentationOperation = (function() {

                /**
                 * Properties of a ClearRepresentationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IClearRepresentationOperation
                 */

                /**
                 * Constructs a new ClearRepresentationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ClearRepresentationOperation.
                 * @implements IClearRepresentationOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IClearRepresentationOperation=} [properties] Properties to set
                 */
                function ClearRepresentationOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ClearRepresentationOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRepresentationOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ClearRepresentationOperation} ClearRepresentationOperation instance
                 */
                ClearRepresentationOperation.create = function create(properties) {
                    return new ClearRepresentationOperation(properties);
                };

                /**
                 * Encodes the specified ClearRepresentationOperation message. Does not implicitly {@link vertexvis.protobuf.stream.ClearRepresentationOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRepresentationOperation} message ClearRepresentationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearRepresentationOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ClearRepresentationOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ClearRepresentationOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IClearRepresentationOperation} message ClearRepresentationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClearRepresentationOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClearRepresentationOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ClearRepresentationOperation} ClearRepresentationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearRepresentationOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ClearRepresentationOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClearRepresentationOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ClearRepresentationOperation} ClearRepresentationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClearRepresentationOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClearRepresentationOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClearRepresentationOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ClearRepresentationOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ClearRepresentationOperation} ClearRepresentationOperation
                 */
                ClearRepresentationOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ClearRepresentationOperation)
                        return object;
                    return new $root.vertexvis.protobuf.stream.ClearRepresentationOperation();
                };

                /**
                 * Creates a plain object from a ClearRepresentationOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ClearRepresentationOperation} message ClearRepresentationOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClearRepresentationOperation.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ClearRepresentationOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ClearRepresentationOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClearRepresentationOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ClearRepresentationOperation;
            })();

            stream.OperationType = (function() {

                /**
                 * Properties of an OperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IOperationType
                 * @property {vertexvis.protobuf.stream.IChangeMaterialOperation|null} [changeMaterial] OperationType changeMaterial
                 * @property {vertexvis.protobuf.stream.IChangeVisibilityOperation|null} [changeVisibility] OperationType changeVisibility
                 * @property {vertexvis.protobuf.stream.IChangeTransformOperation|null} [changeTransform] OperationType changeTransform
                 * @property {vertexvis.protobuf.stream.IChangeSelectionOperation|null} [changeSelection] OperationType changeSelection
                 * @property {vertexvis.protobuf.stream.IClearTransformOperation|null} [clearTransform] OperationType clearTransform
                 * @property {vertexvis.protobuf.stream.IChangePhantomOperation|null} [changePhantom] OperationType changePhantom
                 * @property {vertexvis.protobuf.stream.IChangeEndItemOperation|null} [changeEndItem] OperationType changeEndItem
                 * @property {vertexvis.protobuf.stream.IViewRenditionOperation|null} [viewRendition] OperationType viewRendition
                 * @property {vertexvis.protobuf.stream.IViewDefaultRenditionOperation|null} [viewDefaultRendition] OperationType viewDefaultRendition
                 * @property {vertexvis.protobuf.stream.IClearRenditionOperation|null} [clearRendition] OperationType clearRendition
                 * @property {vertexvis.protobuf.stream.IViewRepresentationOperation|null} [viewRepresentation] OperationType viewRepresentation
                 * @property {vertexvis.protobuf.stream.IClearRepresentationOperation|null} [clearRepresentation] OperationType clearRepresentation
                 * @property {vertexvis.protobuf.stream.IClearMaterialOperation|null} [clearMaterial] OperationType clearMaterial
                 */

                /**
                 * Constructs a new OperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an OperationType.
                 * @implements IOperationType
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IOperationType=} [properties] Properties to set
                 */
                function OperationType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OperationType changeMaterial.
                 * @member {vertexvis.protobuf.stream.IChangeMaterialOperation|null|undefined} changeMaterial
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changeMaterial = null;

                /**
                 * OperationType changeVisibility.
                 * @member {vertexvis.protobuf.stream.IChangeVisibilityOperation|null|undefined} changeVisibility
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changeVisibility = null;

                /**
                 * OperationType changeTransform.
                 * @member {vertexvis.protobuf.stream.IChangeTransformOperation|null|undefined} changeTransform
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changeTransform = null;

                /**
                 * OperationType changeSelection.
                 * @member {vertexvis.protobuf.stream.IChangeSelectionOperation|null|undefined} changeSelection
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changeSelection = null;

                /**
                 * OperationType clearTransform.
                 * @member {vertexvis.protobuf.stream.IClearTransformOperation|null|undefined} clearTransform
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.clearTransform = null;

                /**
                 * OperationType changePhantom.
                 * @member {vertexvis.protobuf.stream.IChangePhantomOperation|null|undefined} changePhantom
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changePhantom = null;

                /**
                 * OperationType changeEndItem.
                 * @member {vertexvis.protobuf.stream.IChangeEndItemOperation|null|undefined} changeEndItem
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.changeEndItem = null;

                /**
                 * OperationType viewRendition.
                 * @member {vertexvis.protobuf.stream.IViewRenditionOperation|null|undefined} viewRendition
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.viewRendition = null;

                /**
                 * OperationType viewDefaultRendition.
                 * @member {vertexvis.protobuf.stream.IViewDefaultRenditionOperation|null|undefined} viewDefaultRendition
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.viewDefaultRendition = null;

                /**
                 * OperationType clearRendition.
                 * @member {vertexvis.protobuf.stream.IClearRenditionOperation|null|undefined} clearRendition
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.clearRendition = null;

                /**
                 * OperationType viewRepresentation.
                 * @member {vertexvis.protobuf.stream.IViewRepresentationOperation|null|undefined} viewRepresentation
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.viewRepresentation = null;

                /**
                 * OperationType clearRepresentation.
                 * @member {vertexvis.protobuf.stream.IClearRepresentationOperation|null|undefined} clearRepresentation
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.clearRepresentation = null;

                /**
                 * OperationType clearMaterial.
                 * @member {vertexvis.protobuf.stream.IClearMaterialOperation|null|undefined} clearMaterial
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                OperationType.prototype.clearMaterial = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * OperationType value.
                 * @member {"changeMaterial"|"changeVisibility"|"changeTransform"|"changeSelection"|"clearTransform"|"changePhantom"|"changeEndItem"|"viewRendition"|"viewDefaultRendition"|"clearRendition"|"viewRepresentation"|"clearRepresentation"|"clearMaterial"|undefined} value
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 */
                Object.defineProperty(OperationType.prototype, "value", {
                    get: $util.oneOfGetter($oneOfFields = ["changeMaterial", "changeVisibility", "changeTransform", "changeSelection", "clearTransform", "changePhantom", "changeEndItem", "viewRendition", "viewDefaultRendition", "clearRendition", "viewRepresentation", "clearRepresentation", "clearMaterial"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new OperationType instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IOperationType=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.OperationType} OperationType instance
                 */
                OperationType.create = function create(properties) {
                    return new OperationType(properties);
                };

                /**
                 * Encodes the specified OperationType message. Does not implicitly {@link vertexvis.protobuf.stream.OperationType.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IOperationType} message OperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OperationType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.changeMaterial != null && Object.hasOwnProperty.call(message, "changeMaterial"))
                        $root.vertexvis.protobuf.stream.ChangeMaterialOperation.encode(message.changeMaterial, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.changeVisibility != null && Object.hasOwnProperty.call(message, "changeVisibility"))
                        $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.encode(message.changeVisibility, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.changeTransform != null && Object.hasOwnProperty.call(message, "changeTransform"))
                        $root.vertexvis.protobuf.stream.ChangeTransformOperation.encode(message.changeTransform, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.changeSelection != null && Object.hasOwnProperty.call(message, "changeSelection"))
                        $root.vertexvis.protobuf.stream.ChangeSelectionOperation.encode(message.changeSelection, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.clearTransform != null && Object.hasOwnProperty.call(message, "clearTransform"))
                        $root.vertexvis.protobuf.stream.ClearTransformOperation.encode(message.clearTransform, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.changePhantom != null && Object.hasOwnProperty.call(message, "changePhantom"))
                        $root.vertexvis.protobuf.stream.ChangePhantomOperation.encode(message.changePhantom, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.changeEndItem != null && Object.hasOwnProperty.call(message, "changeEndItem"))
                        $root.vertexvis.protobuf.stream.ChangeEndItemOperation.encode(message.changeEndItem, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.viewRendition != null && Object.hasOwnProperty.call(message, "viewRendition"))
                        $root.vertexvis.protobuf.stream.ViewRenditionOperation.encode(message.viewRendition, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.viewDefaultRendition != null && Object.hasOwnProperty.call(message, "viewDefaultRendition"))
                        $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.encode(message.viewDefaultRendition, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.clearRendition != null && Object.hasOwnProperty.call(message, "clearRendition"))
                        $root.vertexvis.protobuf.stream.ClearRenditionOperation.encode(message.clearRendition, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.viewRepresentation != null && Object.hasOwnProperty.call(message, "viewRepresentation"))
                        $root.vertexvis.protobuf.stream.ViewRepresentationOperation.encode(message.viewRepresentation, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.clearRepresentation != null && Object.hasOwnProperty.call(message, "clearRepresentation"))
                        $root.vertexvis.protobuf.stream.ClearRepresentationOperation.encode(message.clearRepresentation, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.clearMaterial != null && Object.hasOwnProperty.call(message, "clearMaterial"))
                        $root.vertexvis.protobuf.stream.ClearMaterialOperation.encode(message.clearMaterial, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OperationType message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.OperationType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IOperationType} message OperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OperationType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OperationType message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.OperationType} OperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OperationType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.OperationType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OperationType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.OperationType} OperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OperationType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OperationType message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OperationType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.changeMaterial != null && message.hasOwnProperty("changeMaterial")) {
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.verify(message.changeMaterial);
                            if (error)
                                return "changeMaterial." + error;
                        }
                    }
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.verify(message.changeVisibility);
                            if (error)
                                return "changeVisibility." + error;
                        }
                    }
                    if (message.changeTransform != null && message.hasOwnProperty("changeTransform")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeTransformOperation.verify(message.changeTransform);
                            if (error)
                                return "changeTransform." + error;
                        }
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.verify(message.changeSelection);
                            if (error)
                                return "changeSelection." + error;
                        }
                    }
                    if (message.clearTransform != null && message.hasOwnProperty("clearTransform")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearTransformOperation.verify(message.clearTransform);
                            if (error)
                                return "clearTransform." + error;
                        }
                    }
                    if (message.changePhantom != null && message.hasOwnProperty("changePhantom")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangePhantomOperation.verify(message.changePhantom);
                            if (error)
                                return "changePhantom." + error;
                        }
                    }
                    if (message.changeEndItem != null && message.hasOwnProperty("changeEndItem")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.verify(message.changeEndItem);
                            if (error)
                                return "changeEndItem." + error;
                        }
                    }
                    if (message.viewRendition != null && message.hasOwnProperty("viewRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewRenditionOperation.verify(message.viewRendition);
                            if (error)
                                return "viewRendition." + error;
                        }
                    }
                    if (message.viewDefaultRendition != null && message.hasOwnProperty("viewDefaultRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.verify(message.viewDefaultRendition);
                            if (error)
                                return "viewDefaultRendition." + error;
                        }
                    }
                    if (message.clearRendition != null && message.hasOwnProperty("clearRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearRenditionOperation.verify(message.clearRendition);
                            if (error)
                                return "clearRendition." + error;
                        }
                    }
                    if (message.viewRepresentation != null && message.hasOwnProperty("viewRepresentation")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.verify(message.viewRepresentation);
                            if (error)
                                return "viewRepresentation." + error;
                        }
                    }
                    if (message.clearRepresentation != null && message.hasOwnProperty("clearRepresentation")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.verify(message.clearRepresentation);
                            if (error)
                                return "clearRepresentation." + error;
                        }
                    }
                    if (message.clearMaterial != null && message.hasOwnProperty("clearMaterial")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearMaterialOperation.verify(message.clearMaterial);
                            if (error)
                                return "clearMaterial." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OperationType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.OperationType} OperationType
                 */
                OperationType.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.OperationType)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.OperationType();
                    if (object.changeMaterial != null) {
                        if (typeof object.changeMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changeMaterial: object expected");
                        message.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.fromObject(object.changeMaterial);
                    }
                    if (object.changeVisibility != null) {
                        if (typeof object.changeVisibility !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changeVisibility: object expected");
                        message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.fromObject(object.changeVisibility);
                    }
                    if (object.changeTransform != null) {
                        if (typeof object.changeTransform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changeTransform: object expected");
                        message.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.fromObject(object.changeTransform);
                    }
                    if (object.changeSelection != null) {
                        if (typeof object.changeSelection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changeSelection: object expected");
                        message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.fromObject(object.changeSelection);
                    }
                    if (object.clearTransform != null) {
                        if (typeof object.clearTransform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.clearTransform: object expected");
                        message.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.fromObject(object.clearTransform);
                    }
                    if (object.changePhantom != null) {
                        if (typeof object.changePhantom !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changePhantom: object expected");
                        message.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.fromObject(object.changePhantom);
                    }
                    if (object.changeEndItem != null) {
                        if (typeof object.changeEndItem !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.changeEndItem: object expected");
                        message.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.fromObject(object.changeEndItem);
                    }
                    if (object.viewRendition != null) {
                        if (typeof object.viewRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.viewRendition: object expected");
                        message.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.fromObject(object.viewRendition);
                    }
                    if (object.viewDefaultRendition != null) {
                        if (typeof object.viewDefaultRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.viewDefaultRendition: object expected");
                        message.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.fromObject(object.viewDefaultRendition);
                    }
                    if (object.clearRendition != null) {
                        if (typeof object.clearRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.clearRendition: object expected");
                        message.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.fromObject(object.clearRendition);
                    }
                    if (object.viewRepresentation != null) {
                        if (typeof object.viewRepresentation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.viewRepresentation: object expected");
                        message.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.fromObject(object.viewRepresentation);
                    }
                    if (object.clearRepresentation != null) {
                        if (typeof object.clearRepresentation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.clearRepresentation: object expected");
                        message.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.fromObject(object.clearRepresentation);
                    }
                    if (object.clearMaterial != null) {
                        if (typeof object.clearMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OperationType.clearMaterial: object expected");
                        message.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.fromObject(object.clearMaterial);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OperationType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.OperationType} message OperationType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OperationType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.changeMaterial != null && message.hasOwnProperty("changeMaterial")) {
                        object.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.toObject(message.changeMaterial, options);
                        if (options.oneofs)
                            object.value = "changeMaterial";
                    }
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        object.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.toObject(message.changeVisibility, options);
                        if (options.oneofs)
                            object.value = "changeVisibility";
                    }
                    if (message.changeTransform != null && message.hasOwnProperty("changeTransform")) {
                        object.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.toObject(message.changeTransform, options);
                        if (options.oneofs)
                            object.value = "changeTransform";
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        object.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.toObject(message.changeSelection, options);
                        if (options.oneofs)
                            object.value = "changeSelection";
                    }
                    if (message.clearTransform != null && message.hasOwnProperty("clearTransform")) {
                        object.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.toObject(message.clearTransform, options);
                        if (options.oneofs)
                            object.value = "clearTransform";
                    }
                    if (message.changePhantom != null && message.hasOwnProperty("changePhantom")) {
                        object.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.toObject(message.changePhantom, options);
                        if (options.oneofs)
                            object.value = "changePhantom";
                    }
                    if (message.changeEndItem != null && message.hasOwnProperty("changeEndItem")) {
                        object.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.toObject(message.changeEndItem, options);
                        if (options.oneofs)
                            object.value = "changeEndItem";
                    }
                    if (message.viewRendition != null && message.hasOwnProperty("viewRendition")) {
                        object.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.toObject(message.viewRendition, options);
                        if (options.oneofs)
                            object.value = "viewRendition";
                    }
                    if (message.viewDefaultRendition != null && message.hasOwnProperty("viewDefaultRendition")) {
                        object.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.toObject(message.viewDefaultRendition, options);
                        if (options.oneofs)
                            object.value = "viewDefaultRendition";
                    }
                    if (message.clearRendition != null && message.hasOwnProperty("clearRendition")) {
                        object.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.toObject(message.clearRendition, options);
                        if (options.oneofs)
                            object.value = "clearRendition";
                    }
                    if (message.viewRepresentation != null && message.hasOwnProperty("viewRepresentation")) {
                        object.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.toObject(message.viewRepresentation, options);
                        if (options.oneofs)
                            object.value = "viewRepresentation";
                    }
                    if (message.clearRepresentation != null && message.hasOwnProperty("clearRepresentation")) {
                        object.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.toObject(message.clearRepresentation, options);
                        if (options.oneofs)
                            object.value = "clearRepresentation";
                    }
                    if (message.clearMaterial != null && message.hasOwnProperty("clearMaterial")) {
                        object.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.toObject(message.clearMaterial, options);
                        if (options.oneofs)
                            object.value = "clearMaterial";
                    }
                    return object;
                };

                /**
                 * Converts this OperationType to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.OperationType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OperationType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OperationType;
            })();

            stream.QueryOperand = (function() {

                /**
                 * Properties of a QueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IQueryOperand
                 * @property {vertexvis.protobuf.stream.IMetadataFilterQuery|null} [metadata] QueryOperand metadata
                 * @property {vertexvis.protobuf.stream.IItemQuery|null} [item] QueryOperand item
                 * @property {vertexvis.protobuf.stream.IRootQuery|null} [root] QueryOperand root
                 * @property {vertexvis.protobuf.stream.IPointQuery|null} [point] QueryOperand point
                 * @property {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null} [sceneTreeRange] QueryOperand sceneTreeRange
                 * @property {vertexvis.protobuf.stream.IOverrideQuery|null} [override] QueryOperand override
                 * @property {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null} [volume] QueryOperand volume
                 * @property {vertexvis.protobuf.stream.IQueryCollection|null} [itemCollection] QueryOperand itemCollection
                 */

                /**
                 * Constructs a new QueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a QueryOperand.
                 * @implements IQueryOperand
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IQueryOperand=} [properties] Properties to set
                 */
                function QueryOperand(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * QueryOperand metadata.
                 * @member {vertexvis.protobuf.stream.IMetadataFilterQuery|null|undefined} metadata
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.metadata = null;

                /**
                 * QueryOperand item.
                 * @member {vertexvis.protobuf.stream.IItemQuery|null|undefined} item
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.item = null;

                /**
                 * QueryOperand root.
                 * @member {vertexvis.protobuf.stream.IRootQuery|null|undefined} root
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.root = null;

                /**
                 * QueryOperand point.
                 * @member {vertexvis.protobuf.stream.IPointQuery|null|undefined} point
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.point = null;

                /**
                 * QueryOperand sceneTreeRange.
                 * @member {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null|undefined} sceneTreeRange
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.sceneTreeRange = null;

                /**
                 * QueryOperand override.
                 * @member {vertexvis.protobuf.stream.IOverrideQuery|null|undefined} override
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.override = null;

                /**
                 * QueryOperand volume.
                 * @member {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null|undefined} volume
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.volume = null;

                /**
                 * QueryOperand itemCollection.
                 * @member {vertexvis.protobuf.stream.IQueryCollection|null|undefined} itemCollection
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                QueryOperand.prototype.itemCollection = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * QueryOperand operand.
                 * @member {"metadata"|"item"|"root"|"point"|"sceneTreeRange"|"override"|"volume"|"itemCollection"|undefined} operand
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 */
                Object.defineProperty(QueryOperand.prototype, "operand", {
                    get: $util.oneOfGetter($oneOfFields = ["metadata", "item", "root", "point", "sceneTreeRange", "override", "volume", "itemCollection"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new QueryOperand instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryOperand=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.QueryOperand} QueryOperand instance
                 */
                QueryOperand.create = function create(properties) {
                    return new QueryOperand(properties);
                };

                /**
                 * Encodes the specified QueryOperand message. Does not implicitly {@link vertexvis.protobuf.stream.QueryOperand.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryOperand} message QueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryOperand.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                        $root.vertexvis.protobuf.stream.MetadataFilterQuery.encode(message.metadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                        $root.vertexvis.protobuf.stream.ItemQuery.encode(message.item, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.root != null && Object.hasOwnProperty.call(message, "root"))
                        $root.vertexvis.protobuf.stream.RootQuery.encode(message.root, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                        $root.vertexvis.protobuf.stream.PointQuery.encode(message.point, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sceneTreeRange != null && Object.hasOwnProperty.call(message, "sceneTreeRange"))
                        $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.encode(message.sceneTreeRange, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.override != null && Object.hasOwnProperty.call(message, "override"))
                        $root.vertexvis.protobuf.stream.OverrideQuery.encode(message.override, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                        $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.encode(message.volume, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.itemCollection != null && Object.hasOwnProperty.call(message, "itemCollection"))
                        $root.vertexvis.protobuf.stream.QueryCollection.encode(message.itemCollection, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified QueryOperand message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.QueryOperand.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryOperand} message QueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryOperand.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a QueryOperand message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.QueryOperand} QueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryOperand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.QueryOperand();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.item = $root.vertexvis.protobuf.stream.ItemQuery.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.root = $root.vertexvis.protobuf.stream.RootQuery.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.point = $root.vertexvis.protobuf.stream.PointQuery.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.override = $root.vertexvis.protobuf.stream.OverrideQuery.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a QueryOperand message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.QueryOperand} QueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryOperand.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a QueryOperand message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                QueryOperand.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.MetadataFilterQuery.verify(message.metadata);
                            if (error)
                                return "metadata." + error;
                        }
                    }
                    if (message.item != null && message.hasOwnProperty("item")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ItemQuery.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                    }
                    if (message.root != null && message.hasOwnProperty("root")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RootQuery.verify(message.root);
                            if (error)
                                return "root." + error;
                        }
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PointQuery.verify(message.point);
                            if (error)
                                return "point." + error;
                        }
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.verify(message.sceneTreeRange);
                            if (error)
                                return "sceneTreeRange." + error;
                        }
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.OverrideQuery.verify(message.override);
                            if (error)
                                return "override." + error;
                        }
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.verify(message.volume);
                            if (error)
                                return "volume." + error;
                        }
                    }
                    if (message.itemCollection != null && message.hasOwnProperty("itemCollection")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryCollection.verify(message.itemCollection);
                            if (error)
                                return "itemCollection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a QueryOperand message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.QueryOperand} QueryOperand
                 */
                QueryOperand.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.QueryOperand)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.QueryOperand();
                    if (object.metadata != null) {
                        if (typeof object.metadata !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.metadata: object expected");
                        message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.fromObject(object.metadata);
                    }
                    if (object.item != null) {
                        if (typeof object.item !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.item: object expected");
                        message.item = $root.vertexvis.protobuf.stream.ItemQuery.fromObject(object.item);
                    }
                    if (object.root != null) {
                        if (typeof object.root !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.root: object expected");
                        message.root = $root.vertexvis.protobuf.stream.RootQuery.fromObject(object.root);
                    }
                    if (object.point != null) {
                        if (typeof object.point !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.point: object expected");
                        message.point = $root.vertexvis.protobuf.stream.PointQuery.fromObject(object.point);
                    }
                    if (object.sceneTreeRange != null) {
                        if (typeof object.sceneTreeRange !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.sceneTreeRange: object expected");
                        message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.fromObject(object.sceneTreeRange);
                    }
                    if (object.override != null) {
                        if (typeof object.override !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.override: object expected");
                        message.override = $root.vertexvis.protobuf.stream.OverrideQuery.fromObject(object.override);
                    }
                    if (object.volume != null) {
                        if (typeof object.volume !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.volume: object expected");
                        message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.fromObject(object.volume);
                    }
                    if (object.itemCollection != null) {
                        if (typeof object.itemCollection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryOperand.itemCollection: object expected");
                        message.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.fromObject(object.itemCollection);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a QueryOperand message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.QueryOperand} message QueryOperand
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                QueryOperand.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        object.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.toObject(message.metadata, options);
                        if (options.oneofs)
                            object.operand = "metadata";
                    }
                    if (message.item != null && message.hasOwnProperty("item")) {
                        object.item = $root.vertexvis.protobuf.stream.ItemQuery.toObject(message.item, options);
                        if (options.oneofs)
                            object.operand = "item";
                    }
                    if (message.root != null && message.hasOwnProperty("root")) {
                        object.root = $root.vertexvis.protobuf.stream.RootQuery.toObject(message.root, options);
                        if (options.oneofs)
                            object.operand = "root";
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        object.point = $root.vertexvis.protobuf.stream.PointQuery.toObject(message.point, options);
                        if (options.oneofs)
                            object.operand = "point";
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        object.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.toObject(message.sceneTreeRange, options);
                        if (options.oneofs)
                            object.operand = "sceneTreeRange";
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        object.override = $root.vertexvis.protobuf.stream.OverrideQuery.toObject(message.override, options);
                        if (options.oneofs)
                            object.operand = "override";
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        object.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.toObject(message.volume, options);
                        if (options.oneofs)
                            object.operand = "volume";
                    }
                    if (message.itemCollection != null && message.hasOwnProperty("itemCollection")) {
                        object.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.toObject(message.itemCollection, options);
                        if (options.oneofs)
                            object.operand = "itemCollection";
                    }
                    return object;
                };

                /**
                 * Converts this QueryOperand to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.QueryOperand
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                QueryOperand.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return QueryOperand;
            })();

            stream.QueryExpression = (function() {

                /**
                 * Properties of a QueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IQueryExpression
                 * @property {vertexvis.protobuf.stream.IQueryOperand|null} [operand] QueryExpression operand
                 * @property {vertexvis.protobuf.stream.IOrExpression|null} [or] QueryExpression or
                 * @property {vertexvis.protobuf.stream.IAndExpression|null} [and] QueryExpression and
                 * @property {vertexvis.protobuf.stream.INotExpression|null} [not] QueryExpression not
                 */

                /**
                 * Constructs a new QueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a QueryExpression.
                 * @implements IQueryExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IQueryExpression=} [properties] Properties to set
                 */
                function QueryExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * QueryExpression operand.
                 * @member {vertexvis.protobuf.stream.IQueryOperand|null|undefined} operand
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 */
                QueryExpression.prototype.operand = null;

                /**
                 * QueryExpression or.
                 * @member {vertexvis.protobuf.stream.IOrExpression|null|undefined} or
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 */
                QueryExpression.prototype.or = null;

                /**
                 * QueryExpression and.
                 * @member {vertexvis.protobuf.stream.IAndExpression|null|undefined} and
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 */
                QueryExpression.prototype.and = null;

                /**
                 * QueryExpression not.
                 * @member {vertexvis.protobuf.stream.INotExpression|null|undefined} not
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 */
                QueryExpression.prototype.not = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * QueryExpression sealedValue.
                 * @member {"operand"|"or"|"and"|"not"|undefined} sealedValue
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 */
                Object.defineProperty(QueryExpression.prototype, "sealedValue", {
                    get: $util.oneOfGetter($oneOfFields = ["operand", "or", "and", "not"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new QueryExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.QueryExpression} QueryExpression instance
                 */
                QueryExpression.create = function create(properties) {
                    return new QueryExpression(properties);
                };

                /**
                 * Encodes the specified QueryExpression message. Does not implicitly {@link vertexvis.protobuf.stream.QueryExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryExpression} message QueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operand != null && Object.hasOwnProperty.call(message, "operand"))
                        $root.vertexvis.protobuf.stream.QueryOperand.encode(message.operand, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.or != null && Object.hasOwnProperty.call(message, "or"))
                        $root.vertexvis.protobuf.stream.OrExpression.encode(message.or, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.and != null && Object.hasOwnProperty.call(message, "and"))
                        $root.vertexvis.protobuf.stream.AndExpression.encode(message.and, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.not != null && Object.hasOwnProperty.call(message, "not"))
                        $root.vertexvis.protobuf.stream.NotExpression.encode(message.not, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified QueryExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.QueryExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IQueryExpression} message QueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a QueryExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.QueryExpression} QueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.QueryExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.operand = $root.vertexvis.protobuf.stream.QueryOperand.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.or = $root.vertexvis.protobuf.stream.OrExpression.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.and = $root.vertexvis.protobuf.stream.AndExpression.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.not = $root.vertexvis.protobuf.stream.NotExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a QueryExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.QueryExpression} QueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a QueryExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                QueryExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryOperand.verify(message.operand);
                            if (error)
                                return "operand." + error;
                        }
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.OrExpression.verify(message.or);
                            if (error)
                                return "or." + error;
                        }
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.AndExpression.verify(message.and);
                            if (error)
                                return "and." + error;
                        }
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.NotExpression.verify(message.not);
                            if (error)
                                return "not." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a QueryExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.QueryExpression} QueryExpression
                 */
                QueryExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.QueryExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.QueryExpression();
                    if (object.operand != null) {
                        if (typeof object.operand !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryExpression.operand: object expected");
                        message.operand = $root.vertexvis.protobuf.stream.QueryOperand.fromObject(object.operand);
                    }
                    if (object.or != null) {
                        if (typeof object.or !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryExpression.or: object expected");
                        message.or = $root.vertexvis.protobuf.stream.OrExpression.fromObject(object.or);
                    }
                    if (object.and != null) {
                        if (typeof object.and !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryExpression.and: object expected");
                        message.and = $root.vertexvis.protobuf.stream.AndExpression.fromObject(object.and);
                    }
                    if (object.not != null) {
                        if (typeof object.not !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.QueryExpression.not: object expected");
                        message.not = $root.vertexvis.protobuf.stream.NotExpression.fromObject(object.not);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a QueryExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.QueryExpression} message QueryExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                QueryExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        object.operand = $root.vertexvis.protobuf.stream.QueryOperand.toObject(message.operand, options);
                        if (options.oneofs)
                            object.sealedValue = "operand";
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        object.or = $root.vertexvis.protobuf.stream.OrExpression.toObject(message.or, options);
                        if (options.oneofs)
                            object.sealedValue = "or";
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        object.and = $root.vertexvis.protobuf.stream.AndExpression.toObject(message.and, options);
                        if (options.oneofs)
                            object.sealedValue = "and";
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        object.not = $root.vertexvis.protobuf.stream.NotExpression.toObject(message.not, options);
                        if (options.oneofs)
                            object.sealedValue = "not";
                    }
                    return object;
                };

                /**
                 * Converts this QueryExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.QueryExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                QueryExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return QueryExpression;
            })();

            stream.NotExpression = (function() {

                /**
                 * Properties of a NotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface INotExpression
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [expression] NotExpression expression
                 */

                /**
                 * Constructs a new NotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a NotExpression.
                 * @implements INotExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.INotExpression=} [properties] Properties to set
                 */
                function NotExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NotExpression expression.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} expression
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @instance
                 */
                NotExpression.prototype.expression = null;

                /**
                 * Creates a new NotExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.INotExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.NotExpression} NotExpression instance
                 */
                NotExpression.create = function create(properties) {
                    return new NotExpression(properties);
                };

                /**
                 * Encodes the specified NotExpression message. Does not implicitly {@link vertexvis.protobuf.stream.NotExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.INotExpression} message NotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.expression != null && Object.hasOwnProperty.call(message, "expression"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.expression, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NotExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.NotExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.INotExpression} message NotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NotExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NotExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.NotExpression} NotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.NotExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.expression = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NotExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.NotExpression} NotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NotExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NotExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NotExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.expression != null && message.hasOwnProperty("expression")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.expression);
                        if (error)
                            return "expression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a NotExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.NotExpression} NotExpression
                 */
                NotExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.NotExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.NotExpression();
                    if (object.expression != null) {
                        if (typeof object.expression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.NotExpression.expression: object expected");
                        message.expression = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.expression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NotExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.NotExpression} message NotExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NotExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.expression = null;
                    if (message.expression != null && message.hasOwnProperty("expression"))
                        object.expression = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.expression, options);
                    return object;
                };

                /**
                 * Converts this NotExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.NotExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NotExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NotExpression;
            })();

            stream.OrExpression = (function() {

                /**
                 * Properties of an OrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IOrExpression
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [first] OrExpression first
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [second] OrExpression second
                 */

                /**
                 * Constructs a new OrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an OrExpression.
                 * @implements IOrExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IOrExpression=} [properties] Properties to set
                 */
                function OrExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OrExpression first.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @instance
                 */
                OrExpression.prototype.first = null;

                /**
                 * OrExpression second.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @instance
                 */
                OrExpression.prototype.second = null;

                /**
                 * Creates a new OrExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.OrExpression} OrExpression instance
                 */
                OrExpression.create = function create(properties) {
                    return new OrExpression(properties);
                };

                /**
                 * Encodes the specified OrExpression message. Does not implicitly {@link vertexvis.protobuf.stream.OrExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrExpression} message OrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OrExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.OrExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrExpression} message OrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OrExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.OrExpression} OrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.OrExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OrExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.OrExpression} OrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OrExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OrExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates an OrExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.OrExpression} OrExpression
                 */
                OrExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.OrExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.OrExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OrExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.OrExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OrExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.OrExpression} message OrExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OrExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this OrExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.OrExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OrExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OrExpression;
            })();

            stream.AndExpression = (function() {

                /**
                 * Properties of an AndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IAndExpression
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [first] AndExpression first
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [second] AndExpression second
                 */

                /**
                 * Constructs a new AndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an AndExpression.
                 * @implements IAndExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IAndExpression=} [properties] Properties to set
                 */
                function AndExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AndExpression first.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @instance
                 */
                AndExpression.prototype.first = null;

                /**
                 * AndExpression second.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @instance
                 */
                AndExpression.prototype.second = null;

                /**
                 * Creates a new AndExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IAndExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.AndExpression} AndExpression instance
                 */
                AndExpression.create = function create(properties) {
                    return new AndExpression(properties);
                };

                /**
                 * Encodes the specified AndExpression message. Does not implicitly {@link vertexvis.protobuf.stream.AndExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IAndExpression} message AndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AndExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AndExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.AndExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IAndExpression} message AndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AndExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AndExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.AndExpression} AndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AndExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.AndExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AndExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.AndExpression} AndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AndExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AndExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AndExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AndExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.AndExpression} AndExpression
                 */
                AndExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.AndExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.AndExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.AndExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.AndExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AndExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.AndExpression} message AndExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AndExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this AndExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.AndExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AndExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AndExpression;
            })();

            stream.SceneOperation = (function() {

                /**
                 * Properties of a SceneOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneOperation
                 * @property {vertexvis.protobuf.stream.IItemQuery|null} [item] SceneOperation item
                 * @property {vertexvis.protobuf.stream.IQueryCollection|null} [or] SceneOperation or
                 * @property {vertexvis.protobuf.stream.IQueryCollection|null} [and] SceneOperation and
                 * @property {vertexvis.protobuf.stream.IAllQuery|null} [all] SceneOperation all
                 * @property {vertexvis.protobuf.stream.IPointQuery|null} [point] SceneOperation point
                 * @property {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null} [sceneTreeRange] SceneOperation sceneTreeRange
                 * @property {vertexvis.protobuf.stream.IMetadataFilterQuery|null} [metadata] SceneOperation metadata
                 * @property {vertexvis.protobuf.stream.IOverrideQuery|null} [override] SceneOperation override
                 * @property {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null} [volume] SceneOperation volume
                 * @property {vertexvis.protobuf.stream.IQueryCollection|null} [not] SceneOperation not
                 * @property {Array.<vertexvis.protobuf.stream.IOperationType>|null} [operationTypes] SceneOperation operationTypes
                 * @property {vertexvis.protobuf.stream.IQueryExpression|null} [queryExpression] SceneOperation queryExpression
                 */

                /**
                 * Constructs a new SceneOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneOperation.
                 * @implements ISceneOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneOperation=} [properties] Properties to set
                 */
                function SceneOperation(properties) {
                    this.operationTypes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneOperation item.
                 * @member {vertexvis.protobuf.stream.IItemQuery|null|undefined} item
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.item = null;

                /**
                 * SceneOperation or.
                 * @member {vertexvis.protobuf.stream.IQueryCollection|null|undefined} or
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.or = null;

                /**
                 * SceneOperation and.
                 * @member {vertexvis.protobuf.stream.IQueryCollection|null|undefined} and
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.and = null;

                /**
                 * SceneOperation all.
                 * @member {vertexvis.protobuf.stream.IAllQuery|null|undefined} all
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.all = null;

                /**
                 * SceneOperation point.
                 * @member {vertexvis.protobuf.stream.IPointQuery|null|undefined} point
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.point = null;

                /**
                 * SceneOperation sceneTreeRange.
                 * @member {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null|undefined} sceneTreeRange
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.sceneTreeRange = null;

                /**
                 * SceneOperation metadata.
                 * @member {vertexvis.protobuf.stream.IMetadataFilterQuery|null|undefined} metadata
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.metadata = null;

                /**
                 * SceneOperation override.
                 * @member {vertexvis.protobuf.stream.IOverrideQuery|null|undefined} override
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.override = null;

                /**
                 * SceneOperation volume.
                 * @member {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null|undefined} volume
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.volume = null;

                /**
                 * SceneOperation not.
                 * @member {vertexvis.protobuf.stream.IQueryCollection|null|undefined} not
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.not = null;

                /**
                 * SceneOperation operationTypes.
                 * @member {Array.<vertexvis.protobuf.stream.IOperationType>} operationTypes
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.operationTypes = $util.emptyArray;

                /**
                 * SceneOperation queryExpression.
                 * @member {vertexvis.protobuf.stream.IQueryExpression|null|undefined} queryExpression
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                SceneOperation.prototype.queryExpression = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneOperation query.
                 * @member {"item"|"or"|"and"|"all"|"point"|"sceneTreeRange"|"metadata"|"override"|"volume"|"not"|undefined} query
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 */
                Object.defineProperty(SceneOperation.prototype, "query", {
                    get: $util.oneOfGetter($oneOfFields = ["item", "or", "and", "all", "point", "sceneTreeRange", "metadata", "override", "volume", "not"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneOperation} SceneOperation instance
                 */
                SceneOperation.create = function create(properties) {
                    return new SceneOperation(properties);
                };

                /**
                 * Encodes the specified SceneOperation message. Does not implicitly {@link vertexvis.protobuf.stream.SceneOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneOperation} message SceneOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                        $root.vertexvis.protobuf.stream.ItemQuery.encode(message.item, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.or != null && Object.hasOwnProperty.call(message, "or"))
                        $root.vertexvis.protobuf.stream.QueryCollection.encode(message.or, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.and != null && Object.hasOwnProperty.call(message, "and"))
                        $root.vertexvis.protobuf.stream.QueryCollection.encode(message.and, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.operationTypes != null && message.operationTypes.length)
                        for (let i = 0; i < message.operationTypes.length; ++i)
                            $root.vertexvis.protobuf.stream.OperationType.encode(message.operationTypes[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.all != null && Object.hasOwnProperty.call(message, "all"))
                        $root.vertexvis.protobuf.stream.AllQuery.encode(message.all, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                        $root.vertexvis.protobuf.stream.PointQuery.encode(message.point, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.sceneTreeRange != null && Object.hasOwnProperty.call(message, "sceneTreeRange"))
                        $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.encode(message.sceneTreeRange, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                        $root.vertexvis.protobuf.stream.MetadataFilterQuery.encode(message.metadata, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.override != null && Object.hasOwnProperty.call(message, "override"))
                        $root.vertexvis.protobuf.stream.OverrideQuery.encode(message.override, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                        $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.encode(message.volume, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.not != null && Object.hasOwnProperty.call(message, "not"))
                        $root.vertexvis.protobuf.stream.QueryCollection.encode(message.not, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.queryExpression != null && Object.hasOwnProperty.call(message, "queryExpression"))
                        $root.vertexvis.protobuf.stream.QueryExpression.encode(message.queryExpression, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneOperation} message SceneOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneOperation} SceneOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.item = $root.vertexvis.protobuf.stream.ItemQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.or = $root.vertexvis.protobuf.stream.QueryCollection.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.and = $root.vertexvis.protobuf.stream.QueryCollection.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.all = $root.vertexvis.protobuf.stream.AllQuery.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.point = $root.vertexvis.protobuf.stream.PointQuery.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.override = $root.vertexvis.protobuf.stream.OverrideQuery.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.not = $root.vertexvis.protobuf.stream.QueryCollection.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (!(message.operationTypes && message.operationTypes.length))
                                message.operationTypes = [];
                            message.operationTypes.push($root.vertexvis.protobuf.stream.OperationType.decode(reader, reader.uint32()));
                            break;
                        case 12:
                            message.queryExpression = $root.vertexvis.protobuf.stream.QueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneOperation} SceneOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.item != null && message.hasOwnProperty("item")) {
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ItemQuery.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryCollection.verify(message.or);
                            if (error)
                                return "or." + error;
                        }
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryCollection.verify(message.and);
                            if (error)
                                return "and." + error;
                        }
                    }
                    if (message.all != null && message.hasOwnProperty("all")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.AllQuery.verify(message.all);
                            if (error)
                                return "all." + error;
                        }
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PointQuery.verify(message.point);
                            if (error)
                                return "point." + error;
                        }
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.verify(message.sceneTreeRange);
                            if (error)
                                return "sceneTreeRange." + error;
                        }
                    }
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.MetadataFilterQuery.verify(message.metadata);
                            if (error)
                                return "metadata." + error;
                        }
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.OverrideQuery.verify(message.override);
                            if (error)
                                return "override." + error;
                        }
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.verify(message.volume);
                            if (error)
                                return "volume." + error;
                        }
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        if (properties.query === 1)
                            return "query: multiple values";
                        properties.query = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryCollection.verify(message.not);
                            if (error)
                                return "not." + error;
                        }
                    }
                    if (message.operationTypes != null && message.hasOwnProperty("operationTypes")) {
                        if (!Array.isArray(message.operationTypes))
                            return "operationTypes: array expected";
                        for (let i = 0; i < message.operationTypes.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.OperationType.verify(message.operationTypes[i]);
                            if (error)
                                return "operationTypes." + error;
                        }
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression")) {
                        let error = $root.vertexvis.protobuf.stream.QueryExpression.verify(message.queryExpression);
                        if (error)
                            return "queryExpression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneOperation} SceneOperation
                 */
                SceneOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneOperation();
                    if (object.item != null) {
                        if (typeof object.item !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.item: object expected");
                        message.item = $root.vertexvis.protobuf.stream.ItemQuery.fromObject(object.item);
                    }
                    if (object.or != null) {
                        if (typeof object.or !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.or: object expected");
                        message.or = $root.vertexvis.protobuf.stream.QueryCollection.fromObject(object.or);
                    }
                    if (object.and != null) {
                        if (typeof object.and !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.and: object expected");
                        message.and = $root.vertexvis.protobuf.stream.QueryCollection.fromObject(object.and);
                    }
                    if (object.all != null) {
                        if (typeof object.all !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.all: object expected");
                        message.all = $root.vertexvis.protobuf.stream.AllQuery.fromObject(object.all);
                    }
                    if (object.point != null) {
                        if (typeof object.point !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.point: object expected");
                        message.point = $root.vertexvis.protobuf.stream.PointQuery.fromObject(object.point);
                    }
                    if (object.sceneTreeRange != null) {
                        if (typeof object.sceneTreeRange !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.sceneTreeRange: object expected");
                        message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.fromObject(object.sceneTreeRange);
                    }
                    if (object.metadata != null) {
                        if (typeof object.metadata !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.metadata: object expected");
                        message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.fromObject(object.metadata);
                    }
                    if (object.override != null) {
                        if (typeof object.override !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.override: object expected");
                        message.override = $root.vertexvis.protobuf.stream.OverrideQuery.fromObject(object.override);
                    }
                    if (object.volume != null) {
                        if (typeof object.volume !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.volume: object expected");
                        message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.fromObject(object.volume);
                    }
                    if (object.not != null) {
                        if (typeof object.not !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.not: object expected");
                        message.not = $root.vertexvis.protobuf.stream.QueryCollection.fromObject(object.not);
                    }
                    if (object.operationTypes) {
                        if (!Array.isArray(object.operationTypes))
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.operationTypes: array expected");
                        message.operationTypes = [];
                        for (let i = 0; i < object.operationTypes.length; ++i) {
                            if (typeof object.operationTypes[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.SceneOperation.operationTypes: object expected");
                            message.operationTypes[i] = $root.vertexvis.protobuf.stream.OperationType.fromObject(object.operationTypes[i]);
                        }
                    }
                    if (object.queryExpression != null) {
                        if (typeof object.queryExpression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneOperation.queryExpression: object expected");
                        message.queryExpression = $root.vertexvis.protobuf.stream.QueryExpression.fromObject(object.queryExpression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneOperation} message SceneOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.operationTypes = [];
                    if (options.defaults)
                        object.queryExpression = null;
                    if (message.item != null && message.hasOwnProperty("item")) {
                        object.item = $root.vertexvis.protobuf.stream.ItemQuery.toObject(message.item, options);
                        if (options.oneofs)
                            object.query = "item";
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        object.or = $root.vertexvis.protobuf.stream.QueryCollection.toObject(message.or, options);
                        if (options.oneofs)
                            object.query = "or";
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        object.and = $root.vertexvis.protobuf.stream.QueryCollection.toObject(message.and, options);
                        if (options.oneofs)
                            object.query = "and";
                    }
                    if (message.operationTypes && message.operationTypes.length) {
                        object.operationTypes = [];
                        for (let j = 0; j < message.operationTypes.length; ++j)
                            object.operationTypes[j] = $root.vertexvis.protobuf.stream.OperationType.toObject(message.operationTypes[j], options);
                    }
                    if (message.all != null && message.hasOwnProperty("all")) {
                        object.all = $root.vertexvis.protobuf.stream.AllQuery.toObject(message.all, options);
                        if (options.oneofs)
                            object.query = "all";
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        object.point = $root.vertexvis.protobuf.stream.PointQuery.toObject(message.point, options);
                        if (options.oneofs)
                            object.query = "point";
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        object.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.toObject(message.sceneTreeRange, options);
                        if (options.oneofs)
                            object.query = "sceneTreeRange";
                    }
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        object.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.toObject(message.metadata, options);
                        if (options.oneofs)
                            object.query = "metadata";
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        object.override = $root.vertexvis.protobuf.stream.OverrideQuery.toObject(message.override, options);
                        if (options.oneofs)
                            object.query = "override";
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        object.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.toObject(message.volume, options);
                        if (options.oneofs)
                            object.query = "volume";
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        object.not = $root.vertexvis.protobuf.stream.QueryCollection.toObject(message.not, options);
                        if (options.oneofs)
                            object.query = "not";
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression"))
                        object.queryExpression = $root.vertexvis.protobuf.stream.QueryExpression.toObject(message.queryExpression, options);
                    return object;
                };

                /**
                 * Converts this SceneOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneOperation;
            })();

            stream.SceneItemOperationType = (function() {

                /**
                 * Properties of a SceneItemOperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemOperationType
                 * @property {vertexvis.protobuf.stream.IChangeMaterialOperation|null} [changeMaterial] SceneItemOperationType changeMaterial
                 * @property {vertexvis.protobuf.stream.IChangeVisibilityOperation|null} [changeVisibility] SceneItemOperationType changeVisibility
                 * @property {vertexvis.protobuf.stream.IChangeTransformOperation|null} [changeTransform] SceneItemOperationType changeTransform
                 * @property {vertexvis.protobuf.stream.IChangeSelectionOperation|null} [changeSelection] SceneItemOperationType changeSelection
                 * @property {vertexvis.protobuf.stream.IClearTransformOperation|null} [clearTransform] SceneItemOperationType clearTransform
                 * @property {vertexvis.protobuf.stream.IChangePhantomOperation|null} [changePhantom] SceneItemOperationType changePhantom
                 * @property {vertexvis.protobuf.stream.IChangeEndItemOperation|null} [changeEndItem] SceneItemOperationType changeEndItem
                 * @property {vertexvis.protobuf.stream.IViewRenditionOperation|null} [viewRendition] SceneItemOperationType viewRendition
                 * @property {vertexvis.protobuf.stream.IViewDefaultRenditionOperation|null} [viewDefaultRendition] SceneItemOperationType viewDefaultRendition
                 * @property {vertexvis.protobuf.stream.IClearRenditionOperation|null} [clearRendition] SceneItemOperationType clearRendition
                 * @property {vertexvis.protobuf.stream.IViewRepresentationOperation|null} [viewRepresentation] SceneItemOperationType viewRepresentation
                 * @property {vertexvis.protobuf.stream.IClearRepresentationOperation|null} [clearRepresentation] SceneItemOperationType clearRepresentation
                 * @property {vertexvis.protobuf.stream.IClearMaterialOperation|null} [clearMaterial] SceneItemOperationType clearMaterial
                 */

                /**
                 * Constructs a new SceneItemOperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemOperationType.
                 * @implements ISceneItemOperationType
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemOperationType=} [properties] Properties to set
                 */
                function SceneItemOperationType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemOperationType changeMaterial.
                 * @member {vertexvis.protobuf.stream.IChangeMaterialOperation|null|undefined} changeMaterial
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changeMaterial = null;

                /**
                 * SceneItemOperationType changeVisibility.
                 * @member {vertexvis.protobuf.stream.IChangeVisibilityOperation|null|undefined} changeVisibility
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changeVisibility = null;

                /**
                 * SceneItemOperationType changeTransform.
                 * @member {vertexvis.protobuf.stream.IChangeTransformOperation|null|undefined} changeTransform
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changeTransform = null;

                /**
                 * SceneItemOperationType changeSelection.
                 * @member {vertexvis.protobuf.stream.IChangeSelectionOperation|null|undefined} changeSelection
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changeSelection = null;

                /**
                 * SceneItemOperationType clearTransform.
                 * @member {vertexvis.protobuf.stream.IClearTransformOperation|null|undefined} clearTransform
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.clearTransform = null;

                /**
                 * SceneItemOperationType changePhantom.
                 * @member {vertexvis.protobuf.stream.IChangePhantomOperation|null|undefined} changePhantom
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changePhantom = null;

                /**
                 * SceneItemOperationType changeEndItem.
                 * @member {vertexvis.protobuf.stream.IChangeEndItemOperation|null|undefined} changeEndItem
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.changeEndItem = null;

                /**
                 * SceneItemOperationType viewRendition.
                 * @member {vertexvis.protobuf.stream.IViewRenditionOperation|null|undefined} viewRendition
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.viewRendition = null;

                /**
                 * SceneItemOperationType viewDefaultRendition.
                 * @member {vertexvis.protobuf.stream.IViewDefaultRenditionOperation|null|undefined} viewDefaultRendition
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.viewDefaultRendition = null;

                /**
                 * SceneItemOperationType clearRendition.
                 * @member {vertexvis.protobuf.stream.IClearRenditionOperation|null|undefined} clearRendition
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.clearRendition = null;

                /**
                 * SceneItemOperationType viewRepresentation.
                 * @member {vertexvis.protobuf.stream.IViewRepresentationOperation|null|undefined} viewRepresentation
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.viewRepresentation = null;

                /**
                 * SceneItemOperationType clearRepresentation.
                 * @member {vertexvis.protobuf.stream.IClearRepresentationOperation|null|undefined} clearRepresentation
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.clearRepresentation = null;

                /**
                 * SceneItemOperationType clearMaterial.
                 * @member {vertexvis.protobuf.stream.IClearMaterialOperation|null|undefined} clearMaterial
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                SceneItemOperationType.prototype.clearMaterial = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneItemOperationType value.
                 * @member {"changeMaterial"|"changeVisibility"|"changeTransform"|"changeSelection"|"clearTransform"|"changePhantom"|"changeEndItem"|"viewRendition"|"viewDefaultRendition"|"clearRendition"|"viewRepresentation"|"clearRepresentation"|"clearMaterial"|undefined} value
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 */
                Object.defineProperty(SceneItemOperationType.prototype, "value", {
                    get: $util.oneOfGetter($oneOfFields = ["changeMaterial", "changeVisibility", "changeTransform", "changeSelection", "clearTransform", "changePhantom", "changeEndItem", "viewRendition", "viewDefaultRendition", "clearRendition", "viewRepresentation", "clearRepresentation", "clearMaterial"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneItemOperationType instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperationType=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemOperationType} SceneItemOperationType instance
                 */
                SceneItemOperationType.create = function create(properties) {
                    return new SceneItemOperationType(properties);
                };

                /**
                 * Encodes the specified SceneItemOperationType message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOperationType.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperationType} message SceneItemOperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOperationType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.changeMaterial != null && Object.hasOwnProperty.call(message, "changeMaterial"))
                        $root.vertexvis.protobuf.stream.ChangeMaterialOperation.encode(message.changeMaterial, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.changeVisibility != null && Object.hasOwnProperty.call(message, "changeVisibility"))
                        $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.encode(message.changeVisibility, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.changeTransform != null && Object.hasOwnProperty.call(message, "changeTransform"))
                        $root.vertexvis.protobuf.stream.ChangeTransformOperation.encode(message.changeTransform, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.changeSelection != null && Object.hasOwnProperty.call(message, "changeSelection"))
                        $root.vertexvis.protobuf.stream.ChangeSelectionOperation.encode(message.changeSelection, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.clearTransform != null && Object.hasOwnProperty.call(message, "clearTransform"))
                        $root.vertexvis.protobuf.stream.ClearTransformOperation.encode(message.clearTransform, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.changePhantom != null && Object.hasOwnProperty.call(message, "changePhantom"))
                        $root.vertexvis.protobuf.stream.ChangePhantomOperation.encode(message.changePhantom, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.changeEndItem != null && Object.hasOwnProperty.call(message, "changeEndItem"))
                        $root.vertexvis.protobuf.stream.ChangeEndItemOperation.encode(message.changeEndItem, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.viewRendition != null && Object.hasOwnProperty.call(message, "viewRendition"))
                        $root.vertexvis.protobuf.stream.ViewRenditionOperation.encode(message.viewRendition, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.viewDefaultRendition != null && Object.hasOwnProperty.call(message, "viewDefaultRendition"))
                        $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.encode(message.viewDefaultRendition, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.clearRendition != null && Object.hasOwnProperty.call(message, "clearRendition"))
                        $root.vertexvis.protobuf.stream.ClearRenditionOperation.encode(message.clearRendition, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.viewRepresentation != null && Object.hasOwnProperty.call(message, "viewRepresentation"))
                        $root.vertexvis.protobuf.stream.ViewRepresentationOperation.encode(message.viewRepresentation, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.clearRepresentation != null && Object.hasOwnProperty.call(message, "clearRepresentation"))
                        $root.vertexvis.protobuf.stream.ClearRepresentationOperation.encode(message.clearRepresentation, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.clearMaterial != null && Object.hasOwnProperty.call(message, "clearMaterial"))
                        $root.vertexvis.protobuf.stream.ClearMaterialOperation.encode(message.clearMaterial, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemOperationType message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOperationType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperationType} message SceneItemOperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOperationType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemOperationType message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemOperationType} SceneItemOperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOperationType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemOperationType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemOperationType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemOperationType} SceneItemOperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOperationType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemOperationType message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemOperationType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.changeMaterial != null && message.hasOwnProperty("changeMaterial")) {
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.verify(message.changeMaterial);
                            if (error)
                                return "changeMaterial." + error;
                        }
                    }
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.verify(message.changeVisibility);
                            if (error)
                                return "changeVisibility." + error;
                        }
                    }
                    if (message.changeTransform != null && message.hasOwnProperty("changeTransform")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeTransformOperation.verify(message.changeTransform);
                            if (error)
                                return "changeTransform." + error;
                        }
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.verify(message.changeSelection);
                            if (error)
                                return "changeSelection." + error;
                        }
                    }
                    if (message.clearTransform != null && message.hasOwnProperty("clearTransform")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearTransformOperation.verify(message.clearTransform);
                            if (error)
                                return "clearTransform." + error;
                        }
                    }
                    if (message.changePhantom != null && message.hasOwnProperty("changePhantom")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangePhantomOperation.verify(message.changePhantom);
                            if (error)
                                return "changePhantom." + error;
                        }
                    }
                    if (message.changeEndItem != null && message.hasOwnProperty("changeEndItem")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.verify(message.changeEndItem);
                            if (error)
                                return "changeEndItem." + error;
                        }
                    }
                    if (message.viewRendition != null && message.hasOwnProperty("viewRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewRenditionOperation.verify(message.viewRendition);
                            if (error)
                                return "viewRendition." + error;
                        }
                    }
                    if (message.viewDefaultRendition != null && message.hasOwnProperty("viewDefaultRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.verify(message.viewDefaultRendition);
                            if (error)
                                return "viewDefaultRendition." + error;
                        }
                    }
                    if (message.clearRendition != null && message.hasOwnProperty("clearRendition")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearRenditionOperation.verify(message.clearRendition);
                            if (error)
                                return "clearRendition." + error;
                        }
                    }
                    if (message.viewRepresentation != null && message.hasOwnProperty("viewRepresentation")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.verify(message.viewRepresentation);
                            if (error)
                                return "viewRepresentation." + error;
                        }
                    }
                    if (message.clearRepresentation != null && message.hasOwnProperty("clearRepresentation")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.verify(message.clearRepresentation);
                            if (error)
                                return "clearRepresentation." + error;
                        }
                    }
                    if (message.clearMaterial != null && message.hasOwnProperty("clearMaterial")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ClearMaterialOperation.verify(message.clearMaterial);
                            if (error)
                                return "clearMaterial." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemOperationType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemOperationType} SceneItemOperationType
                 */
                SceneItemOperationType.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemOperationType)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemOperationType();
                    if (object.changeMaterial != null) {
                        if (typeof object.changeMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changeMaterial: object expected");
                        message.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.fromObject(object.changeMaterial);
                    }
                    if (object.changeVisibility != null) {
                        if (typeof object.changeVisibility !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changeVisibility: object expected");
                        message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.fromObject(object.changeVisibility);
                    }
                    if (object.changeTransform != null) {
                        if (typeof object.changeTransform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changeTransform: object expected");
                        message.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.fromObject(object.changeTransform);
                    }
                    if (object.changeSelection != null) {
                        if (typeof object.changeSelection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changeSelection: object expected");
                        message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.fromObject(object.changeSelection);
                    }
                    if (object.clearTransform != null) {
                        if (typeof object.clearTransform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.clearTransform: object expected");
                        message.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.fromObject(object.clearTransform);
                    }
                    if (object.changePhantom != null) {
                        if (typeof object.changePhantom !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changePhantom: object expected");
                        message.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.fromObject(object.changePhantom);
                    }
                    if (object.changeEndItem != null) {
                        if (typeof object.changeEndItem !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.changeEndItem: object expected");
                        message.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.fromObject(object.changeEndItem);
                    }
                    if (object.viewRendition != null) {
                        if (typeof object.viewRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.viewRendition: object expected");
                        message.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.fromObject(object.viewRendition);
                    }
                    if (object.viewDefaultRendition != null) {
                        if (typeof object.viewDefaultRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.viewDefaultRendition: object expected");
                        message.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.fromObject(object.viewDefaultRendition);
                    }
                    if (object.clearRendition != null) {
                        if (typeof object.clearRendition !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.clearRendition: object expected");
                        message.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.fromObject(object.clearRendition);
                    }
                    if (object.viewRepresentation != null) {
                        if (typeof object.viewRepresentation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.viewRepresentation: object expected");
                        message.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.fromObject(object.viewRepresentation);
                    }
                    if (object.clearRepresentation != null) {
                        if (typeof object.clearRepresentation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.clearRepresentation: object expected");
                        message.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.fromObject(object.clearRepresentation);
                    }
                    if (object.clearMaterial != null) {
                        if (typeof object.clearMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperationType.clearMaterial: object expected");
                        message.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.fromObject(object.clearMaterial);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemOperationType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemOperationType} message SceneItemOperationType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemOperationType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.changeMaterial != null && message.hasOwnProperty("changeMaterial")) {
                        object.changeMaterial = $root.vertexvis.protobuf.stream.ChangeMaterialOperation.toObject(message.changeMaterial, options);
                        if (options.oneofs)
                            object.value = "changeMaterial";
                    }
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        object.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.toObject(message.changeVisibility, options);
                        if (options.oneofs)
                            object.value = "changeVisibility";
                    }
                    if (message.changeTransform != null && message.hasOwnProperty("changeTransform")) {
                        object.changeTransform = $root.vertexvis.protobuf.stream.ChangeTransformOperation.toObject(message.changeTransform, options);
                        if (options.oneofs)
                            object.value = "changeTransform";
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        object.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.toObject(message.changeSelection, options);
                        if (options.oneofs)
                            object.value = "changeSelection";
                    }
                    if (message.clearTransform != null && message.hasOwnProperty("clearTransform")) {
                        object.clearTransform = $root.vertexvis.protobuf.stream.ClearTransformOperation.toObject(message.clearTransform, options);
                        if (options.oneofs)
                            object.value = "clearTransform";
                    }
                    if (message.changePhantom != null && message.hasOwnProperty("changePhantom")) {
                        object.changePhantom = $root.vertexvis.protobuf.stream.ChangePhantomOperation.toObject(message.changePhantom, options);
                        if (options.oneofs)
                            object.value = "changePhantom";
                    }
                    if (message.changeEndItem != null && message.hasOwnProperty("changeEndItem")) {
                        object.changeEndItem = $root.vertexvis.protobuf.stream.ChangeEndItemOperation.toObject(message.changeEndItem, options);
                        if (options.oneofs)
                            object.value = "changeEndItem";
                    }
                    if (message.viewRendition != null && message.hasOwnProperty("viewRendition")) {
                        object.viewRendition = $root.vertexvis.protobuf.stream.ViewRenditionOperation.toObject(message.viewRendition, options);
                        if (options.oneofs)
                            object.value = "viewRendition";
                    }
                    if (message.viewDefaultRendition != null && message.hasOwnProperty("viewDefaultRendition")) {
                        object.viewDefaultRendition = $root.vertexvis.protobuf.stream.ViewDefaultRenditionOperation.toObject(message.viewDefaultRendition, options);
                        if (options.oneofs)
                            object.value = "viewDefaultRendition";
                    }
                    if (message.clearRendition != null && message.hasOwnProperty("clearRendition")) {
                        object.clearRendition = $root.vertexvis.protobuf.stream.ClearRenditionOperation.toObject(message.clearRendition, options);
                        if (options.oneofs)
                            object.value = "clearRendition";
                    }
                    if (message.viewRepresentation != null && message.hasOwnProperty("viewRepresentation")) {
                        object.viewRepresentation = $root.vertexvis.protobuf.stream.ViewRepresentationOperation.toObject(message.viewRepresentation, options);
                        if (options.oneofs)
                            object.value = "viewRepresentation";
                    }
                    if (message.clearRepresentation != null && message.hasOwnProperty("clearRepresentation")) {
                        object.clearRepresentation = $root.vertexvis.protobuf.stream.ClearRepresentationOperation.toObject(message.clearRepresentation, options);
                        if (options.oneofs)
                            object.value = "clearRepresentation";
                    }
                    if (message.clearMaterial != null && message.hasOwnProperty("clearMaterial")) {
                        object.clearMaterial = $root.vertexvis.protobuf.stream.ClearMaterialOperation.toObject(message.clearMaterial, options);
                        if (options.oneofs)
                            object.value = "clearMaterial";
                    }
                    return object;
                };

                /**
                 * Converts this SceneItemOperationType to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemOperationType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemOperationType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemOperationType;
            })();

            stream.SceneItemQueryOperand = (function() {

                /**
                 * Properties of a SceneItemQueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemQueryOperand
                 * @property {vertexvis.protobuf.stream.IMetadataFilterQuery|null} [metadata] SceneItemQueryOperand metadata
                 * @property {vertexvis.protobuf.stream.IItemQuery|null} [item] SceneItemQueryOperand item
                 * @property {vertexvis.protobuf.stream.IRootQuery|null} [root] SceneItemQueryOperand root
                 * @property {vertexvis.protobuf.stream.IPointQuery|null} [point] SceneItemQueryOperand point
                 * @property {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null} [sceneTreeRange] SceneItemQueryOperand sceneTreeRange
                 * @property {vertexvis.protobuf.stream.IOverrideQuery|null} [override] SceneItemQueryOperand override
                 * @property {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null} [volume] SceneItemQueryOperand volume
                 * @property {vertexvis.protobuf.stream.IQueryCollection|null} [itemCollection] SceneItemQueryOperand itemCollection
                 */

                /**
                 * Constructs a new SceneItemQueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemQueryOperand.
                 * @implements ISceneItemQueryOperand
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryOperand=} [properties] Properties to set
                 */
                function SceneItemQueryOperand(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemQueryOperand metadata.
                 * @member {vertexvis.protobuf.stream.IMetadataFilterQuery|null|undefined} metadata
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.metadata = null;

                /**
                 * SceneItemQueryOperand item.
                 * @member {vertexvis.protobuf.stream.IItemQuery|null|undefined} item
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.item = null;

                /**
                 * SceneItemQueryOperand root.
                 * @member {vertexvis.protobuf.stream.IRootQuery|null|undefined} root
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.root = null;

                /**
                 * SceneItemQueryOperand point.
                 * @member {vertexvis.protobuf.stream.IPointQuery|null|undefined} point
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.point = null;

                /**
                 * SceneItemQueryOperand sceneTreeRange.
                 * @member {vertexvis.protobuf.stream.ISceneTreeRangeQuery|null|undefined} sceneTreeRange
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.sceneTreeRange = null;

                /**
                 * SceneItemQueryOperand override.
                 * @member {vertexvis.protobuf.stream.IOverrideQuery|null|undefined} override
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.override = null;

                /**
                 * SceneItemQueryOperand volume.
                 * @member {vertexvis.protobuf.stream.IVolumeIntersectionQuery|null|undefined} volume
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.volume = null;

                /**
                 * SceneItemQueryOperand itemCollection.
                 * @member {vertexvis.protobuf.stream.IQueryCollection|null|undefined} itemCollection
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                SceneItemQueryOperand.prototype.itemCollection = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneItemQueryOperand operand.
                 * @member {"metadata"|"item"|"root"|"point"|"sceneTreeRange"|"override"|"volume"|"itemCollection"|undefined} operand
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 */
                Object.defineProperty(SceneItemQueryOperand.prototype, "operand", {
                    get: $util.oneOfGetter($oneOfFields = ["metadata", "item", "root", "point", "sceneTreeRange", "override", "volume", "itemCollection"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneItemQueryOperand instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryOperand=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryOperand} SceneItemQueryOperand instance
                 */
                SceneItemQueryOperand.create = function create(properties) {
                    return new SceneItemQueryOperand(properties);
                };

                /**
                 * Encodes the specified SceneItemQueryOperand message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQueryOperand.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryOperand} message SceneItemQueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQueryOperand.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                        $root.vertexvis.protobuf.stream.MetadataFilterQuery.encode(message.metadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                        $root.vertexvis.protobuf.stream.ItemQuery.encode(message.item, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.root != null && Object.hasOwnProperty.call(message, "root"))
                        $root.vertexvis.protobuf.stream.RootQuery.encode(message.root, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                        $root.vertexvis.protobuf.stream.PointQuery.encode(message.point, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.sceneTreeRange != null && Object.hasOwnProperty.call(message, "sceneTreeRange"))
                        $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.encode(message.sceneTreeRange, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.override != null && Object.hasOwnProperty.call(message, "override"))
                        $root.vertexvis.protobuf.stream.OverrideQuery.encode(message.override, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                        $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.encode(message.volume, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.itemCollection != null && Object.hasOwnProperty.call(message, "itemCollection"))
                        $root.vertexvis.protobuf.stream.QueryCollection.encode(message.itemCollection, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemQueryOperand message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQueryOperand.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryOperand} message SceneItemQueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQueryOperand.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemQueryOperand message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryOperand} SceneItemQueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQueryOperand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemQueryOperand();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.item = $root.vertexvis.protobuf.stream.ItemQuery.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.root = $root.vertexvis.protobuf.stream.RootQuery.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.point = $root.vertexvis.protobuf.stream.PointQuery.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.override = $root.vertexvis.protobuf.stream.OverrideQuery.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemQueryOperand message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryOperand} SceneItemQueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQueryOperand.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemQueryOperand message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemQueryOperand.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.MetadataFilterQuery.verify(message.metadata);
                            if (error)
                                return "metadata." + error;
                        }
                    }
                    if (message.item != null && message.hasOwnProperty("item")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ItemQuery.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                    }
                    if (message.root != null && message.hasOwnProperty("root")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RootQuery.verify(message.root);
                            if (error)
                                return "root." + error;
                        }
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PointQuery.verify(message.point);
                            if (error)
                                return "point." + error;
                        }
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.verify(message.sceneTreeRange);
                            if (error)
                                return "sceneTreeRange." + error;
                        }
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.OverrideQuery.verify(message.override);
                            if (error)
                                return "override." + error;
                        }
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.verify(message.volume);
                            if (error)
                                return "volume." + error;
                        }
                    }
                    if (message.itemCollection != null && message.hasOwnProperty("itemCollection")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.QueryCollection.verify(message.itemCollection);
                            if (error)
                                return "itemCollection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemQueryOperand message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryOperand} SceneItemQueryOperand
                 */
                SceneItemQueryOperand.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemQueryOperand)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemQueryOperand();
                    if (object.metadata != null) {
                        if (typeof object.metadata !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.metadata: object expected");
                        message.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.fromObject(object.metadata);
                    }
                    if (object.item != null) {
                        if (typeof object.item !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.item: object expected");
                        message.item = $root.vertexvis.protobuf.stream.ItemQuery.fromObject(object.item);
                    }
                    if (object.root != null) {
                        if (typeof object.root !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.root: object expected");
                        message.root = $root.vertexvis.protobuf.stream.RootQuery.fromObject(object.root);
                    }
                    if (object.point != null) {
                        if (typeof object.point !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.point: object expected");
                        message.point = $root.vertexvis.protobuf.stream.PointQuery.fromObject(object.point);
                    }
                    if (object.sceneTreeRange != null) {
                        if (typeof object.sceneTreeRange !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.sceneTreeRange: object expected");
                        message.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.fromObject(object.sceneTreeRange);
                    }
                    if (object.override != null) {
                        if (typeof object.override !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.override: object expected");
                        message.override = $root.vertexvis.protobuf.stream.OverrideQuery.fromObject(object.override);
                    }
                    if (object.volume != null) {
                        if (typeof object.volume !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.volume: object expected");
                        message.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.fromObject(object.volume);
                    }
                    if (object.itemCollection != null) {
                        if (typeof object.itemCollection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryOperand.itemCollection: object expected");
                        message.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.fromObject(object.itemCollection);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemQueryOperand message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemQueryOperand} message SceneItemQueryOperand
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemQueryOperand.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.metadata != null && message.hasOwnProperty("metadata")) {
                        object.metadata = $root.vertexvis.protobuf.stream.MetadataFilterQuery.toObject(message.metadata, options);
                        if (options.oneofs)
                            object.operand = "metadata";
                    }
                    if (message.item != null && message.hasOwnProperty("item")) {
                        object.item = $root.vertexvis.protobuf.stream.ItemQuery.toObject(message.item, options);
                        if (options.oneofs)
                            object.operand = "item";
                    }
                    if (message.root != null && message.hasOwnProperty("root")) {
                        object.root = $root.vertexvis.protobuf.stream.RootQuery.toObject(message.root, options);
                        if (options.oneofs)
                            object.operand = "root";
                    }
                    if (message.point != null && message.hasOwnProperty("point")) {
                        object.point = $root.vertexvis.protobuf.stream.PointQuery.toObject(message.point, options);
                        if (options.oneofs)
                            object.operand = "point";
                    }
                    if (message.sceneTreeRange != null && message.hasOwnProperty("sceneTreeRange")) {
                        object.sceneTreeRange = $root.vertexvis.protobuf.stream.SceneTreeRangeQuery.toObject(message.sceneTreeRange, options);
                        if (options.oneofs)
                            object.operand = "sceneTreeRange";
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        object.override = $root.vertexvis.protobuf.stream.OverrideQuery.toObject(message.override, options);
                        if (options.oneofs)
                            object.operand = "override";
                    }
                    if (message.volume != null && message.hasOwnProperty("volume")) {
                        object.volume = $root.vertexvis.protobuf.stream.VolumeIntersectionQuery.toObject(message.volume, options);
                        if (options.oneofs)
                            object.operand = "volume";
                    }
                    if (message.itemCollection != null && message.hasOwnProperty("itemCollection")) {
                        object.itemCollection = $root.vertexvis.protobuf.stream.QueryCollection.toObject(message.itemCollection, options);
                        if (options.oneofs)
                            object.operand = "itemCollection";
                    }
                    return object;
                };

                /**
                 * Converts this SceneItemQueryOperand to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryOperand
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemQueryOperand.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemQueryOperand;
            })();

            stream.SceneItemQueryExpression = (function() {

                /**
                 * Properties of a SceneItemQueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemQueryExpression
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryOperand|null} [operand] SceneItemQueryExpression operand
                 * @property {vertexvis.protobuf.stream.ISceneItemOrExpression|null} [or] SceneItemQueryExpression or
                 * @property {vertexvis.protobuf.stream.ISceneItemAndExpression|null} [and] SceneItemQueryExpression and
                 * @property {vertexvis.protobuf.stream.ISceneItemNotExpression|null} [not] SceneItemQueryExpression not
                 */

                /**
                 * Constructs a new SceneItemQueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemQueryExpression.
                 * @implements ISceneItemQueryExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryExpression=} [properties] Properties to set
                 */
                function SceneItemQueryExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemQueryExpression operand.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryOperand|null|undefined} operand
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 */
                SceneItemQueryExpression.prototype.operand = null;

                /**
                 * SceneItemQueryExpression or.
                 * @member {vertexvis.protobuf.stream.ISceneItemOrExpression|null|undefined} or
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 */
                SceneItemQueryExpression.prototype.or = null;

                /**
                 * SceneItemQueryExpression and.
                 * @member {vertexvis.protobuf.stream.ISceneItemAndExpression|null|undefined} and
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 */
                SceneItemQueryExpression.prototype.and = null;

                /**
                 * SceneItemQueryExpression not.
                 * @member {vertexvis.protobuf.stream.ISceneItemNotExpression|null|undefined} not
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 */
                SceneItemQueryExpression.prototype.not = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneItemQueryExpression sealedValue.
                 * @member {"operand"|"or"|"and"|"not"|undefined} sealedValue
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 */
                Object.defineProperty(SceneItemQueryExpression.prototype, "sealedValue", {
                    get: $util.oneOfGetter($oneOfFields = ["operand", "or", "and", "not"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneItemQueryExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryExpression} SceneItemQueryExpression instance
                 */
                SceneItemQueryExpression.create = function create(properties) {
                    return new SceneItemQueryExpression(properties);
                };

                /**
                 * Encodes the specified SceneItemQueryExpression message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQueryExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryExpression} message SceneItemQueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQueryExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operand != null && Object.hasOwnProperty.call(message, "operand"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryOperand.encode(message.operand, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.or != null && Object.hasOwnProperty.call(message, "or"))
                        $root.vertexvis.protobuf.stream.SceneItemOrExpression.encode(message.or, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.and != null && Object.hasOwnProperty.call(message, "and"))
                        $root.vertexvis.protobuf.stream.SceneItemAndExpression.encode(message.and, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.not != null && Object.hasOwnProperty.call(message, "not"))
                        $root.vertexvis.protobuf.stream.SceneItemNotExpression.encode(message.not, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemQueryExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemQueryExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemQueryExpression} message SceneItemQueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemQueryExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemQueryExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryExpression} SceneItemQueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQueryExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemQueryExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.operand = $root.vertexvis.protobuf.stream.SceneItemQueryOperand.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.or = $root.vertexvis.protobuf.stream.SceneItemOrExpression.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.and = $root.vertexvis.protobuf.stream.SceneItemAndExpression.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.not = $root.vertexvis.protobuf.stream.SceneItemNotExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemQueryExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryExpression} SceneItemQueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemQueryExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemQueryExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemQueryExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemQueryOperand.verify(message.operand);
                            if (error)
                                return "operand." + error;
                        }
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemOrExpression.verify(message.or);
                            if (error)
                                return "or." + error;
                        }
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemAndExpression.verify(message.and);
                            if (error)
                                return "and." + error;
                        }
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemNotExpression.verify(message.not);
                            if (error)
                                return "not." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemQueryExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemQueryExpression} SceneItemQueryExpression
                 */
                SceneItemQueryExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemQueryExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemQueryExpression();
                    if (object.operand != null) {
                        if (typeof object.operand !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryExpression.operand: object expected");
                        message.operand = $root.vertexvis.protobuf.stream.SceneItemQueryOperand.fromObject(object.operand);
                    }
                    if (object.or != null) {
                        if (typeof object.or !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryExpression.or: object expected");
                        message.or = $root.vertexvis.protobuf.stream.SceneItemOrExpression.fromObject(object.or);
                    }
                    if (object.and != null) {
                        if (typeof object.and !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryExpression.and: object expected");
                        message.and = $root.vertexvis.protobuf.stream.SceneItemAndExpression.fromObject(object.and);
                    }
                    if (object.not != null) {
                        if (typeof object.not !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemQueryExpression.not: object expected");
                        message.not = $root.vertexvis.protobuf.stream.SceneItemNotExpression.fromObject(object.not);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemQueryExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemQueryExpression} message SceneItemQueryExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemQueryExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        object.operand = $root.vertexvis.protobuf.stream.SceneItemQueryOperand.toObject(message.operand, options);
                        if (options.oneofs)
                            object.sealedValue = "operand";
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        object.or = $root.vertexvis.protobuf.stream.SceneItemOrExpression.toObject(message.or, options);
                        if (options.oneofs)
                            object.sealedValue = "or";
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        object.and = $root.vertexvis.protobuf.stream.SceneItemAndExpression.toObject(message.and, options);
                        if (options.oneofs)
                            object.sealedValue = "and";
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        object.not = $root.vertexvis.protobuf.stream.SceneItemNotExpression.toObject(message.not, options);
                        if (options.oneofs)
                            object.sealedValue = "not";
                    }
                    return object;
                };

                /**
                 * Converts this SceneItemQueryExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemQueryExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemQueryExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemQueryExpression;
            })();

            stream.SceneItemNotExpression = (function() {

                /**
                 * Properties of a SceneItemNotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemNotExpression
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [expression] SceneItemNotExpression expression
                 */

                /**
                 * Constructs a new SceneItemNotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemNotExpression.
                 * @implements ISceneItemNotExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemNotExpression=} [properties] Properties to set
                 */
                function SceneItemNotExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemNotExpression expression.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} expression
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @instance
                 */
                SceneItemNotExpression.prototype.expression = null;

                /**
                 * Creates a new SceneItemNotExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemNotExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemNotExpression} SceneItemNotExpression instance
                 */
                SceneItemNotExpression.create = function create(properties) {
                    return new SceneItemNotExpression(properties);
                };

                /**
                 * Encodes the specified SceneItemNotExpression message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemNotExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemNotExpression} message SceneItemNotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemNotExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.expression != null && Object.hasOwnProperty.call(message, "expression"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.expression, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemNotExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemNotExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemNotExpression} message SceneItemNotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemNotExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemNotExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemNotExpression} SceneItemNotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemNotExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemNotExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.expression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemNotExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemNotExpression} SceneItemNotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemNotExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemNotExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemNotExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.expression != null && message.hasOwnProperty("expression")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.expression);
                        if (error)
                            return "expression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemNotExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemNotExpression} SceneItemNotExpression
                 */
                SceneItemNotExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemNotExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemNotExpression();
                    if (object.expression != null) {
                        if (typeof object.expression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemNotExpression.expression: object expected");
                        message.expression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.expression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemNotExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemNotExpression} message SceneItemNotExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemNotExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.expression = null;
                    if (message.expression != null && message.hasOwnProperty("expression"))
                        object.expression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.expression, options);
                    return object;
                };

                /**
                 * Converts this SceneItemNotExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemNotExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemNotExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemNotExpression;
            })();

            stream.SceneItemOrExpression = (function() {

                /**
                 * Properties of a SceneItemOrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemOrExpression
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [first] SceneItemOrExpression first
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [second] SceneItemOrExpression second
                 */

                /**
                 * Constructs a new SceneItemOrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemOrExpression.
                 * @implements ISceneItemOrExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemOrExpression=} [properties] Properties to set
                 */
                function SceneItemOrExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemOrExpression first.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @instance
                 */
                SceneItemOrExpression.prototype.first = null;

                /**
                 * SceneItemOrExpression second.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @instance
                 */
                SceneItemOrExpression.prototype.second = null;

                /**
                 * Creates a new SceneItemOrExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOrExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemOrExpression} SceneItemOrExpression instance
                 */
                SceneItemOrExpression.create = function create(properties) {
                    return new SceneItemOrExpression(properties);
                };

                /**
                 * Encodes the specified SceneItemOrExpression message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOrExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOrExpression} message SceneItemOrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOrExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemOrExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOrExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOrExpression} message SceneItemOrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOrExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemOrExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemOrExpression} SceneItemOrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOrExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemOrExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemOrExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemOrExpression} SceneItemOrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOrExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemOrExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemOrExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemOrExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemOrExpression} SceneItemOrExpression
                 */
                SceneItemOrExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemOrExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemOrExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOrExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOrExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemOrExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemOrExpression} message SceneItemOrExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemOrExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this SceneItemOrExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemOrExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemOrExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemOrExpression;
            })();

            stream.SceneItemAndExpression = (function() {

                /**
                 * Properties of a SceneItemAndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemAndExpression
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [first] SceneItemAndExpression first
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [second] SceneItemAndExpression second
                 */

                /**
                 * Constructs a new SceneItemAndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemAndExpression.
                 * @implements ISceneItemAndExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemAndExpression=} [properties] Properties to set
                 */
                function SceneItemAndExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemAndExpression first.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @instance
                 */
                SceneItemAndExpression.prototype.first = null;

                /**
                 * SceneItemAndExpression second.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @instance
                 */
                SceneItemAndExpression.prototype.second = null;

                /**
                 * Creates a new SceneItemAndExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemAndExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemAndExpression} SceneItemAndExpression instance
                 */
                SceneItemAndExpression.create = function create(properties) {
                    return new SceneItemAndExpression(properties);
                };

                /**
                 * Encodes the specified SceneItemAndExpression message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemAndExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemAndExpression} message SceneItemAndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemAndExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemAndExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemAndExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemAndExpression} message SceneItemAndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemAndExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemAndExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemAndExpression} SceneItemAndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemAndExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemAndExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemAndExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemAndExpression} SceneItemAndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemAndExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemAndExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemAndExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemAndExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemAndExpression} SceneItemAndExpression
                 */
                SceneItemAndExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemAndExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemAndExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemAndExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemAndExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemAndExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemAndExpression} message SceneItemAndExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemAndExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this SceneItemAndExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemAndExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemAndExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemAndExpression;
            })();

            stream.SceneItemOperation = (function() {

                /**
                 * Properties of a SceneItemOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneItemOperation
                 * @property {Array.<vertexvis.protobuf.stream.ISceneItemOperationType>|null} [operationTypes] SceneItemOperation operationTypes
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [queryExpression] SceneItemOperation queryExpression
                 */

                /**
                 * Constructs a new SceneItemOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneItemOperation.
                 * @implements ISceneItemOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneItemOperation=} [properties] Properties to set
                 */
                function SceneItemOperation(properties) {
                    this.operationTypes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneItemOperation operationTypes.
                 * @member {Array.<vertexvis.protobuf.stream.ISceneItemOperationType>} operationTypes
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @instance
                 */
                SceneItemOperation.prototype.operationTypes = $util.emptyArray;

                /**
                 * SceneItemOperation queryExpression.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} queryExpression
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @instance
                 */
                SceneItemOperation.prototype.queryExpression = null;

                /**
                 * Creates a new SceneItemOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneItemOperation} SceneItemOperation instance
                 */
                SceneItemOperation.create = function create(properties) {
                    return new SceneItemOperation(properties);
                };

                /**
                 * Encodes the specified SceneItemOperation message. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperation} message SceneItemOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationTypes != null && message.operationTypes.length)
                        for (let i = 0; i < message.operationTypes.length; ++i)
                            $root.vertexvis.protobuf.stream.SceneItemOperationType.encode(message.operationTypes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.queryExpression != null && Object.hasOwnProperty.call(message, "queryExpression"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.queryExpression, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneItemOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneItemOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneItemOperation} message SceneItemOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneItemOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneItemOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneItemOperation} SceneItemOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneItemOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.operationTypes && message.operationTypes.length))
                                message.operationTypes = [];
                            message.operationTypes.push($root.vertexvis.protobuf.stream.SceneItemOperationType.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.queryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneItemOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneItemOperation} SceneItemOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneItemOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneItemOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneItemOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationTypes != null && message.hasOwnProperty("operationTypes")) {
                        if (!Array.isArray(message.operationTypes))
                            return "operationTypes: array expected";
                        for (let i = 0; i < message.operationTypes.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.SceneItemOperationType.verify(message.operationTypes[i]);
                            if (error)
                                return "operationTypes." + error;
                        }
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression")) {
                        let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.queryExpression);
                        if (error)
                            return "queryExpression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneItemOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneItemOperation} SceneItemOperation
                 */
                SceneItemOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneItemOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneItemOperation();
                    if (object.operationTypes) {
                        if (!Array.isArray(object.operationTypes))
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperation.operationTypes: array expected");
                        message.operationTypes = [];
                        for (let i = 0; i < object.operationTypes.length; ++i) {
                            if (typeof object.operationTypes[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.SceneItemOperation.operationTypes: object expected");
                            message.operationTypes[i] = $root.vertexvis.protobuf.stream.SceneItemOperationType.fromObject(object.operationTypes[i]);
                        }
                    }
                    if (object.queryExpression != null) {
                        if (typeof object.queryExpression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneItemOperation.queryExpression: object expected");
                        message.queryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.queryExpression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneItemOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneItemOperation} message SceneItemOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneItemOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.operationTypes = [];
                    if (options.defaults)
                        object.queryExpression = null;
                    if (message.operationTypes && message.operationTypes.length) {
                        object.operationTypes = [];
                        for (let j = 0; j < message.operationTypes.length; ++j)
                            object.operationTypes[j] = $root.vertexvis.protobuf.stream.SceneItemOperationType.toObject(message.operationTypes[j], options);
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression"))
                        object.queryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.queryExpression, options);
                    return object;
                };

                /**
                 * Converts this SceneItemOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneItemOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneItemOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneItemOperation;
            })();

            stream.AnnotationQuery = (function() {

                /**
                 * Properties of an AnnotationQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IAnnotationQuery
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [id] AnnotationQuery id
                 */

                /**
                 * Constructs a new AnnotationQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an AnnotationQuery.
                 * @implements IAnnotationQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IAnnotationQuery=} [properties] Properties to set
                 */
                function AnnotationQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AnnotationQuery id.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} id
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @instance
                 */
                AnnotationQuery.prototype.id = null;

                /**
                 * Creates a new AnnotationQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnnotationQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.AnnotationQuery} AnnotationQuery instance
                 */
                AnnotationQuery.create = function create(properties) {
                    return new AnnotationQuery(properties);
                };

                /**
                 * Encodes the specified AnnotationQuery message. Does not implicitly {@link vertexvis.protobuf.stream.AnnotationQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnnotationQuery} message AnnotationQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnnotationQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AnnotationQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.AnnotationQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnnotationQuery} message AnnotationQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnnotationQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AnnotationQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.AnnotationQuery} AnnotationQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnnotationQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.AnnotationQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AnnotationQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.AnnotationQuery} AnnotationQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnnotationQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AnnotationQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AnnotationQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.id);
                        if (error)
                            return "id." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AnnotationQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.AnnotationQuery} AnnotationQuery
                 */
                AnnotationQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.AnnotationQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.AnnotationQuery();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.AnnotationQuery.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.id);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AnnotationQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.AnnotationQuery} message AnnotationQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AnnotationQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.id = null;
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.id, options);
                    return object;
                };

                /**
                 * Converts this AnnotationQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.AnnotationQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AnnotationQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AnnotationQuery;
            })();

            stream.PmiAnnotationOverrideQuery = (function() {

                /**
                 * Properties of a PmiAnnotationOverrideQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationOverrideQuery
                 * @property {vertexvis.protobuf.stream.ISelectionQuery|null} [selection] PmiAnnotationOverrideQuery selection
                 * @property {vertexvis.protobuf.stream.IVisibilityQuery|null} [visibility] PmiAnnotationOverrideQuery visibility
                 */

                /**
                 * Constructs a new PmiAnnotationOverrideQuery.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationOverrideQuery.
                 * @implements IPmiAnnotationOverrideQuery
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery=} [properties] Properties to set
                 */
                function PmiAnnotationOverrideQuery(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationOverrideQuery selection.
                 * @member {vertexvis.protobuf.stream.ISelectionQuery|null|undefined} selection
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @instance
                 */
                PmiAnnotationOverrideQuery.prototype.selection = null;

                /**
                 * PmiAnnotationOverrideQuery visibility.
                 * @member {vertexvis.protobuf.stream.IVisibilityQuery|null|undefined} visibility
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @instance
                 */
                PmiAnnotationOverrideQuery.prototype.visibility = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PmiAnnotationOverrideQuery override.
                 * @member {"selection"|"visibility"|undefined} override
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @instance
                 */
                Object.defineProperty(PmiAnnotationOverrideQuery.prototype, "override", {
                    get: $util.oneOfGetter($oneOfFields = ["selection", "visibility"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PmiAnnotationOverrideQuery instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOverrideQuery} PmiAnnotationOverrideQuery instance
                 */
                PmiAnnotationOverrideQuery.create = function create(properties) {
                    return new PmiAnnotationOverrideQuery(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationOverrideQuery message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery} message PmiAnnotationOverrideQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOverrideQuery.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.selection != null && Object.hasOwnProperty.call(message, "selection"))
                        $root.vertexvis.protobuf.stream.SelectionQuery.encode(message.selection, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.visibility != null && Object.hasOwnProperty.call(message, "visibility"))
                        $root.vertexvis.protobuf.stream.VisibilityQuery.encode(message.visibility, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationOverrideQuery message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery} message PmiAnnotationOverrideQuery message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOverrideQuery.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationOverrideQuery message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOverrideQuery} PmiAnnotationOverrideQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOverrideQuery.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.selection = $root.vertexvis.protobuf.stream.SelectionQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationOverrideQuery message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOverrideQuery} PmiAnnotationOverrideQuery
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOverrideQuery.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationOverrideQuery message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationOverrideQuery.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.selection != null && message.hasOwnProperty("selection")) {
                        properties.override = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SelectionQuery.verify(message.selection);
                            if (error)
                                return "selection." + error;
                        }
                    }
                    if (message.visibility != null && message.hasOwnProperty("visibility")) {
                        if (properties.override === 1)
                            return "override: multiple values";
                        properties.override = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.VisibilityQuery.verify(message.visibility);
                            if (error)
                                return "visibility." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationOverrideQuery message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOverrideQuery} PmiAnnotationOverrideQuery
                 */
                PmiAnnotationOverrideQuery.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery();
                    if (object.selection != null) {
                        if (typeof object.selection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.selection: object expected");
                        message.selection = $root.vertexvis.protobuf.stream.SelectionQuery.fromObject(object.selection);
                    }
                    if (object.visibility != null) {
                        if (typeof object.visibility !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.visibility: object expected");
                        message.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.fromObject(object.visibility);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationOverrideQuery message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationOverrideQuery} message PmiAnnotationOverrideQuery
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationOverrideQuery.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.selection != null && message.hasOwnProperty("selection")) {
                        object.selection = $root.vertexvis.protobuf.stream.SelectionQuery.toObject(message.selection, options);
                        if (options.oneofs)
                            object.override = "selection";
                    }
                    if (message.visibility != null && message.hasOwnProperty("visibility")) {
                        object.visibility = $root.vertexvis.protobuf.stream.VisibilityQuery.toObject(message.visibility, options);
                        if (options.oneofs)
                            object.override = "visibility";
                    }
                    return object;
                };

                /**
                 * Converts this PmiAnnotationOverrideQuery to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOverrideQuery
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationOverrideQuery.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationOverrideQuery;
            })();

            stream.PmiAnnotationOperationType = (function() {

                /**
                 * Properties of a PmiAnnotationOperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationOperationType
                 * @property {vertexvis.protobuf.stream.IChangeVisibilityOperation|null} [changeVisibility] PmiAnnotationOperationType changeVisibility
                 * @property {vertexvis.protobuf.stream.IChangeSelectionOperation|null} [changeSelection] PmiAnnotationOperationType changeSelection
                 */

                /**
                 * Constructs a new PmiAnnotationOperationType.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationOperationType.
                 * @implements IPmiAnnotationOperationType
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperationType=} [properties] Properties to set
                 */
                function PmiAnnotationOperationType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationOperationType changeVisibility.
                 * @member {vertexvis.protobuf.stream.IChangeVisibilityOperation|null|undefined} changeVisibility
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @instance
                 */
                PmiAnnotationOperationType.prototype.changeVisibility = null;

                /**
                 * PmiAnnotationOperationType changeSelection.
                 * @member {vertexvis.protobuf.stream.IChangeSelectionOperation|null|undefined} changeSelection
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @instance
                 */
                PmiAnnotationOperationType.prototype.changeSelection = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PmiAnnotationOperationType operationType.
                 * @member {"changeVisibility"|"changeSelection"|undefined} operationType
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @instance
                 */
                Object.defineProperty(PmiAnnotationOperationType.prototype, "operationType", {
                    get: $util.oneOfGetter($oneOfFields = ["changeVisibility", "changeSelection"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PmiAnnotationOperationType instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperationType=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperationType} PmiAnnotationOperationType instance
                 */
                PmiAnnotationOperationType.create = function create(properties) {
                    return new PmiAnnotationOperationType(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationOperationType message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOperationType.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperationType} message PmiAnnotationOperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOperationType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.changeVisibility != null && Object.hasOwnProperty.call(message, "changeVisibility"))
                        $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.encode(message.changeVisibility, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.changeSelection != null && Object.hasOwnProperty.call(message, "changeSelection"))
                        $root.vertexvis.protobuf.stream.ChangeSelectionOperation.encode(message.changeSelection, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationOperationType message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOperationType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperationType} message PmiAnnotationOperationType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOperationType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationOperationType message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperationType} PmiAnnotationOperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOperationType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationOperationType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationOperationType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperationType} PmiAnnotationOperationType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOperationType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationOperationType message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationOperationType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        properties.operationType = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.verify(message.changeVisibility);
                            if (error)
                                return "changeVisibility." + error;
                        }
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        if (properties.operationType === 1)
                            return "operationType: multiple values";
                        properties.operationType = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.verify(message.changeSelection);
                            if (error)
                                return "changeSelection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationOperationType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperationType} PmiAnnotationOperationType
                 */
                PmiAnnotationOperationType.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationOperationType)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationOperationType();
                    if (object.changeVisibility != null) {
                        if (typeof object.changeVisibility !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOperationType.changeVisibility: object expected");
                        message.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.fromObject(object.changeVisibility);
                    }
                    if (object.changeSelection != null) {
                        if (typeof object.changeSelection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOperationType.changeSelection: object expected");
                        message.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.fromObject(object.changeSelection);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationOperationType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationOperationType} message PmiAnnotationOperationType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationOperationType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.changeVisibility != null && message.hasOwnProperty("changeVisibility")) {
                        object.changeVisibility = $root.vertexvis.protobuf.stream.ChangeVisibilityOperation.toObject(message.changeVisibility, options);
                        if (options.oneofs)
                            object.operationType = "changeVisibility";
                    }
                    if (message.changeSelection != null && message.hasOwnProperty("changeSelection")) {
                        object.changeSelection = $root.vertexvis.protobuf.stream.ChangeSelectionOperation.toObject(message.changeSelection, options);
                        if (options.oneofs)
                            object.operationType = "changeSelection";
                    }
                    return object;
                };

                /**
                 * Converts this PmiAnnotationOperationType to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperationType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationOperationType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationOperationType;
            })();

            stream.PmiAnnotationQueryOperand = (function() {

                /**
                 * Properties of a PmiAnnotationQueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationQueryOperand
                 * @property {vertexvis.protobuf.stream.IAnnotationQuery|null} [annotation] PmiAnnotationQueryOperand annotation
                 * @property {vertexvis.protobuf.stream.IAllQuery|null} [all] PmiAnnotationQueryOperand all
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery|null} [override] PmiAnnotationQueryOperand override
                 */

                /**
                 * Constructs a new PmiAnnotationQueryOperand.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationQueryOperand.
                 * @implements IPmiAnnotationQueryOperand
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand=} [properties] Properties to set
                 */
                function PmiAnnotationQueryOperand(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationQueryOperand annotation.
                 * @member {vertexvis.protobuf.stream.IAnnotationQuery|null|undefined} annotation
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @instance
                 */
                PmiAnnotationQueryOperand.prototype.annotation = null;

                /**
                 * PmiAnnotationQueryOperand all.
                 * @member {vertexvis.protobuf.stream.IAllQuery|null|undefined} all
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @instance
                 */
                PmiAnnotationQueryOperand.prototype.all = null;

                /**
                 * PmiAnnotationQueryOperand override.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationOverrideQuery|null|undefined} override
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @instance
                 */
                PmiAnnotationQueryOperand.prototype.override = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PmiAnnotationQueryOperand operand.
                 * @member {"annotation"|"all"|"override"|undefined} operand
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @instance
                 */
                Object.defineProperty(PmiAnnotationQueryOperand.prototype, "operand", {
                    get: $util.oneOfGetter($oneOfFields = ["annotation", "all", "override"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PmiAnnotationQueryOperand instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryOperand} PmiAnnotationQueryOperand instance
                 */
                PmiAnnotationQueryOperand.create = function create(properties) {
                    return new PmiAnnotationQueryOperand(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationQueryOperand message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationQueryOperand.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand} message PmiAnnotationQueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationQueryOperand.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.annotation != null && Object.hasOwnProperty.call(message, "annotation"))
                        $root.vertexvis.protobuf.stream.AnnotationQuery.encode(message.annotation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.all != null && Object.hasOwnProperty.call(message, "all"))
                        $root.vertexvis.protobuf.stream.AllQuery.encode(message.all, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.override != null && Object.hasOwnProperty.call(message, "override"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.encode(message.override, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationQueryOperand message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationQueryOperand.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand} message PmiAnnotationQueryOperand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationQueryOperand.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationQueryOperand message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryOperand} PmiAnnotationQueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationQueryOperand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.annotation = $root.vertexvis.protobuf.stream.AnnotationQuery.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.all = $root.vertexvis.protobuf.stream.AllQuery.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.override = $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationQueryOperand message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryOperand} PmiAnnotationQueryOperand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationQueryOperand.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationQueryOperand message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationQueryOperand.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.annotation != null && message.hasOwnProperty("annotation")) {
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.AnnotationQuery.verify(message.annotation);
                            if (error)
                                return "annotation." + error;
                        }
                    }
                    if (message.all != null && message.hasOwnProperty("all")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.AllQuery.verify(message.all);
                            if (error)
                                return "all." + error;
                        }
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        if (properties.operand === 1)
                            return "operand: multiple values";
                        properties.operand = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.verify(message.override);
                            if (error)
                                return "override." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationQueryOperand message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryOperand} PmiAnnotationQueryOperand
                 */
                PmiAnnotationQueryOperand.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand();
                    if (object.annotation != null) {
                        if (typeof object.annotation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryOperand.annotation: object expected");
                        message.annotation = $root.vertexvis.protobuf.stream.AnnotationQuery.fromObject(object.annotation);
                    }
                    if (object.all != null) {
                        if (typeof object.all !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryOperand.all: object expected");
                        message.all = $root.vertexvis.protobuf.stream.AllQuery.fromObject(object.all);
                    }
                    if (object.override != null) {
                        if (typeof object.override !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryOperand.override: object expected");
                        message.override = $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.fromObject(object.override);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationQueryOperand message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationQueryOperand} message PmiAnnotationQueryOperand
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationQueryOperand.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.annotation != null && message.hasOwnProperty("annotation")) {
                        object.annotation = $root.vertexvis.protobuf.stream.AnnotationQuery.toObject(message.annotation, options);
                        if (options.oneofs)
                            object.operand = "annotation";
                    }
                    if (message.all != null && message.hasOwnProperty("all")) {
                        object.all = $root.vertexvis.protobuf.stream.AllQuery.toObject(message.all, options);
                        if (options.oneofs)
                            object.operand = "all";
                    }
                    if (message.override != null && message.hasOwnProperty("override")) {
                        object.override = $root.vertexvis.protobuf.stream.PmiAnnotationOverrideQuery.toObject(message.override, options);
                        if (options.oneofs)
                            object.operand = "override";
                    }
                    return object;
                };

                /**
                 * Converts this PmiAnnotationQueryOperand to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryOperand
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationQueryOperand.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationQueryOperand;
            })();

            stream.PmiAnnotationNotExpression = (function() {

                /**
                 * Properties of a PmiAnnotationNotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationNotExpression
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [expression] PmiAnnotationNotExpression expression
                 */

                /**
                 * Constructs a new PmiAnnotationNotExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationNotExpression.
                 * @implements IPmiAnnotationNotExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationNotExpression=} [properties] Properties to set
                 */
                function PmiAnnotationNotExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationNotExpression expression.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} expression
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @instance
                 */
                PmiAnnotationNotExpression.prototype.expression = null;

                /**
                 * Creates a new PmiAnnotationNotExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationNotExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationNotExpression} PmiAnnotationNotExpression instance
                 */
                PmiAnnotationNotExpression.create = function create(properties) {
                    return new PmiAnnotationNotExpression(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationNotExpression message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationNotExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationNotExpression} message PmiAnnotationNotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationNotExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.expression != null && Object.hasOwnProperty.call(message, "expression"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.expression, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationNotExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationNotExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationNotExpression} message PmiAnnotationNotExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationNotExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationNotExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationNotExpression} PmiAnnotationNotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationNotExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.expression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationNotExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationNotExpression} PmiAnnotationNotExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationNotExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationNotExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationNotExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.expression != null && message.hasOwnProperty("expression")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.expression);
                        if (error)
                            return "expression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationNotExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationNotExpression} PmiAnnotationNotExpression
                 */
                PmiAnnotationNotExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression();
                    if (object.expression != null) {
                        if (typeof object.expression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationNotExpression.expression: object expected");
                        message.expression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.expression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationNotExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationNotExpression} message PmiAnnotationNotExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationNotExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.expression = null;
                    if (message.expression != null && message.hasOwnProperty("expression"))
                        object.expression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.expression, options);
                    return object;
                };

                /**
                 * Converts this PmiAnnotationNotExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationNotExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationNotExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationNotExpression;
            })();

            stream.PmiAnnotationOrExpression = (function() {

                /**
                 * Properties of a PmiAnnotationOrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationOrExpression
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [first] PmiAnnotationOrExpression first
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [second] PmiAnnotationOrExpression second
                 */

                /**
                 * Constructs a new PmiAnnotationOrExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationOrExpression.
                 * @implements IPmiAnnotationOrExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOrExpression=} [properties] Properties to set
                 */
                function PmiAnnotationOrExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationOrExpression first.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @instance
                 */
                PmiAnnotationOrExpression.prototype.first = null;

                /**
                 * PmiAnnotationOrExpression second.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @instance
                 */
                PmiAnnotationOrExpression.prototype.second = null;

                /**
                 * Creates a new PmiAnnotationOrExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOrExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOrExpression} PmiAnnotationOrExpression instance
                 */
                PmiAnnotationOrExpression.create = function create(properties) {
                    return new PmiAnnotationOrExpression(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationOrExpression message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOrExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOrExpression} message PmiAnnotationOrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOrExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationOrExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOrExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOrExpression} message PmiAnnotationOrExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOrExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationOrExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOrExpression} PmiAnnotationOrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOrExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationOrExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOrExpression} PmiAnnotationOrExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOrExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationOrExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationOrExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationOrExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOrExpression} PmiAnnotationOrExpression
                 */
                PmiAnnotationOrExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOrExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOrExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationOrExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationOrExpression} message PmiAnnotationOrExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationOrExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this PmiAnnotationOrExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOrExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationOrExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationOrExpression;
            })();

            stream.PmiAnnotationAndExpression = (function() {

                /**
                 * Properties of a PmiAnnotationAndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationAndExpression
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [first] PmiAnnotationAndExpression first
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [second] PmiAnnotationAndExpression second
                 */

                /**
                 * Constructs a new PmiAnnotationAndExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationAndExpression.
                 * @implements IPmiAnnotationAndExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationAndExpression=} [properties] Properties to set
                 */
                function PmiAnnotationAndExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationAndExpression first.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} first
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @instance
                 */
                PmiAnnotationAndExpression.prototype.first = null;

                /**
                 * PmiAnnotationAndExpression second.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} second
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @instance
                 */
                PmiAnnotationAndExpression.prototype.second = null;

                /**
                 * Creates a new PmiAnnotationAndExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationAndExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationAndExpression} PmiAnnotationAndExpression instance
                 */
                PmiAnnotationAndExpression.create = function create(properties) {
                    return new PmiAnnotationAndExpression(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationAndExpression message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationAndExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationAndExpression} message PmiAnnotationAndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationAndExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.first != null && Object.hasOwnProperty.call(message, "first"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.first, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.second, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationAndExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationAndExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationAndExpression} message PmiAnnotationAndExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationAndExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationAndExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationAndExpression} PmiAnnotationAndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationAndExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationAndExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationAndExpression} PmiAnnotationAndExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationAndExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationAndExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationAndExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.first != null && message.hasOwnProperty("first")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.first);
                        if (error)
                            return "first." + error;
                    }
                    if (message.second != null && message.hasOwnProperty("second")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.second);
                        if (error)
                            return "second." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationAndExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationAndExpression} PmiAnnotationAndExpression
                 */
                PmiAnnotationAndExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression();
                    if (object.first != null) {
                        if (typeof object.first !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationAndExpression.first: object expected");
                        message.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.first);
                    }
                    if (object.second != null) {
                        if (typeof object.second !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationAndExpression.second: object expected");
                        message.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.second);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationAndExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationAndExpression} message PmiAnnotationAndExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationAndExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.first = null;
                        object.second = null;
                    }
                    if (message.first != null && message.hasOwnProperty("first"))
                        object.first = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.first, options);
                    if (message.second != null && message.hasOwnProperty("second"))
                        object.second = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.second, options);
                    return object;
                };

                /**
                 * Converts this PmiAnnotationAndExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationAndExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationAndExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationAndExpression;
            })();

            stream.PmiAnnotationQueryExpression = (function() {

                /**
                 * Properties of a PmiAnnotationQueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationQueryExpression
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand|null} [operand] PmiAnnotationQueryExpression operand
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationOrExpression|null} [or] PmiAnnotationQueryExpression or
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationAndExpression|null} [and] PmiAnnotationQueryExpression and
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationNotExpression|null} [not] PmiAnnotationQueryExpression not
                 */

                /**
                 * Constructs a new PmiAnnotationQueryExpression.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationQueryExpression.
                 * @implements IPmiAnnotationQueryExpression
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression=} [properties] Properties to set
                 */
                function PmiAnnotationQueryExpression(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationQueryExpression operand.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryOperand|null|undefined} operand
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 */
                PmiAnnotationQueryExpression.prototype.operand = null;

                /**
                 * PmiAnnotationQueryExpression or.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationOrExpression|null|undefined} or
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 */
                PmiAnnotationQueryExpression.prototype.or = null;

                /**
                 * PmiAnnotationQueryExpression and.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationAndExpression|null|undefined} and
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 */
                PmiAnnotationQueryExpression.prototype.and = null;

                /**
                 * PmiAnnotationQueryExpression not.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationNotExpression|null|undefined} not
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 */
                PmiAnnotationQueryExpression.prototype.not = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PmiAnnotationQueryExpression sealedValue.
                 * @member {"operand"|"or"|"and"|"not"|undefined} sealedValue
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 */
                Object.defineProperty(PmiAnnotationQueryExpression.prototype, "sealedValue", {
                    get: $util.oneOfGetter($oneOfFields = ["operand", "or", "and", "not"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PmiAnnotationQueryExpression instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryExpression} PmiAnnotationQueryExpression instance
                 */
                PmiAnnotationQueryExpression.create = function create(properties) {
                    return new PmiAnnotationQueryExpression(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationQueryExpression message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression} message PmiAnnotationQueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationQueryExpression.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operand != null && Object.hasOwnProperty.call(message, "operand"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand.encode(message.operand, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.or != null && Object.hasOwnProperty.call(message, "or"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression.encode(message.or, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.and != null && Object.hasOwnProperty.call(message, "and"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression.encode(message.and, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.not != null && Object.hasOwnProperty.call(message, "not"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression.encode(message.not, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationQueryExpression message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression} message PmiAnnotationQueryExpression message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationQueryExpression.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationQueryExpression message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryExpression} PmiAnnotationQueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationQueryExpression.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.operand = $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.or = $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.and = $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.not = $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationQueryExpression message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryExpression} PmiAnnotationQueryExpression
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationQueryExpression.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationQueryExpression message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationQueryExpression.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand.verify(message.operand);
                            if (error)
                                return "operand." + error;
                        }
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression.verify(message.or);
                            if (error)
                                return "or." + error;
                        }
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression.verify(message.and);
                            if (error)
                                return "and." + error;
                        }
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        if (properties.sealedValue === 1)
                            return "sealedValue: multiple values";
                        properties.sealedValue = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression.verify(message.not);
                            if (error)
                                return "not." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationQueryExpression message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationQueryExpression} PmiAnnotationQueryExpression
                 */
                PmiAnnotationQueryExpression.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression();
                    if (object.operand != null) {
                        if (typeof object.operand !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryExpression.operand: object expected");
                        message.operand = $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand.fromObject(object.operand);
                    }
                    if (object.or != null) {
                        if (typeof object.or !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryExpression.or: object expected");
                        message.or = $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression.fromObject(object.or);
                    }
                    if (object.and != null) {
                        if (typeof object.and !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryExpression.and: object expected");
                        message.and = $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression.fromObject(object.and);
                    }
                    if (object.not != null) {
                        if (typeof object.not !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationQueryExpression.not: object expected");
                        message.not = $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression.fromObject(object.not);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationQueryExpression message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationQueryExpression} message PmiAnnotationQueryExpression
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationQueryExpression.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.operand != null && message.hasOwnProperty("operand")) {
                        object.operand = $root.vertexvis.protobuf.stream.PmiAnnotationQueryOperand.toObject(message.operand, options);
                        if (options.oneofs)
                            object.sealedValue = "operand";
                    }
                    if (message.or != null && message.hasOwnProperty("or")) {
                        object.or = $root.vertexvis.protobuf.stream.PmiAnnotationOrExpression.toObject(message.or, options);
                        if (options.oneofs)
                            object.sealedValue = "or";
                    }
                    if (message.and != null && message.hasOwnProperty("and")) {
                        object.and = $root.vertexvis.protobuf.stream.PmiAnnotationAndExpression.toObject(message.and, options);
                        if (options.oneofs)
                            object.sealedValue = "and";
                    }
                    if (message.not != null && message.hasOwnProperty("not")) {
                        object.not = $root.vertexvis.protobuf.stream.PmiAnnotationNotExpression.toObject(message.not, options);
                        if (options.oneofs)
                            object.sealedValue = "not";
                    }
                    return object;
                };

                /**
                 * Converts this PmiAnnotationQueryExpression to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationQueryExpression
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationQueryExpression.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationQueryExpression;
            })();

            stream.PmiAnnotationOperation = (function() {

                /**
                 * Properties of a PmiAnnotationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPmiAnnotationOperation
                 * @property {Array.<vertexvis.protobuf.stream.IPmiAnnotationOperationType>|null} [operationTypes] PmiAnnotationOperation operationTypes
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null} [queryExpression] PmiAnnotationOperation queryExpression
                 */

                /**
                 * Constructs a new PmiAnnotationOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PmiAnnotationOperation.
                 * @implements IPmiAnnotationOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperation=} [properties] Properties to set
                 */
                function PmiAnnotationOperation(properties) {
                    this.operationTypes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotationOperation operationTypes.
                 * @member {Array.<vertexvis.protobuf.stream.IPmiAnnotationOperationType>} operationTypes
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @instance
                 */
                PmiAnnotationOperation.prototype.operationTypes = $util.emptyArray;

                /**
                 * PmiAnnotationOperation queryExpression.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationQueryExpression|null|undefined} queryExpression
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @instance
                 */
                PmiAnnotationOperation.prototype.queryExpression = null;

                /**
                 * Creates a new PmiAnnotationOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperation} PmiAnnotationOperation instance
                 */
                PmiAnnotationOperation.create = function create(properties) {
                    return new PmiAnnotationOperation(properties);
                };

                /**
                 * Encodes the specified PmiAnnotationOperation message. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperation} message PmiAnnotationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.operationTypes != null && message.operationTypes.length)
                        for (let i = 0; i < message.operationTypes.length; ++i)
                            $root.vertexvis.protobuf.stream.PmiAnnotationOperationType.encode(message.operationTypes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.queryExpression != null && Object.hasOwnProperty.call(message, "queryExpression"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.encode(message.queryExpression, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotationOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PmiAnnotationOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.IPmiAnnotationOperation} message PmiAnnotationOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotationOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotationOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperation} PmiAnnotationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PmiAnnotationOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.operationTypes && message.operationTypes.length))
                                message.operationTypes = [];
                            message.operationTypes.push($root.vertexvis.protobuf.stream.PmiAnnotationOperationType.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.queryExpression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotationOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperation} PmiAnnotationOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotationOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotationOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotationOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.operationTypes != null && message.hasOwnProperty("operationTypes")) {
                        if (!Array.isArray(message.operationTypes))
                            return "operationTypes: array expected";
                        for (let i = 0; i < message.operationTypes.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationOperationType.verify(message.operationTypes[i]);
                            if (error)
                                return "operationTypes." + error;
                        }
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression")) {
                        let error = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.verify(message.queryExpression);
                        if (error)
                            return "queryExpression." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PmiAnnotationOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PmiAnnotationOperation} PmiAnnotationOperation
                 */
                PmiAnnotationOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PmiAnnotationOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PmiAnnotationOperation();
                    if (object.operationTypes) {
                        if (!Array.isArray(object.operationTypes))
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOperation.operationTypes: array expected");
                        message.operationTypes = [];
                        for (let i = 0; i < object.operationTypes.length; ++i) {
                            if (typeof object.operationTypes[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOperation.operationTypes: object expected");
                            message.operationTypes[i] = $root.vertexvis.protobuf.stream.PmiAnnotationOperationType.fromObject(object.operationTypes[i]);
                        }
                    }
                    if (object.queryExpression != null) {
                        if (typeof object.queryExpression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PmiAnnotationOperation.queryExpression: object expected");
                        message.queryExpression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.fromObject(object.queryExpression);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotationOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.PmiAnnotationOperation} message PmiAnnotationOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotationOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.operationTypes = [];
                    if (options.defaults)
                        object.queryExpression = null;
                    if (message.operationTypes && message.operationTypes.length) {
                        object.operationTypes = [];
                        for (let j = 0; j < message.operationTypes.length; ++j)
                            object.operationTypes[j] = $root.vertexvis.protobuf.stream.PmiAnnotationOperationType.toObject(message.operationTypes[j], options);
                    }
                    if (message.queryExpression != null && message.hasOwnProperty("queryExpression"))
                        object.queryExpression = $root.vertexvis.protobuf.stream.PmiAnnotationQueryExpression.toObject(message.queryExpression, options);
                    return object;
                };

                /**
                 * Converts this PmiAnnotationOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PmiAnnotationOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotationOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotationOperation;
            })();

            stream.SceneElementOperation = (function() {

                /**
                 * Properties of a SceneElementOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneElementOperation
                 * @property {vertexvis.protobuf.stream.ISceneItemOperation|null} [sceneItemOperation] SceneElementOperation sceneItemOperation
                 * @property {vertexvis.protobuf.stream.IPmiAnnotationOperation|null} [pmiAnnotationOperation] SceneElementOperation pmiAnnotationOperation
                 */

                /**
                 * Constructs a new SceneElementOperation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneElementOperation.
                 * @implements ISceneElementOperation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneElementOperation=} [properties] Properties to set
                 */
                function SceneElementOperation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneElementOperation sceneItemOperation.
                 * @member {vertexvis.protobuf.stream.ISceneItemOperation|null|undefined} sceneItemOperation
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @instance
                 */
                SceneElementOperation.prototype.sceneItemOperation = null;

                /**
                 * SceneElementOperation pmiAnnotationOperation.
                 * @member {vertexvis.protobuf.stream.IPmiAnnotationOperation|null|undefined} pmiAnnotationOperation
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @instance
                 */
                SceneElementOperation.prototype.pmiAnnotationOperation = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneElementOperation operation.
                 * @member {"sceneItemOperation"|"pmiAnnotationOperation"|undefined} operation
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @instance
                 */
                Object.defineProperty(SceneElementOperation.prototype, "operation", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneItemOperation", "pmiAnnotationOperation"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneElementOperation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneElementOperation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneElementOperation} SceneElementOperation instance
                 */
                SceneElementOperation.create = function create(properties) {
                    return new SceneElementOperation(properties);
                };

                /**
                 * Encodes the specified SceneElementOperation message. Does not implicitly {@link vertexvis.protobuf.stream.SceneElementOperation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneElementOperation} message SceneElementOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneElementOperation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sceneItemOperation != null && Object.hasOwnProperty.call(message, "sceneItemOperation"))
                        $root.vertexvis.protobuf.stream.SceneItemOperation.encode(message.sceneItemOperation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pmiAnnotationOperation != null && Object.hasOwnProperty.call(message, "pmiAnnotationOperation"))
                        $root.vertexvis.protobuf.stream.PmiAnnotationOperation.encode(message.pmiAnnotationOperation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneElementOperation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneElementOperation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneElementOperation} message SceneElementOperation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneElementOperation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneElementOperation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneElementOperation} SceneElementOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneElementOperation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneElementOperation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sceneItemOperation = $root.vertexvis.protobuf.stream.SceneItemOperation.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.pmiAnnotationOperation = $root.vertexvis.protobuf.stream.PmiAnnotationOperation.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneElementOperation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneElementOperation} SceneElementOperation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneElementOperation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneElementOperation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneElementOperation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.sceneItemOperation != null && message.hasOwnProperty("sceneItemOperation")) {
                        properties.operation = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemOperation.verify(message.sceneItemOperation);
                            if (error)
                                return "sceneItemOperation." + error;
                        }
                    }
                    if (message.pmiAnnotationOperation != null && message.hasOwnProperty("pmiAnnotationOperation")) {
                        if (properties.operation === 1)
                            return "operation: multiple values";
                        properties.operation = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.PmiAnnotationOperation.verify(message.pmiAnnotationOperation);
                            if (error)
                                return "pmiAnnotationOperation." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SceneElementOperation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneElementOperation} SceneElementOperation
                 */
                SceneElementOperation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneElementOperation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneElementOperation();
                    if (object.sceneItemOperation != null) {
                        if (typeof object.sceneItemOperation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneElementOperation.sceneItemOperation: object expected");
                        message.sceneItemOperation = $root.vertexvis.protobuf.stream.SceneItemOperation.fromObject(object.sceneItemOperation);
                    }
                    if (object.pmiAnnotationOperation != null) {
                        if (typeof object.pmiAnnotationOperation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneElementOperation.pmiAnnotationOperation: object expected");
                        message.pmiAnnotationOperation = $root.vertexvis.protobuf.stream.PmiAnnotationOperation.fromObject(object.pmiAnnotationOperation);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneElementOperation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneElementOperation} message SceneElementOperation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneElementOperation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.sceneItemOperation != null && message.hasOwnProperty("sceneItemOperation")) {
                        object.sceneItemOperation = $root.vertexvis.protobuf.stream.SceneItemOperation.toObject(message.sceneItemOperation, options);
                        if (options.oneofs)
                            object.operation = "sceneItemOperation";
                    }
                    if (message.pmiAnnotationOperation != null && message.hasOwnProperty("pmiAnnotationOperation")) {
                        object.pmiAnnotationOperation = $root.vertexvis.protobuf.stream.PmiAnnotationOperation.toObject(message.pmiAnnotationOperation, options);
                        if (options.oneofs)
                            object.operation = "pmiAnnotationOperation";
                    }
                    return object;
                };

                /**
                 * Converts this SceneElementOperation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneElementOperation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneElementOperation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneElementOperation;
            })();

            stream.PerformanceTiming = (function() {

                /**
                 * Properties of a PerformanceTiming.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPerformanceTiming
                 * @property {google.protobuf.IDuration|null} [receiveToPaintDuration] PerformanceTiming receiveToPaintDuration
                 */

                /**
                 * Constructs a new PerformanceTiming.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PerformanceTiming.
                 * @implements IPerformanceTiming
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPerformanceTiming=} [properties] Properties to set
                 */
                function PerformanceTiming(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PerformanceTiming receiveToPaintDuration.
                 * @member {google.protobuf.IDuration|null|undefined} receiveToPaintDuration
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @instance
                 */
                PerformanceTiming.prototype.receiveToPaintDuration = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PerformanceTiming timing.
                 * @member {"receiveToPaintDuration"|undefined} timing
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @instance
                 */
                Object.defineProperty(PerformanceTiming.prototype, "timing", {
                    get: $util.oneOfGetter($oneOfFields = ["receiveToPaintDuration"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PerformanceTiming instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerformanceTiming=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PerformanceTiming} PerformanceTiming instance
                 */
                PerformanceTiming.create = function create(properties) {
                    return new PerformanceTiming(properties);
                };

                /**
                 * Encodes the specified PerformanceTiming message. Does not implicitly {@link vertexvis.protobuf.stream.PerformanceTiming.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerformanceTiming} message PerformanceTiming message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerformanceTiming.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.receiveToPaintDuration != null && Object.hasOwnProperty.call(message, "receiveToPaintDuration"))
                        $root.google.protobuf.Duration.encode(message.receiveToPaintDuration, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PerformanceTiming message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PerformanceTiming.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {vertexvis.protobuf.stream.IPerformanceTiming} message PerformanceTiming message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerformanceTiming.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PerformanceTiming message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PerformanceTiming} PerformanceTiming
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerformanceTiming.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PerformanceTiming();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.receiveToPaintDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PerformanceTiming message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PerformanceTiming} PerformanceTiming
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerformanceTiming.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PerformanceTiming message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PerformanceTiming.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.receiveToPaintDuration != null && message.hasOwnProperty("receiveToPaintDuration")) {
                        properties.timing = 1;
                        {
                            let error = $root.google.protobuf.Duration.verify(message.receiveToPaintDuration);
                            if (error)
                                return "receiveToPaintDuration." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PerformanceTiming message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PerformanceTiming} PerformanceTiming
                 */
                PerformanceTiming.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PerformanceTiming)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PerformanceTiming();
                    if (object.receiveToPaintDuration != null) {
                        if (typeof object.receiveToPaintDuration !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PerformanceTiming.receiveToPaintDuration: object expected");
                        message.receiveToPaintDuration = $root.google.protobuf.Duration.fromObject(object.receiveToPaintDuration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PerformanceTiming message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @static
                 * @param {vertexvis.protobuf.stream.PerformanceTiming} message PerformanceTiming
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PerformanceTiming.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.receiveToPaintDuration != null && message.hasOwnProperty("receiveToPaintDuration")) {
                        object.receiveToPaintDuration = $root.google.protobuf.Duration.toObject(message.receiveToPaintDuration, options);
                        if (options.oneofs)
                            object.timing = "receiveToPaintDuration";
                    }
                    return object;
                };

                /**
                 * Converts this PerformanceTiming to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PerformanceTiming
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PerformanceTiming.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PerformanceTiming;
            })();

            stream.StreamAttributes = (function() {

                /**
                 * Properties of a StreamAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStreamAttributes
                 * @property {vertexvis.protobuf.stream.IDepthBufferAttributes|null} [depthBuffers] StreamAttributes depthBuffers
                 * @property {vertexvis.protobuf.stream.IFeatureLineAttributes|null} [featureLines] StreamAttributes featureLines
                 * @property {vertexvis.protobuf.stream.IFeatureHighlightAttributes|null} [featureHighlighting] StreamAttributes featureHighlighting
                 * @property {vertexvis.protobuf.stream.IFeatureMapAttributes|null} [featureMaps] StreamAttributes featureMaps
                 * @property {boolean|null} [noDefaultLights] StreamAttributes noDefaultLights
                 * @property {string|null} [experimentalRenderingOptions] StreamAttributes experimentalRenderingOptions
                 * @property {vertexvis.protobuf.stream.ISelectionHighlightAttributes|null} [selectionHighlighting] StreamAttributes selectionHighlighting
                 * @property {vertexvis.protobuf.stream.IPhantomAttributes|null} [phantomItems] StreamAttributes phantomItems
                 * @property {vertexvis.protobuf.stream.IFrameAttributes|null} [frames] StreamAttributes frames
                 * @property {vertexvis.protobuf.stream.ISceneComparisonAttributes|null} [sceneComparison] StreamAttributes sceneComparison
                 * @property {vertexvis.protobuf.stream.ICrossSectioningAttributes|null} [crossSectioningAttributes] StreamAttributes crossSectioningAttributes
                 */

                /**
                 * Constructs a new StreamAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StreamAttributes.
                 * @implements IStreamAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStreamAttributes=} [properties] Properties to set
                 */
                function StreamAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StreamAttributes depthBuffers.
                 * @member {vertexvis.protobuf.stream.IDepthBufferAttributes|null|undefined} depthBuffers
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.depthBuffers = null;

                /**
                 * StreamAttributes featureLines.
                 * @member {vertexvis.protobuf.stream.IFeatureLineAttributes|null|undefined} featureLines
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.featureLines = null;

                /**
                 * StreamAttributes featureHighlighting.
                 * @member {vertexvis.protobuf.stream.IFeatureHighlightAttributes|null|undefined} featureHighlighting
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.featureHighlighting = null;

                /**
                 * StreamAttributes featureMaps.
                 * @member {vertexvis.protobuf.stream.IFeatureMapAttributes|null|undefined} featureMaps
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.featureMaps = null;

                /**
                 * StreamAttributes noDefaultLights.
                 * @member {boolean} noDefaultLights
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.noDefaultLights = false;

                /**
                 * StreamAttributes experimentalRenderingOptions.
                 * @member {string} experimentalRenderingOptions
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.experimentalRenderingOptions = "";

                /**
                 * StreamAttributes selectionHighlighting.
                 * @member {vertexvis.protobuf.stream.ISelectionHighlightAttributes|null|undefined} selectionHighlighting
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.selectionHighlighting = null;

                /**
                 * StreamAttributes phantomItems.
                 * @member {vertexvis.protobuf.stream.IPhantomAttributes|null|undefined} phantomItems
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.phantomItems = null;

                /**
                 * StreamAttributes frames.
                 * @member {vertexvis.protobuf.stream.IFrameAttributes|null|undefined} frames
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.frames = null;

                /**
                 * StreamAttributes sceneComparison.
                 * @member {vertexvis.protobuf.stream.ISceneComparisonAttributes|null|undefined} sceneComparison
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.sceneComparison = null;

                /**
                 * StreamAttributes crossSectioningAttributes.
                 * @member {vertexvis.protobuf.stream.ICrossSectioningAttributes|null|undefined} crossSectioningAttributes
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 */
                StreamAttributes.prototype.crossSectioningAttributes = null;

                /**
                 * Creates a new StreamAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StreamAttributes} StreamAttributes instance
                 */
                StreamAttributes.create = function create(properties) {
                    return new StreamAttributes(properties);
                };

                /**
                 * Encodes the specified StreamAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.StreamAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamAttributes} message StreamAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.depthBuffers != null && Object.hasOwnProperty.call(message, "depthBuffers"))
                        $root.vertexvis.protobuf.stream.DepthBufferAttributes.encode(message.depthBuffers, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.featureLines != null && Object.hasOwnProperty.call(message, "featureLines"))
                        $root.vertexvis.protobuf.stream.FeatureLineAttributes.encode(message.featureLines, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.featureHighlighting != null && Object.hasOwnProperty.call(message, "featureHighlighting"))
                        $root.vertexvis.protobuf.stream.FeatureHighlightAttributes.encode(message.featureHighlighting, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.featureMaps != null && Object.hasOwnProperty.call(message, "featureMaps"))
                        $root.vertexvis.protobuf.stream.FeatureMapAttributes.encode(message.featureMaps, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.noDefaultLights != null && Object.hasOwnProperty.call(message, "noDefaultLights"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.noDefaultLights);
                    if (message.experimentalRenderingOptions != null && Object.hasOwnProperty.call(message, "experimentalRenderingOptions"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.experimentalRenderingOptions);
                    if (message.selectionHighlighting != null && Object.hasOwnProperty.call(message, "selectionHighlighting"))
                        $root.vertexvis.protobuf.stream.SelectionHighlightAttributes.encode(message.selectionHighlighting, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.phantomItems != null && Object.hasOwnProperty.call(message, "phantomItems"))
                        $root.vertexvis.protobuf.stream.PhantomAttributes.encode(message.phantomItems, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.frames != null && Object.hasOwnProperty.call(message, "frames"))
                        $root.vertexvis.protobuf.stream.FrameAttributes.encode(message.frames, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.sceneComparison != null && Object.hasOwnProperty.call(message, "sceneComparison"))
                        $root.vertexvis.protobuf.stream.SceneComparisonAttributes.encode(message.sceneComparison, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.crossSectioningAttributes != null && Object.hasOwnProperty.call(message, "crossSectioningAttributes"))
                        $root.vertexvis.protobuf.stream.CrossSectioningAttributes.encode(message.crossSectioningAttributes, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StreamAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StreamAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamAttributes} message StreamAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StreamAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StreamAttributes} StreamAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StreamAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.depthBuffers = $root.vertexvis.protobuf.stream.DepthBufferAttributes.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.featureLines = $root.vertexvis.protobuf.stream.FeatureLineAttributes.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.featureHighlighting = $root.vertexvis.protobuf.stream.FeatureHighlightAttributes.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.featureMaps = $root.vertexvis.protobuf.stream.FeatureMapAttributes.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.noDefaultLights = reader.bool();
                            break;
                        case 7:
                            message.experimentalRenderingOptions = reader.string();
                            break;
                        case 8:
                            message.selectionHighlighting = $root.vertexvis.protobuf.stream.SelectionHighlightAttributes.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.phantomItems = $root.vertexvis.protobuf.stream.PhantomAttributes.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.frames = $root.vertexvis.protobuf.stream.FrameAttributes.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.sceneComparison = $root.vertexvis.protobuf.stream.SceneComparisonAttributes.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.crossSectioningAttributes = $root.vertexvis.protobuf.stream.CrossSectioningAttributes.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StreamAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StreamAttributes} StreamAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StreamAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StreamAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.depthBuffers != null && message.hasOwnProperty("depthBuffers")) {
                        let error = $root.vertexvis.protobuf.stream.DepthBufferAttributes.verify(message.depthBuffers);
                        if (error)
                            return "depthBuffers." + error;
                    }
                    if (message.featureLines != null && message.hasOwnProperty("featureLines")) {
                        let error = $root.vertexvis.protobuf.stream.FeatureLineAttributes.verify(message.featureLines);
                        if (error)
                            return "featureLines." + error;
                    }
                    if (message.featureHighlighting != null && message.hasOwnProperty("featureHighlighting")) {
                        let error = $root.vertexvis.protobuf.stream.FeatureHighlightAttributes.verify(message.featureHighlighting);
                        if (error)
                            return "featureHighlighting." + error;
                    }
                    if (message.featureMaps != null && message.hasOwnProperty("featureMaps")) {
                        let error = $root.vertexvis.protobuf.stream.FeatureMapAttributes.verify(message.featureMaps);
                        if (error)
                            return "featureMaps." + error;
                    }
                    if (message.noDefaultLights != null && message.hasOwnProperty("noDefaultLights"))
                        if (typeof message.noDefaultLights !== "boolean")
                            return "noDefaultLights: boolean expected";
                    if (message.experimentalRenderingOptions != null && message.hasOwnProperty("experimentalRenderingOptions"))
                        if (!$util.isString(message.experimentalRenderingOptions))
                            return "experimentalRenderingOptions: string expected";
                    if (message.selectionHighlighting != null && message.hasOwnProperty("selectionHighlighting")) {
                        let error = $root.vertexvis.protobuf.stream.SelectionHighlightAttributes.verify(message.selectionHighlighting);
                        if (error)
                            return "selectionHighlighting." + error;
                    }
                    if (message.phantomItems != null && message.hasOwnProperty("phantomItems")) {
                        let error = $root.vertexvis.protobuf.stream.PhantomAttributes.verify(message.phantomItems);
                        if (error)
                            return "phantomItems." + error;
                    }
                    if (message.frames != null && message.hasOwnProperty("frames")) {
                        let error = $root.vertexvis.protobuf.stream.FrameAttributes.verify(message.frames);
                        if (error)
                            return "frames." + error;
                    }
                    if (message.sceneComparison != null && message.hasOwnProperty("sceneComparison")) {
                        let error = $root.vertexvis.protobuf.stream.SceneComparisonAttributes.verify(message.sceneComparison);
                        if (error)
                            return "sceneComparison." + error;
                    }
                    if (message.crossSectioningAttributes != null && message.hasOwnProperty("crossSectioningAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.CrossSectioningAttributes.verify(message.crossSectioningAttributes);
                        if (error)
                            return "crossSectioningAttributes." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StreamAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StreamAttributes} StreamAttributes
                 */
                StreamAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StreamAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StreamAttributes();
                    if (object.depthBuffers != null) {
                        if (typeof object.depthBuffers !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.depthBuffers: object expected");
                        message.depthBuffers = $root.vertexvis.protobuf.stream.DepthBufferAttributes.fromObject(object.depthBuffers);
                    }
                    if (object.featureLines != null) {
                        if (typeof object.featureLines !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.featureLines: object expected");
                        message.featureLines = $root.vertexvis.protobuf.stream.FeatureLineAttributes.fromObject(object.featureLines);
                    }
                    if (object.featureHighlighting != null) {
                        if (typeof object.featureHighlighting !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.featureHighlighting: object expected");
                        message.featureHighlighting = $root.vertexvis.protobuf.stream.FeatureHighlightAttributes.fromObject(object.featureHighlighting);
                    }
                    if (object.featureMaps != null) {
                        if (typeof object.featureMaps !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.featureMaps: object expected");
                        message.featureMaps = $root.vertexvis.protobuf.stream.FeatureMapAttributes.fromObject(object.featureMaps);
                    }
                    if (object.noDefaultLights != null)
                        message.noDefaultLights = Boolean(object.noDefaultLights);
                    if (object.experimentalRenderingOptions != null)
                        message.experimentalRenderingOptions = String(object.experimentalRenderingOptions);
                    if (object.selectionHighlighting != null) {
                        if (typeof object.selectionHighlighting !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.selectionHighlighting: object expected");
                        message.selectionHighlighting = $root.vertexvis.protobuf.stream.SelectionHighlightAttributes.fromObject(object.selectionHighlighting);
                    }
                    if (object.phantomItems != null) {
                        if (typeof object.phantomItems !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.phantomItems: object expected");
                        message.phantomItems = $root.vertexvis.protobuf.stream.PhantomAttributes.fromObject(object.phantomItems);
                    }
                    if (object.frames != null) {
                        if (typeof object.frames !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.frames: object expected");
                        message.frames = $root.vertexvis.protobuf.stream.FrameAttributes.fromObject(object.frames);
                    }
                    if (object.sceneComparison != null) {
                        if (typeof object.sceneComparison !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.sceneComparison: object expected");
                        message.sceneComparison = $root.vertexvis.protobuf.stream.SceneComparisonAttributes.fromObject(object.sceneComparison);
                    }
                    if (object.crossSectioningAttributes != null) {
                        if (typeof object.crossSectioningAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamAttributes.crossSectioningAttributes: object expected");
                        message.crossSectioningAttributes = $root.vertexvis.protobuf.stream.CrossSectioningAttributes.fromObject(object.crossSectioningAttributes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StreamAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.StreamAttributes} message StreamAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StreamAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.depthBuffers = null;
                        object.featureLines = null;
                        object.featureHighlighting = null;
                        object.featureMaps = null;
                        object.noDefaultLights = false;
                        object.experimentalRenderingOptions = "";
                        object.selectionHighlighting = null;
                        object.phantomItems = null;
                        object.frames = null;
                        object.sceneComparison = null;
                        object.crossSectioningAttributes = null;
                    }
                    if (message.depthBuffers != null && message.hasOwnProperty("depthBuffers"))
                        object.depthBuffers = $root.vertexvis.protobuf.stream.DepthBufferAttributes.toObject(message.depthBuffers, options);
                    if (message.featureLines != null && message.hasOwnProperty("featureLines"))
                        object.featureLines = $root.vertexvis.protobuf.stream.FeatureLineAttributes.toObject(message.featureLines, options);
                    if (message.featureHighlighting != null && message.hasOwnProperty("featureHighlighting"))
                        object.featureHighlighting = $root.vertexvis.protobuf.stream.FeatureHighlightAttributes.toObject(message.featureHighlighting, options);
                    if (message.featureMaps != null && message.hasOwnProperty("featureMaps"))
                        object.featureMaps = $root.vertexvis.protobuf.stream.FeatureMapAttributes.toObject(message.featureMaps, options);
                    if (message.noDefaultLights != null && message.hasOwnProperty("noDefaultLights"))
                        object.noDefaultLights = message.noDefaultLights;
                    if (message.experimentalRenderingOptions != null && message.hasOwnProperty("experimentalRenderingOptions"))
                        object.experimentalRenderingOptions = message.experimentalRenderingOptions;
                    if (message.selectionHighlighting != null && message.hasOwnProperty("selectionHighlighting"))
                        object.selectionHighlighting = $root.vertexvis.protobuf.stream.SelectionHighlightAttributes.toObject(message.selectionHighlighting, options);
                    if (message.phantomItems != null && message.hasOwnProperty("phantomItems"))
                        object.phantomItems = $root.vertexvis.protobuf.stream.PhantomAttributes.toObject(message.phantomItems, options);
                    if (message.frames != null && message.hasOwnProperty("frames"))
                        object.frames = $root.vertexvis.protobuf.stream.FrameAttributes.toObject(message.frames, options);
                    if (message.sceneComparison != null && message.hasOwnProperty("sceneComparison"))
                        object.sceneComparison = $root.vertexvis.protobuf.stream.SceneComparisonAttributes.toObject(message.sceneComparison, options);
                    if (message.crossSectioningAttributes != null && message.hasOwnProperty("crossSectioningAttributes"))
                        object.crossSectioningAttributes = $root.vertexvis.protobuf.stream.CrossSectioningAttributes.toObject(message.crossSectioningAttributes, options);
                    return object;
                };

                /**
                 * Converts this StreamAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StreamAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StreamAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StreamAttributes;
            })();

            stream.PhantomAttributes = (function() {

                /**
                 * Properties of a PhantomAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPhantomAttributes
                 * @property {google.protobuf.IFloatValue|null} [opacity] PhantomAttributes opacity
                 */

                /**
                 * Constructs a new PhantomAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a PhantomAttributes.
                 * @implements IPhantomAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPhantomAttributes=} [properties] Properties to set
                 */
                function PhantomAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhantomAttributes opacity.
                 * @member {google.protobuf.IFloatValue|null|undefined} opacity
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @instance
                 */
                PhantomAttributes.prototype.opacity = null;

                /**
                 * Creates a new PhantomAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IPhantomAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.PhantomAttributes} PhantomAttributes instance
                 */
                PhantomAttributes.create = function create(properties) {
                    return new PhantomAttributes(properties);
                };

                /**
                 * Encodes the specified PhantomAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.PhantomAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IPhantomAttributes} message PhantomAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhantomAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.opacity != null && Object.hasOwnProperty.call(message, "opacity"))
                        $root.google.protobuf.FloatValue.encode(message.opacity, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PhantomAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.PhantomAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IPhantomAttributes} message PhantomAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhantomAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhantomAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.PhantomAttributes} PhantomAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhantomAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.PhantomAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.opacity = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhantomAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.PhantomAttributes} PhantomAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhantomAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhantomAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhantomAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.opacity != null && message.hasOwnProperty("opacity")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.opacity);
                        if (error)
                            return "opacity." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PhantomAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.PhantomAttributes} PhantomAttributes
                 */
                PhantomAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.PhantomAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.PhantomAttributes();
                    if (object.opacity != null) {
                        if (typeof object.opacity !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.PhantomAttributes.opacity: object expected");
                        message.opacity = $root.google.protobuf.FloatValue.fromObject(object.opacity);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PhantomAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.PhantomAttributes} message PhantomAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhantomAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.opacity = null;
                    if (message.opacity != null && message.hasOwnProperty("opacity"))
                        object.opacity = $root.google.protobuf.FloatValue.toObject(message.opacity, options);
                    return object;
                };

                /**
                 * Converts this PhantomAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.PhantomAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhantomAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PhantomAttributes;
            })();

            stream.DepthBufferAttributes = (function() {

                /**
                 * Properties of a DepthBufferAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IDepthBufferAttributes
                 * @property {google.protobuf.IBoolValue|null} [enabled] DepthBufferAttributes enabled
                 * @property {vertexvis.protobuf.stream.FrameType|null} [frameType] DepthBufferAttributes frameType
                 */

                /**
                 * Constructs a new DepthBufferAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a DepthBufferAttributes.
                 * @implements IDepthBufferAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IDepthBufferAttributes=} [properties] Properties to set
                 */
                function DepthBufferAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DepthBufferAttributes enabled.
                 * @member {google.protobuf.IBoolValue|null|undefined} enabled
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @instance
                 */
                DepthBufferAttributes.prototype.enabled = null;

                /**
                 * DepthBufferAttributes frameType.
                 * @member {vertexvis.protobuf.stream.FrameType} frameType
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @instance
                 */
                DepthBufferAttributes.prototype.frameType = 0;

                /**
                 * Creates a new DepthBufferAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IDepthBufferAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.DepthBufferAttributes} DepthBufferAttributes instance
                 */
                DepthBufferAttributes.create = function create(properties) {
                    return new DepthBufferAttributes(properties);
                };

                /**
                 * Encodes the specified DepthBufferAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.DepthBufferAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IDepthBufferAttributes} message DepthBufferAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DepthBufferAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                        $root.google.protobuf.BoolValue.encode(message.enabled, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameType != null && Object.hasOwnProperty.call(message, "frameType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.frameType);
                    return writer;
                };

                /**
                 * Encodes the specified DepthBufferAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.DepthBufferAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IDepthBufferAttributes} message DepthBufferAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DepthBufferAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DepthBufferAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.DepthBufferAttributes} DepthBufferAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DepthBufferAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.DepthBufferAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.enabled = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DepthBufferAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.DepthBufferAttributes} DepthBufferAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DepthBufferAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DepthBufferAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DepthBufferAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.enabled != null && message.hasOwnProperty("enabled")) {
                        let error = $root.google.protobuf.BoolValue.verify(message.enabled);
                        if (error)
                            return "enabled." + error;
                    }
                    if (message.frameType != null && message.hasOwnProperty("frameType"))
                        switch (message.frameType) {
                        default:
                            return "frameType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a DepthBufferAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.DepthBufferAttributes} DepthBufferAttributes
                 */
                DepthBufferAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.DepthBufferAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.DepthBufferAttributes();
                    if (object.enabled != null) {
                        if (typeof object.enabled !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DepthBufferAttributes.enabled: object expected");
                        message.enabled = $root.google.protobuf.BoolValue.fromObject(object.enabled);
                    }
                    switch (object.frameType) {
                    case "FRAME_TYPE_INVALID":
                    case 0:
                        message.frameType = 0;
                        break;
                    case "FRAME_TYPE_ALL":
                    case 1:
                        message.frameType = 1;
                        break;
                    case "FRAME_TYPE_TRANSITION":
                    case 2:
                        message.frameType = 2;
                        break;
                    case "FRAME_TYPE_FINAL":
                    case 3:
                        message.frameType = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DepthBufferAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.DepthBufferAttributes} message DepthBufferAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DepthBufferAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.enabled = null;
                        object.frameType = options.enums === String ? "FRAME_TYPE_INVALID" : 0;
                    }
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        object.enabled = $root.google.protobuf.BoolValue.toObject(message.enabled, options);
                    if (message.frameType != null && message.hasOwnProperty("frameType"))
                        object.frameType = options.enums === String ? $root.vertexvis.protobuf.stream.FrameType[message.frameType] : message.frameType;
                    return object;
                };

                /**
                 * Converts this DepthBufferAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.DepthBufferAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DepthBufferAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DepthBufferAttributes;
            })();

            stream.FeatureMapAttributes = (function() {

                /**
                 * Properties of a FeatureMapAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFeatureMapAttributes
                 * @property {google.protobuf.IBoolValue|null} [enabled] FeatureMapAttributes enabled
                 * @property {vertexvis.protobuf.stream.FrameType|null} [frameType] FeatureMapAttributes frameType
                 */

                /**
                 * Constructs a new FeatureMapAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FeatureMapAttributes.
                 * @implements IFeatureMapAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFeatureMapAttributes=} [properties] Properties to set
                 */
                function FeatureMapAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FeatureMapAttributes enabled.
                 * @member {google.protobuf.IBoolValue|null|undefined} enabled
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @instance
                 */
                FeatureMapAttributes.prototype.enabled = null;

                /**
                 * FeatureMapAttributes frameType.
                 * @member {vertexvis.protobuf.stream.FrameType} frameType
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @instance
                 */
                FeatureMapAttributes.prototype.frameType = 0;

                /**
                 * Creates a new FeatureMapAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureMapAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FeatureMapAttributes} FeatureMapAttributes instance
                 */
                FeatureMapAttributes.create = function create(properties) {
                    return new FeatureMapAttributes(properties);
                };

                /**
                 * Encodes the specified FeatureMapAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.FeatureMapAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureMapAttributes} message FeatureMapAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureMapAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                        $root.google.protobuf.BoolValue.encode(message.enabled, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameType != null && Object.hasOwnProperty.call(message, "frameType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.frameType);
                    return writer;
                };

                /**
                 * Encodes the specified FeatureMapAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FeatureMapAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureMapAttributes} message FeatureMapAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureMapAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FeatureMapAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FeatureMapAttributes} FeatureMapAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureMapAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FeatureMapAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.enabled = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FeatureMapAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FeatureMapAttributes} FeatureMapAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureMapAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FeatureMapAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FeatureMapAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.enabled != null && message.hasOwnProperty("enabled")) {
                        let error = $root.google.protobuf.BoolValue.verify(message.enabled);
                        if (error)
                            return "enabled." + error;
                    }
                    if (message.frameType != null && message.hasOwnProperty("frameType"))
                        switch (message.frameType) {
                        default:
                            return "frameType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a FeatureMapAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FeatureMapAttributes} FeatureMapAttributes
                 */
                FeatureMapAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FeatureMapAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FeatureMapAttributes();
                    if (object.enabled != null) {
                        if (typeof object.enabled !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FeatureMapAttributes.enabled: object expected");
                        message.enabled = $root.google.protobuf.BoolValue.fromObject(object.enabled);
                    }
                    switch (object.frameType) {
                    case "FRAME_TYPE_INVALID":
                    case 0:
                        message.frameType = 0;
                        break;
                    case "FRAME_TYPE_ALL":
                    case 1:
                        message.frameType = 1;
                        break;
                    case "FRAME_TYPE_TRANSITION":
                    case 2:
                        message.frameType = 2;
                        break;
                    case "FRAME_TYPE_FINAL":
                    case 3:
                        message.frameType = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FeatureMapAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.FeatureMapAttributes} message FeatureMapAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FeatureMapAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.enabled = null;
                        object.frameType = options.enums === String ? "FRAME_TYPE_INVALID" : 0;
                    }
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        object.enabled = $root.google.protobuf.BoolValue.toObject(message.enabled, options);
                    if (message.frameType != null && message.hasOwnProperty("frameType"))
                        object.frameType = options.enums === String ? $root.vertexvis.protobuf.stream.FrameType[message.frameType] : message.frameType;
                    return object;
                };

                /**
                 * Converts this FeatureMapAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FeatureMapAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FeatureMapAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FeatureMapAttributes;
            })();

            stream.AnimationAttributes = (function() {

                /**
                 * Properties of an AnimationAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IAnimationAttributes
                 * @property {google.protobuf.IDuration|null} [duration] AnimationAttributes duration
                 */

                /**
                 * Constructs a new AnimationAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an AnimationAttributes.
                 * @implements IAnimationAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IAnimationAttributes=} [properties] Properties to set
                 */
                function AnimationAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AnimationAttributes duration.
                 * @member {google.protobuf.IDuration|null|undefined} duration
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @instance
                 */
                AnimationAttributes.prototype.duration = null;

                /**
                 * Creates a new AnimationAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.AnimationAttributes} AnimationAttributes instance
                 */
                AnimationAttributes.create = function create(properties) {
                    return new AnimationAttributes(properties);
                };

                /**
                 * Encodes the specified AnimationAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.AnimationAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationAttributes} message AnimationAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnimationAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        $root.google.protobuf.Duration.encode(message.duration, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AnimationAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.AnimationAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationAttributes} message AnimationAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnimationAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AnimationAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.AnimationAttributes} AnimationAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnimationAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.AnimationAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.duration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AnimationAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.AnimationAttributes} AnimationAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnimationAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AnimationAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AnimationAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.duration != null && message.hasOwnProperty("duration")) {
                        let error = $root.google.protobuf.Duration.verify(message.duration);
                        if (error)
                            return "duration." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AnimationAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.AnimationAttributes} AnimationAttributes
                 */
                AnimationAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.AnimationAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.AnimationAttributes();
                    if (object.duration != null) {
                        if (typeof object.duration !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.AnimationAttributes.duration: object expected");
                        message.duration = $root.google.protobuf.Duration.fromObject(object.duration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AnimationAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.AnimationAttributes} message AnimationAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AnimationAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.duration = null;
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = $root.google.protobuf.Duration.toObject(message.duration, options);
                    return object;
                };

                /**
                 * Converts this AnimationAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.AnimationAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AnimationAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AnimationAttributes;
            })();

            stream.SceneComparisonAttributes = (function() {

                /**
                 * Properties of a SceneComparisonAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneComparisonAttributes
                 * @property {google.protobuf.IStringValue|null} [streamKeyToCompare] SceneComparisonAttributes streamKeyToCompare
                 */

                /**
                 * Constructs a new SceneComparisonAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneComparisonAttributes.
                 * @implements ISceneComparisonAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneComparisonAttributes=} [properties] Properties to set
                 */
                function SceneComparisonAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneComparisonAttributes streamKeyToCompare.
                 * @member {google.protobuf.IStringValue|null|undefined} streamKeyToCompare
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @instance
                 */
                SceneComparisonAttributes.prototype.streamKeyToCompare = null;

                /**
                 * Creates a new SceneComparisonAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneComparisonAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneComparisonAttributes} SceneComparisonAttributes instance
                 */
                SceneComparisonAttributes.create = function create(properties) {
                    return new SceneComparisonAttributes(properties);
                };

                /**
                 * Encodes the specified SceneComparisonAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.SceneComparisonAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneComparisonAttributes} message SceneComparisonAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneComparisonAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.streamKeyToCompare != null && Object.hasOwnProperty.call(message, "streamKeyToCompare"))
                        $root.google.protobuf.StringValue.encode(message.streamKeyToCompare, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneComparisonAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneComparisonAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneComparisonAttributes} message SceneComparisonAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneComparisonAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneComparisonAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneComparisonAttributes} SceneComparisonAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneComparisonAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneComparisonAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.streamKeyToCompare = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneComparisonAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneComparisonAttributes} SceneComparisonAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneComparisonAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneComparisonAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneComparisonAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.streamKeyToCompare != null && message.hasOwnProperty("streamKeyToCompare")) {
                        let error = $root.google.protobuf.StringValue.verify(message.streamKeyToCompare);
                        if (error)
                            return "streamKeyToCompare." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SceneComparisonAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneComparisonAttributes} SceneComparisonAttributes
                 */
                SceneComparisonAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneComparisonAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneComparisonAttributes();
                    if (object.streamKeyToCompare != null) {
                        if (typeof object.streamKeyToCompare !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneComparisonAttributes.streamKeyToCompare: object expected");
                        message.streamKeyToCompare = $root.google.protobuf.StringValue.fromObject(object.streamKeyToCompare);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneComparisonAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneComparisonAttributes} message SceneComparisonAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneComparisonAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.streamKeyToCompare = null;
                    if (message.streamKeyToCompare != null && message.hasOwnProperty("streamKeyToCompare"))
                        object.streamKeyToCompare = $root.google.protobuf.StringValue.toObject(message.streamKeyToCompare, options);
                    return object;
                };

                /**
                 * Converts this SceneComparisonAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneComparisonAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneComparisonAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneComparisonAttributes;
            })();

            stream.CrossSectioningAttributes = (function() {

                /**
                 * Properties of a CrossSectioningAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ICrossSectioningAttributes
                 * @property {boolean|null} [endCapEnabled] CrossSectioningAttributes endCapEnabled
                 * @property {vertexvis.protobuf.core.IRGBi|null} [endCapColor] CrossSectioningAttributes endCapColor
                 */

                /**
                 * Constructs a new CrossSectioningAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a CrossSectioningAttributes.
                 * @implements ICrossSectioningAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ICrossSectioningAttributes=} [properties] Properties to set
                 */
                function CrossSectioningAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CrossSectioningAttributes endCapEnabled.
                 * @member {boolean} endCapEnabled
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @instance
                 */
                CrossSectioningAttributes.prototype.endCapEnabled = false;

                /**
                 * CrossSectioningAttributes endCapColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} endCapColor
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @instance
                 */
                CrossSectioningAttributes.prototype.endCapColor = null;

                /**
                 * Creates a new CrossSectioningAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioningAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.CrossSectioningAttributes} CrossSectioningAttributes instance
                 */
                CrossSectioningAttributes.create = function create(properties) {
                    return new CrossSectioningAttributes(properties);
                };

                /**
                 * Encodes the specified CrossSectioningAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.CrossSectioningAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioningAttributes} message CrossSectioningAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CrossSectioningAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.endCapEnabled != null && Object.hasOwnProperty.call(message, "endCapEnabled"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.endCapEnabled);
                    if (message.endCapColor != null && Object.hasOwnProperty.call(message, "endCapColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.endCapColor, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CrossSectioningAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.CrossSectioningAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioningAttributes} message CrossSectioningAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CrossSectioningAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CrossSectioningAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.CrossSectioningAttributes} CrossSectioningAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CrossSectioningAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.CrossSectioningAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.endCapEnabled = reader.bool();
                            break;
                        case 2:
                            message.endCapColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CrossSectioningAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.CrossSectioningAttributes} CrossSectioningAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CrossSectioningAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CrossSectioningAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CrossSectioningAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.endCapEnabled != null && message.hasOwnProperty("endCapEnabled"))
                        if (typeof message.endCapEnabled !== "boolean")
                            return "endCapEnabled: boolean expected";
                    if (message.endCapColor != null && message.hasOwnProperty("endCapColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.endCapColor);
                        if (error)
                            return "endCapColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CrossSectioningAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.CrossSectioningAttributes} CrossSectioningAttributes
                 */
                CrossSectioningAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.CrossSectioningAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.CrossSectioningAttributes();
                    if (object.endCapEnabled != null)
                        message.endCapEnabled = Boolean(object.endCapEnabled);
                    if (object.endCapColor != null) {
                        if (typeof object.endCapColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CrossSectioningAttributes.endCapColor: object expected");
                        message.endCapColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.endCapColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CrossSectioningAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.CrossSectioningAttributes} message CrossSectioningAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CrossSectioningAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.endCapEnabled = false;
                        object.endCapColor = null;
                    }
                    if (message.endCapEnabled != null && message.hasOwnProperty("endCapEnabled"))
                        object.endCapEnabled = message.endCapEnabled;
                    if (message.endCapColor != null && message.hasOwnProperty("endCapColor"))
                        object.endCapColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.endCapColor, options);
                    return object;
                };

                /**
                 * Converts this CrossSectioningAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.CrossSectioningAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CrossSectioningAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CrossSectioningAttributes;
            })();

            stream.FrameAttributes = (function() {

                /**
                 * Properties of a FrameAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFrameAttributes
                 * @property {vertexvis.protobuf.core.IRGBi|null} [frameBackgroundColor] FrameAttributes frameBackgroundColor
                 */

                /**
                 * Constructs a new FrameAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FrameAttributes.
                 * @implements IFrameAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFrameAttributes=} [properties] Properties to set
                 */
                function FrameAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FrameAttributes frameBackgroundColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} frameBackgroundColor
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @instance
                 */
                FrameAttributes.prototype.frameBackgroundColor = null;

                /**
                 * Creates a new FrameAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrameAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FrameAttributes} FrameAttributes instance
                 */
                FrameAttributes.create = function create(properties) {
                    return new FrameAttributes(properties);
                };

                /**
                 * Encodes the specified FrameAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.FrameAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrameAttributes} message FrameAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FrameAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameBackgroundColor != null && Object.hasOwnProperty.call(message, "frameBackgroundColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.frameBackgroundColor, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FrameAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FrameAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFrameAttributes} message FrameAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FrameAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FrameAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FrameAttributes} FrameAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FrameAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FrameAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FrameAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FrameAttributes} FrameAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FrameAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FrameAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FrameAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.frameBackgroundColor);
                        if (error)
                            return "frameBackgroundColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FrameAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FrameAttributes} FrameAttributes
                 */
                FrameAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FrameAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FrameAttributes();
                    if (object.frameBackgroundColor != null) {
                        if (typeof object.frameBackgroundColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FrameAttributes.frameBackgroundColor: object expected");
                        message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.frameBackgroundColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FrameAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.FrameAttributes} message FrameAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FrameAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.frameBackgroundColor = null;
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor"))
                        object.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.frameBackgroundColor, options);
                    return object;
                };

                /**
                 * Converts this FrameAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FrameAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FrameAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FrameAttributes;
            })();

            /**
             * FrameType enum.
             * @name vertexvis.protobuf.stream.FrameType
             * @enum {number}
             * @property {number} FRAME_TYPE_INVALID=0 FRAME_TYPE_INVALID value
             * @property {number} FRAME_TYPE_ALL=1 FRAME_TYPE_ALL value
             * @property {number} FRAME_TYPE_TRANSITION=2 FRAME_TYPE_TRANSITION value
             * @property {number} FRAME_TYPE_FINAL=3 FRAME_TYPE_FINAL value
             */
            stream.FrameType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "FRAME_TYPE_INVALID"] = 0;
                values[valuesById[1] = "FRAME_TYPE_ALL"] = 1;
                values[valuesById[2] = "FRAME_TYPE_TRANSITION"] = 2;
                values[valuesById[3] = "FRAME_TYPE_FINAL"] = 3;
                return values;
            })();

            /**
             * MetadataPropertyCategory enum.
             * @name vertexvis.protobuf.stream.MetadataPropertyCategory
             * @enum {number}
             * @property {number} METADATA_PROPERTY_CATEGORY_INVALID=0 METADATA_PROPERTY_CATEGORY_INVALID value
             * @property {number} METADATA_PROPERTY_CATEGORY_USER=1 METADATA_PROPERTY_CATEGORY_USER value
             * @property {number} METADATA_PROPERTY_CATEGORY_VERTEX=2 METADATA_PROPERTY_CATEGORY_VERTEX value
             * @property {number} METADATA_PROPERTY_CATEGORY_VENDOR=3 METADATA_PROPERTY_CATEGORY_VENDOR value
             */
            stream.MetadataPropertyCategory = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "METADATA_PROPERTY_CATEGORY_INVALID"] = 0;
                values[valuesById[1] = "METADATA_PROPERTY_CATEGORY_USER"] = 1;
                values[valuesById[2] = "METADATA_PROPERTY_CATEGORY_VERTEX"] = 2;
                values[valuesById[3] = "METADATA_PROPERTY_CATEGORY_VENDOR"] = 3;
                return values;
            })();

            stream.MetadataProperty = (function() {

                /**
                 * Properties of a MetadataProperty.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IMetadataProperty
                 * @property {vertexvis.protobuf.stream.MetadataPropertyCategory|null} [category] MetadataProperty category
                 * @property {string|null} [key] MetadataProperty key
                 * @property {string|null} [asString] MetadataProperty asString
                 * @property {number|Long|null} [asLong] MetadataProperty asLong
                 * @property {number|null} [asFloat] MetadataProperty asFloat
                 * @property {vertexvis.protobuf.core.IInstant|null} [asDate] MetadataProperty asDate
                 */

                /**
                 * Constructs a new MetadataProperty.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a MetadataProperty.
                 * @implements IMetadataProperty
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IMetadataProperty=} [properties] Properties to set
                 */
                function MetadataProperty(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MetadataProperty category.
                 * @member {vertexvis.protobuf.stream.MetadataPropertyCategory} category
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.category = 0;

                /**
                 * MetadataProperty key.
                 * @member {string} key
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.key = "";

                /**
                 * MetadataProperty asString.
                 * @member {string|null|undefined} asString
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.asString = null;

                /**
                 * MetadataProperty asLong.
                 * @member {number|Long|null|undefined} asLong
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.asLong = null;

                /**
                 * MetadataProperty asFloat.
                 * @member {number|null|undefined} asFloat
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.asFloat = null;

                /**
                 * MetadataProperty asDate.
                 * @member {vertexvis.protobuf.core.IInstant|null|undefined} asDate
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                MetadataProperty.prototype.asDate = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * MetadataProperty value.
                 * @member {"asString"|"asLong"|"asFloat"|"asDate"|undefined} value
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 */
                Object.defineProperty(MetadataProperty.prototype, "value", {
                    get: $util.oneOfGetter($oneOfFields = ["asString", "asLong", "asFloat", "asDate"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MetadataProperty instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataProperty=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.MetadataProperty} MetadataProperty instance
                 */
                MetadataProperty.create = function create(properties) {
                    return new MetadataProperty(properties);
                };

                /**
                 * Encodes the specified MetadataProperty message. Does not implicitly {@link vertexvis.protobuf.stream.MetadataProperty.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataProperty} message MetadataProperty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProperty.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.category);
                    if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
                    if (message.asString != null && Object.hasOwnProperty.call(message, "asString"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.asString);
                    if (message.asLong != null && Object.hasOwnProperty.call(message, "asLong"))
                        writer.uint32(/* id 4, wireType 0 =*/32).sint64(message.asLong);
                    if (message.asFloat != null && Object.hasOwnProperty.call(message, "asFloat"))
                        writer.uint32(/* id 5, wireType 5 =*/45).float(message.asFloat);
                    if (message.asDate != null && Object.hasOwnProperty.call(message, "asDate"))
                        $root.vertexvis.protobuf.core.Instant.encode(message.asDate, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MetadataProperty message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.MetadataProperty.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {vertexvis.protobuf.stream.IMetadataProperty} message MetadataProperty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MetadataProperty.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MetadataProperty message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.MetadataProperty} MetadataProperty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProperty.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.MetadataProperty();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.category = reader.int32();
                            break;
                        case 2:
                            message.key = reader.string();
                            break;
                        case 3:
                            message.asString = reader.string();
                            break;
                        case 4:
                            message.asLong = reader.sint64();
                            break;
                        case 5:
                            message.asFloat = reader.float();
                            break;
                        case 6:
                            message.asDate = $root.vertexvis.protobuf.core.Instant.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MetadataProperty message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.MetadataProperty} MetadataProperty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MetadataProperty.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MetadataProperty message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MetadataProperty.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.category != null && message.hasOwnProperty("category"))
                        switch (message.category) {
                        default:
                            return "category: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.key != null && message.hasOwnProperty("key"))
                        if (!$util.isString(message.key))
                            return "key: string expected";
                    if (message.asString != null && message.hasOwnProperty("asString")) {
                        properties.value = 1;
                        if (!$util.isString(message.asString))
                            return "asString: string expected";
                    }
                    if (message.asLong != null && message.hasOwnProperty("asLong")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        if (!$util.isInteger(message.asLong) && !(message.asLong && $util.isInteger(message.asLong.low) && $util.isInteger(message.asLong.high)))
                            return "asLong: integer|Long expected";
                    }
                    if (message.asFloat != null && message.hasOwnProperty("asFloat")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        if (typeof message.asFloat !== "number")
                            return "asFloat: number expected";
                    }
                    if (message.asDate != null && message.hasOwnProperty("asDate")) {
                        if (properties.value === 1)
                            return "value: multiple values";
                        properties.value = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Instant.verify(message.asDate);
                            if (error)
                                return "asDate." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MetadataProperty message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.MetadataProperty} MetadataProperty
                 */
                MetadataProperty.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.MetadataProperty)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.MetadataProperty();
                    switch (object.category) {
                    case "METADATA_PROPERTY_CATEGORY_INVALID":
                    case 0:
                        message.category = 0;
                        break;
                    case "METADATA_PROPERTY_CATEGORY_USER":
                    case 1:
                        message.category = 1;
                        break;
                    case "METADATA_PROPERTY_CATEGORY_VERTEX":
                    case 2:
                        message.category = 2;
                        break;
                    case "METADATA_PROPERTY_CATEGORY_VENDOR":
                    case 3:
                        message.category = 3;
                        break;
                    }
                    if (object.key != null)
                        message.key = String(object.key);
                    if (object.asString != null)
                        message.asString = String(object.asString);
                    if (object.asLong != null)
                        if ($util.Long)
                            (message.asLong = $util.Long.fromValue(object.asLong)).unsigned = false;
                        else if (typeof object.asLong === "string")
                            message.asLong = parseInt(object.asLong, 10);
                        else if (typeof object.asLong === "number")
                            message.asLong = object.asLong;
                        else if (typeof object.asLong === "object")
                            message.asLong = new $util.LongBits(object.asLong.low >>> 0, object.asLong.high >>> 0).toNumber();
                    if (object.asFloat != null)
                        message.asFloat = Number(object.asFloat);
                    if (object.asDate != null) {
                        if (typeof object.asDate !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.MetadataProperty.asDate: object expected");
                        message.asDate = $root.vertexvis.protobuf.core.Instant.fromObject(object.asDate);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MetadataProperty message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @static
                 * @param {vertexvis.protobuf.stream.MetadataProperty} message MetadataProperty
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MetadataProperty.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.category = options.enums === String ? "METADATA_PROPERTY_CATEGORY_INVALID" : 0;
                        object.key = "";
                    }
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = options.enums === String ? $root.vertexvis.protobuf.stream.MetadataPropertyCategory[message.category] : message.category;
                    if (message.key != null && message.hasOwnProperty("key"))
                        object.key = message.key;
                    if (message.asString != null && message.hasOwnProperty("asString")) {
                        object.asString = message.asString;
                        if (options.oneofs)
                            object.value = "asString";
                    }
                    if (message.asLong != null && message.hasOwnProperty("asLong")) {
                        if (typeof message.asLong === "number")
                            object.asLong = options.longs === String ? String(message.asLong) : message.asLong;
                        else
                            object.asLong = options.longs === String ? $util.Long.prototype.toString.call(message.asLong) : options.longs === Number ? new $util.LongBits(message.asLong.low >>> 0, message.asLong.high >>> 0).toNumber() : message.asLong;
                        if (options.oneofs)
                            object.value = "asLong";
                    }
                    if (message.asFloat != null && message.hasOwnProperty("asFloat")) {
                        object.asFloat = options.json && !isFinite(message.asFloat) ? String(message.asFloat) : message.asFloat;
                        if (options.oneofs)
                            object.value = "asFloat";
                    }
                    if (message.asDate != null && message.hasOwnProperty("asDate")) {
                        object.asDate = $root.vertexvis.protobuf.core.Instant.toObject(message.asDate, options);
                        if (options.oneofs)
                            object.value = "asDate";
                    }
                    return object;
                };

                /**
                 * Converts this MetadataProperty to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.MetadataProperty
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MetadataProperty.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return MetadataProperty;
            })();

            stream.SectionPlane = (function() {

                /**
                 * Properties of a SectionPlane.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISectionPlane
                 * @property {vertexvis.protobuf.core.IVector3f|null} [normal] SectionPlane normal
                 * @property {number|null} [offset] SectionPlane offset
                 */

                /**
                 * Constructs a new SectionPlane.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SectionPlane.
                 * @implements ISectionPlane
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISectionPlane=} [properties] Properties to set
                 */
                function SectionPlane(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SectionPlane normal.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} normal
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @instance
                 */
                SectionPlane.prototype.normal = null;

                /**
                 * SectionPlane offset.
                 * @member {number} offset
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @instance
                 */
                SectionPlane.prototype.offset = 0;

                /**
                 * Creates a new SectionPlane instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {vertexvis.protobuf.stream.ISectionPlane=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SectionPlane} SectionPlane instance
                 */
                SectionPlane.create = function create(properties) {
                    return new SectionPlane(properties);
                };

                /**
                 * Encodes the specified SectionPlane message. Does not implicitly {@link vertexvis.protobuf.stream.SectionPlane.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {vertexvis.protobuf.stream.ISectionPlane} message SectionPlane message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SectionPlane.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.normal != null && Object.hasOwnProperty.call(message, "normal"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.normal, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.offset);
                    return writer;
                };

                /**
                 * Encodes the specified SectionPlane message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SectionPlane.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {vertexvis.protobuf.stream.ISectionPlane} message SectionPlane message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SectionPlane.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SectionPlane message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SectionPlane} SectionPlane
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SectionPlane.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SectionPlane();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.normal = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.offset = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SectionPlane message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SectionPlane} SectionPlane
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SectionPlane.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SectionPlane message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SectionPlane.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.normal != null && message.hasOwnProperty("normal")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.normal);
                        if (error)
                            return "normal." + error;
                    }
                    if (message.offset != null && message.hasOwnProperty("offset"))
                        if (typeof message.offset !== "number")
                            return "offset: number expected";
                    return null;
                };

                /**
                 * Creates a SectionPlane message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SectionPlane} SectionPlane
                 */
                SectionPlane.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SectionPlane)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SectionPlane();
                    if (object.normal != null) {
                        if (typeof object.normal !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SectionPlane.normal: object expected");
                        message.normal = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.normal);
                    }
                    if (object.offset != null)
                        message.offset = Number(object.offset);
                    return message;
                };

                /**
                 * Creates a plain object from a SectionPlane message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @static
                 * @param {vertexvis.protobuf.stream.SectionPlane} message SectionPlane
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SectionPlane.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.normal = null;
                        object.offset = 0;
                    }
                    if (message.normal != null && message.hasOwnProperty("normal"))
                        object.normal = $root.vertexvis.protobuf.core.Vector3f.toObject(message.normal, options);
                    if (message.offset != null && message.hasOwnProperty("offset"))
                        object.offset = options.json && !isFinite(message.offset) ? String(message.offset) : message.offset;
                    return object;
                };

                /**
                 * Converts this SectionPlane to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SectionPlane
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SectionPlane.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SectionPlane;
            })();

            stream.EndCapping = (function() {

                /**
                 * Properties of an EndCapping.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IEndCapping
                 * @property {boolean|null} [enabled] EndCapping enabled
                 * @property {vertexvis.protobuf.core.IRGBi|null} [capColor] EndCapping capColor
                 */

                /**
                 * Constructs a new EndCapping.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an EndCapping.
                 * @implements IEndCapping
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IEndCapping=} [properties] Properties to set
                 */
                function EndCapping(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EndCapping enabled.
                 * @member {boolean} enabled
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @instance
                 */
                EndCapping.prototype.enabled = false;

                /**
                 * EndCapping capColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} capColor
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @instance
                 */
                EndCapping.prototype.capColor = null;

                /**
                 * Creates a new EndCapping instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndCapping=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.EndCapping} EndCapping instance
                 */
                EndCapping.create = function create(properties) {
                    return new EndCapping(properties);
                };

                /**
                 * Encodes the specified EndCapping message. Does not implicitly {@link vertexvis.protobuf.stream.EndCapping.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndCapping} message EndCapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndCapping.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
                    if (message.capColor != null && Object.hasOwnProperty.call(message, "capColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.capColor, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EndCapping message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.EndCapping.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndCapping} message EndCapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndCapping.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EndCapping message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.EndCapping} EndCapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndCapping.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.EndCapping();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.enabled = reader.bool();
                            break;
                        case 2:
                            message.capColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EndCapping message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.EndCapping} EndCapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndCapping.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EndCapping message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EndCapping.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        if (typeof message.enabled !== "boolean")
                            return "enabled: boolean expected";
                    if (message.capColor != null && message.hasOwnProperty("capColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.capColor);
                        if (error)
                            return "capColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates an EndCapping message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.EndCapping} EndCapping
                 */
                EndCapping.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.EndCapping)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.EndCapping();
                    if (object.enabled != null)
                        message.enabled = Boolean(object.enabled);
                    if (object.capColor != null) {
                        if (typeof object.capColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.EndCapping.capColor: object expected");
                        message.capColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.capColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EndCapping message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @static
                 * @param {vertexvis.protobuf.stream.EndCapping} message EndCapping
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EndCapping.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.enabled = false;
                        object.capColor = null;
                    }
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        object.enabled = message.enabled;
                    if (message.capColor != null && message.hasOwnProperty("capColor"))
                        object.capColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.capColor, options);
                    return object;
                };

                /**
                 * Converts this EndCapping to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.EndCapping
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EndCapping.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EndCapping;
            })();

            stream.CrossSectioning = (function() {

                /**
                 * Properties of a CrossSectioning.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ICrossSectioning
                 * @property {Array.<vertexvis.protobuf.stream.ISectionPlane>|null} [sectionPlanes] CrossSectioning sectionPlanes
                 * @property {vertexvis.protobuf.core.IRGBi|null} [highlightColor] CrossSectioning highlightColor
                 * @property {google.protobuf.IFloatValue|null} [lineWidth] CrossSectioning lineWidth
                 * @property {vertexvis.protobuf.stream.IEndCapping|null} [endCapping] CrossSectioning endCapping
                 */

                /**
                 * Constructs a new CrossSectioning.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a CrossSectioning.
                 * @implements ICrossSectioning
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ICrossSectioning=} [properties] Properties to set
                 */
                function CrossSectioning(properties) {
                    this.sectionPlanes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CrossSectioning sectionPlanes.
                 * @member {Array.<vertexvis.protobuf.stream.ISectionPlane>} sectionPlanes
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @instance
                 */
                CrossSectioning.prototype.sectionPlanes = $util.emptyArray;

                /**
                 * CrossSectioning highlightColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} highlightColor
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @instance
                 */
                CrossSectioning.prototype.highlightColor = null;

                /**
                 * CrossSectioning lineWidth.
                 * @member {google.protobuf.IFloatValue|null|undefined} lineWidth
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @instance
                 */
                CrossSectioning.prototype.lineWidth = null;

                /**
                 * CrossSectioning endCapping.
                 * @member {vertexvis.protobuf.stream.IEndCapping|null|undefined} endCapping
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @instance
                 */
                CrossSectioning.prototype.endCapping = null;

                /**
                 * Creates a new CrossSectioning instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioning=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.CrossSectioning} CrossSectioning instance
                 */
                CrossSectioning.create = function create(properties) {
                    return new CrossSectioning(properties);
                };

                /**
                 * Encodes the specified CrossSectioning message. Does not implicitly {@link vertexvis.protobuf.stream.CrossSectioning.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioning} message CrossSectioning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CrossSectioning.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sectionPlanes != null && message.sectionPlanes.length)
                        for (let i = 0; i < message.sectionPlanes.length; ++i)
                            $root.vertexvis.protobuf.stream.SectionPlane.encode(message.sectionPlanes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.highlightColor != null && Object.hasOwnProperty.call(message, "highlightColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.highlightColor, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.lineWidth != null && Object.hasOwnProperty.call(message, "lineWidth"))
                        $root.google.protobuf.FloatValue.encode(message.lineWidth, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.endCapping != null && Object.hasOwnProperty.call(message, "endCapping"))
                        $root.vertexvis.protobuf.stream.EndCapping.encode(message.endCapping, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CrossSectioning message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.CrossSectioning.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {vertexvis.protobuf.stream.ICrossSectioning} message CrossSectioning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CrossSectioning.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CrossSectioning message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.CrossSectioning} CrossSectioning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CrossSectioning.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.CrossSectioning();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.sectionPlanes && message.sectionPlanes.length))
                                message.sectionPlanes = [];
                            message.sectionPlanes.push($root.vertexvis.protobuf.stream.SectionPlane.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.highlightColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.lineWidth = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.endCapping = $root.vertexvis.protobuf.stream.EndCapping.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CrossSectioning message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.CrossSectioning} CrossSectioning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CrossSectioning.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CrossSectioning message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CrossSectioning.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sectionPlanes != null && message.hasOwnProperty("sectionPlanes")) {
                        if (!Array.isArray(message.sectionPlanes))
                            return "sectionPlanes: array expected";
                        for (let i = 0; i < message.sectionPlanes.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.SectionPlane.verify(message.sectionPlanes[i]);
                            if (error)
                                return "sectionPlanes." + error;
                        }
                    }
                    if (message.highlightColor != null && message.hasOwnProperty("highlightColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.highlightColor);
                        if (error)
                            return "highlightColor." + error;
                    }
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.lineWidth);
                        if (error)
                            return "lineWidth." + error;
                    }
                    if (message.endCapping != null && message.hasOwnProperty("endCapping")) {
                        let error = $root.vertexvis.protobuf.stream.EndCapping.verify(message.endCapping);
                        if (error)
                            return "endCapping." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CrossSectioning message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.CrossSectioning} CrossSectioning
                 */
                CrossSectioning.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.CrossSectioning)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.CrossSectioning();
                    if (object.sectionPlanes) {
                        if (!Array.isArray(object.sectionPlanes))
                            throw TypeError(".vertexvis.protobuf.stream.CrossSectioning.sectionPlanes: array expected");
                        message.sectionPlanes = [];
                        for (let i = 0; i < object.sectionPlanes.length; ++i) {
                            if (typeof object.sectionPlanes[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.CrossSectioning.sectionPlanes: object expected");
                            message.sectionPlanes[i] = $root.vertexvis.protobuf.stream.SectionPlane.fromObject(object.sectionPlanes[i]);
                        }
                    }
                    if (object.highlightColor != null) {
                        if (typeof object.highlightColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CrossSectioning.highlightColor: object expected");
                        message.highlightColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.highlightColor);
                    }
                    if (object.lineWidth != null) {
                        if (typeof object.lineWidth !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CrossSectioning.lineWidth: object expected");
                        message.lineWidth = $root.google.protobuf.FloatValue.fromObject(object.lineWidth);
                    }
                    if (object.endCapping != null) {
                        if (typeof object.endCapping !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CrossSectioning.endCapping: object expected");
                        message.endCapping = $root.vertexvis.protobuf.stream.EndCapping.fromObject(object.endCapping);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CrossSectioning message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @static
                 * @param {vertexvis.protobuf.stream.CrossSectioning} message CrossSectioning
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CrossSectioning.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.sectionPlanes = [];
                    if (options.defaults) {
                        object.highlightColor = null;
                        object.lineWidth = null;
                        object.endCapping = null;
                    }
                    if (message.sectionPlanes && message.sectionPlanes.length) {
                        object.sectionPlanes = [];
                        for (let j = 0; j < message.sectionPlanes.length; ++j)
                            object.sectionPlanes[j] = $root.vertexvis.protobuf.stream.SectionPlane.toObject(message.sectionPlanes[j], options);
                    }
                    if (message.highlightColor != null && message.hasOwnProperty("highlightColor"))
                        object.highlightColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.highlightColor, options);
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth"))
                        object.lineWidth = $root.google.protobuf.FloatValue.toObject(message.lineWidth, options);
                    if (message.endCapping != null && message.hasOwnProperty("endCapping"))
                        object.endCapping = $root.vertexvis.protobuf.stream.EndCapping.toObject(message.endCapping, options);
                    return object;
                };

                /**
                 * Converts this CrossSectioning to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.CrossSectioning
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CrossSectioning.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CrossSectioning;
            })();

            stream.Orientation = (function() {

                /**
                 * Properties of an Orientation.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IOrientation
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] Orientation up
                 * @property {vertexvis.protobuf.core.IVector3f|null} [front] Orientation front
                 */

                /**
                 * Constructs a new Orientation.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an Orientation.
                 * @implements IOrientation
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IOrientation=} [properties] Properties to set
                 */
                function Orientation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Orientation up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @instance
                 */
                Orientation.prototype.up = null;

                /**
                 * Orientation front.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} front
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @instance
                 */
                Orientation.prototype.front = null;

                /**
                 * Creates a new Orientation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrientation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Orientation} Orientation instance
                 */
                Orientation.create = function create(properties) {
                    return new Orientation(properties);
                };

                /**
                 * Encodes the specified Orientation message. Does not implicitly {@link vertexvis.protobuf.stream.Orientation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrientation} message Orientation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Orientation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.front != null && Object.hasOwnProperty.call(message, "front"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.front, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Orientation message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Orientation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {vertexvis.protobuf.stream.IOrientation} message Orientation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Orientation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Orientation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Orientation} Orientation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Orientation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Orientation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.front = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Orientation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Orientation} Orientation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Orientation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Orientation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Orientation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.front != null && message.hasOwnProperty("front")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.front);
                        if (error)
                            return "front." + error;
                    }
                    return null;
                };

                /**
                 * Creates an Orientation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Orientation} Orientation
                 */
                Orientation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Orientation)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Orientation();
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Orientation.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.front != null) {
                        if (typeof object.front !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Orientation.front: object expected");
                        message.front = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.front);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an Orientation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @static
                 * @param {vertexvis.protobuf.stream.Orientation} message Orientation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Orientation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.up = null;
                        object.front = null;
                    }
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.front != null && message.hasOwnProperty("front"))
                        object.front = $root.vertexvis.protobuf.core.Vector3f.toObject(message.front, options);
                    return object;
                };

                /**
                 * Converts this Orientation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Orientation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Orientation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Orientation;
            })();

            stream.FeatureLineAttributes = (function() {

                /**
                 * Properties of a FeatureLineAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFeatureLineAttributes
                 * @property {number|null} [lineWidth] FeatureLineAttributes lineWidth
                 * @property {vertexvis.protobuf.core.IRGBi|null} [lineColor] FeatureLineAttributes lineColor
                 */

                /**
                 * Constructs a new FeatureLineAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FeatureLineAttributes.
                 * @implements IFeatureLineAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFeatureLineAttributes=} [properties] Properties to set
                 */
                function FeatureLineAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FeatureLineAttributes lineWidth.
                 * @member {number} lineWidth
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @instance
                 */
                FeatureLineAttributes.prototype.lineWidth = 0;

                /**
                 * FeatureLineAttributes lineColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} lineColor
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @instance
                 */
                FeatureLineAttributes.prototype.lineColor = null;

                /**
                 * Creates a new FeatureLineAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureLineAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FeatureLineAttributes} FeatureLineAttributes instance
                 */
                FeatureLineAttributes.create = function create(properties) {
                    return new FeatureLineAttributes(properties);
                };

                /**
                 * Encodes the specified FeatureLineAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.FeatureLineAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureLineAttributes} message FeatureLineAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureLineAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.lineWidth != null && Object.hasOwnProperty.call(message, "lineWidth"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.lineWidth);
                    if (message.lineColor != null && Object.hasOwnProperty.call(message, "lineColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.lineColor, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FeatureLineAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FeatureLineAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureLineAttributes} message FeatureLineAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureLineAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FeatureLineAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FeatureLineAttributes} FeatureLineAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureLineAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FeatureLineAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.lineWidth = reader.float();
                            break;
                        case 2:
                            message.lineColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FeatureLineAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FeatureLineAttributes} FeatureLineAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureLineAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FeatureLineAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FeatureLineAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth"))
                        if (typeof message.lineWidth !== "number")
                            return "lineWidth: number expected";
                    if (message.lineColor != null && message.hasOwnProperty("lineColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.lineColor);
                        if (error)
                            return "lineColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FeatureLineAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FeatureLineAttributes} FeatureLineAttributes
                 */
                FeatureLineAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FeatureLineAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FeatureLineAttributes();
                    if (object.lineWidth != null)
                        message.lineWidth = Number(object.lineWidth);
                    if (object.lineColor != null) {
                        if (typeof object.lineColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FeatureLineAttributes.lineColor: object expected");
                        message.lineColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.lineColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FeatureLineAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.FeatureLineAttributes} message FeatureLineAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FeatureLineAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.lineWidth = 0;
                        object.lineColor = null;
                    }
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth"))
                        object.lineWidth = options.json && !isFinite(message.lineWidth) ? String(message.lineWidth) : message.lineWidth;
                    if (message.lineColor != null && message.hasOwnProperty("lineColor"))
                        object.lineColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.lineColor, options);
                    return object;
                };

                /**
                 * Converts this FeatureLineAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FeatureLineAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FeatureLineAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FeatureLineAttributes;
            })();

            stream.FeatureHighlightAttributes = (function() {

                /**
                 * Properties of a FeatureHighlightAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFeatureHighlightAttributes
                 * @property {vertexvis.protobuf.core.IRGBi|null} [highlightColor] FeatureHighlightAttributes highlightColor
                 * @property {google.protobuf.IFloatValue|null} [occludedOpacity] FeatureHighlightAttributes occludedOpacity
                 * @property {vertexvis.protobuf.stream.IFeatureLineAttributes|null} [outline] FeatureHighlightAttributes outline
                 */

                /**
                 * Constructs a new FeatureHighlightAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FeatureHighlightAttributes.
                 * @implements IFeatureHighlightAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFeatureHighlightAttributes=} [properties] Properties to set
                 */
                function FeatureHighlightAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FeatureHighlightAttributes highlightColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} highlightColor
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @instance
                 */
                FeatureHighlightAttributes.prototype.highlightColor = null;

                /**
                 * FeatureHighlightAttributes occludedOpacity.
                 * @member {google.protobuf.IFloatValue|null|undefined} occludedOpacity
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @instance
                 */
                FeatureHighlightAttributes.prototype.occludedOpacity = null;

                /**
                 * FeatureHighlightAttributes outline.
                 * @member {vertexvis.protobuf.stream.IFeatureLineAttributes|null|undefined} outline
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @instance
                 */
                FeatureHighlightAttributes.prototype.outline = null;

                /**
                 * Creates a new FeatureHighlightAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureHighlightAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FeatureHighlightAttributes} FeatureHighlightAttributes instance
                 */
                FeatureHighlightAttributes.create = function create(properties) {
                    return new FeatureHighlightAttributes(properties);
                };

                /**
                 * Encodes the specified FeatureHighlightAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.FeatureHighlightAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureHighlightAttributes} message FeatureHighlightAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureHighlightAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.highlightColor != null && Object.hasOwnProperty.call(message, "highlightColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.highlightColor, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.occludedOpacity != null && Object.hasOwnProperty.call(message, "occludedOpacity"))
                        $root.google.protobuf.FloatValue.encode(message.occludedOpacity, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.outline != null && Object.hasOwnProperty.call(message, "outline"))
                        $root.vertexvis.protobuf.stream.FeatureLineAttributes.encode(message.outline, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FeatureHighlightAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FeatureHighlightAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.IFeatureHighlightAttributes} message FeatureHighlightAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FeatureHighlightAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FeatureHighlightAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FeatureHighlightAttributes} FeatureHighlightAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureHighlightAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FeatureHighlightAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.highlightColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.occludedOpacity = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.outline = $root.vertexvis.protobuf.stream.FeatureLineAttributes.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FeatureHighlightAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FeatureHighlightAttributes} FeatureHighlightAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FeatureHighlightAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FeatureHighlightAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FeatureHighlightAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.highlightColor != null && message.hasOwnProperty("highlightColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.highlightColor);
                        if (error)
                            return "highlightColor." + error;
                    }
                    if (message.occludedOpacity != null && message.hasOwnProperty("occludedOpacity")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.occludedOpacity);
                        if (error)
                            return "occludedOpacity." + error;
                    }
                    if (message.outline != null && message.hasOwnProperty("outline")) {
                        let error = $root.vertexvis.protobuf.stream.FeatureLineAttributes.verify(message.outline);
                        if (error)
                            return "outline." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FeatureHighlightAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FeatureHighlightAttributes} FeatureHighlightAttributes
                 */
                FeatureHighlightAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FeatureHighlightAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FeatureHighlightAttributes();
                    if (object.highlightColor != null) {
                        if (typeof object.highlightColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FeatureHighlightAttributes.highlightColor: object expected");
                        message.highlightColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.highlightColor);
                    }
                    if (object.occludedOpacity != null) {
                        if (typeof object.occludedOpacity !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FeatureHighlightAttributes.occludedOpacity: object expected");
                        message.occludedOpacity = $root.google.protobuf.FloatValue.fromObject(object.occludedOpacity);
                    }
                    if (object.outline != null) {
                        if (typeof object.outline !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FeatureHighlightAttributes.outline: object expected");
                        message.outline = $root.vertexvis.protobuf.stream.FeatureLineAttributes.fromObject(object.outline);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FeatureHighlightAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.FeatureHighlightAttributes} message FeatureHighlightAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FeatureHighlightAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.highlightColor = null;
                        object.occludedOpacity = null;
                        object.outline = null;
                    }
                    if (message.highlightColor != null && message.hasOwnProperty("highlightColor"))
                        object.highlightColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.highlightColor, options);
                    if (message.occludedOpacity != null && message.hasOwnProperty("occludedOpacity"))
                        object.occludedOpacity = $root.google.protobuf.FloatValue.toObject(message.occludedOpacity, options);
                    if (message.outline != null && message.hasOwnProperty("outline"))
                        object.outline = $root.vertexvis.protobuf.stream.FeatureLineAttributes.toObject(message.outline, options);
                    return object;
                };

                /**
                 * Converts this FeatureHighlightAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FeatureHighlightAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FeatureHighlightAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FeatureHighlightAttributes;
            })();

            stream.SelectionHighlightAttributes = (function() {

                /**
                 * Properties of a SelectionHighlightAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISelectionHighlightAttributes
                 * @property {vertexvis.protobuf.core.IRGBi|null} [color] SelectionHighlightAttributes color
                 * @property {google.protobuf.IFloatValue|null} [opacity] SelectionHighlightAttributes opacity
                 * @property {number|null} [lineWidth] SelectionHighlightAttributes lineWidth
                 */

                /**
                 * Constructs a new SelectionHighlightAttributes.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SelectionHighlightAttributes.
                 * @implements ISelectionHighlightAttributes
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISelectionHighlightAttributes=} [properties] Properties to set
                 */
                function SelectionHighlightAttributes(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SelectionHighlightAttributes color.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} color
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @instance
                 */
                SelectionHighlightAttributes.prototype.color = null;

                /**
                 * SelectionHighlightAttributes opacity.
                 * @member {google.protobuf.IFloatValue|null|undefined} opacity
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @instance
                 */
                SelectionHighlightAttributes.prototype.opacity = null;

                /**
                 * SelectionHighlightAttributes lineWidth.
                 * @member {number} lineWidth
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @instance
                 */
                SelectionHighlightAttributes.prototype.lineWidth = 0;

                /**
                 * Creates a new SelectionHighlightAttributes instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionHighlightAttributes=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SelectionHighlightAttributes} SelectionHighlightAttributes instance
                 */
                SelectionHighlightAttributes.create = function create(properties) {
                    return new SelectionHighlightAttributes(properties);
                };

                /**
                 * Encodes the specified SelectionHighlightAttributes message. Does not implicitly {@link vertexvis.protobuf.stream.SelectionHighlightAttributes.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionHighlightAttributes} message SelectionHighlightAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectionHighlightAttributes.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.color, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.opacity != null && Object.hasOwnProperty.call(message, "opacity"))
                        $root.google.protobuf.FloatValue.encode(message.opacity, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.lineWidth != null && Object.hasOwnProperty.call(message, "lineWidth"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.lineWidth);
                    return writer;
                };

                /**
                 * Encodes the specified SelectionHighlightAttributes message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SelectionHighlightAttributes.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.ISelectionHighlightAttributes} message SelectionHighlightAttributes message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectionHighlightAttributes.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SelectionHighlightAttributes message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SelectionHighlightAttributes} SelectionHighlightAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectionHighlightAttributes.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SelectionHighlightAttributes();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.color = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.opacity = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.lineWidth = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SelectionHighlightAttributes message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SelectionHighlightAttributes} SelectionHighlightAttributes
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectionHighlightAttributes.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SelectionHighlightAttributes message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SelectionHighlightAttributes.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.color != null && message.hasOwnProperty("color")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.color);
                        if (error)
                            return "color." + error;
                    }
                    if (message.opacity != null && message.hasOwnProperty("opacity")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.opacity);
                        if (error)
                            return "opacity." + error;
                    }
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth"))
                        if (!$util.isInteger(message.lineWidth))
                            return "lineWidth: integer expected";
                    return null;
                };

                /**
                 * Creates a SelectionHighlightAttributes message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SelectionHighlightAttributes} SelectionHighlightAttributes
                 */
                SelectionHighlightAttributes.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SelectionHighlightAttributes)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SelectionHighlightAttributes();
                    if (object.color != null) {
                        if (typeof object.color !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SelectionHighlightAttributes.color: object expected");
                        message.color = $root.vertexvis.protobuf.core.RGBi.fromObject(object.color);
                    }
                    if (object.opacity != null) {
                        if (typeof object.opacity !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SelectionHighlightAttributes.opacity: object expected");
                        message.opacity = $root.google.protobuf.FloatValue.fromObject(object.opacity);
                    }
                    if (object.lineWidth != null)
                        message.lineWidth = object.lineWidth >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SelectionHighlightAttributes message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @static
                 * @param {vertexvis.protobuf.stream.SelectionHighlightAttributes} message SelectionHighlightAttributes
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SelectionHighlightAttributes.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.color = null;
                        object.opacity = null;
                        object.lineWidth = 0;
                    }
                    if (message.color != null && message.hasOwnProperty("color"))
                        object.color = $root.vertexvis.protobuf.core.RGBi.toObject(message.color, options);
                    if (message.opacity != null && message.hasOwnProperty("opacity"))
                        object.opacity = $root.google.protobuf.FloatValue.toObject(message.opacity, options);
                    if (message.lineWidth != null && message.hasOwnProperty("lineWidth"))
                        object.lineWidth = message.lineWidth;
                    return object;
                };

                /**
                 * Converts this SelectionHighlightAttributes to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SelectionHighlightAttributes
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SelectionHighlightAttributes.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SelectionHighlightAttributes;
            })();

            stream.Token = (function() {

                /**
                 * Properties of a Token.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IToken
                 * @property {string|null} [token] Token token
                 * @property {number|null} [expiresIn] Token expiresIn
                 */

                /**
                 * Constructs a new Token.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Token.
                 * @implements IToken
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IToken=} [properties] Properties to set
                 */
                function Token(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Token token.
                 * @member {string} token
                 * @memberof vertexvis.protobuf.stream.Token
                 * @instance
                 */
                Token.prototype.token = "";

                /**
                 * Token expiresIn.
                 * @member {number} expiresIn
                 * @memberof vertexvis.protobuf.stream.Token
                 * @instance
                 */
                Token.prototype.expiresIn = 0;

                /**
                 * Creates a new Token instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {vertexvis.protobuf.stream.IToken=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Token} Token instance
                 */
                Token.create = function create(properties) {
                    return new Token(properties);
                };

                /**
                 * Encodes the specified Token message. Does not implicitly {@link vertexvis.protobuf.stream.Token.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {vertexvis.protobuf.stream.IToken} message Token message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Token.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                    if (message.expiresIn != null && Object.hasOwnProperty.call(message, "expiresIn"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.expiresIn);
                    return writer;
                };

                /**
                 * Encodes the specified Token message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Token.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {vertexvis.protobuf.stream.IToken} message Token message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Token.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Token message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Token} Token
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Token.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Token();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.token = reader.string();
                            break;
                        case 2:
                            message.expiresIn = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Token message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Token} Token
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Token.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Token message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Token.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.token != null && message.hasOwnProperty("token"))
                        if (!$util.isString(message.token))
                            return "token: string expected";
                    if (message.expiresIn != null && message.hasOwnProperty("expiresIn"))
                        if (!$util.isInteger(message.expiresIn))
                            return "expiresIn: integer expected";
                    return null;
                };

                /**
                 * Creates a Token message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Token} Token
                 */
                Token.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Token)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Token();
                    if (object.token != null)
                        message.token = String(object.token);
                    if (object.expiresIn != null)
                        message.expiresIn = object.expiresIn >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Token message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Token
                 * @static
                 * @param {vertexvis.protobuf.stream.Token} message Token
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Token.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.token = "";
                        object.expiresIn = 0;
                    }
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = message.token;
                    if (message.expiresIn != null && message.hasOwnProperty("expiresIn"))
                        object.expiresIn = message.expiresIn;
                    return object;
                };

                /**
                 * Converts this Token to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Token
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Token.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Token;
            })();

            stream.TransformInteraction = (function() {

                /**
                 * Properties of a TransformInteraction.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ITransformInteraction
                 * @property {vertexvis.protobuf.core.IAffineMatrix4f|null} [delta] TransformInteraction delta
                 */

                /**
                 * Constructs a new TransformInteraction.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a TransformInteraction.
                 * @implements ITransformInteraction
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ITransformInteraction=} [properties] Properties to set
                 */
                function TransformInteraction(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TransformInteraction delta.
                 * @member {vertexvis.protobuf.core.IAffineMatrix4f|null|undefined} delta
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @instance
                 */
                TransformInteraction.prototype.delta = null;

                /**
                 * Creates a new TransformInteraction instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {vertexvis.protobuf.stream.ITransformInteraction=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.TransformInteraction} TransformInteraction instance
                 */
                TransformInteraction.create = function create(properties) {
                    return new TransformInteraction(properties);
                };

                /**
                 * Encodes the specified TransformInteraction message. Does not implicitly {@link vertexvis.protobuf.stream.TransformInteraction.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {vertexvis.protobuf.stream.ITransformInteraction} message TransformInteraction message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TransformInteraction.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.delta != null && Object.hasOwnProperty.call(message, "delta"))
                        $root.vertexvis.protobuf.core.AffineMatrix4f.encode(message.delta, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified TransformInteraction message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.TransformInteraction.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {vertexvis.protobuf.stream.ITransformInteraction} message TransformInteraction message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TransformInteraction.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TransformInteraction message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.TransformInteraction} TransformInteraction
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TransformInteraction.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.TransformInteraction();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.delta = $root.vertexvis.protobuf.core.AffineMatrix4f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TransformInteraction message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.TransformInteraction} TransformInteraction
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TransformInteraction.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TransformInteraction message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TransformInteraction.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.delta != null && message.hasOwnProperty("delta")) {
                        let error = $root.vertexvis.protobuf.core.AffineMatrix4f.verify(message.delta);
                        if (error)
                            return "delta." + error;
                    }
                    return null;
                };

                /**
                 * Creates a TransformInteraction message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.TransformInteraction} TransformInteraction
                 */
                TransformInteraction.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.TransformInteraction)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.TransformInteraction();
                    if (object.delta != null) {
                        if (typeof object.delta !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.TransformInteraction.delta: object expected");
                        message.delta = $root.vertexvis.protobuf.core.AffineMatrix4f.fromObject(object.delta);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TransformInteraction message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @static
                 * @param {vertexvis.protobuf.stream.TransformInteraction} message TransformInteraction
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TransformInteraction.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.delta = null;
                    if (message.delta != null && message.hasOwnProperty("delta"))
                        object.delta = $root.vertexvis.protobuf.core.AffineMatrix4f.toObject(message.delta, options);
                    return object;
                };

                /**
                 * Converts this TransformInteraction to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.TransformInteraction
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TransformInteraction.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TransformInteraction;
            })();

            stream.SceneViewStateIdentifier = (function() {

                /**
                 * Properties of a SceneViewStateIdentifier.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISceneViewStateIdentifier
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneViewStateId] SceneViewStateIdentifier sceneViewStateId
                 * @property {google.protobuf.IStringValue|null} [sceneViewStateSuppliedId] SceneViewStateIdentifier sceneViewStateSuppliedId
                 */

                /**
                 * Constructs a new SceneViewStateIdentifier.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SceneViewStateIdentifier.
                 * @implements ISceneViewStateIdentifier
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISceneViewStateIdentifier=} [properties] Properties to set
                 */
                function SceneViewStateIdentifier(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SceneViewStateIdentifier sceneViewStateId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneViewStateId
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @instance
                 */
                SceneViewStateIdentifier.prototype.sceneViewStateId = null;

                /**
                 * SceneViewStateIdentifier sceneViewStateSuppliedId.
                 * @member {google.protobuf.IStringValue|null|undefined} sceneViewStateSuppliedId
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @instance
                 */
                SceneViewStateIdentifier.prototype.sceneViewStateSuppliedId = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SceneViewStateIdentifier id.
                 * @member {"sceneViewStateId"|"sceneViewStateSuppliedId"|undefined} id
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @instance
                 */
                Object.defineProperty(SceneViewStateIdentifier.prototype, "id", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneViewStateId", "sceneViewStateSuppliedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SceneViewStateIdentifier instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneViewStateIdentifier=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SceneViewStateIdentifier} SceneViewStateIdentifier instance
                 */
                SceneViewStateIdentifier.create = function create(properties) {
                    return new SceneViewStateIdentifier(properties);
                };

                /**
                 * Encodes the specified SceneViewStateIdentifier message. Does not implicitly {@link vertexvis.protobuf.stream.SceneViewStateIdentifier.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneViewStateIdentifier} message SceneViewStateIdentifier message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneViewStateIdentifier.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sceneViewStateId != null && Object.hasOwnProperty.call(message, "sceneViewStateId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneViewStateId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.sceneViewStateSuppliedId != null && Object.hasOwnProperty.call(message, "sceneViewStateSuppliedId"))
                        $root.google.protobuf.StringValue.encode(message.sceneViewStateSuppliedId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SceneViewStateIdentifier message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SceneViewStateIdentifier.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {vertexvis.protobuf.stream.ISceneViewStateIdentifier} message SceneViewStateIdentifier message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SceneViewStateIdentifier.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SceneViewStateIdentifier message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SceneViewStateIdentifier} SceneViewStateIdentifier
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneViewStateIdentifier.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SceneViewStateIdentifier();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SceneViewStateIdentifier message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SceneViewStateIdentifier} SceneViewStateIdentifier
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SceneViewStateIdentifier.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SceneViewStateIdentifier message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SceneViewStateIdentifier.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        properties.id = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneViewStateId);
                            if (error)
                                return "sceneViewStateId." + error;
                        }
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        if (properties.id === 1)
                            return "id: multiple values";
                        properties.id = 1;
                        {
                            let error = $root.google.protobuf.StringValue.verify(message.sceneViewStateSuppliedId);
                            if (error)
                                return "sceneViewStateSuppliedId." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SceneViewStateIdentifier message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SceneViewStateIdentifier} SceneViewStateIdentifier
                 */
                SceneViewStateIdentifier.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SceneViewStateIdentifier)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SceneViewStateIdentifier();
                    if (object.sceneViewStateId != null) {
                        if (typeof object.sceneViewStateId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneViewStateIdentifier.sceneViewStateId: object expected");
                        message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneViewStateId);
                    }
                    if (object.sceneViewStateSuppliedId != null) {
                        if (typeof object.sceneViewStateSuppliedId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SceneViewStateIdentifier.sceneViewStateSuppliedId: object expected");
                        message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.fromObject(object.sceneViewStateSuppliedId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SceneViewStateIdentifier message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @static
                 * @param {vertexvis.protobuf.stream.SceneViewStateIdentifier} message SceneViewStateIdentifier
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SceneViewStateIdentifier.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        object.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneViewStateId, options);
                        if (options.oneofs)
                            object.id = "sceneViewStateId";
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        object.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.toObject(message.sceneViewStateSuppliedId, options);
                        if (options.oneofs)
                            object.id = "sceneViewStateSuppliedId";
                    }
                    return object;
                };

                /**
                 * Converts this SceneViewStateIdentifier to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SceneViewStateIdentifier
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SceneViewStateIdentifier.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SceneViewStateIdentifier;
            })();

            stream.Error = (function() {

                /**
                 * Properties of an Error.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IError
                 * @property {google.protobuf.IStringValue|null} [message] Error message
                 * @property {google.protobuf.IStringValue|null} [details] Error details
                 */

                /**
                 * Constructs a new Error.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an Error.
                 * @implements IError
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IError=} [properties] Properties to set
                 */
                function Error(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Error message.
                 * @member {google.protobuf.IStringValue|null|undefined} message
                 * @memberof vertexvis.protobuf.stream.Error
                 * @instance
                 */
                Error.prototype.message = null;

                /**
                 * Error details.
                 * @member {google.protobuf.IStringValue|null|undefined} details
                 * @memberof vertexvis.protobuf.stream.Error
                 * @instance
                 */
                Error.prototype.details = null;

                /**
                 * Creates a new Error instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {vertexvis.protobuf.stream.IError=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Error} Error instance
                 */
                Error.create = function create(properties) {
                    return new Error(properties);
                };

                /**
                 * Encodes the specified Error message. Does not implicitly {@link vertexvis.protobuf.stream.Error.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {vertexvis.protobuf.stream.IError} message Error message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Error.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        $root.google.protobuf.StringValue.encode(message.message, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                        $root.google.protobuf.StringValue.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Error message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Error.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {vertexvis.protobuf.stream.IError} message Error message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Error.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Error message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Error} Error
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Error.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Error();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.message = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.details = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Error message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Error} Error
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Error.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Error message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Error.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.message != null && message.hasOwnProperty("message")) {
                        let error = $root.google.protobuf.StringValue.verify(message.message);
                        if (error)
                            return "message." + error;
                    }
                    if (message.details != null && message.hasOwnProperty("details")) {
                        let error = $root.google.protobuf.StringValue.verify(message.details);
                        if (error)
                            return "details." + error;
                    }
                    return null;
                };

                /**
                 * Creates an Error message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Error} Error
                 */
                Error.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Error)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Error();
                    if (object.message != null) {
                        if (typeof object.message !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Error.message: object expected");
                        message.message = $root.google.protobuf.StringValue.fromObject(object.message);
                    }
                    if (object.details != null) {
                        if (typeof object.details !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.Error.details: object expected");
                        message.details = $root.google.protobuf.StringValue.fromObject(object.details);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an Error message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Error
                 * @static
                 * @param {vertexvis.protobuf.stream.Error} message Error
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Error.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.message = null;
                        object.details = null;
                    }
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = $root.google.protobuf.StringValue.toObject(message.message, options);
                    if (message.details != null && message.hasOwnProperty("details"))
                        object.details = $root.google.protobuf.StringValue.toObject(message.details, options);
                    return object;
                };

                /**
                 * Converts this Error to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Error
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Error.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Error;
            })();

            stream.Rectangle = (function() {

                /**
                 * Properties of a Rectangle.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRectangle
                 * @property {number|null} [x] Rectangle x
                 * @property {number|null} [y] Rectangle y
                 * @property {number|null} [width] Rectangle width
                 * @property {number|null} [height] Rectangle height
                 */

                /**
                 * Constructs a new Rectangle.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Rectangle.
                 * @implements IRectangle
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRectangle=} [properties] Properties to set
                 */
                function Rectangle(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Rectangle x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @instance
                 */
                Rectangle.prototype.x = 0;

                /**
                 * Rectangle y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @instance
                 */
                Rectangle.prototype.y = 0;

                /**
                 * Rectangle width.
                 * @member {number} width
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @instance
                 */
                Rectangle.prototype.width = 0;

                /**
                 * Rectangle height.
                 * @member {number} height
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @instance
                 */
                Rectangle.prototype.height = 0;

                /**
                 * Creates a new Rectangle instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IRectangle=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Rectangle} Rectangle instance
                 */
                Rectangle.create = function create(properties) {
                    return new Rectangle(properties);
                };

                /**
                 * Encodes the specified Rectangle message. Does not implicitly {@link vertexvis.protobuf.stream.Rectangle.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IRectangle} message Rectangle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Rectangle.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.y);
                    if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.width);
                    if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.height);
                    return writer;
                };

                /**
                 * Encodes the specified Rectangle message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Rectangle.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.IRectangle} message Rectangle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Rectangle.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Rectangle message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Rectangle} Rectangle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Rectangle.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Rectangle();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.int32();
                            break;
                        case 2:
                            message.y = reader.int32();
                            break;
                        case 3:
                            message.width = reader.int32();
                            break;
                        case 4:
                            message.height = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Rectangle message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Rectangle} Rectangle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Rectangle.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Rectangle message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Rectangle.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (!$util.isInteger(message.x))
                            return "x: integer expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (!$util.isInteger(message.y))
                            return "y: integer expected";
                    if (message.width != null && message.hasOwnProperty("width"))
                        if (!$util.isInteger(message.width))
                            return "width: integer expected";
                    if (message.height != null && message.hasOwnProperty("height"))
                        if (!$util.isInteger(message.height))
                            return "height: integer expected";
                    return null;
                };

                /**
                 * Creates a Rectangle message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Rectangle} Rectangle
                 */
                Rectangle.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Rectangle)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Rectangle();
                    if (object.x != null)
                        message.x = object.x | 0;
                    if (object.y != null)
                        message.y = object.y | 0;
                    if (object.width != null)
                        message.width = object.width | 0;
                    if (object.height != null)
                        message.height = object.height | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Rectangle message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @static
                 * @param {vertexvis.protobuf.stream.Rectangle} message Rectangle
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Rectangle.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                        object.width = 0;
                        object.height = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = message.y;
                    if (message.width != null && message.hasOwnProperty("width"))
                        object.width = message.width;
                    if (message.height != null && message.hasOwnProperty("height"))
                        object.height = message.height;
                    return object;
                };

                /**
                 * Converts this Rectangle to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Rectangle
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Rectangle.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Rectangle;
            })();

            stream.Dimensions = (function() {

                /**
                 * Properties of a Dimensions.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IDimensions
                 * @property {number|null} [width] Dimensions width
                 * @property {number|null} [height] Dimensions height
                 */

                /**
                 * Constructs a new Dimensions.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Dimensions.
                 * @implements IDimensions
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IDimensions=} [properties] Properties to set
                 */
                function Dimensions(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Dimensions width.
                 * @member {number} width
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @instance
                 */
                Dimensions.prototype.width = 0;

                /**
                 * Dimensions height.
                 * @member {number} height
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @instance
                 */
                Dimensions.prototype.height = 0;

                /**
                 * Creates a new Dimensions instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {vertexvis.protobuf.stream.IDimensions=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Dimensions} Dimensions instance
                 */
                Dimensions.create = function create(properties) {
                    return new Dimensions(properties);
                };

                /**
                 * Encodes the specified Dimensions message. Does not implicitly {@link vertexvis.protobuf.stream.Dimensions.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {vertexvis.protobuf.stream.IDimensions} message Dimensions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Dimensions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.width);
                    if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.height);
                    return writer;
                };

                /**
                 * Encodes the specified Dimensions message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Dimensions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {vertexvis.protobuf.stream.IDimensions} message Dimensions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Dimensions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Dimensions message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Dimensions} Dimensions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Dimensions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Dimensions();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.width = reader.int32();
                            break;
                        case 2:
                            message.height = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Dimensions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Dimensions} Dimensions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Dimensions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Dimensions message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Dimensions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.width != null && message.hasOwnProperty("width"))
                        if (!$util.isInteger(message.width))
                            return "width: integer expected";
                    if (message.height != null && message.hasOwnProperty("height"))
                        if (!$util.isInteger(message.height))
                            return "height: integer expected";
                    return null;
                };

                /**
                 * Creates a Dimensions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Dimensions} Dimensions
                 */
                Dimensions.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Dimensions)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Dimensions();
                    if (object.width != null)
                        message.width = object.width | 0;
                    if (object.height != null)
                        message.height = object.height | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Dimensions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @static
                 * @param {vertexvis.protobuf.stream.Dimensions} message Dimensions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Dimensions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.width = 0;
                        object.height = 0;
                    }
                    if (message.width != null && message.hasOwnProperty("width"))
                        object.width = message.width;
                    if (message.height != null && message.hasOwnProperty("height"))
                        object.height = message.height;
                    return object;
                };

                /**
                 * Converts this Dimensions to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Dimensions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Dimensions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Dimensions;
            })();

            stream.Point = (function() {

                /**
                 * Properties of a Point.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IPoint
                 * @property {number|null} [x] Point x
                 * @property {number|null} [y] Point y
                 */

                /**
                 * Constructs a new Point.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a Point.
                 * @implements IPoint
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IPoint=} [properties] Properties to set
                 */
                function Point(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Point x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.stream.Point
                 * @instance
                 */
                Point.prototype.x = 0;

                /**
                 * Point y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.stream.Point
                 * @instance
                 */
                Point.prototype.y = 0;

                /**
                 * Creates a new Point instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {vertexvis.protobuf.stream.IPoint=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.Point} Point instance
                 */
                Point.create = function create(properties) {
                    return new Point(properties);
                };

                /**
                 * Encodes the specified Point message. Does not implicitly {@link vertexvis.protobuf.stream.Point.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {vertexvis.protobuf.stream.IPoint} message Point message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Point.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.y);
                    return writer;
                };

                /**
                 * Encodes the specified Point message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.Point.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {vertexvis.protobuf.stream.IPoint} message Point message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Point.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Point message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.Point} Point
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Point.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.Point();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.int32();
                            break;
                        case 2:
                            message.y = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Point message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.Point} Point
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Point.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Point message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Point.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (!$util.isInteger(message.x))
                            return "x: integer expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (!$util.isInteger(message.y))
                            return "y: integer expected";
                    return null;
                };

                /**
                 * Creates a Point message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.Point} Point
                 */
                Point.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.Point)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.Point();
                    if (object.x != null)
                        message.x = object.x | 0;
                    if (object.y != null)
                        message.y = object.y | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Point message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.Point
                 * @static
                 * @param {vertexvis.protobuf.stream.Point} message Point
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Point.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = message.y;
                    return object;
                };

                /**
                 * Converts this Point to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.Point
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Point.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Point;
            })();

            stream.StreamMessage = (function() {

                /**
                 * Properties of a StreamMessage.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStreamMessage
                 * @property {vertexvis.protobuf.stream.IStreamRequest|null} [request] StreamMessage request
                 * @property {vertexvis.protobuf.stream.IStreamResponse|null} [response] StreamMessage response
                 * @property {vertexvis.protobuf.stream.IStreamEvent|null} [event] StreamMessage event
                 * @property {google.protobuf.ITimestamp|null} [sentAtTime] StreamMessage sentAtTime
                 */

                /**
                 * Constructs a new StreamMessage.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StreamMessage.
                 * @implements IStreamMessage
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStreamMessage=} [properties] Properties to set
                 */
                function StreamMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StreamMessage request.
                 * @member {vertexvis.protobuf.stream.IStreamRequest|null|undefined} request
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 */
                StreamMessage.prototype.request = null;

                /**
                 * StreamMessage response.
                 * @member {vertexvis.protobuf.stream.IStreamResponse|null|undefined} response
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 */
                StreamMessage.prototype.response = null;

                /**
                 * StreamMessage event.
                 * @member {vertexvis.protobuf.stream.IStreamEvent|null|undefined} event
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 */
                StreamMessage.prototype.event = null;

                /**
                 * StreamMessage sentAtTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} sentAtTime
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 */
                StreamMessage.prototype.sentAtTime = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * StreamMessage message.
                 * @member {"request"|"response"|"event"|undefined} message
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 */
                Object.defineProperty(StreamMessage.prototype, "message", {
                    get: $util.oneOfGetter($oneOfFields = ["request", "response", "event"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StreamMessage instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamMessage=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StreamMessage} StreamMessage instance
                 */
                StreamMessage.create = function create(properties) {
                    return new StreamMessage(properties);
                };

                /**
                 * Encodes the specified StreamMessage message. Does not implicitly {@link vertexvis.protobuf.stream.StreamMessage.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamMessage} message StreamMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamMessage.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.request != null && Object.hasOwnProperty.call(message, "request"))
                        $root.vertexvis.protobuf.stream.StreamRequest.encode(message.request, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.response != null && Object.hasOwnProperty.call(message, "response"))
                        $root.vertexvis.protobuf.stream.StreamResponse.encode(message.response, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sentAtTime != null && Object.hasOwnProperty.call(message, "sentAtTime"))
                        $root.google.protobuf.Timestamp.encode(message.sentAtTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                        $root.vertexvis.protobuf.stream.StreamEvent.encode(message.event, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StreamMessage message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StreamMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamMessage} message StreamMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StreamMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StreamMessage} StreamMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamMessage.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StreamMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.request = $root.vertexvis.protobuf.stream.StreamRequest.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.response = $root.vertexvis.protobuf.stream.StreamResponse.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.event = $root.vertexvis.protobuf.stream.StreamEvent.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.sentAtTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StreamMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StreamMessage} StreamMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StreamMessage message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StreamMessage.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.request != null && message.hasOwnProperty("request")) {
                        properties.message = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.StreamRequest.verify(message.request);
                            if (error)
                                return "request." + error;
                        }
                    }
                    if (message.response != null && message.hasOwnProperty("response")) {
                        if (properties.message === 1)
                            return "message: multiple values";
                        properties.message = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.StreamResponse.verify(message.response);
                            if (error)
                                return "response." + error;
                        }
                    }
                    if (message.event != null && message.hasOwnProperty("event")) {
                        if (properties.message === 1)
                            return "message: multiple values";
                        properties.message = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.StreamEvent.verify(message.event);
                            if (error)
                                return "event." + error;
                        }
                    }
                    if (message.sentAtTime != null && message.hasOwnProperty("sentAtTime")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.sentAtTime);
                        if (error)
                            return "sentAtTime." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StreamMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StreamMessage} StreamMessage
                 */
                StreamMessage.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StreamMessage)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StreamMessage();
                    if (object.request != null) {
                        if (typeof object.request !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamMessage.request: object expected");
                        message.request = $root.vertexvis.protobuf.stream.StreamRequest.fromObject(object.request);
                    }
                    if (object.response != null) {
                        if (typeof object.response !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamMessage.response: object expected");
                        message.response = $root.vertexvis.protobuf.stream.StreamResponse.fromObject(object.response);
                    }
                    if (object.event != null) {
                        if (typeof object.event !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamMessage.event: object expected");
                        message.event = $root.vertexvis.protobuf.stream.StreamEvent.fromObject(object.event);
                    }
                    if (object.sentAtTime != null) {
                        if (typeof object.sentAtTime !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamMessage.sentAtTime: object expected");
                        message.sentAtTime = $root.google.protobuf.Timestamp.fromObject(object.sentAtTime);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StreamMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @static
                 * @param {vertexvis.protobuf.stream.StreamMessage} message StreamMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StreamMessage.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.sentAtTime = null;
                    if (message.request != null && message.hasOwnProperty("request")) {
                        object.request = $root.vertexvis.protobuf.stream.StreamRequest.toObject(message.request, options);
                        if (options.oneofs)
                            object.message = "request";
                    }
                    if (message.response != null && message.hasOwnProperty("response")) {
                        object.response = $root.vertexvis.protobuf.stream.StreamResponse.toObject(message.response, options);
                        if (options.oneofs)
                            object.message = "response";
                    }
                    if (message.sentAtTime != null && message.hasOwnProperty("sentAtTime"))
                        object.sentAtTime = $root.google.protobuf.Timestamp.toObject(message.sentAtTime, options);
                    if (message.event != null && message.hasOwnProperty("event")) {
                        object.event = $root.vertexvis.protobuf.stream.StreamEvent.toObject(message.event, options);
                        if (options.oneofs)
                            object.message = "event";
                    }
                    return object;
                };

                /**
                 * Converts this StreamMessage to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StreamMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StreamMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StreamMessage;
            })();

            stream.StreamRequest = (function() {

                /**
                 * Properties of a StreamRequest.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStreamRequest
                 * @property {google.protobuf.IStringValue|null} [requestId] StreamRequest requestId
                 * @property {vertexvis.protobuf.stream.IStartStreamPayload|null} [startStream] StreamRequest startStream
                 * @property {vertexvis.protobuf.stream.IUpdateCameraPayload|null} [updateCamera] StreamRequest updateCamera
                 * @property {vertexvis.protobuf.stream.IBeginInteractionPayload|null} [beginInteraction] StreamRequest beginInteraction
                 * @property {vertexvis.protobuf.stream.IEndInteractionPayload|null} [endInteraction] StreamRequest endInteraction
                 * @property {vertexvis.protobuf.stream.IGracefulReconnectionPayload|null} [gracefulReconnection] StreamRequest gracefulReconnection
                 * @property {vertexvis.protobuf.stream.IReconnectPayload|null} [reconnect] StreamRequest reconnect
                 * @property {vertexvis.protobuf.stream.IHitItemsPayload|null} [hitItems] StreamRequest hitItems
                 * @property {vertexvis.protobuf.stream.ICreateSceneAlterationPayload|null} [createSceneAlteration] StreamRequest createSceneAlteration
                 * @property {vertexvis.protobuf.stream.IDrawFramePayload|null} [drawFrame] StreamRequest drawFrame
                 * @property {vertexvis.protobuf.stream.ISyncTimePayload|null} [syncTime] StreamRequest syncTime
                 * @property {vertexvis.protobuf.stream.IRecordPerformancePayload|null} [recordPerformance] StreamRequest recordPerformance
                 * @property {vertexvis.protobuf.stream.IUpdateDimensionsPayload|null} [updateDimensions] StreamRequest updateDimensions
                 * @property {vertexvis.protobuf.stream.IUpdateStreamPayload|null} [updateStream] StreamRequest updateStream
                 * @property {vertexvis.protobuf.stream.IFlyToPayload|null} [flyTo] StreamRequest flyTo
                 * @property {vertexvis.protobuf.stream.ILoadSceneViewStatePayload|null} [loadSceneViewState] StreamRequest loadSceneViewState
                 * @property {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload|null} [updateCrossSectioning] StreamRequest updateCrossSectioning
                 * @property {vertexvis.protobuf.stream.IGetStencilBufferPayload|null} [getStencilBuffer] StreamRequest getStencilBuffer
                 * @property {vertexvis.protobuf.stream.IResetViewPlayload|null} [resetView] StreamRequest resetView
                 * @property {vertexvis.protobuf.stream.IRefreshTokenPayload|null} [refreshToken] StreamRequest refreshToken
                 * @property {vertexvis.protobuf.stream.IUpdateInteractionPayload|null} [updateInteraction] StreamRequest updateInteraction
                 * @property {vertexvis.protobuf.stream.IUpdateModelViewPayload|null} [updateModelView] StreamRequest updateModelView
                 */

                /**
                 * Constructs a new StreamRequest.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StreamRequest.
                 * @implements IStreamRequest
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStreamRequest=} [properties] Properties to set
                 */
                function StreamRequest(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StreamRequest requestId.
                 * @member {google.protobuf.IStringValue|null|undefined} requestId
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.requestId = null;

                /**
                 * StreamRequest startStream.
                 * @member {vertexvis.protobuf.stream.IStartStreamPayload|null|undefined} startStream
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.startStream = null;

                /**
                 * StreamRequest updateCamera.
                 * @member {vertexvis.protobuf.stream.IUpdateCameraPayload|null|undefined} updateCamera
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateCamera = null;

                /**
                 * StreamRequest beginInteraction.
                 * @member {vertexvis.protobuf.stream.IBeginInteractionPayload|null|undefined} beginInteraction
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.beginInteraction = null;

                /**
                 * StreamRequest endInteraction.
                 * @member {vertexvis.protobuf.stream.IEndInteractionPayload|null|undefined} endInteraction
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.endInteraction = null;

                /**
                 * StreamRequest gracefulReconnection.
                 * @member {vertexvis.protobuf.stream.IGracefulReconnectionPayload|null|undefined} gracefulReconnection
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.gracefulReconnection = null;

                /**
                 * StreamRequest reconnect.
                 * @member {vertexvis.protobuf.stream.IReconnectPayload|null|undefined} reconnect
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.reconnect = null;

                /**
                 * StreamRequest hitItems.
                 * @member {vertexvis.protobuf.stream.IHitItemsPayload|null|undefined} hitItems
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.hitItems = null;

                /**
                 * StreamRequest createSceneAlteration.
                 * @member {vertexvis.protobuf.stream.ICreateSceneAlterationPayload|null|undefined} createSceneAlteration
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.createSceneAlteration = null;

                /**
                 * StreamRequest drawFrame.
                 * @member {vertexvis.protobuf.stream.IDrawFramePayload|null|undefined} drawFrame
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.drawFrame = null;

                /**
                 * StreamRequest syncTime.
                 * @member {vertexvis.protobuf.stream.ISyncTimePayload|null|undefined} syncTime
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.syncTime = null;

                /**
                 * StreamRequest recordPerformance.
                 * @member {vertexvis.protobuf.stream.IRecordPerformancePayload|null|undefined} recordPerformance
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.recordPerformance = null;

                /**
                 * StreamRequest updateDimensions.
                 * @member {vertexvis.protobuf.stream.IUpdateDimensionsPayload|null|undefined} updateDimensions
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateDimensions = null;

                /**
                 * StreamRequest updateStream.
                 * @member {vertexvis.protobuf.stream.IUpdateStreamPayload|null|undefined} updateStream
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateStream = null;

                /**
                 * StreamRequest flyTo.
                 * @member {vertexvis.protobuf.stream.IFlyToPayload|null|undefined} flyTo
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.flyTo = null;

                /**
                 * StreamRequest loadSceneViewState.
                 * @member {vertexvis.protobuf.stream.ILoadSceneViewStatePayload|null|undefined} loadSceneViewState
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.loadSceneViewState = null;

                /**
                 * StreamRequest updateCrossSectioning.
                 * @member {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload|null|undefined} updateCrossSectioning
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateCrossSectioning = null;

                /**
                 * StreamRequest getStencilBuffer.
                 * @member {vertexvis.protobuf.stream.IGetStencilBufferPayload|null|undefined} getStencilBuffer
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.getStencilBuffer = null;

                /**
                 * StreamRequest resetView.
                 * @member {vertexvis.protobuf.stream.IResetViewPlayload|null|undefined} resetView
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.resetView = null;

                /**
                 * StreamRequest refreshToken.
                 * @member {vertexvis.protobuf.stream.IRefreshTokenPayload|null|undefined} refreshToken
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.refreshToken = null;

                /**
                 * StreamRequest updateInteraction.
                 * @member {vertexvis.protobuf.stream.IUpdateInteractionPayload|null|undefined} updateInteraction
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateInteraction = null;

                /**
                 * StreamRequest updateModelView.
                 * @member {vertexvis.protobuf.stream.IUpdateModelViewPayload|null|undefined} updateModelView
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                StreamRequest.prototype.updateModelView = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * StreamRequest payload.
                 * @member {"startStream"|"updateCamera"|"beginInteraction"|"endInteraction"|"gracefulReconnection"|"reconnect"|"hitItems"|"createSceneAlteration"|"drawFrame"|"syncTime"|"recordPerformance"|"updateDimensions"|"updateStream"|"flyTo"|"loadSceneViewState"|"updateCrossSectioning"|"getStencilBuffer"|"resetView"|"refreshToken"|"updateInteraction"|"updateModelView"|undefined} payload
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 */
                Object.defineProperty(StreamRequest.prototype, "payload", {
                    get: $util.oneOfGetter($oneOfFields = ["startStream", "updateCamera", "beginInteraction", "endInteraction", "gracefulReconnection", "reconnect", "hitItems", "createSceneAlteration", "drawFrame", "syncTime", "recordPerformance", "updateDimensions", "updateStream", "flyTo", "loadSceneViewState", "updateCrossSectioning", "getStencilBuffer", "resetView", "refreshToken", "updateInteraction", "updateModelView"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StreamRequest instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamRequest=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StreamRequest} StreamRequest instance
                 */
                StreamRequest.create = function create(properties) {
                    return new StreamRequest(properties);
                };

                /**
                 * Encodes the specified StreamRequest message. Does not implicitly {@link vertexvis.protobuf.stream.StreamRequest.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamRequest} message StreamRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        $root.google.protobuf.StringValue.encode(message.requestId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.startStream != null && Object.hasOwnProperty.call(message, "startStream"))
                        $root.vertexvis.protobuf.stream.StartStreamPayload.encode(message.startStream, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.updateCamera != null && Object.hasOwnProperty.call(message, "updateCamera"))
                        $root.vertexvis.protobuf.stream.UpdateCameraPayload.encode(message.updateCamera, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.beginInteraction != null && Object.hasOwnProperty.call(message, "beginInteraction"))
                        $root.vertexvis.protobuf.stream.BeginInteractionPayload.encode(message.beginInteraction, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.endInteraction != null && Object.hasOwnProperty.call(message, "endInteraction"))
                        $root.vertexvis.protobuf.stream.EndInteractionPayload.encode(message.endInteraction, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.gracefulReconnection != null && Object.hasOwnProperty.call(message, "gracefulReconnection"))
                        $root.vertexvis.protobuf.stream.GracefulReconnectionPayload.encode(message.gracefulReconnection, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.reconnect != null && Object.hasOwnProperty.call(message, "reconnect"))
                        $root.vertexvis.protobuf.stream.ReconnectPayload.encode(message.reconnect, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.hitItems != null && Object.hasOwnProperty.call(message, "hitItems"))
                        $root.vertexvis.protobuf.stream.HitItemsPayload.encode(message.hitItems, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.createSceneAlteration != null && Object.hasOwnProperty.call(message, "createSceneAlteration"))
                        $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload.encode(message.createSceneAlteration, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.drawFrame != null && Object.hasOwnProperty.call(message, "drawFrame"))
                        $root.vertexvis.protobuf.stream.DrawFramePayload.encode(message.drawFrame, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.syncTime != null && Object.hasOwnProperty.call(message, "syncTime"))
                        $root.vertexvis.protobuf.stream.SyncTimePayload.encode(message.syncTime, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.recordPerformance != null && Object.hasOwnProperty.call(message, "recordPerformance"))
                        $root.vertexvis.protobuf.stream.RecordPerformancePayload.encode(message.recordPerformance, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.updateDimensions != null && Object.hasOwnProperty.call(message, "updateDimensions"))
                        $root.vertexvis.protobuf.stream.UpdateDimensionsPayload.encode(message.updateDimensions, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.updateStream != null && Object.hasOwnProperty.call(message, "updateStream"))
                        $root.vertexvis.protobuf.stream.UpdateStreamPayload.encode(message.updateStream, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.flyTo != null && Object.hasOwnProperty.call(message, "flyTo"))
                        $root.vertexvis.protobuf.stream.FlyToPayload.encode(message.flyTo, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.loadSceneViewState != null && Object.hasOwnProperty.call(message, "loadSceneViewState"))
                        $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload.encode(message.loadSceneViewState, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.updateCrossSectioning != null && Object.hasOwnProperty.call(message, "updateCrossSectioning"))
                        $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload.encode(message.updateCrossSectioning, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.getStencilBuffer != null && Object.hasOwnProperty.call(message, "getStencilBuffer"))
                        $root.vertexvis.protobuf.stream.GetStencilBufferPayload.encode(message.getStencilBuffer, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.resetView != null && Object.hasOwnProperty.call(message, "resetView"))
                        $root.vertexvis.protobuf.stream.ResetViewPlayload.encode(message.resetView, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                        $root.vertexvis.protobuf.stream.RefreshTokenPayload.encode(message.refreshToken, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.updateInteraction != null && Object.hasOwnProperty.call(message, "updateInteraction"))
                        $root.vertexvis.protobuf.stream.UpdateInteractionPayload.encode(message.updateInteraction, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.updateModelView != null && Object.hasOwnProperty.call(message, "updateModelView"))
                        $root.vertexvis.protobuf.stream.UpdateModelViewPayload.encode(message.updateModelView, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StreamRequest message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StreamRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamRequest} message StreamRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StreamRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StreamRequest} StreamRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StreamRequest();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.requestId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.startStream = $root.vertexvis.protobuf.stream.StartStreamPayload.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraPayload.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionPayload.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionPayload.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionPayload.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.reconnect = $root.vertexvis.protobuf.stream.ReconnectPayload.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.hitItems = $root.vertexvis.protobuf.stream.HitItemsPayload.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.createSceneAlteration = $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.drawFrame = $root.vertexvis.protobuf.stream.DrawFramePayload.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.syncTime = $root.vertexvis.protobuf.stream.SyncTimePayload.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformancePayload.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsPayload.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamPayload.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.flyTo = $root.vertexvis.protobuf.stream.FlyToPayload.decode(reader, reader.uint32());
                            break;
                        case 16:
                            message.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.getStencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferPayload.decode(reader, reader.uint32());
                            break;
                        case 19:
                            message.resetView = $root.vertexvis.protobuf.stream.ResetViewPlayload.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenPayload.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionPayload.decode(reader, reader.uint32());
                            break;
                        case 22:
                            message.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewPayload.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StreamRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StreamRequest} StreamRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StreamRequest message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StreamRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.requestId != null && message.hasOwnProperty("requestId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.requestId);
                        if (error)
                            return "requestId." + error;
                    }
                    if (message.startStream != null && message.hasOwnProperty("startStream")) {
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.StartStreamPayload.verify(message.startStream);
                            if (error)
                                return "startStream." + error;
                        }
                    }
                    if (message.updateCamera != null && message.hasOwnProperty("updateCamera")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateCameraPayload.verify(message.updateCamera);
                            if (error)
                                return "updateCamera." + error;
                        }
                    }
                    if (message.beginInteraction != null && message.hasOwnProperty("beginInteraction")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.BeginInteractionPayload.verify(message.beginInteraction);
                            if (error)
                                return "beginInteraction." + error;
                        }
                    }
                    if (message.endInteraction != null && message.hasOwnProperty("endInteraction")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.EndInteractionPayload.verify(message.endInteraction);
                            if (error)
                                return "endInteraction." + error;
                        }
                    }
                    if (message.gracefulReconnection != null && message.hasOwnProperty("gracefulReconnection")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.GracefulReconnectionPayload.verify(message.gracefulReconnection);
                            if (error)
                                return "gracefulReconnection." + error;
                        }
                    }
                    if (message.reconnect != null && message.hasOwnProperty("reconnect")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ReconnectPayload.verify(message.reconnect);
                            if (error)
                                return "reconnect." + error;
                        }
                    }
                    if (message.hitItems != null && message.hasOwnProperty("hitItems")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.HitItemsPayload.verify(message.hitItems);
                            if (error)
                                return "hitItems." + error;
                        }
                    }
                    if (message.createSceneAlteration != null && message.hasOwnProperty("createSceneAlteration")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload.verify(message.createSceneAlteration);
                            if (error)
                                return "createSceneAlteration." + error;
                        }
                    }
                    if (message.drawFrame != null && message.hasOwnProperty("drawFrame")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.DrawFramePayload.verify(message.drawFrame);
                            if (error)
                                return "drawFrame." + error;
                        }
                    }
                    if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SyncTimePayload.verify(message.syncTime);
                            if (error)
                                return "syncTime." + error;
                        }
                    }
                    if (message.recordPerformance != null && message.hasOwnProperty("recordPerformance")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RecordPerformancePayload.verify(message.recordPerformance);
                            if (error)
                                return "recordPerformance." + error;
                        }
                    }
                    if (message.updateDimensions != null && message.hasOwnProperty("updateDimensions")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateDimensionsPayload.verify(message.updateDimensions);
                            if (error)
                                return "updateDimensions." + error;
                        }
                    }
                    if (message.updateStream != null && message.hasOwnProperty("updateStream")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateStreamPayload.verify(message.updateStream);
                            if (error)
                                return "updateStream." + error;
                        }
                    }
                    if (message.flyTo != null && message.hasOwnProperty("flyTo")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.FlyToPayload.verify(message.flyTo);
                            if (error)
                                return "flyTo." + error;
                        }
                    }
                    if (message.loadSceneViewState != null && message.hasOwnProperty("loadSceneViewState")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload.verify(message.loadSceneViewState);
                            if (error)
                                return "loadSceneViewState." + error;
                        }
                    }
                    if (message.updateCrossSectioning != null && message.hasOwnProperty("updateCrossSectioning")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload.verify(message.updateCrossSectioning);
                            if (error)
                                return "updateCrossSectioning." + error;
                        }
                    }
                    if (message.getStencilBuffer != null && message.hasOwnProperty("getStencilBuffer")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.GetStencilBufferPayload.verify(message.getStencilBuffer);
                            if (error)
                                return "getStencilBuffer." + error;
                        }
                    }
                    if (message.resetView != null && message.hasOwnProperty("resetView")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ResetViewPlayload.verify(message.resetView);
                            if (error)
                                return "resetView." + error;
                        }
                    }
                    if (message.refreshToken != null && message.hasOwnProperty("refreshToken")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RefreshTokenPayload.verify(message.refreshToken);
                            if (error)
                                return "refreshToken." + error;
                        }
                    }
                    if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateInteractionPayload.verify(message.updateInteraction);
                            if (error)
                                return "updateInteraction." + error;
                        }
                    }
                    if (message.updateModelView != null && message.hasOwnProperty("updateModelView")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateModelViewPayload.verify(message.updateModelView);
                            if (error)
                                return "updateModelView." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StreamRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StreamRequest} StreamRequest
                 */
                StreamRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StreamRequest)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StreamRequest();
                    if (object.requestId != null) {
                        if (typeof object.requestId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.requestId: object expected");
                        message.requestId = $root.google.protobuf.StringValue.fromObject(object.requestId);
                    }
                    if (object.startStream != null) {
                        if (typeof object.startStream !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.startStream: object expected");
                        message.startStream = $root.vertexvis.protobuf.stream.StartStreamPayload.fromObject(object.startStream);
                    }
                    if (object.updateCamera != null) {
                        if (typeof object.updateCamera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateCamera: object expected");
                        message.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraPayload.fromObject(object.updateCamera);
                    }
                    if (object.beginInteraction != null) {
                        if (typeof object.beginInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.beginInteraction: object expected");
                        message.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionPayload.fromObject(object.beginInteraction);
                    }
                    if (object.endInteraction != null) {
                        if (typeof object.endInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.endInteraction: object expected");
                        message.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionPayload.fromObject(object.endInteraction);
                    }
                    if (object.gracefulReconnection != null) {
                        if (typeof object.gracefulReconnection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.gracefulReconnection: object expected");
                        message.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionPayload.fromObject(object.gracefulReconnection);
                    }
                    if (object.reconnect != null) {
                        if (typeof object.reconnect !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.reconnect: object expected");
                        message.reconnect = $root.vertexvis.protobuf.stream.ReconnectPayload.fromObject(object.reconnect);
                    }
                    if (object.hitItems != null) {
                        if (typeof object.hitItems !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.hitItems: object expected");
                        message.hitItems = $root.vertexvis.protobuf.stream.HitItemsPayload.fromObject(object.hitItems);
                    }
                    if (object.createSceneAlteration != null) {
                        if (typeof object.createSceneAlteration !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.createSceneAlteration: object expected");
                        message.createSceneAlteration = $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload.fromObject(object.createSceneAlteration);
                    }
                    if (object.drawFrame != null) {
                        if (typeof object.drawFrame !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.drawFrame: object expected");
                        message.drawFrame = $root.vertexvis.protobuf.stream.DrawFramePayload.fromObject(object.drawFrame);
                    }
                    if (object.syncTime != null) {
                        if (typeof object.syncTime !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.syncTime: object expected");
                        message.syncTime = $root.vertexvis.protobuf.stream.SyncTimePayload.fromObject(object.syncTime);
                    }
                    if (object.recordPerformance != null) {
                        if (typeof object.recordPerformance !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.recordPerformance: object expected");
                        message.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformancePayload.fromObject(object.recordPerformance);
                    }
                    if (object.updateDimensions != null) {
                        if (typeof object.updateDimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateDimensions: object expected");
                        message.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsPayload.fromObject(object.updateDimensions);
                    }
                    if (object.updateStream != null) {
                        if (typeof object.updateStream !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateStream: object expected");
                        message.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamPayload.fromObject(object.updateStream);
                    }
                    if (object.flyTo != null) {
                        if (typeof object.flyTo !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.flyTo: object expected");
                        message.flyTo = $root.vertexvis.protobuf.stream.FlyToPayload.fromObject(object.flyTo);
                    }
                    if (object.loadSceneViewState != null) {
                        if (typeof object.loadSceneViewState !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.loadSceneViewState: object expected");
                        message.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload.fromObject(object.loadSceneViewState);
                    }
                    if (object.updateCrossSectioning != null) {
                        if (typeof object.updateCrossSectioning !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateCrossSectioning: object expected");
                        message.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload.fromObject(object.updateCrossSectioning);
                    }
                    if (object.getStencilBuffer != null) {
                        if (typeof object.getStencilBuffer !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.getStencilBuffer: object expected");
                        message.getStencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferPayload.fromObject(object.getStencilBuffer);
                    }
                    if (object.resetView != null) {
                        if (typeof object.resetView !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.resetView: object expected");
                        message.resetView = $root.vertexvis.protobuf.stream.ResetViewPlayload.fromObject(object.resetView);
                    }
                    if (object.refreshToken != null) {
                        if (typeof object.refreshToken !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.refreshToken: object expected");
                        message.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenPayload.fromObject(object.refreshToken);
                    }
                    if (object.updateInteraction != null) {
                        if (typeof object.updateInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateInteraction: object expected");
                        message.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionPayload.fromObject(object.updateInteraction);
                    }
                    if (object.updateModelView != null) {
                        if (typeof object.updateModelView !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamRequest.updateModelView: object expected");
                        message.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewPayload.fromObject(object.updateModelView);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StreamRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @static
                 * @param {vertexvis.protobuf.stream.StreamRequest} message StreamRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StreamRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.requestId = null;
                    if (message.requestId != null && message.hasOwnProperty("requestId"))
                        object.requestId = $root.google.protobuf.StringValue.toObject(message.requestId, options);
                    if (message.startStream != null && message.hasOwnProperty("startStream")) {
                        object.startStream = $root.vertexvis.protobuf.stream.StartStreamPayload.toObject(message.startStream, options);
                        if (options.oneofs)
                            object.payload = "startStream";
                    }
                    if (message.updateCamera != null && message.hasOwnProperty("updateCamera")) {
                        object.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraPayload.toObject(message.updateCamera, options);
                        if (options.oneofs)
                            object.payload = "updateCamera";
                    }
                    if (message.beginInteraction != null && message.hasOwnProperty("beginInteraction")) {
                        object.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionPayload.toObject(message.beginInteraction, options);
                        if (options.oneofs)
                            object.payload = "beginInteraction";
                    }
                    if (message.endInteraction != null && message.hasOwnProperty("endInteraction")) {
                        object.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionPayload.toObject(message.endInteraction, options);
                        if (options.oneofs)
                            object.payload = "endInteraction";
                    }
                    if (message.gracefulReconnection != null && message.hasOwnProperty("gracefulReconnection")) {
                        object.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionPayload.toObject(message.gracefulReconnection, options);
                        if (options.oneofs)
                            object.payload = "gracefulReconnection";
                    }
                    if (message.reconnect != null && message.hasOwnProperty("reconnect")) {
                        object.reconnect = $root.vertexvis.protobuf.stream.ReconnectPayload.toObject(message.reconnect, options);
                        if (options.oneofs)
                            object.payload = "reconnect";
                    }
                    if (message.hitItems != null && message.hasOwnProperty("hitItems")) {
                        object.hitItems = $root.vertexvis.protobuf.stream.HitItemsPayload.toObject(message.hitItems, options);
                        if (options.oneofs)
                            object.payload = "hitItems";
                    }
                    if (message.createSceneAlteration != null && message.hasOwnProperty("createSceneAlteration")) {
                        object.createSceneAlteration = $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload.toObject(message.createSceneAlteration, options);
                        if (options.oneofs)
                            object.payload = "createSceneAlteration";
                    }
                    if (message.drawFrame != null && message.hasOwnProperty("drawFrame")) {
                        object.drawFrame = $root.vertexvis.protobuf.stream.DrawFramePayload.toObject(message.drawFrame, options);
                        if (options.oneofs)
                            object.payload = "drawFrame";
                    }
                    if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                        object.syncTime = $root.vertexvis.protobuf.stream.SyncTimePayload.toObject(message.syncTime, options);
                        if (options.oneofs)
                            object.payload = "syncTime";
                    }
                    if (message.recordPerformance != null && message.hasOwnProperty("recordPerformance")) {
                        object.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformancePayload.toObject(message.recordPerformance, options);
                        if (options.oneofs)
                            object.payload = "recordPerformance";
                    }
                    if (message.updateDimensions != null && message.hasOwnProperty("updateDimensions")) {
                        object.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsPayload.toObject(message.updateDimensions, options);
                        if (options.oneofs)
                            object.payload = "updateDimensions";
                    }
                    if (message.updateStream != null && message.hasOwnProperty("updateStream")) {
                        object.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamPayload.toObject(message.updateStream, options);
                        if (options.oneofs)
                            object.payload = "updateStream";
                    }
                    if (message.flyTo != null && message.hasOwnProperty("flyTo")) {
                        object.flyTo = $root.vertexvis.protobuf.stream.FlyToPayload.toObject(message.flyTo, options);
                        if (options.oneofs)
                            object.payload = "flyTo";
                    }
                    if (message.loadSceneViewState != null && message.hasOwnProperty("loadSceneViewState")) {
                        object.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload.toObject(message.loadSceneViewState, options);
                        if (options.oneofs)
                            object.payload = "loadSceneViewState";
                    }
                    if (message.updateCrossSectioning != null && message.hasOwnProperty("updateCrossSectioning")) {
                        object.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload.toObject(message.updateCrossSectioning, options);
                        if (options.oneofs)
                            object.payload = "updateCrossSectioning";
                    }
                    if (message.getStencilBuffer != null && message.hasOwnProperty("getStencilBuffer")) {
                        object.getStencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferPayload.toObject(message.getStencilBuffer, options);
                        if (options.oneofs)
                            object.payload = "getStencilBuffer";
                    }
                    if (message.resetView != null && message.hasOwnProperty("resetView")) {
                        object.resetView = $root.vertexvis.protobuf.stream.ResetViewPlayload.toObject(message.resetView, options);
                        if (options.oneofs)
                            object.payload = "resetView";
                    }
                    if (message.refreshToken != null && message.hasOwnProperty("refreshToken")) {
                        object.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenPayload.toObject(message.refreshToken, options);
                        if (options.oneofs)
                            object.payload = "refreshToken";
                    }
                    if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                        object.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionPayload.toObject(message.updateInteraction, options);
                        if (options.oneofs)
                            object.payload = "updateInteraction";
                    }
                    if (message.updateModelView != null && message.hasOwnProperty("updateModelView")) {
                        object.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewPayload.toObject(message.updateModelView, options);
                        if (options.oneofs)
                            object.payload = "updateModelView";
                    }
                    return object;
                };

                /**
                 * Converts this StreamRequest to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StreamRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StreamRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StreamRequest;
            })();

            /**
             * CameraType enum.
             * @name vertexvis.protobuf.stream.CameraType
             * @enum {number}
             * @property {number} CAMERA_TYPE_INVALID=0 CAMERA_TYPE_INVALID value
             * @property {number} CAMERA_TYPE_PERSPECTIVE=1 CAMERA_TYPE_PERSPECTIVE value
             * @property {number} CAMERA_TYPE_ORTHOGRAPHIC=2 CAMERA_TYPE_ORTHOGRAPHIC value
             */
            stream.CameraType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "CAMERA_TYPE_INVALID"] = 0;
                values[valuesById[1] = "CAMERA_TYPE_PERSPECTIVE"] = 1;
                values[valuesById[2] = "CAMERA_TYPE_ORTHOGRAPHIC"] = 2;
                return values;
            })();

            stream.GracefulReconnectionPayload = (function() {

                /**
                 * Properties of a GracefulReconnectionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IGracefulReconnectionPayload
                 * @property {vertexvis.protobuf.core.IUuid|null} [streamId] GracefulReconnectionPayload streamId
                 * @property {google.protobuf.IDuration|null} [timeToReconnectDuration] GracefulReconnectionPayload timeToReconnectDuration
                 */

                /**
                 * Constructs a new GracefulReconnectionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a GracefulReconnectionPayload.
                 * @implements IGracefulReconnectionPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionPayload=} [properties] Properties to set
                 */
                function GracefulReconnectionPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GracefulReconnectionPayload streamId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} streamId
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @instance
                 */
                GracefulReconnectionPayload.prototype.streamId = null;

                /**
                 * GracefulReconnectionPayload timeToReconnectDuration.
                 * @member {google.protobuf.IDuration|null|undefined} timeToReconnectDuration
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @instance
                 */
                GracefulReconnectionPayload.prototype.timeToReconnectDuration = null;

                /**
                 * Creates a new GracefulReconnectionPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionPayload} GracefulReconnectionPayload instance
                 */
                GracefulReconnectionPayload.create = function create(properties) {
                    return new GracefulReconnectionPayload(properties);
                };

                /**
                 * Encodes the specified GracefulReconnectionPayload message. Does not implicitly {@link vertexvis.protobuf.stream.GracefulReconnectionPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionPayload} message GracefulReconnectionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GracefulReconnectionPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.streamId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.timeToReconnectDuration != null && Object.hasOwnProperty.call(message, "timeToReconnectDuration"))
                        $root.google.protobuf.Duration.encode(message.timeToReconnectDuration, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GracefulReconnectionPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.GracefulReconnectionPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionPayload} message GracefulReconnectionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GracefulReconnectionPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GracefulReconnectionPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionPayload} GracefulReconnectionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GracefulReconnectionPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.GracefulReconnectionPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.streamId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.timeToReconnectDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GracefulReconnectionPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionPayload} GracefulReconnectionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GracefulReconnectionPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GracefulReconnectionPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GracefulReconnectionPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.streamId != null && message.hasOwnProperty("streamId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.streamId);
                        if (error)
                            return "streamId." + error;
                    }
                    if (message.timeToReconnectDuration != null && message.hasOwnProperty("timeToReconnectDuration")) {
                        let error = $root.google.protobuf.Duration.verify(message.timeToReconnectDuration);
                        if (error)
                            return "timeToReconnectDuration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GracefulReconnectionPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionPayload} GracefulReconnectionPayload
                 */
                GracefulReconnectionPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.GracefulReconnectionPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.GracefulReconnectionPayload();
                    if (object.streamId != null) {
                        if (typeof object.streamId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.GracefulReconnectionPayload.streamId: object expected");
                        message.streamId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.streamId);
                    }
                    if (object.timeToReconnectDuration != null) {
                        if (typeof object.timeToReconnectDuration !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.GracefulReconnectionPayload.timeToReconnectDuration: object expected");
                        message.timeToReconnectDuration = $root.google.protobuf.Duration.fromObject(object.timeToReconnectDuration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GracefulReconnectionPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.GracefulReconnectionPayload} message GracefulReconnectionPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GracefulReconnectionPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.streamId = null;
                        object.timeToReconnectDuration = null;
                    }
                    if (message.streamId != null && message.hasOwnProperty("streamId"))
                        object.streamId = $root.vertexvis.protobuf.core.Uuid.toObject(message.streamId, options);
                    if (message.timeToReconnectDuration != null && message.hasOwnProperty("timeToReconnectDuration"))
                        object.timeToReconnectDuration = $root.google.protobuf.Duration.toObject(message.timeToReconnectDuration, options);
                    return object;
                };

                /**
                 * Converts this GracefulReconnectionPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GracefulReconnectionPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GracefulReconnectionPayload;
            })();

            stream.StartStreamPayload = (function() {

                /**
                 * Properties of a StartStreamPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStartStreamPayload
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [dimensions] StartStreamPayload dimensions
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] StartStreamPayload frameCorrelationId
                 * @property {vertexvis.protobuf.core.IRGBi|null} [frameBackgroundColor] StartStreamPayload frameBackgroundColor
                 * @property {vertexvis.protobuf.stream.IStreamAttributes|null} [streamAttributes] StartStreamPayload streamAttributes
                 * @property {google.protobuf.IStringValue|null} [streamKey] StartStreamPayload streamKey
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneViewStateId] StartStreamPayload sceneViewStateId
                 * @property {google.protobuf.IStringValue|null} [sceneViewStateSuppliedId] StartStreamPayload sceneViewStateSuppliedId
                 * @property {boolean|null} [clientSupportsTemporalRefinement] StartStreamPayload clientSupportsTemporalRefinement
                 * @property {vertexvis.protobuf.stream.CameraType|null} [cameraType] StartStreamPayload cameraType
                 */

                /**
                 * Constructs a new StartStreamPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StartStreamPayload.
                 * @implements IStartStreamPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStartStreamPayload=} [properties] Properties to set
                 */
                function StartStreamPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartStreamPayload dimensions.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} dimensions
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.dimensions = null;

                /**
                 * StartStreamPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.frameCorrelationId = null;

                /**
                 * StartStreamPayload frameBackgroundColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} frameBackgroundColor
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.frameBackgroundColor = null;

                /**
                 * StartStreamPayload streamAttributes.
                 * @member {vertexvis.protobuf.stream.IStreamAttributes|null|undefined} streamAttributes
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.streamAttributes = null;

                /**
                 * StartStreamPayload streamKey.
                 * @member {google.protobuf.IStringValue|null|undefined} streamKey
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.streamKey = null;

                /**
                 * StartStreamPayload sceneViewStateId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneViewStateId
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.sceneViewStateId = null;

                /**
                 * StartStreamPayload sceneViewStateSuppliedId.
                 * @member {google.protobuf.IStringValue|null|undefined} sceneViewStateSuppliedId
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.sceneViewStateSuppliedId = null;

                /**
                 * StartStreamPayload clientSupportsTemporalRefinement.
                 * @member {boolean} clientSupportsTemporalRefinement
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.clientSupportsTemporalRefinement = false;

                /**
                 * StartStreamPayload cameraType.
                 * @member {vertexvis.protobuf.stream.CameraType} cameraType
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                StartStreamPayload.prototype.cameraType = 0;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * StartStreamPayload sceneViewStateIdentifier.
                 * @member {"sceneViewStateId"|"sceneViewStateSuppliedId"|undefined} sceneViewStateIdentifier
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 */
                Object.defineProperty(StartStreamPayload.prototype, "sceneViewStateIdentifier", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneViewStateId", "sceneViewStateSuppliedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StartStreamPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StartStreamPayload} StartStreamPayload instance
                 */
                StartStreamPayload.create = function create(properties) {
                    return new StartStreamPayload(properties);
                };

                /**
                 * Encodes the specified StartStreamPayload message. Does not implicitly {@link vertexvis.protobuf.stream.StartStreamPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamPayload} message StartStreamPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartStreamPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dimensions != null && Object.hasOwnProperty.call(message, "dimensions"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.dimensions, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.frameBackgroundColor != null && Object.hasOwnProperty.call(message, "frameBackgroundColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.frameBackgroundColor, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.streamAttributes != null && Object.hasOwnProperty.call(message, "streamAttributes"))
                        $root.vertexvis.protobuf.stream.StreamAttributes.encode(message.streamAttributes, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.streamKey != null && Object.hasOwnProperty.call(message, "streamKey"))
                        $root.google.protobuf.StringValue.encode(message.streamKey, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.sceneViewStateId != null && Object.hasOwnProperty.call(message, "sceneViewStateId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneViewStateId, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.sceneViewStateSuppliedId != null && Object.hasOwnProperty.call(message, "sceneViewStateSuppliedId"))
                        $root.google.protobuf.StringValue.encode(message.sceneViewStateSuppliedId, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.clientSupportsTemporalRefinement != null && Object.hasOwnProperty.call(message, "clientSupportsTemporalRefinement"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.clientSupportsTemporalRefinement);
                    if (message.cameraType != null && Object.hasOwnProperty.call(message, "cameraType"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cameraType);
                    return writer;
                };

                /**
                 * Encodes the specified StartStreamPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StartStreamPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamPayload} message StartStreamPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartStreamPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartStreamPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StartStreamPayload} StartStreamPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartStreamPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StartStreamPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.streamKey = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.clientSupportsTemporalRefinement = reader.bool();
                            break;
                        case 9:
                            message.cameraType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartStreamPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StartStreamPayload} StartStreamPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartStreamPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartStreamPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartStreamPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.dimensions);
                        if (error)
                            return "dimensions." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.frameBackgroundColor);
                        if (error)
                            return "frameBackgroundColor." + error;
                    }
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.StreamAttributes.verify(message.streamAttributes);
                        if (error)
                            return "streamAttributes." + error;
                    }
                    if (message.streamKey != null && message.hasOwnProperty("streamKey")) {
                        let error = $root.google.protobuf.StringValue.verify(message.streamKey);
                        if (error)
                            return "streamKey." + error;
                    }
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        properties.sceneViewStateIdentifier = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneViewStateId);
                            if (error)
                                return "sceneViewStateId." + error;
                        }
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        if (properties.sceneViewStateIdentifier === 1)
                            return "sceneViewStateIdentifier: multiple values";
                        properties.sceneViewStateIdentifier = 1;
                        {
                            let error = $root.google.protobuf.StringValue.verify(message.sceneViewStateSuppliedId);
                            if (error)
                                return "sceneViewStateSuppliedId." + error;
                        }
                    }
                    if (message.clientSupportsTemporalRefinement != null && message.hasOwnProperty("clientSupportsTemporalRefinement"))
                        if (typeof message.clientSupportsTemporalRefinement !== "boolean")
                            return "clientSupportsTemporalRefinement: boolean expected";
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        switch (message.cameraType) {
                        default:
                            return "cameraType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a StartStreamPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StartStreamPayload} StartStreamPayload
                 */
                StartStreamPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StartStreamPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StartStreamPayload();
                    if (object.dimensions != null) {
                        if (typeof object.dimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.dimensions: object expected");
                        message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.dimensions);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.frameBackgroundColor != null) {
                        if (typeof object.frameBackgroundColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.frameBackgroundColor: object expected");
                        message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.frameBackgroundColor);
                    }
                    if (object.streamAttributes != null) {
                        if (typeof object.streamAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.streamAttributes: object expected");
                        message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.fromObject(object.streamAttributes);
                    }
                    if (object.streamKey != null) {
                        if (typeof object.streamKey !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.streamKey: object expected");
                        message.streamKey = $root.google.protobuf.StringValue.fromObject(object.streamKey);
                    }
                    if (object.sceneViewStateId != null) {
                        if (typeof object.sceneViewStateId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.sceneViewStateId: object expected");
                        message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneViewStateId);
                    }
                    if (object.sceneViewStateSuppliedId != null) {
                        if (typeof object.sceneViewStateSuppliedId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamPayload.sceneViewStateSuppliedId: object expected");
                        message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.fromObject(object.sceneViewStateSuppliedId);
                    }
                    if (object.clientSupportsTemporalRefinement != null)
                        message.clientSupportsTemporalRefinement = Boolean(object.clientSupportsTemporalRefinement);
                    switch (object.cameraType) {
                    case "CAMERA_TYPE_INVALID":
                    case 0:
                        message.cameraType = 0;
                        break;
                    case "CAMERA_TYPE_PERSPECTIVE":
                    case 1:
                        message.cameraType = 1;
                        break;
                    case "CAMERA_TYPE_ORTHOGRAPHIC":
                    case 2:
                        message.cameraType = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartStreamPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.StartStreamPayload} message StartStreamPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartStreamPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.dimensions = null;
                        object.frameCorrelationId = null;
                        object.frameBackgroundColor = null;
                        object.streamAttributes = null;
                        object.streamKey = null;
                        object.clientSupportsTemporalRefinement = false;
                        object.cameraType = options.enums === String ? "CAMERA_TYPE_INVALID" : 0;
                    }
                    if (message.dimensions != null && message.hasOwnProperty("dimensions"))
                        object.dimensions = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.dimensions, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor"))
                        object.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.frameBackgroundColor, options);
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes"))
                        object.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.toObject(message.streamAttributes, options);
                    if (message.streamKey != null && message.hasOwnProperty("streamKey"))
                        object.streamKey = $root.google.protobuf.StringValue.toObject(message.streamKey, options);
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        object.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneViewStateId, options);
                        if (options.oneofs)
                            object.sceneViewStateIdentifier = "sceneViewStateId";
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        object.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.toObject(message.sceneViewStateSuppliedId, options);
                        if (options.oneofs)
                            object.sceneViewStateIdentifier = "sceneViewStateSuppliedId";
                    }
                    if (message.clientSupportsTemporalRefinement != null && message.hasOwnProperty("clientSupportsTemporalRefinement"))
                        object.clientSupportsTemporalRefinement = message.clientSupportsTemporalRefinement;
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        object.cameraType = options.enums === String ? $root.vertexvis.protobuf.stream.CameraType[message.cameraType] : message.cameraType;
                    return object;
                };

                /**
                 * Converts this StartStreamPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StartStreamPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartStreamPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StartStreamPayload;
            })();

            stream.BeginInteractionPayload = (function() {

                /**
                 * Properties of a BeginInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IBeginInteractionPayload
                 * @property {vertexvis.protobuf.stream.ITransformInteraction|null} [transform] BeginInteractionPayload transform
                 */

                /**
                 * Constructs a new BeginInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a BeginInteractionPayload.
                 * @implements IBeginInteractionPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IBeginInteractionPayload=} [properties] Properties to set
                 */
                function BeginInteractionPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BeginInteractionPayload transform.
                 * @member {vertexvis.protobuf.stream.ITransformInteraction|null|undefined} transform
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @instance
                 */
                BeginInteractionPayload.prototype.transform = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * BeginInteractionPayload interaction.
                 * @member {"transform"|undefined} interaction
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @instance
                 */
                Object.defineProperty(BeginInteractionPayload.prototype, "interaction", {
                    get: $util.oneOfGetter($oneOfFields = ["transform"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BeginInteractionPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.BeginInteractionPayload} BeginInteractionPayload instance
                 */
                BeginInteractionPayload.create = function create(properties) {
                    return new BeginInteractionPayload(properties);
                };

                /**
                 * Encodes the specified BeginInteractionPayload message. Does not implicitly {@link vertexvis.protobuf.stream.BeginInteractionPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionPayload} message BeginInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BeginInteractionPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.stream.TransformInteraction.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BeginInteractionPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.BeginInteractionPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionPayload} message BeginInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BeginInteractionPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BeginInteractionPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.BeginInteractionPayload} BeginInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BeginInteractionPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.BeginInteractionPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BeginInteractionPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.BeginInteractionPayload} BeginInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BeginInteractionPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BeginInteractionPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BeginInteractionPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        properties.interaction = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.TransformInteraction.verify(message.transform);
                            if (error)
                                return "transform." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BeginInteractionPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.BeginInteractionPayload} BeginInteractionPayload
                 */
                BeginInteractionPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.BeginInteractionPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.BeginInteractionPayload();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.BeginInteractionPayload.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.fromObject(object.transform);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BeginInteractionPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.BeginInteractionPayload} message BeginInteractionPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BeginInteractionPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        object.transform = $root.vertexvis.protobuf.stream.TransformInteraction.toObject(message.transform, options);
                        if (options.oneofs)
                            object.interaction = "transform";
                    }
                    return object;
                };

                /**
                 * Converts this BeginInteractionPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.BeginInteractionPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BeginInteractionPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BeginInteractionPayload;
            })();

            stream.UpdateInteractionPayload = (function() {

                /**
                 * Properties of an UpdateInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateInteractionPayload
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateInteractionPayload frameCorrelationId
                 * @property {vertexvis.protobuf.stream.ITransformInteraction|null} [transform] UpdateInteractionPayload transform
                 */

                /**
                 * Constructs a new UpdateInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateInteractionPayload.
                 * @implements IUpdateInteractionPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionPayload=} [properties] Properties to set
                 */
                function UpdateInteractionPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateInteractionPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @instance
                 */
                UpdateInteractionPayload.prototype.frameCorrelationId = null;

                /**
                 * UpdateInteractionPayload transform.
                 * @member {vertexvis.protobuf.stream.ITransformInteraction|null|undefined} transform
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @instance
                 */
                UpdateInteractionPayload.prototype.transform = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * UpdateInteractionPayload interaction.
                 * @member {"transform"|undefined} interaction
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @instance
                 */
                Object.defineProperty(UpdateInteractionPayload.prototype, "interaction", {
                    get: $util.oneOfGetter($oneOfFields = ["transform"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new UpdateInteractionPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionPayload} UpdateInteractionPayload instance
                 */
                UpdateInteractionPayload.create = function create(properties) {
                    return new UpdateInteractionPayload(properties);
                };

                /**
                 * Encodes the specified UpdateInteractionPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateInteractionPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionPayload} message UpdateInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateInteractionPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.stream.TransformInteraction.encode(message.transform, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateInteractionPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateInteractionPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionPayload} message UpdateInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateInteractionPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateInteractionPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionPayload} UpdateInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateInteractionPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateInteractionPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateInteractionPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionPayload} UpdateInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateInteractionPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateInteractionPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateInteractionPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        properties.interaction = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.TransformInteraction.verify(message.transform);
                            if (error)
                                return "transform." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an UpdateInteractionPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionPayload} UpdateInteractionPayload
                 */
                UpdateInteractionPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateInteractionPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateInteractionPayload();
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateInteractionPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateInteractionPayload.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.fromObject(object.transform);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateInteractionPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateInteractionPayload} message UpdateInteractionPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateInteractionPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.frameCorrelationId = null;
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        object.transform = $root.vertexvis.protobuf.stream.TransformInteraction.toObject(message.transform, options);
                        if (options.oneofs)
                            object.interaction = "transform";
                    }
                    return object;
                };

                /**
                 * Converts this UpdateInteractionPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateInteractionPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateInteractionPayload;
            })();

            stream.EndInteractionPayload = (function() {

                /**
                 * Properties of an EndInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IEndInteractionPayload
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] EndInteractionPayload frameCorrelationId
                 * @property {vertexvis.protobuf.stream.ITransformInteraction|null} [transform] EndInteractionPayload transform
                 */

                /**
                 * Constructs a new EndInteractionPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an EndInteractionPayload.
                 * @implements IEndInteractionPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IEndInteractionPayload=} [properties] Properties to set
                 */
                function EndInteractionPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EndInteractionPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @instance
                 */
                EndInteractionPayload.prototype.frameCorrelationId = null;

                /**
                 * EndInteractionPayload transform.
                 * @member {vertexvis.protobuf.stream.ITransformInteraction|null|undefined} transform
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @instance
                 */
                EndInteractionPayload.prototype.transform = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * EndInteractionPayload interaction.
                 * @member {"transform"|undefined} interaction
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @instance
                 */
                Object.defineProperty(EndInteractionPayload.prototype, "interaction", {
                    get: $util.oneOfGetter($oneOfFields = ["transform"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new EndInteractionPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.EndInteractionPayload} EndInteractionPayload instance
                 */
                EndInteractionPayload.create = function create(properties) {
                    return new EndInteractionPayload(properties);
                };

                /**
                 * Encodes the specified EndInteractionPayload message. Does not implicitly {@link vertexvis.protobuf.stream.EndInteractionPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionPayload} message EndInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndInteractionPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.stream.TransformInteraction.encode(message.transform, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EndInteractionPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.EndInteractionPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionPayload} message EndInteractionPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndInteractionPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EndInteractionPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.EndInteractionPayload} EndInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndInteractionPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.EndInteractionPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EndInteractionPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.EndInteractionPayload} EndInteractionPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndInteractionPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EndInteractionPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EndInteractionPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        properties.interaction = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.TransformInteraction.verify(message.transform);
                            if (error)
                                return "transform." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an EndInteractionPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.EndInteractionPayload} EndInteractionPayload
                 */
                EndInteractionPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.EndInteractionPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.EndInteractionPayload();
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.EndInteractionPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.EndInteractionPayload.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.stream.TransformInteraction.fromObject(object.transform);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EndInteractionPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.EndInteractionPayload} message EndInteractionPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EndInteractionPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.frameCorrelationId = null;
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        object.transform = $root.vertexvis.protobuf.stream.TransformInteraction.toObject(message.transform, options);
                        if (options.oneofs)
                            object.interaction = "transform";
                    }
                    return object;
                };

                /**
                 * Converts this EndInteractionPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.EndInteractionPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EndInteractionPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EndInteractionPayload;
            })();

            stream.UpdateCameraPayload = (function() {

                /**
                 * Properties of an UpdateCameraPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateCameraPayload
                 * @property {vertexvis.protobuf.stream.ICamera|null} [camera] UpdateCameraPayload camera
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateCameraPayload frameCorrelationId
                 */

                /**
                 * Constructs a new UpdateCameraPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateCameraPayload.
                 * @implements IUpdateCameraPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateCameraPayload=} [properties] Properties to set
                 */
                function UpdateCameraPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateCameraPayload camera.
                 * @member {vertexvis.protobuf.stream.ICamera|null|undefined} camera
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @instance
                 */
                UpdateCameraPayload.prototype.camera = null;

                /**
                 * UpdateCameraPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @instance
                 */
                UpdateCameraPayload.prototype.frameCorrelationId = null;

                /**
                 * Creates a new UpdateCameraPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateCameraPayload} UpdateCameraPayload instance
                 */
                UpdateCameraPayload.create = function create(properties) {
                    return new UpdateCameraPayload(properties);
                };

                /**
                 * Encodes the specified UpdateCameraPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCameraPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraPayload} message UpdateCameraPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCameraPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                        $root.vertexvis.protobuf.stream.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateCameraPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCameraPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraPayload} message UpdateCameraPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCameraPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateCameraPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateCameraPayload} UpdateCameraPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCameraPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateCameraPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.camera = $root.vertexvis.protobuf.stream.Camera.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateCameraPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateCameraPayload} UpdateCameraPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCameraPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateCameraPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateCameraPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        let error = $root.vertexvis.protobuf.stream.Camera.verify(message.camera);
                        if (error)
                            return "camera." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateCameraPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateCameraPayload} UpdateCameraPayload
                 */
                UpdateCameraPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateCameraPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateCameraPayload();
                    if (object.camera != null) {
                        if (typeof object.camera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCameraPayload.camera: object expected");
                        message.camera = $root.vertexvis.protobuf.stream.Camera.fromObject(object.camera);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCameraPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateCameraPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateCameraPayload} message UpdateCameraPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateCameraPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.camera = null;
                        object.frameCorrelationId = null;
                    }
                    if (message.camera != null && message.hasOwnProperty("camera"))
                        object.camera = $root.vertexvis.protobuf.stream.Camera.toObject(message.camera, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    return object;
                };

                /**
                 * Converts this UpdateCameraPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateCameraPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateCameraPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateCameraPayload;
            })();

            stream.ReconnectPayload = (function() {

                /**
                 * Properties of a ReconnectPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IReconnectPayload
                 * @property {vertexvis.protobuf.core.IUuid|null} [streamId] ReconnectPayload streamId
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [dimensions] ReconnectPayload dimensions
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] ReconnectPayload frameCorrelationId
                 * @property {vertexvis.protobuf.core.IRGBi|null} [frameBackgroundColor] ReconnectPayload frameBackgroundColor
                 * @property {vertexvis.protobuf.stream.IStreamAttributes|null} [streamAttributes] ReconnectPayload streamAttributes
                 * @property {boolean|null} [clientSupportsTemporalRefinement] ReconnectPayload clientSupportsTemporalRefinement
                 */

                /**
                 * Constructs a new ReconnectPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ReconnectPayload.
                 * @implements IReconnectPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IReconnectPayload=} [properties] Properties to set
                 */
                function ReconnectPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReconnectPayload streamId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} streamId
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.streamId = null;

                /**
                 * ReconnectPayload dimensions.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} dimensions
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.dimensions = null;

                /**
                 * ReconnectPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.frameCorrelationId = null;

                /**
                 * ReconnectPayload frameBackgroundColor.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} frameBackgroundColor
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.frameBackgroundColor = null;

                /**
                 * ReconnectPayload streamAttributes.
                 * @member {vertexvis.protobuf.stream.IStreamAttributes|null|undefined} streamAttributes
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.streamAttributes = null;

                /**
                 * ReconnectPayload clientSupportsTemporalRefinement.
                 * @member {boolean} clientSupportsTemporalRefinement
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 */
                ReconnectPayload.prototype.clientSupportsTemporalRefinement = false;

                /**
                 * Creates a new ReconnectPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ReconnectPayload} ReconnectPayload instance
                 */
                ReconnectPayload.create = function create(properties) {
                    return new ReconnectPayload(properties);
                };

                /**
                 * Encodes the specified ReconnectPayload message. Does not implicitly {@link vertexvis.protobuf.stream.ReconnectPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectPayload} message ReconnectPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReconnectPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.streamId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.dimensions != null && Object.hasOwnProperty.call(message, "dimensions"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.dimensions, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.frameBackgroundColor != null && Object.hasOwnProperty.call(message, "frameBackgroundColor"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.frameBackgroundColor, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.streamAttributes != null && Object.hasOwnProperty.call(message, "streamAttributes"))
                        $root.vertexvis.protobuf.stream.StreamAttributes.encode(message.streamAttributes, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.clientSupportsTemporalRefinement != null && Object.hasOwnProperty.call(message, "clientSupportsTemporalRefinement"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.clientSupportsTemporalRefinement);
                    return writer;
                };

                /**
                 * Encodes the specified ReconnectPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ReconnectPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectPayload} message ReconnectPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReconnectPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReconnectPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ReconnectPayload} ReconnectPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReconnectPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ReconnectPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.streamId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.clientSupportsTemporalRefinement = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReconnectPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ReconnectPayload} ReconnectPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReconnectPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReconnectPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReconnectPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.streamId != null && message.hasOwnProperty("streamId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.streamId);
                        if (error)
                            return "streamId." + error;
                    }
                    if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.dimensions);
                        if (error)
                            return "dimensions." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.frameBackgroundColor);
                        if (error)
                            return "frameBackgroundColor." + error;
                    }
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.StreamAttributes.verify(message.streamAttributes);
                        if (error)
                            return "streamAttributes." + error;
                    }
                    if (message.clientSupportsTemporalRefinement != null && message.hasOwnProperty("clientSupportsTemporalRefinement"))
                        if (typeof message.clientSupportsTemporalRefinement !== "boolean")
                            return "clientSupportsTemporalRefinement: boolean expected";
                    return null;
                };

                /**
                 * Creates a ReconnectPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ReconnectPayload} ReconnectPayload
                 */
                ReconnectPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ReconnectPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ReconnectPayload();
                    if (object.streamId != null) {
                        if (typeof object.streamId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectPayload.streamId: object expected");
                        message.streamId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.streamId);
                    }
                    if (object.dimensions != null) {
                        if (typeof object.dimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectPayload.dimensions: object expected");
                        message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.dimensions);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.frameBackgroundColor != null) {
                        if (typeof object.frameBackgroundColor !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectPayload.frameBackgroundColor: object expected");
                        message.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.fromObject(object.frameBackgroundColor);
                    }
                    if (object.streamAttributes != null) {
                        if (typeof object.streamAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectPayload.streamAttributes: object expected");
                        message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.fromObject(object.streamAttributes);
                    }
                    if (object.clientSupportsTemporalRefinement != null)
                        message.clientSupportsTemporalRefinement = Boolean(object.clientSupportsTemporalRefinement);
                    return message;
                };

                /**
                 * Creates a plain object from a ReconnectPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ReconnectPayload} message ReconnectPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReconnectPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.streamId = null;
                        object.dimensions = null;
                        object.frameCorrelationId = null;
                        object.frameBackgroundColor = null;
                        object.streamAttributes = null;
                        object.clientSupportsTemporalRefinement = false;
                    }
                    if (message.streamId != null && message.hasOwnProperty("streamId"))
                        object.streamId = $root.vertexvis.protobuf.core.Uuid.toObject(message.streamId, options);
                    if (message.dimensions != null && message.hasOwnProperty("dimensions"))
                        object.dimensions = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.dimensions, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.frameBackgroundColor != null && message.hasOwnProperty("frameBackgroundColor"))
                        object.frameBackgroundColor = $root.vertexvis.protobuf.core.RGBi.toObject(message.frameBackgroundColor, options);
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes"))
                        object.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.toObject(message.streamAttributes, options);
                    if (message.clientSupportsTemporalRefinement != null && message.hasOwnProperty("clientSupportsTemporalRefinement"))
                        object.clientSupportsTemporalRefinement = message.clientSupportsTemporalRefinement;
                    return object;
                };

                /**
                 * Converts this ReconnectPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ReconnectPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReconnectPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReconnectPayload;
            })();

            stream.UpdateDimensionsPayload = (function() {

                /**
                 * Properties of an UpdateDimensionsPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateDimensionsPayload
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [dimensions] UpdateDimensionsPayload dimensions
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateDimensionsPayload frameCorrelationId
                 */

                /**
                 * Constructs a new UpdateDimensionsPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateDimensionsPayload.
                 * @implements IUpdateDimensionsPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsPayload=} [properties] Properties to set
                 */
                function UpdateDimensionsPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateDimensionsPayload dimensions.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} dimensions
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @instance
                 */
                UpdateDimensionsPayload.prototype.dimensions = null;

                /**
                 * UpdateDimensionsPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @instance
                 */
                UpdateDimensionsPayload.prototype.frameCorrelationId = null;

                /**
                 * Creates a new UpdateDimensionsPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsPayload} UpdateDimensionsPayload instance
                 */
                UpdateDimensionsPayload.create = function create(properties) {
                    return new UpdateDimensionsPayload(properties);
                };

                /**
                 * Encodes the specified UpdateDimensionsPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateDimensionsPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsPayload} message UpdateDimensionsPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateDimensionsPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dimensions != null && Object.hasOwnProperty.call(message, "dimensions"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.dimensions, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateDimensionsPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateDimensionsPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsPayload} message UpdateDimensionsPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateDimensionsPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateDimensionsPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsPayload} UpdateDimensionsPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateDimensionsPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateDimensionsPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateDimensionsPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsPayload} UpdateDimensionsPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateDimensionsPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateDimensionsPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateDimensionsPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.dimensions);
                        if (error)
                            return "dimensions." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateDimensionsPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsPayload} UpdateDimensionsPayload
                 */
                UpdateDimensionsPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateDimensionsPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateDimensionsPayload();
                    if (object.dimensions != null) {
                        if (typeof object.dimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateDimensionsPayload.dimensions: object expected");
                        message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.dimensions);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateDimensionsPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateDimensionsPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateDimensionsPayload} message UpdateDimensionsPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateDimensionsPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.dimensions = null;
                        object.frameCorrelationId = null;
                    }
                    if (message.dimensions != null && message.hasOwnProperty("dimensions"))
                        object.dimensions = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.dimensions, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    return object;
                };

                /**
                 * Converts this UpdateDimensionsPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateDimensionsPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateDimensionsPayload;
            })();

            stream.HitItemsPayload = (function() {

                /**
                 * Properties of a HitItemsPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IHitItemsPayload
                 * @property {vertexvis.protobuf.stream.IPoint|null} [point] HitItemsPayload point
                 * @property {boolean|null} [includeMetadata] HitItemsPayload includeMetadata
                 * @property {Array.<vertexvis.protobuf.core.SceneElementTypeMask>|null} [typeMask] HitItemsPayload typeMask
                 */

                /**
                 * Constructs a new HitItemsPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a HitItemsPayload.
                 * @implements IHitItemsPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IHitItemsPayload=} [properties] Properties to set
                 */
                function HitItemsPayload(properties) {
                    this.typeMask = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HitItemsPayload point.
                 * @member {vertexvis.protobuf.stream.IPoint|null|undefined} point
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @instance
                 */
                HitItemsPayload.prototype.point = null;

                /**
                 * HitItemsPayload includeMetadata.
                 * @member {boolean} includeMetadata
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @instance
                 */
                HitItemsPayload.prototype.includeMetadata = false;

                /**
                 * HitItemsPayload typeMask.
                 * @member {Array.<vertexvis.protobuf.core.SceneElementTypeMask>} typeMask
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @instance
                 */
                HitItemsPayload.prototype.typeMask = $util.emptyArray;

                /**
                 * Creates a new HitItemsPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.HitItemsPayload} HitItemsPayload instance
                 */
                HitItemsPayload.create = function create(properties) {
                    return new HitItemsPayload(properties);
                };

                /**
                 * Encodes the specified HitItemsPayload message. Does not implicitly {@link vertexvis.protobuf.stream.HitItemsPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsPayload} message HitItemsPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemsPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.point != null && Object.hasOwnProperty.call(message, "point"))
                        $root.vertexvis.protobuf.stream.Point.encode(message.point, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.includeMetadata != null && Object.hasOwnProperty.call(message, "includeMetadata"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeMetadata);
                    if (message.typeMask != null && message.typeMask.length) {
                        writer.uint32(/* id 8, wireType 2 =*/66).fork();
                        for (let i = 0; i < message.typeMask.length; ++i)
                            writer.int32(message.typeMask[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified HitItemsPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.HitItemsPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsPayload} message HitItemsPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemsPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HitItemsPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.HitItemsPayload} HitItemsPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemsPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.HitItemsPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.point = $root.vertexvis.protobuf.stream.Point.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.includeMetadata = reader.bool();
                            break;
                        case 8:
                            if (!(message.typeMask && message.typeMask.length))
                                message.typeMask = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.typeMask.push(reader.int32());
                            } else
                                message.typeMask.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HitItemsPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.HitItemsPayload} HitItemsPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemsPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HitItemsPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HitItemsPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.point != null && message.hasOwnProperty("point")) {
                        let error = $root.vertexvis.protobuf.stream.Point.verify(message.point);
                        if (error)
                            return "point." + error;
                    }
                    if (message.includeMetadata != null && message.hasOwnProperty("includeMetadata"))
                        if (typeof message.includeMetadata !== "boolean")
                            return "includeMetadata: boolean expected";
                    if (message.typeMask != null && message.hasOwnProperty("typeMask")) {
                        if (!Array.isArray(message.typeMask))
                            return "typeMask: array expected";
                        for (let i = 0; i < message.typeMask.length; ++i)
                            switch (message.typeMask[i]) {
                            default:
                                return "typeMask: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a HitItemsPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.HitItemsPayload} HitItemsPayload
                 */
                HitItemsPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.HitItemsPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.HitItemsPayload();
                    if (object.point != null) {
                        if (typeof object.point !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.HitItemsPayload.point: object expected");
                        message.point = $root.vertexvis.protobuf.stream.Point.fromObject(object.point);
                    }
                    if (object.includeMetadata != null)
                        message.includeMetadata = Boolean(object.includeMetadata);
                    if (object.typeMask) {
                        if (!Array.isArray(object.typeMask))
                            throw TypeError(".vertexvis.protobuf.stream.HitItemsPayload.typeMask: array expected");
                        message.typeMask = [];
                        for (let i = 0; i < object.typeMask.length; ++i)
                            switch (object.typeMask[i]) {
                            default:
                            case "SCENE_ELEMENT_TYPE_MASK_INVALID":
                            case 0:
                                message.typeMask[i] = 0;
                                break;
                            case "SCENE_ELEMENT_TYPE_MASK_SCENE_ITEMS":
                            case 1:
                                message.typeMask[i] = 1;
                                break;
                            case "SCENE_ELEMENT_TYPE_MASK_ANNOTATION_PRIMITIVES":
                            case 2:
                                message.typeMask[i] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HitItemsPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.HitItemsPayload} message HitItemsPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HitItemsPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.typeMask = [];
                    if (options.defaults) {
                        object.point = null;
                        object.includeMetadata = false;
                    }
                    if (message.point != null && message.hasOwnProperty("point"))
                        object.point = $root.vertexvis.protobuf.stream.Point.toObject(message.point, options);
                    if (message.includeMetadata != null && message.hasOwnProperty("includeMetadata"))
                        object.includeMetadata = message.includeMetadata;
                    if (message.typeMask && message.typeMask.length) {
                        object.typeMask = [];
                        for (let j = 0; j < message.typeMask.length; ++j)
                            object.typeMask[j] = options.enums === String ? $root.vertexvis.protobuf.core.SceneElementTypeMask[message.typeMask[j]] : message.typeMask[j];
                    }
                    return object;
                };

                /**
                 * Converts this HitItemsPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.HitItemsPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HitItemsPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HitItemsPayload;
            })();

            stream.CreateSceneAlterationPayload = (function() {

                /**
                 * Properties of a CreateSceneAlterationPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ICreateSceneAlterationPayload
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneViewId] CreateSceneAlterationPayload sceneViewId
                 * @property {Array.<vertexvis.protobuf.stream.ISceneOperation>|null} [operations] CreateSceneAlterationPayload operations
                 * @property {google.protobuf.IStringValue|null} [suppliedCorrelationId] CreateSceneAlterationPayload suppliedCorrelationId
                 * @property {Array.<vertexvis.protobuf.stream.ISceneElementOperation>|null} [elementOperations] CreateSceneAlterationPayload elementOperations
                 */

                /**
                 * Constructs a new CreateSceneAlterationPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a CreateSceneAlterationPayload.
                 * @implements ICreateSceneAlterationPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ICreateSceneAlterationPayload=} [properties] Properties to set
                 */
                function CreateSceneAlterationPayload(properties) {
                    this.operations = [];
                    this.elementOperations = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CreateSceneAlterationPayload sceneViewId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneViewId
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 */
                CreateSceneAlterationPayload.prototype.sceneViewId = null;

                /**
                 * CreateSceneAlterationPayload operations.
                 * @member {Array.<vertexvis.protobuf.stream.ISceneOperation>} operations
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 */
                CreateSceneAlterationPayload.prototype.operations = $util.emptyArray;

                /**
                 * CreateSceneAlterationPayload suppliedCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} suppliedCorrelationId
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 */
                CreateSceneAlterationPayload.prototype.suppliedCorrelationId = null;

                /**
                 * CreateSceneAlterationPayload elementOperations.
                 * @member {Array.<vertexvis.protobuf.stream.ISceneElementOperation>} elementOperations
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 */
                CreateSceneAlterationPayload.prototype.elementOperations = $util.emptyArray;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * CreateSceneAlterationPayload id.
                 * @member {"sceneViewId"|undefined} id
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 */
                Object.defineProperty(CreateSceneAlterationPayload.prototype, "id", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneViewId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CreateSceneAlterationPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ICreateSceneAlterationPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.CreateSceneAlterationPayload} CreateSceneAlterationPayload instance
                 */
                CreateSceneAlterationPayload.create = function create(properties) {
                    return new CreateSceneAlterationPayload(properties);
                };

                /**
                 * Encodes the specified CreateSceneAlterationPayload message. Does not implicitly {@link vertexvis.protobuf.stream.CreateSceneAlterationPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ICreateSceneAlterationPayload} message CreateSceneAlterationPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CreateSceneAlterationPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sceneViewId != null && Object.hasOwnProperty.call(message, "sceneViewId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneViewId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.operations != null && message.operations.length)
                        for (let i = 0; i < message.operations.length; ++i)
                            $root.vertexvis.protobuf.stream.SceneOperation.encode(message.operations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.suppliedCorrelationId != null && Object.hasOwnProperty.call(message, "suppliedCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.suppliedCorrelationId, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.elementOperations != null && message.elementOperations.length)
                        for (let i = 0; i < message.elementOperations.length; ++i)
                            $root.vertexvis.protobuf.stream.SceneElementOperation.encode(message.elementOperations[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CreateSceneAlterationPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.CreateSceneAlterationPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ICreateSceneAlterationPayload} message CreateSceneAlterationPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CreateSceneAlterationPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CreateSceneAlterationPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.CreateSceneAlterationPayload} CreateSceneAlterationPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CreateSceneAlterationPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sceneViewId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.operations && message.operations.length))
                                message.operations = [];
                            message.operations.push($root.vertexvis.protobuf.stream.SceneOperation.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.suppliedCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (!(message.elementOperations && message.elementOperations.length))
                                message.elementOperations = [];
                            message.elementOperations.push($root.vertexvis.protobuf.stream.SceneElementOperation.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CreateSceneAlterationPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.CreateSceneAlterationPayload} CreateSceneAlterationPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CreateSceneAlterationPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CreateSceneAlterationPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CreateSceneAlterationPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.sceneViewId != null && message.hasOwnProperty("sceneViewId")) {
                        properties.id = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneViewId);
                            if (error)
                                return "sceneViewId." + error;
                        }
                    }
                    if (message.operations != null && message.hasOwnProperty("operations")) {
                        if (!Array.isArray(message.operations))
                            return "operations: array expected";
                        for (let i = 0; i < message.operations.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.SceneOperation.verify(message.operations[i]);
                            if (error)
                                return "operations." + error;
                        }
                    }
                    if (message.suppliedCorrelationId != null && message.hasOwnProperty("suppliedCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.suppliedCorrelationId);
                        if (error)
                            return "suppliedCorrelationId." + error;
                    }
                    if (message.elementOperations != null && message.hasOwnProperty("elementOperations")) {
                        if (!Array.isArray(message.elementOperations))
                            return "elementOperations: array expected";
                        for (let i = 0; i < message.elementOperations.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.SceneElementOperation.verify(message.elementOperations[i]);
                            if (error)
                                return "elementOperations." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CreateSceneAlterationPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.CreateSceneAlterationPayload} CreateSceneAlterationPayload
                 */
                CreateSceneAlterationPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.CreateSceneAlterationPayload();
                    if (object.sceneViewId != null) {
                        if (typeof object.sceneViewId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.sceneViewId: object expected");
                        message.sceneViewId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneViewId);
                    }
                    if (object.operations) {
                        if (!Array.isArray(object.operations))
                            throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.operations: array expected");
                        message.operations = [];
                        for (let i = 0; i < object.operations.length; ++i) {
                            if (typeof object.operations[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.operations: object expected");
                            message.operations[i] = $root.vertexvis.protobuf.stream.SceneOperation.fromObject(object.operations[i]);
                        }
                    }
                    if (object.suppliedCorrelationId != null) {
                        if (typeof object.suppliedCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.suppliedCorrelationId: object expected");
                        message.suppliedCorrelationId = $root.google.protobuf.StringValue.fromObject(object.suppliedCorrelationId);
                    }
                    if (object.elementOperations) {
                        if (!Array.isArray(object.elementOperations))
                            throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.elementOperations: array expected");
                        message.elementOperations = [];
                        for (let i = 0; i < object.elementOperations.length; ++i) {
                            if (typeof object.elementOperations[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.CreateSceneAlterationPayload.elementOperations: object expected");
                            message.elementOperations[i] = $root.vertexvis.protobuf.stream.SceneElementOperation.fromObject(object.elementOperations[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CreateSceneAlterationPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.CreateSceneAlterationPayload} message CreateSceneAlterationPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CreateSceneAlterationPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.operations = [];
                        object.elementOperations = [];
                    }
                    if (options.defaults)
                        object.suppliedCorrelationId = null;
                    if (message.sceneViewId != null && message.hasOwnProperty("sceneViewId")) {
                        object.sceneViewId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneViewId, options);
                        if (options.oneofs)
                            object.id = "sceneViewId";
                    }
                    if (message.operations && message.operations.length) {
                        object.operations = [];
                        for (let j = 0; j < message.operations.length; ++j)
                            object.operations[j] = $root.vertexvis.protobuf.stream.SceneOperation.toObject(message.operations[j], options);
                    }
                    if (message.suppliedCorrelationId != null && message.hasOwnProperty("suppliedCorrelationId"))
                        object.suppliedCorrelationId = $root.google.protobuf.StringValue.toObject(message.suppliedCorrelationId, options);
                    if (message.elementOperations && message.elementOperations.length) {
                        object.elementOperations = [];
                        for (let j = 0; j < message.elementOperations.length; ++j)
                            object.elementOperations[j] = $root.vertexvis.protobuf.stream.SceneElementOperation.toObject(message.elementOperations[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this CreateSceneAlterationPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.CreateSceneAlterationPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CreateSceneAlterationPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CreateSceneAlterationPayload;
            })();

            stream.DrawFramePayload = (function() {

                /**
                 * Properties of a DrawFramePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IDrawFramePayload
                 * @property {number|null} [sequenceNumber] DrawFramePayload sequenceNumber
                 * @property {vertexvis.protobuf.stream.ISceneAttributes|null} [sceneAttributes] DrawFramePayload sceneAttributes
                 * @property {vertexvis.protobuf.stream.IImageAttributes|null} [imageAttributes] DrawFramePayload imageAttributes
                 * @property {Uint8Array|null} [image] DrawFramePayload image
                 * @property {Array.<string>|null} [frameCorrelationIds] DrawFramePayload frameCorrelationIds
                 * @property {google.protobuf.IBytesValue|null} [depthBuffer] DrawFramePayload depthBuffer
                 * @property {google.protobuf.IBytesValue|null} [featureMap] DrawFramePayload featureMap
                 * @property {boolean|null} [temporalRefinement] DrawFramePayload temporalRefinement
                 * @property {vertexvis.protobuf.core.IUuid|null} [temporalRefinementCorrelationId] DrawFramePayload temporalRefinementCorrelationId
                 */

                /**
                 * Constructs a new DrawFramePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a DrawFramePayload.
                 * @implements IDrawFramePayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IDrawFramePayload=} [properties] Properties to set
                 */
                function DrawFramePayload(properties) {
                    this.frameCorrelationIds = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DrawFramePayload sequenceNumber.
                 * @member {number} sequenceNumber
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.sequenceNumber = 0;

                /**
                 * DrawFramePayload sceneAttributes.
                 * @member {vertexvis.protobuf.stream.ISceneAttributes|null|undefined} sceneAttributes
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.sceneAttributes = null;

                /**
                 * DrawFramePayload imageAttributes.
                 * @member {vertexvis.protobuf.stream.IImageAttributes|null|undefined} imageAttributes
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.imageAttributes = null;

                /**
                 * DrawFramePayload image.
                 * @member {Uint8Array} image
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.image = $util.newBuffer([]);

                /**
                 * DrawFramePayload frameCorrelationIds.
                 * @member {Array.<string>} frameCorrelationIds
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.frameCorrelationIds = $util.emptyArray;

                /**
                 * DrawFramePayload depthBuffer.
                 * @member {google.protobuf.IBytesValue|null|undefined} depthBuffer
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.depthBuffer = null;

                /**
                 * DrawFramePayload featureMap.
                 * @member {google.protobuf.IBytesValue|null|undefined} featureMap
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.featureMap = null;

                /**
                 * DrawFramePayload temporalRefinement.
                 * @member {boolean} temporalRefinement
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.temporalRefinement = false;

                /**
                 * DrawFramePayload temporalRefinementCorrelationId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} temporalRefinementCorrelationId
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 */
                DrawFramePayload.prototype.temporalRefinementCorrelationId = null;

                /**
                 * Creates a new DrawFramePayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFramePayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.DrawFramePayload} DrawFramePayload instance
                 */
                DrawFramePayload.create = function create(properties) {
                    return new DrawFramePayload(properties);
                };

                /**
                 * Encodes the specified DrawFramePayload message. Does not implicitly {@link vertexvis.protobuf.stream.DrawFramePayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFramePayload} message DrawFramePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DrawFramePayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.sequenceNumber);
                    if (message.sceneAttributes != null && Object.hasOwnProperty.call(message, "sceneAttributes"))
                        $root.vertexvis.protobuf.stream.SceneAttributes.encode(message.sceneAttributes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.imageAttributes != null && Object.hasOwnProperty.call(message, "imageAttributes"))
                        $root.vertexvis.protobuf.stream.ImageAttributes.encode(message.imageAttributes, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.image);
                    if (message.frameCorrelationIds != null && message.frameCorrelationIds.length)
                        for (let i = 0; i < message.frameCorrelationIds.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.frameCorrelationIds[i]);
                    if (message.depthBuffer != null && Object.hasOwnProperty.call(message, "depthBuffer"))
                        $root.google.protobuf.BytesValue.encode(message.depthBuffer, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.featureMap != null && Object.hasOwnProperty.call(message, "featureMap"))
                        $root.google.protobuf.BytesValue.encode(message.featureMap, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.temporalRefinement != null && Object.hasOwnProperty.call(message, "temporalRefinement"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.temporalRefinement);
                    if (message.temporalRefinementCorrelationId != null && Object.hasOwnProperty.call(message, "temporalRefinementCorrelationId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.temporalRefinementCorrelationId, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DrawFramePayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.DrawFramePayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFramePayload} message DrawFramePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DrawFramePayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DrawFramePayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.DrawFramePayload} DrawFramePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DrawFramePayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.DrawFramePayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sequenceNumber = reader.uint32();
                            break;
                        case 2:
                            message.sceneAttributes = $root.vertexvis.protobuf.stream.SceneAttributes.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.image = reader.bytes();
                            break;
                        case 5:
                            if (!(message.frameCorrelationIds && message.frameCorrelationIds.length))
                                message.frameCorrelationIds = [];
                            message.frameCorrelationIds.push(reader.string());
                            break;
                        case 6:
                            message.depthBuffer = $root.google.protobuf.BytesValue.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.featureMap = $root.google.protobuf.BytesValue.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.temporalRefinement = reader.bool();
                            break;
                        case 9:
                            message.temporalRefinementCorrelationId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DrawFramePayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.DrawFramePayload} DrawFramePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DrawFramePayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DrawFramePayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DrawFramePayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                        if (!$util.isInteger(message.sequenceNumber))
                            return "sequenceNumber: integer expected";
                    if (message.sceneAttributes != null && message.hasOwnProperty("sceneAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.SceneAttributes.verify(message.sceneAttributes);
                        if (error)
                            return "sceneAttributes." + error;
                    }
                    if (message.imageAttributes != null && message.hasOwnProperty("imageAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.ImageAttributes.verify(message.imageAttributes);
                        if (error)
                            return "imageAttributes." + error;
                    }
                    if (message.image != null && message.hasOwnProperty("image"))
                        if (!(message.image && typeof message.image.length === "number" || $util.isString(message.image)))
                            return "image: buffer expected";
                    if (message.frameCorrelationIds != null && message.hasOwnProperty("frameCorrelationIds")) {
                        if (!Array.isArray(message.frameCorrelationIds))
                            return "frameCorrelationIds: array expected";
                        for (let i = 0; i < message.frameCorrelationIds.length; ++i)
                            if (!$util.isString(message.frameCorrelationIds[i]))
                                return "frameCorrelationIds: string[] expected";
                    }
                    if (message.depthBuffer != null && message.hasOwnProperty("depthBuffer")) {
                        let error = $root.google.protobuf.BytesValue.verify(message.depthBuffer);
                        if (error)
                            return "depthBuffer." + error;
                    }
                    if (message.featureMap != null && message.hasOwnProperty("featureMap")) {
                        let error = $root.google.protobuf.BytesValue.verify(message.featureMap);
                        if (error)
                            return "featureMap." + error;
                    }
                    if (message.temporalRefinement != null && message.hasOwnProperty("temporalRefinement"))
                        if (typeof message.temporalRefinement !== "boolean")
                            return "temporalRefinement: boolean expected";
                    if (message.temporalRefinementCorrelationId != null && message.hasOwnProperty("temporalRefinementCorrelationId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.temporalRefinementCorrelationId);
                        if (error)
                            return "temporalRefinementCorrelationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates a DrawFramePayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.DrawFramePayload} DrawFramePayload
                 */
                DrawFramePayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.DrawFramePayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.DrawFramePayload();
                    if (object.sequenceNumber != null)
                        message.sequenceNumber = object.sequenceNumber >>> 0;
                    if (object.sceneAttributes != null) {
                        if (typeof object.sceneAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.sceneAttributes: object expected");
                        message.sceneAttributes = $root.vertexvis.protobuf.stream.SceneAttributes.fromObject(object.sceneAttributes);
                    }
                    if (object.imageAttributes != null) {
                        if (typeof object.imageAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.imageAttributes: object expected");
                        message.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.fromObject(object.imageAttributes);
                    }
                    if (object.image != null)
                        if (typeof object.image === "string")
                            $util.base64.decode(object.image, message.image = $util.newBuffer($util.base64.length(object.image)), 0);
                        else if (object.image.length)
                            message.image = object.image;
                    if (object.frameCorrelationIds) {
                        if (!Array.isArray(object.frameCorrelationIds))
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.frameCorrelationIds: array expected");
                        message.frameCorrelationIds = [];
                        for (let i = 0; i < object.frameCorrelationIds.length; ++i)
                            message.frameCorrelationIds[i] = String(object.frameCorrelationIds[i]);
                    }
                    if (object.depthBuffer != null) {
                        if (typeof object.depthBuffer !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.depthBuffer: object expected");
                        message.depthBuffer = $root.google.protobuf.BytesValue.fromObject(object.depthBuffer);
                    }
                    if (object.featureMap != null) {
                        if (typeof object.featureMap !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.featureMap: object expected");
                        message.featureMap = $root.google.protobuf.BytesValue.fromObject(object.featureMap);
                    }
                    if (object.temporalRefinement != null)
                        message.temporalRefinement = Boolean(object.temporalRefinement);
                    if (object.temporalRefinementCorrelationId != null) {
                        if (typeof object.temporalRefinementCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFramePayload.temporalRefinementCorrelationId: object expected");
                        message.temporalRefinementCorrelationId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.temporalRefinementCorrelationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DrawFramePayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.DrawFramePayload} message DrawFramePayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DrawFramePayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.frameCorrelationIds = [];
                    if (options.defaults) {
                        object.sequenceNumber = 0;
                        object.sceneAttributes = null;
                        object.imageAttributes = null;
                        if (options.bytes === String)
                            object.image = "";
                        else {
                            object.image = [];
                            if (options.bytes !== Array)
                                object.image = $util.newBuffer(object.image);
                        }
                        object.depthBuffer = null;
                        object.featureMap = null;
                        object.temporalRefinement = false;
                        object.temporalRefinementCorrelationId = null;
                    }
                    if (message.sequenceNumber != null && message.hasOwnProperty("sequenceNumber"))
                        object.sequenceNumber = message.sequenceNumber;
                    if (message.sceneAttributes != null && message.hasOwnProperty("sceneAttributes"))
                        object.sceneAttributes = $root.vertexvis.protobuf.stream.SceneAttributes.toObject(message.sceneAttributes, options);
                    if (message.imageAttributes != null && message.hasOwnProperty("imageAttributes"))
                        object.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.toObject(message.imageAttributes, options);
                    if (message.image != null && message.hasOwnProperty("image"))
                        object.image = options.bytes === String ? $util.base64.encode(message.image, 0, message.image.length) : options.bytes === Array ? Array.prototype.slice.call(message.image) : message.image;
                    if (message.frameCorrelationIds && message.frameCorrelationIds.length) {
                        object.frameCorrelationIds = [];
                        for (let j = 0; j < message.frameCorrelationIds.length; ++j)
                            object.frameCorrelationIds[j] = message.frameCorrelationIds[j];
                    }
                    if (message.depthBuffer != null && message.hasOwnProperty("depthBuffer"))
                        object.depthBuffer = $root.google.protobuf.BytesValue.toObject(message.depthBuffer, options);
                    if (message.featureMap != null && message.hasOwnProperty("featureMap"))
                        object.featureMap = $root.google.protobuf.BytesValue.toObject(message.featureMap, options);
                    if (message.temporalRefinement != null && message.hasOwnProperty("temporalRefinement"))
                        object.temporalRefinement = message.temporalRefinement;
                    if (message.temporalRefinementCorrelationId != null && message.hasOwnProperty("temporalRefinementCorrelationId"))
                        object.temporalRefinementCorrelationId = $root.vertexvis.protobuf.core.Uuid.toObject(message.temporalRefinementCorrelationId, options);
                    return object;
                };

                /**
                 * Converts this DrawFramePayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.DrawFramePayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DrawFramePayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DrawFramePayload;
            })();

            stream.SyncTimePayload = (function() {

                /**
                 * Properties of a SyncTimePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISyncTimePayload
                 * @property {google.protobuf.ITimestamp|null} [requestTime] SyncTimePayload requestTime
                 */

                /**
                 * Constructs a new SyncTimePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SyncTimePayload.
                 * @implements ISyncTimePayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISyncTimePayload=} [properties] Properties to set
                 */
                function SyncTimePayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SyncTimePayload requestTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} requestTime
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @instance
                 */
                SyncTimePayload.prototype.requestTime = null;

                /**
                 * Creates a new SyncTimePayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimePayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SyncTimePayload} SyncTimePayload instance
                 */
                SyncTimePayload.create = function create(properties) {
                    return new SyncTimePayload(properties);
                };

                /**
                 * Encodes the specified SyncTimePayload message. Does not implicitly {@link vertexvis.protobuf.stream.SyncTimePayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimePayload} message SyncTimePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SyncTimePayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.requestTime != null && Object.hasOwnProperty.call(message, "requestTime"))
                        $root.google.protobuf.Timestamp.encode(message.requestTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SyncTimePayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SyncTimePayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimePayload} message SyncTimePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SyncTimePayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SyncTimePayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SyncTimePayload} SyncTimePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SyncTimePayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SyncTimePayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.requestTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SyncTimePayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SyncTimePayload} SyncTimePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SyncTimePayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SyncTimePayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SyncTimePayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.requestTime != null && message.hasOwnProperty("requestTime")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.requestTime);
                        if (error)
                            return "requestTime." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SyncTimePayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SyncTimePayload} SyncTimePayload
                 */
                SyncTimePayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SyncTimePayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SyncTimePayload();
                    if (object.requestTime != null) {
                        if (typeof object.requestTime !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SyncTimePayload.requestTime: object expected");
                        message.requestTime = $root.google.protobuf.Timestamp.fromObject(object.requestTime);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SyncTimePayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.SyncTimePayload} message SyncTimePayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SyncTimePayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.requestTime = null;
                    if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                        object.requestTime = $root.google.protobuf.Timestamp.toObject(message.requestTime, options);
                    return object;
                };

                /**
                 * Converts this SyncTimePayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SyncTimePayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SyncTimePayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SyncTimePayload;
            })();

            stream.RecordPerformancePayload = (function() {

                /**
                 * Properties of a RecordPerformancePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRecordPerformancePayload
                 * @property {Array.<vertexvis.protobuf.stream.IPerformanceTiming>|null} [timings] RecordPerformancePayload timings
                 */

                /**
                 * Constructs a new RecordPerformancePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a RecordPerformancePayload.
                 * @implements IRecordPerformancePayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRecordPerformancePayload=} [properties] Properties to set
                 */
                function RecordPerformancePayload(properties) {
                    this.timings = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordPerformancePayload timings.
                 * @member {Array.<vertexvis.protobuf.stream.IPerformanceTiming>} timings
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @instance
                 */
                RecordPerformancePayload.prototype.timings = $util.emptyArray;

                /**
                 * Creates a new RecordPerformancePayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformancePayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.RecordPerformancePayload} RecordPerformancePayload instance
                 */
                RecordPerformancePayload.create = function create(properties) {
                    return new RecordPerformancePayload(properties);
                };

                /**
                 * Encodes the specified RecordPerformancePayload message. Does not implicitly {@link vertexvis.protobuf.stream.RecordPerformancePayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformancePayload} message RecordPerformancePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordPerformancePayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.timings != null && message.timings.length)
                        for (let i = 0; i < message.timings.length; ++i)
                            $root.vertexvis.protobuf.stream.PerformanceTiming.encode(message.timings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordPerformancePayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.RecordPerformancePayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformancePayload} message RecordPerformancePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordPerformancePayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordPerformancePayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.RecordPerformancePayload} RecordPerformancePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordPerformancePayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.RecordPerformancePayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.timings && message.timings.length))
                                message.timings = [];
                            message.timings.push($root.vertexvis.protobuf.stream.PerformanceTiming.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordPerformancePayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.RecordPerformancePayload} RecordPerformancePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordPerformancePayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordPerformancePayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordPerformancePayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.timings != null && message.hasOwnProperty("timings")) {
                        if (!Array.isArray(message.timings))
                            return "timings: array expected";
                        for (let i = 0; i < message.timings.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.PerformanceTiming.verify(message.timings[i]);
                            if (error)
                                return "timings." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RecordPerformancePayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.RecordPerformancePayload} RecordPerformancePayload
                 */
                RecordPerformancePayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.RecordPerformancePayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.RecordPerformancePayload();
                    if (object.timings) {
                        if (!Array.isArray(object.timings))
                            throw TypeError(".vertexvis.protobuf.stream.RecordPerformancePayload.timings: array expected");
                        message.timings = [];
                        for (let i = 0; i < object.timings.length; ++i) {
                            if (typeof object.timings[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.RecordPerformancePayload.timings: object expected");
                            message.timings[i] = $root.vertexvis.protobuf.stream.PerformanceTiming.fromObject(object.timings[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordPerformancePayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.RecordPerformancePayload} message RecordPerformancePayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordPerformancePayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.timings = [];
                    if (message.timings && message.timings.length) {
                        object.timings = [];
                        for (let j = 0; j < message.timings.length; ++j)
                            object.timings[j] = $root.vertexvis.protobuf.stream.PerformanceTiming.toObject(message.timings[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RecordPerformancePayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.RecordPerformancePayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordPerformancePayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordPerformancePayload;
            })();

            stream.UpdateStreamPayload = (function() {

                /**
                 * Properties of an UpdateStreamPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateStreamPayload
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateStreamPayload frameCorrelationId
                 * @property {vertexvis.protobuf.stream.IStreamAttributes|null} [streamAttributes] UpdateStreamPayload streamAttributes
                 */

                /**
                 * Constructs a new UpdateStreamPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateStreamPayload.
                 * @implements IUpdateStreamPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateStreamPayload=} [properties] Properties to set
                 */
                function UpdateStreamPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateStreamPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @instance
                 */
                UpdateStreamPayload.prototype.frameCorrelationId = null;

                /**
                 * UpdateStreamPayload streamAttributes.
                 * @member {vertexvis.protobuf.stream.IStreamAttributes|null|undefined} streamAttributes
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @instance
                 */
                UpdateStreamPayload.prototype.streamAttributes = null;

                /**
                 * Creates a new UpdateStreamPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateStreamPayload} UpdateStreamPayload instance
                 */
                UpdateStreamPayload.create = function create(properties) {
                    return new UpdateStreamPayload(properties);
                };

                /**
                 * Encodes the specified UpdateStreamPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateStreamPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamPayload} message UpdateStreamPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateStreamPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.streamAttributes != null && Object.hasOwnProperty.call(message, "streamAttributes"))
                        $root.vertexvis.protobuf.stream.StreamAttributes.encode(message.streamAttributes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateStreamPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateStreamPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamPayload} message UpdateStreamPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateStreamPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateStreamPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateStreamPayload} UpdateStreamPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateStreamPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateStreamPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateStreamPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateStreamPayload} UpdateStreamPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateStreamPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateStreamPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateStreamPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.StreamAttributes.verify(message.streamAttributes);
                        if (error)
                            return "streamAttributes." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateStreamPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateStreamPayload} UpdateStreamPayload
                 */
                UpdateStreamPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateStreamPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateStreamPayload();
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateStreamPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.streamAttributes != null) {
                        if (typeof object.streamAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateStreamPayload.streamAttributes: object expected");
                        message.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.fromObject(object.streamAttributes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateStreamPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateStreamPayload} message UpdateStreamPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateStreamPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.frameCorrelationId = null;
                        object.streamAttributes = null;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.streamAttributes != null && message.hasOwnProperty("streamAttributes"))
                        object.streamAttributes = $root.vertexvis.protobuf.stream.StreamAttributes.toObject(message.streamAttributes, options);
                    return object;
                };

                /**
                 * Converts this UpdateStreamPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateStreamPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateStreamPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateStreamPayload;
            })();

            stream.FlyToPayload = (function() {

                /**
                 * Properties of a FlyToPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFlyToPayload
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] FlyToPayload frameCorrelationId
                 * @property {vertexvis.protobuf.stream.IAnimationAttributes|null} [animation] FlyToPayload animation
                 * @property {vertexvis.protobuf.core.IUuid|null} [itemId] FlyToPayload itemId
                 * @property {string|null} [itemSuppliedId] FlyToPayload itemSuppliedId
                 * @property {vertexvis.protobuf.core.IBoundingBox3f|null} [boundingBox] FlyToPayload boundingBox
                 * @property {vertexvis.protobuf.stream.ICamera|null} [camera] FlyToPayload camera
                 * @property {vertexvis.protobuf.stream.ISceneViewStateIdentifier|null} [sceneViewStateIdentifier] FlyToPayload sceneViewStateIdentifier
                 * @property {vertexvis.protobuf.stream.ISceneItemQueryExpression|null} [sceneItemQueryExpression] FlyToPayload sceneItemQueryExpression
                 * @property {vertexvis.protobuf.stream.ICamera|null} [baseCamera] FlyToPayload baseCamera
                 */

                /**
                 * Constructs a new FlyToPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FlyToPayload.
                 * @implements IFlyToPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFlyToPayload=} [properties] Properties to set
                 */
                function FlyToPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FlyToPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.frameCorrelationId = null;

                /**
                 * FlyToPayload animation.
                 * @member {vertexvis.protobuf.stream.IAnimationAttributes|null|undefined} animation
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.animation = null;

                /**
                 * FlyToPayload itemId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} itemId
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.itemId = null;

                /**
                 * FlyToPayload itemSuppliedId.
                 * @member {string|null|undefined} itemSuppliedId
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.itemSuppliedId = null;

                /**
                 * FlyToPayload boundingBox.
                 * @member {vertexvis.protobuf.core.IBoundingBox3f|null|undefined} boundingBox
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.boundingBox = null;

                /**
                 * FlyToPayload camera.
                 * @member {vertexvis.protobuf.stream.ICamera|null|undefined} camera
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.camera = null;

                /**
                 * FlyToPayload sceneViewStateIdentifier.
                 * @member {vertexvis.protobuf.stream.ISceneViewStateIdentifier|null|undefined} sceneViewStateIdentifier
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.sceneViewStateIdentifier = null;

                /**
                 * FlyToPayload sceneItemQueryExpression.
                 * @member {vertexvis.protobuf.stream.ISceneItemQueryExpression|null|undefined} sceneItemQueryExpression
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.sceneItemQueryExpression = null;

                /**
                 * FlyToPayload baseCamera.
                 * @member {vertexvis.protobuf.stream.ICamera|null|undefined} baseCamera
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                FlyToPayload.prototype.baseCamera = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * FlyToPayload flyToType.
                 * @member {"itemId"|"itemSuppliedId"|"boundingBox"|"camera"|"sceneViewStateIdentifier"|"sceneItemQueryExpression"|undefined} flyToType
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 */
                Object.defineProperty(FlyToPayload.prototype, "flyToType", {
                    get: $util.oneOfGetter($oneOfFields = ["itemId", "itemSuppliedId", "boundingBox", "camera", "sceneViewStateIdentifier", "sceneItemQueryExpression"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new FlyToPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FlyToPayload} FlyToPayload instance
                 */
                FlyToPayload.create = function create(properties) {
                    return new FlyToPayload(properties);
                };

                /**
                 * Encodes the specified FlyToPayload message. Does not implicitly {@link vertexvis.protobuf.stream.FlyToPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToPayload} message FlyToPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FlyToPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.animation != null && Object.hasOwnProperty.call(message, "animation"))
                        $root.vertexvis.protobuf.stream.AnimationAttributes.encode(message.animation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.itemId, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.itemSuppliedId != null && Object.hasOwnProperty.call(message, "itemSuppliedId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.itemSuppliedId);
                    if (message.boundingBox != null && Object.hasOwnProperty.call(message, "boundingBox"))
                        $root.vertexvis.protobuf.core.BoundingBox3f.encode(message.boundingBox, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                        $root.vertexvis.protobuf.stream.Camera.encode(message.camera, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.baseCamera != null && Object.hasOwnProperty.call(message, "baseCamera"))
                        $root.vertexvis.protobuf.stream.Camera.encode(message.baseCamera, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.sceneViewStateIdentifier != null && Object.hasOwnProperty.call(message, "sceneViewStateIdentifier"))
                        $root.vertexvis.protobuf.stream.SceneViewStateIdentifier.encode(message.sceneViewStateIdentifier, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.sceneItemQueryExpression != null && Object.hasOwnProperty.call(message, "sceneItemQueryExpression"))
                        $root.vertexvis.protobuf.stream.SceneItemQueryExpression.encode(message.sceneItemQueryExpression, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FlyToPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FlyToPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToPayload} message FlyToPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FlyToPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FlyToPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FlyToPayload} FlyToPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FlyToPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FlyToPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.animation = $root.vertexvis.protobuf.stream.AnimationAttributes.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.itemId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.itemSuppliedId = reader.string();
                            break;
                        case 5:
                            message.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.camera = $root.vertexvis.protobuf.stream.Camera.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.sceneViewStateIdentifier = $root.vertexvis.protobuf.stream.SceneViewStateIdentifier.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.sceneItemQueryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.baseCamera = $root.vertexvis.protobuf.stream.Camera.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FlyToPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FlyToPayload} FlyToPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FlyToPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FlyToPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FlyToPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.animation != null && message.hasOwnProperty("animation")) {
                        let error = $root.vertexvis.protobuf.stream.AnimationAttributes.verify(message.animation);
                        if (error)
                            return "animation." + error;
                    }
                    if (message.itemId != null && message.hasOwnProperty("itemId")) {
                        properties.flyToType = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.itemId);
                            if (error)
                                return "itemId." + error;
                        }
                    }
                    if (message.itemSuppliedId != null && message.hasOwnProperty("itemSuppliedId")) {
                        if (properties.flyToType === 1)
                            return "flyToType: multiple values";
                        properties.flyToType = 1;
                        if (!$util.isString(message.itemSuppliedId))
                            return "itemSuppliedId: string expected";
                    }
                    if (message.boundingBox != null && message.hasOwnProperty("boundingBox")) {
                        if (properties.flyToType === 1)
                            return "flyToType: multiple values";
                        properties.flyToType = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.BoundingBox3f.verify(message.boundingBox);
                            if (error)
                                return "boundingBox." + error;
                        }
                    }
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        if (properties.flyToType === 1)
                            return "flyToType: multiple values";
                        properties.flyToType = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.Camera.verify(message.camera);
                            if (error)
                                return "camera." + error;
                        }
                    }
                    if (message.sceneViewStateIdentifier != null && message.hasOwnProperty("sceneViewStateIdentifier")) {
                        if (properties.flyToType === 1)
                            return "flyToType: multiple values";
                        properties.flyToType = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneViewStateIdentifier.verify(message.sceneViewStateIdentifier);
                            if (error)
                                return "sceneViewStateIdentifier." + error;
                        }
                    }
                    if (message.sceneItemQueryExpression != null && message.hasOwnProperty("sceneItemQueryExpression")) {
                        if (properties.flyToType === 1)
                            return "flyToType: multiple values";
                        properties.flyToType = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.verify(message.sceneItemQueryExpression);
                            if (error)
                                return "sceneItemQueryExpression." + error;
                        }
                    }
                    if (message.baseCamera != null && message.hasOwnProperty("baseCamera")) {
                        let error = $root.vertexvis.protobuf.stream.Camera.verify(message.baseCamera);
                        if (error)
                            return "baseCamera." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FlyToPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FlyToPayload} FlyToPayload
                 */
                FlyToPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FlyToPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FlyToPayload();
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.animation != null) {
                        if (typeof object.animation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.animation: object expected");
                        message.animation = $root.vertexvis.protobuf.stream.AnimationAttributes.fromObject(object.animation);
                    }
                    if (object.itemId != null) {
                        if (typeof object.itemId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.itemId: object expected");
                        message.itemId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.itemId);
                    }
                    if (object.itemSuppliedId != null)
                        message.itemSuppliedId = String(object.itemSuppliedId);
                    if (object.boundingBox != null) {
                        if (typeof object.boundingBox !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.boundingBox: object expected");
                        message.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.fromObject(object.boundingBox);
                    }
                    if (object.camera != null) {
                        if (typeof object.camera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.camera: object expected");
                        message.camera = $root.vertexvis.protobuf.stream.Camera.fromObject(object.camera);
                    }
                    if (object.sceneViewStateIdentifier != null) {
                        if (typeof object.sceneViewStateIdentifier !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.sceneViewStateIdentifier: object expected");
                        message.sceneViewStateIdentifier = $root.vertexvis.protobuf.stream.SceneViewStateIdentifier.fromObject(object.sceneViewStateIdentifier);
                    }
                    if (object.sceneItemQueryExpression != null) {
                        if (typeof object.sceneItemQueryExpression !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.sceneItemQueryExpression: object expected");
                        message.sceneItemQueryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.fromObject(object.sceneItemQueryExpression);
                    }
                    if (object.baseCamera != null) {
                        if (typeof object.baseCamera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToPayload.baseCamera: object expected");
                        message.baseCamera = $root.vertexvis.protobuf.stream.Camera.fromObject(object.baseCamera);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FlyToPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.FlyToPayload} message FlyToPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FlyToPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.frameCorrelationId = null;
                        object.animation = null;
                        object.baseCamera = null;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.animation != null && message.hasOwnProperty("animation"))
                        object.animation = $root.vertexvis.protobuf.stream.AnimationAttributes.toObject(message.animation, options);
                    if (message.itemId != null && message.hasOwnProperty("itemId")) {
                        object.itemId = $root.vertexvis.protobuf.core.Uuid.toObject(message.itemId, options);
                        if (options.oneofs)
                            object.flyToType = "itemId";
                    }
                    if (message.itemSuppliedId != null && message.hasOwnProperty("itemSuppliedId")) {
                        object.itemSuppliedId = message.itemSuppliedId;
                        if (options.oneofs)
                            object.flyToType = "itemSuppliedId";
                    }
                    if (message.boundingBox != null && message.hasOwnProperty("boundingBox")) {
                        object.boundingBox = $root.vertexvis.protobuf.core.BoundingBox3f.toObject(message.boundingBox, options);
                        if (options.oneofs)
                            object.flyToType = "boundingBox";
                    }
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        object.camera = $root.vertexvis.protobuf.stream.Camera.toObject(message.camera, options);
                        if (options.oneofs)
                            object.flyToType = "camera";
                    }
                    if (message.baseCamera != null && message.hasOwnProperty("baseCamera"))
                        object.baseCamera = $root.vertexvis.protobuf.stream.Camera.toObject(message.baseCamera, options);
                    if (message.sceneViewStateIdentifier != null && message.hasOwnProperty("sceneViewStateIdentifier")) {
                        object.sceneViewStateIdentifier = $root.vertexvis.protobuf.stream.SceneViewStateIdentifier.toObject(message.sceneViewStateIdentifier, options);
                        if (options.oneofs)
                            object.flyToType = "sceneViewStateIdentifier";
                    }
                    if (message.sceneItemQueryExpression != null && message.hasOwnProperty("sceneItemQueryExpression")) {
                        object.sceneItemQueryExpression = $root.vertexvis.protobuf.stream.SceneItemQueryExpression.toObject(message.sceneItemQueryExpression, options);
                        if (options.oneofs)
                            object.flyToType = "sceneItemQueryExpression";
                    }
                    return object;
                };

                /**
                 * Converts this FlyToPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FlyToPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FlyToPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FlyToPayload;
            })();

            /**
             * SceneViewStateFeature enum.
             * @name vertexvis.protobuf.stream.SceneViewStateFeature
             * @enum {number}
             * @property {number} SCENE_VIEW_STATE_FEATURE_INVALID=0 SCENE_VIEW_STATE_FEATURE_INVALID value
             * @property {number} SCENE_VIEW_STATE_FEATURE_CAMERA=1 SCENE_VIEW_STATE_FEATURE_CAMERA value
             * @property {number} SCENE_VIEW_STATE_FEATURE_MATERIAL_OVERRIDE=2 SCENE_VIEW_STATE_FEATURE_MATERIAL_OVERRIDE value
             * @property {number} SCENE_VIEW_STATE_FEATURE_SELECTION=3 SCENE_VIEW_STATE_FEATURE_SELECTION value
             * @property {number} SCENE_VIEW_STATE_FEATURE_VISIBILITY=4 SCENE_VIEW_STATE_FEATURE_VISIBILITY value
             * @property {number} SCENE_VIEW_STATE_FEATURE_TRANSFORM=5 SCENE_VIEW_STATE_FEATURE_TRANSFORM value
             * @property {number} SCENE_VIEW_STATE_FEATURE_CROSS_SECTION=6 SCENE_VIEW_STATE_FEATURE_CROSS_SECTION value
             * @property {number} SCENE_VIEW_STATE_FEATURE_PHANTOM=7 SCENE_VIEW_STATE_FEATURE_PHANTOM value
             * @property {number} SCENE_VIEW_STATE_FEATURE_SHADING=8 SCENE_VIEW_STATE_FEATURE_SHADING value
             */
            stream.SceneViewStateFeature = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SCENE_VIEW_STATE_FEATURE_INVALID"] = 0;
                values[valuesById[1] = "SCENE_VIEW_STATE_FEATURE_CAMERA"] = 1;
                values[valuesById[2] = "SCENE_VIEW_STATE_FEATURE_MATERIAL_OVERRIDE"] = 2;
                values[valuesById[3] = "SCENE_VIEW_STATE_FEATURE_SELECTION"] = 3;
                values[valuesById[4] = "SCENE_VIEW_STATE_FEATURE_VISIBILITY"] = 4;
                values[valuesById[5] = "SCENE_VIEW_STATE_FEATURE_TRANSFORM"] = 5;
                values[valuesById[6] = "SCENE_VIEW_STATE_FEATURE_CROSS_SECTION"] = 6;
                values[valuesById[7] = "SCENE_VIEW_STATE_FEATURE_PHANTOM"] = 7;
                values[valuesById[8] = "SCENE_VIEW_STATE_FEATURE_SHADING"] = 8;
                return values;
            })();

            stream.LoadSceneViewStatePayload = (function() {

                /**
                 * Properties of a LoadSceneViewStatePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ILoadSceneViewStatePayload
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneViewStateId] LoadSceneViewStatePayload sceneViewStateId
                 * @property {google.protobuf.IStringValue|null} [sceneViewStateSuppliedId] LoadSceneViewStatePayload sceneViewStateSuppliedId
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] LoadSceneViewStatePayload frameCorrelationId
                 * @property {Array.<vertexvis.protobuf.stream.SceneViewStateFeature>|null} [sceneViewStateFeatureSubset] LoadSceneViewStatePayload sceneViewStateFeatureSubset
                 * @property {vertexvis.protobuf.stream.CameraType|null} [cameraType] LoadSceneViewStatePayload cameraType
                 */

                /**
                 * Constructs a new LoadSceneViewStatePayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a LoadSceneViewStatePayload.
                 * @implements ILoadSceneViewStatePayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStatePayload=} [properties] Properties to set
                 */
                function LoadSceneViewStatePayload(properties) {
                    this.sceneViewStateFeatureSubset = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LoadSceneViewStatePayload sceneViewStateId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneViewStateId
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                LoadSceneViewStatePayload.prototype.sceneViewStateId = null;

                /**
                 * LoadSceneViewStatePayload sceneViewStateSuppliedId.
                 * @member {google.protobuf.IStringValue|null|undefined} sceneViewStateSuppliedId
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                LoadSceneViewStatePayload.prototype.sceneViewStateSuppliedId = null;

                /**
                 * LoadSceneViewStatePayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                LoadSceneViewStatePayload.prototype.frameCorrelationId = null;

                /**
                 * LoadSceneViewStatePayload sceneViewStateFeatureSubset.
                 * @member {Array.<vertexvis.protobuf.stream.SceneViewStateFeature>} sceneViewStateFeatureSubset
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                LoadSceneViewStatePayload.prototype.sceneViewStateFeatureSubset = $util.emptyArray;

                /**
                 * LoadSceneViewStatePayload cameraType.
                 * @member {vertexvis.protobuf.stream.CameraType} cameraType
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                LoadSceneViewStatePayload.prototype.cameraType = 0;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * LoadSceneViewStatePayload sceneViewStateIdentifier.
                 * @member {"sceneViewStateId"|"sceneViewStateSuppliedId"|undefined} sceneViewStateIdentifier
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 */
                Object.defineProperty(LoadSceneViewStatePayload.prototype, "sceneViewStateIdentifier", {
                    get: $util.oneOfGetter($oneOfFields = ["sceneViewStateId", "sceneViewStateSuppliedId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new LoadSceneViewStatePayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStatePayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStatePayload} LoadSceneViewStatePayload instance
                 */
                LoadSceneViewStatePayload.create = function create(properties) {
                    return new LoadSceneViewStatePayload(properties);
                };

                /**
                 * Encodes the specified LoadSceneViewStatePayload message. Does not implicitly {@link vertexvis.protobuf.stream.LoadSceneViewStatePayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStatePayload} message LoadSceneViewStatePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoadSceneViewStatePayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sceneViewStateId != null && Object.hasOwnProperty.call(message, "sceneViewStateId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneViewStateId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sceneViewStateFeatureSubset != null && message.sceneViewStateFeatureSubset.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (let i = 0; i < message.sceneViewStateFeatureSubset.length; ++i)
                            writer.int32(message.sceneViewStateFeatureSubset[i]);
                        writer.ldelim();
                    }
                    if (message.sceneViewStateSuppliedId != null && Object.hasOwnProperty.call(message, "sceneViewStateSuppliedId"))
                        $root.google.protobuf.StringValue.encode(message.sceneViewStateSuppliedId, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.cameraType != null && Object.hasOwnProperty.call(message, "cameraType"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cameraType);
                    return writer;
                };

                /**
                 * Encodes the specified LoadSceneViewStatePayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.LoadSceneViewStatePayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStatePayload} message LoadSceneViewStatePayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoadSceneViewStatePayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LoadSceneViewStatePayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStatePayload} LoadSceneViewStatePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoadSceneViewStatePayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 3:
                            if (!(message.sceneViewStateFeatureSubset && message.sceneViewStateFeatureSubset.length))
                                message.sceneViewStateFeatureSubset = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.sceneViewStateFeatureSubset.push(reader.int32());
                            } else
                                message.sceneViewStateFeatureSubset.push(reader.int32());
                            break;
                        case 5:
                            message.cameraType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LoadSceneViewStatePayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStatePayload} LoadSceneViewStatePayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoadSceneViewStatePayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LoadSceneViewStatePayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LoadSceneViewStatePayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        properties.sceneViewStateIdentifier = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneViewStateId);
                            if (error)
                                return "sceneViewStateId." + error;
                        }
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        if (properties.sceneViewStateIdentifier === 1)
                            return "sceneViewStateIdentifier: multiple values";
                        properties.sceneViewStateIdentifier = 1;
                        {
                            let error = $root.google.protobuf.StringValue.verify(message.sceneViewStateSuppliedId);
                            if (error)
                                return "sceneViewStateSuppliedId." + error;
                        }
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.sceneViewStateFeatureSubset != null && message.hasOwnProperty("sceneViewStateFeatureSubset")) {
                        if (!Array.isArray(message.sceneViewStateFeatureSubset))
                            return "sceneViewStateFeatureSubset: array expected";
                        for (let i = 0; i < message.sceneViewStateFeatureSubset.length; ++i)
                            switch (message.sceneViewStateFeatureSubset[i]) {
                            default:
                                return "sceneViewStateFeatureSubset: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                                break;
                            }
                    }
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        switch (message.cameraType) {
                        default:
                            return "cameraType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a LoadSceneViewStatePayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStatePayload} LoadSceneViewStatePayload
                 */
                LoadSceneViewStatePayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.LoadSceneViewStatePayload();
                    if (object.sceneViewStateId != null) {
                        if (typeof object.sceneViewStateId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.LoadSceneViewStatePayload.sceneViewStateId: object expected");
                        message.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneViewStateId);
                    }
                    if (object.sceneViewStateSuppliedId != null) {
                        if (typeof object.sceneViewStateSuppliedId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.LoadSceneViewStatePayload.sceneViewStateSuppliedId: object expected");
                        message.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.fromObject(object.sceneViewStateSuppliedId);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.LoadSceneViewStatePayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.sceneViewStateFeatureSubset) {
                        if (!Array.isArray(object.sceneViewStateFeatureSubset))
                            throw TypeError(".vertexvis.protobuf.stream.LoadSceneViewStatePayload.sceneViewStateFeatureSubset: array expected");
                        message.sceneViewStateFeatureSubset = [];
                        for (let i = 0; i < object.sceneViewStateFeatureSubset.length; ++i)
                            switch (object.sceneViewStateFeatureSubset[i]) {
                            default:
                            case "SCENE_VIEW_STATE_FEATURE_INVALID":
                            case 0:
                                message.sceneViewStateFeatureSubset[i] = 0;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_CAMERA":
                            case 1:
                                message.sceneViewStateFeatureSubset[i] = 1;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_MATERIAL_OVERRIDE":
                            case 2:
                                message.sceneViewStateFeatureSubset[i] = 2;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_SELECTION":
                            case 3:
                                message.sceneViewStateFeatureSubset[i] = 3;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_VISIBILITY":
                            case 4:
                                message.sceneViewStateFeatureSubset[i] = 4;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_TRANSFORM":
                            case 5:
                                message.sceneViewStateFeatureSubset[i] = 5;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_CROSS_SECTION":
                            case 6:
                                message.sceneViewStateFeatureSubset[i] = 6;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_PHANTOM":
                            case 7:
                                message.sceneViewStateFeatureSubset[i] = 7;
                                break;
                            case "SCENE_VIEW_STATE_FEATURE_SHADING":
                            case 8:
                                message.sceneViewStateFeatureSubset[i] = 8;
                                break;
                            }
                    }
                    switch (object.cameraType) {
                    case "CAMERA_TYPE_INVALID":
                    case 0:
                        message.cameraType = 0;
                        break;
                    case "CAMERA_TYPE_PERSPECTIVE":
                    case 1:
                        message.cameraType = 1;
                        break;
                    case "CAMERA_TYPE_ORTHOGRAPHIC":
                    case 2:
                        message.cameraType = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LoadSceneViewStatePayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @static
                 * @param {vertexvis.protobuf.stream.LoadSceneViewStatePayload} message LoadSceneViewStatePayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LoadSceneViewStatePayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.sceneViewStateFeatureSubset = [];
                    if (options.defaults) {
                        object.frameCorrelationId = null;
                        object.cameraType = options.enums === String ? "CAMERA_TYPE_INVALID" : 0;
                    }
                    if (message.sceneViewStateId != null && message.hasOwnProperty("sceneViewStateId")) {
                        object.sceneViewStateId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneViewStateId, options);
                        if (options.oneofs)
                            object.sceneViewStateIdentifier = "sceneViewStateId";
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.sceneViewStateFeatureSubset && message.sceneViewStateFeatureSubset.length) {
                        object.sceneViewStateFeatureSubset = [];
                        for (let j = 0; j < message.sceneViewStateFeatureSubset.length; ++j)
                            object.sceneViewStateFeatureSubset[j] = options.enums === String ? $root.vertexvis.protobuf.stream.SceneViewStateFeature[message.sceneViewStateFeatureSubset[j]] : message.sceneViewStateFeatureSubset[j];
                    }
                    if (message.sceneViewStateSuppliedId != null && message.hasOwnProperty("sceneViewStateSuppliedId")) {
                        object.sceneViewStateSuppliedId = $root.google.protobuf.StringValue.toObject(message.sceneViewStateSuppliedId, options);
                        if (options.oneofs)
                            object.sceneViewStateIdentifier = "sceneViewStateSuppliedId";
                    }
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        object.cameraType = options.enums === String ? $root.vertexvis.protobuf.stream.CameraType[message.cameraType] : message.cameraType;
                    return object;
                };

                /**
                 * Converts this LoadSceneViewStatePayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStatePayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LoadSceneViewStatePayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LoadSceneViewStatePayload;
            })();

            stream.ResetViewPlayload = (function() {

                /**
                 * Properties of a ResetViewPlayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IResetViewPlayload
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] ResetViewPlayload frameCorrelationId
                 * @property {boolean|null} [includeCamera] ResetViewPlayload includeCamera
                 * @property {vertexvis.protobuf.stream.CameraType|null} [cameraType] ResetViewPlayload cameraType
                 */

                /**
                 * Constructs a new ResetViewPlayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ResetViewPlayload.
                 * @implements IResetViewPlayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IResetViewPlayload=} [properties] Properties to set
                 */
                function ResetViewPlayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ResetViewPlayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @instance
                 */
                ResetViewPlayload.prototype.frameCorrelationId = null;

                /**
                 * ResetViewPlayload includeCamera.
                 * @member {boolean} includeCamera
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @instance
                 */
                ResetViewPlayload.prototype.includeCamera = false;

                /**
                 * ResetViewPlayload cameraType.
                 * @member {vertexvis.protobuf.stream.CameraType} cameraType
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @instance
                 */
                ResetViewPlayload.prototype.cameraType = 0;

                /**
                 * Creates a new ResetViewPlayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewPlayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ResetViewPlayload} ResetViewPlayload instance
                 */
                ResetViewPlayload.create = function create(properties) {
                    return new ResetViewPlayload(properties);
                };

                /**
                 * Encodes the specified ResetViewPlayload message. Does not implicitly {@link vertexvis.protobuf.stream.ResetViewPlayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewPlayload} message ResetViewPlayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetViewPlayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.includeCamera != null && Object.hasOwnProperty.call(message, "includeCamera"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeCamera);
                    if (message.cameraType != null && Object.hasOwnProperty.call(message, "cameraType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.cameraType);
                    return writer;
                };

                /**
                 * Encodes the specified ResetViewPlayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ResetViewPlayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewPlayload} message ResetViewPlayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetViewPlayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ResetViewPlayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ResetViewPlayload} ResetViewPlayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetViewPlayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ResetViewPlayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.includeCamera = reader.bool();
                            break;
                        case 3:
                            message.cameraType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ResetViewPlayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ResetViewPlayload} ResetViewPlayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetViewPlayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ResetViewPlayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResetViewPlayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    if (message.includeCamera != null && message.hasOwnProperty("includeCamera"))
                        if (typeof message.includeCamera !== "boolean")
                            return "includeCamera: boolean expected";
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        switch (message.cameraType) {
                        default:
                            return "cameraType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ResetViewPlayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ResetViewPlayload} ResetViewPlayload
                 */
                ResetViewPlayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ResetViewPlayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ResetViewPlayload();
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ResetViewPlayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    if (object.includeCamera != null)
                        message.includeCamera = Boolean(object.includeCamera);
                    switch (object.cameraType) {
                    case "CAMERA_TYPE_INVALID":
                    case 0:
                        message.cameraType = 0;
                        break;
                    case "CAMERA_TYPE_PERSPECTIVE":
                    case 1:
                        message.cameraType = 1;
                        break;
                    case "CAMERA_TYPE_ORTHOGRAPHIC":
                    case 2:
                        message.cameraType = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ResetViewPlayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @static
                 * @param {vertexvis.protobuf.stream.ResetViewPlayload} message ResetViewPlayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResetViewPlayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.frameCorrelationId = null;
                        object.includeCamera = false;
                        object.cameraType = options.enums === String ? "CAMERA_TYPE_INVALID" : 0;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    if (message.includeCamera != null && message.hasOwnProperty("includeCamera"))
                        object.includeCamera = message.includeCamera;
                    if (message.cameraType != null && message.hasOwnProperty("cameraType"))
                        object.cameraType = options.enums === String ? $root.vertexvis.protobuf.stream.CameraType[message.cameraType] : message.cameraType;
                    return object;
                };

                /**
                 * Converts this ResetViewPlayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ResetViewPlayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResetViewPlayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ResetViewPlayload;
            })();

            stream.UpdateCrossSectioningPayload = (function() {

                /**
                 * Properties of an UpdateCrossSectioningPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateCrossSectioningPayload
                 * @property {vertexvis.protobuf.stream.ICrossSectioning|null} [crossSectioning] UpdateCrossSectioningPayload crossSectioning
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateCrossSectioningPayload frameCorrelationId
                 */

                /**
                 * Constructs a new UpdateCrossSectioningPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateCrossSectioningPayload.
                 * @implements IUpdateCrossSectioningPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload=} [properties] Properties to set
                 */
                function UpdateCrossSectioningPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateCrossSectioningPayload crossSectioning.
                 * @member {vertexvis.protobuf.stream.ICrossSectioning|null|undefined} crossSectioning
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @instance
                 */
                UpdateCrossSectioningPayload.prototype.crossSectioning = null;

                /**
                 * UpdateCrossSectioningPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @instance
                 */
                UpdateCrossSectioningPayload.prototype.frameCorrelationId = null;

                /**
                 * Creates a new UpdateCrossSectioningPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningPayload} UpdateCrossSectioningPayload instance
                 */
                UpdateCrossSectioningPayload.create = function create(properties) {
                    return new UpdateCrossSectioningPayload(properties);
                };

                /**
                 * Encodes the specified UpdateCrossSectioningPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCrossSectioningPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload} message UpdateCrossSectioningPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCrossSectioningPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.crossSectioning != null && Object.hasOwnProperty.call(message, "crossSectioning"))
                        $root.vertexvis.protobuf.stream.CrossSectioning.encode(message.crossSectioning, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateCrossSectioningPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCrossSectioningPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningPayload} message UpdateCrossSectioningPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCrossSectioningPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateCrossSectioningPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningPayload} UpdateCrossSectioningPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCrossSectioningPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateCrossSectioningPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningPayload} UpdateCrossSectioningPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCrossSectioningPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateCrossSectioningPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateCrossSectioningPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning")) {
                        let error = $root.vertexvis.protobuf.stream.CrossSectioning.verify(message.crossSectioning);
                        if (error)
                            return "crossSectioning." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateCrossSectioningPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningPayload} UpdateCrossSectioningPayload
                 */
                UpdateCrossSectioningPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateCrossSectioningPayload();
                    if (object.crossSectioning != null) {
                        if (typeof object.crossSectioning !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCrossSectioningPayload.crossSectioning: object expected");
                        message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.fromObject(object.crossSectioning);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCrossSectioningPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateCrossSectioningPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateCrossSectioningPayload} message UpdateCrossSectioningPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateCrossSectioningPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.crossSectioning = null;
                        object.frameCorrelationId = null;
                    }
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning"))
                        object.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.toObject(message.crossSectioning, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    return object;
                };

                /**
                 * Converts this UpdateCrossSectioningPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateCrossSectioningPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateCrossSectioningPayload;
            })();

            stream.GetStencilBufferPayload = (function() {

                /**
                 * Properties of a GetStencilBufferPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IGetStencilBufferPayload
                 * @property {boolean|null} [includeDepthBuffer] GetStencilBufferPayload includeDepthBuffer
                 */

                /**
                 * Constructs a new GetStencilBufferPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a GetStencilBufferPayload.
                 * @implements IGetStencilBufferPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferPayload=} [properties] Properties to set
                 */
                function GetStencilBufferPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetStencilBufferPayload includeDepthBuffer.
                 * @member {boolean} includeDepthBuffer
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @instance
                 */
                GetStencilBufferPayload.prototype.includeDepthBuffer = false;

                /**
                 * Creates a new GetStencilBufferPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferPayload} GetStencilBufferPayload instance
                 */
                GetStencilBufferPayload.create = function create(properties) {
                    return new GetStencilBufferPayload(properties);
                };

                /**
                 * Encodes the specified GetStencilBufferPayload message. Does not implicitly {@link vertexvis.protobuf.stream.GetStencilBufferPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferPayload} message GetStencilBufferPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetStencilBufferPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.includeDepthBuffer != null && Object.hasOwnProperty.call(message, "includeDepthBuffer"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.includeDepthBuffer);
                    return writer;
                };

                /**
                 * Encodes the specified GetStencilBufferPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.GetStencilBufferPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferPayload} message GetStencilBufferPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetStencilBufferPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetStencilBufferPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferPayload} GetStencilBufferPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetStencilBufferPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.GetStencilBufferPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.includeDepthBuffer = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetStencilBufferPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferPayload} GetStencilBufferPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetStencilBufferPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetStencilBufferPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetStencilBufferPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.includeDepthBuffer != null && message.hasOwnProperty("includeDepthBuffer"))
                        if (typeof message.includeDepthBuffer !== "boolean")
                            return "includeDepthBuffer: boolean expected";
                    return null;
                };

                /**
                 * Creates a GetStencilBufferPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferPayload} GetStencilBufferPayload
                 */
                GetStencilBufferPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.GetStencilBufferPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.GetStencilBufferPayload();
                    if (object.includeDepthBuffer != null)
                        message.includeDepthBuffer = Boolean(object.includeDepthBuffer);
                    return message;
                };

                /**
                 * Creates a plain object from a GetStencilBufferPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.GetStencilBufferPayload} message GetStencilBufferPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetStencilBufferPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.includeDepthBuffer = false;
                    if (message.includeDepthBuffer != null && message.hasOwnProperty("includeDepthBuffer"))
                        object.includeDepthBuffer = message.includeDepthBuffer;
                    return object;
                };

                /**
                 * Converts this GetStencilBufferPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetStencilBufferPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetStencilBufferPayload;
            })();

            stream.RefreshTokenPayload = (function() {

                /**
                 * Properties of a RefreshTokenPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRefreshTokenPayload
                 */

                /**
                 * Constructs a new RefreshTokenPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a RefreshTokenPayload.
                 * @implements IRefreshTokenPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRefreshTokenPayload=} [properties] Properties to set
                 */
                function RefreshTokenPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new RefreshTokenPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.RefreshTokenPayload} RefreshTokenPayload instance
                 */
                RefreshTokenPayload.create = function create(properties) {
                    return new RefreshTokenPayload(properties);
                };

                /**
                 * Encodes the specified RefreshTokenPayload message. Does not implicitly {@link vertexvis.protobuf.stream.RefreshTokenPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenPayload} message RefreshTokenPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefreshTokenPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified RefreshTokenPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.RefreshTokenPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenPayload} message RefreshTokenPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefreshTokenPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RefreshTokenPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.RefreshTokenPayload} RefreshTokenPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefreshTokenPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.RefreshTokenPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RefreshTokenPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.RefreshTokenPayload} RefreshTokenPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefreshTokenPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RefreshTokenPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RefreshTokenPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a RefreshTokenPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.RefreshTokenPayload} RefreshTokenPayload
                 */
                RefreshTokenPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.RefreshTokenPayload)
                        return object;
                    return new $root.vertexvis.protobuf.stream.RefreshTokenPayload();
                };

                /**
                 * Creates a plain object from a RefreshTokenPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.RefreshTokenPayload} message RefreshTokenPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RefreshTokenPayload.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this RefreshTokenPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.RefreshTokenPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RefreshTokenPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RefreshTokenPayload;
            })();

            stream.UpdateModelViewPayload = (function() {

                /**
                 * Properties of an UpdateModelViewPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateModelViewPayload
                 * @property {vertexvis.protobuf.core.IItemModelView|null} [itemModelView] UpdateModelViewPayload itemModelView
                 * @property {google.protobuf.IStringValue|null} [frameCorrelationId] UpdateModelViewPayload frameCorrelationId
                 */

                /**
                 * Constructs a new UpdateModelViewPayload.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateModelViewPayload.
                 * @implements IUpdateModelViewPayload
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewPayload=} [properties] Properties to set
                 */
                function UpdateModelViewPayload(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateModelViewPayload itemModelView.
                 * @member {vertexvis.protobuf.core.IItemModelView|null|undefined} itemModelView
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @instance
                 */
                UpdateModelViewPayload.prototype.itemModelView = null;

                /**
                 * UpdateModelViewPayload frameCorrelationId.
                 * @member {google.protobuf.IStringValue|null|undefined} frameCorrelationId
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @instance
                 */
                UpdateModelViewPayload.prototype.frameCorrelationId = null;

                /**
                 * Creates a new UpdateModelViewPayload instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewPayload=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewPayload} UpdateModelViewPayload instance
                 */
                UpdateModelViewPayload.create = function create(properties) {
                    return new UpdateModelViewPayload(properties);
                };

                /**
                 * Encodes the specified UpdateModelViewPayload message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateModelViewPayload.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewPayload} message UpdateModelViewPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateModelViewPayload.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.itemModelView != null && Object.hasOwnProperty.call(message, "itemModelView"))
                        $root.vertexvis.protobuf.core.ItemModelView.encode(message.itemModelView, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.frameCorrelationId != null && Object.hasOwnProperty.call(message, "frameCorrelationId"))
                        $root.google.protobuf.StringValue.encode(message.frameCorrelationId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateModelViewPayload message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateModelViewPayload.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewPayload} message UpdateModelViewPayload message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateModelViewPayload.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateModelViewPayload message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewPayload} UpdateModelViewPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateModelViewPayload.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateModelViewPayload();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.itemModelView = $root.vertexvis.protobuf.core.ItemModelView.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.frameCorrelationId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateModelViewPayload message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewPayload} UpdateModelViewPayload
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateModelViewPayload.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateModelViewPayload message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateModelViewPayload.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.itemModelView != null && message.hasOwnProperty("itemModelView")) {
                        let error = $root.vertexvis.protobuf.core.ItemModelView.verify(message.itemModelView);
                        if (error)
                            return "itemModelView." + error;
                    }
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.frameCorrelationId);
                        if (error)
                            return "frameCorrelationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateModelViewPayload message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewPayload} UpdateModelViewPayload
                 */
                UpdateModelViewPayload.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateModelViewPayload)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateModelViewPayload();
                    if (object.itemModelView != null) {
                        if (typeof object.itemModelView !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateModelViewPayload.itemModelView: object expected");
                        message.itemModelView = $root.vertexvis.protobuf.core.ItemModelView.fromObject(object.itemModelView);
                    }
                    if (object.frameCorrelationId != null) {
                        if (typeof object.frameCorrelationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateModelViewPayload.frameCorrelationId: object expected");
                        message.frameCorrelationId = $root.google.protobuf.StringValue.fromObject(object.frameCorrelationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateModelViewPayload message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateModelViewPayload} message UpdateModelViewPayload
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateModelViewPayload.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.itemModelView = null;
                        object.frameCorrelationId = null;
                    }
                    if (message.itemModelView != null && message.hasOwnProperty("itemModelView"))
                        object.itemModelView = $root.vertexvis.protobuf.core.ItemModelView.toObject(message.itemModelView, options);
                    if (message.frameCorrelationId != null && message.hasOwnProperty("frameCorrelationId"))
                        object.frameCorrelationId = $root.google.protobuf.StringValue.toObject(message.frameCorrelationId, options);
                    return object;
                };

                /**
                 * Converts this UpdateModelViewPayload to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewPayload
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateModelViewPayload.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateModelViewPayload;
            })();

            stream.StreamResponse = (function() {

                /**
                 * Properties of a StreamResponse.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStreamResponse
                 * @property {google.protobuf.IStringValue|null} [requestId] StreamResponse requestId
                 * @property {vertexvis.protobuf.stream.IError|null} [error] StreamResponse error
                 * @property {vertexvis.protobuf.stream.IStartStreamResult|null} [startStream] StreamResponse startStream
                 * @property {vertexvis.protobuf.stream.IUpdateCameraResult|null} [updateCamera] StreamResponse updateCamera
                 * @property {vertexvis.protobuf.stream.IBeginInteractionResult|null} [beginInteraction] StreamResponse beginInteraction
                 * @property {vertexvis.protobuf.stream.IEndInteractionResult|null} [endInteraction] StreamResponse endInteraction
                 * @property {vertexvis.protobuf.stream.IGracefulReconnectionResult|null} [gracefulReconnection] StreamResponse gracefulReconnection
                 * @property {vertexvis.protobuf.stream.IReconnectResult|null} [reconnect] StreamResponse reconnect
                 * @property {vertexvis.protobuf.stream.IHitItemsResult|null} [hitItems] StreamResponse hitItems
                 * @property {vertexvis.protobuf.stream.IDrawFrameResult|null} [drawFrame] StreamResponse drawFrame
                 * @property {vertexvis.protobuf.stream.ISyncTimeResult|null} [syncTime] StreamResponse syncTime
                 * @property {vertexvis.protobuf.stream.IRecordPerformanceResult|null} [recordPerformance] StreamResponse recordPerformance
                 * @property {vertexvis.protobuf.stream.IUpdateDimensionsResult|null} [updateDimensions] StreamResponse updateDimensions
                 * @property {vertexvis.protobuf.stream.IUpdateStreamResult|null} [updateStream] StreamResponse updateStream
                 * @property {vertexvis.protobuf.stream.IFlyToResult|null} [flyTo] StreamResponse flyTo
                 * @property {vertexvis.protobuf.stream.ILoadSceneViewStateResult|null} [loadSceneViewState] StreamResponse loadSceneViewState
                 * @property {vertexvis.protobuf.stream.IUpdateCrossSectioningResult|null} [updateCrossSectioning] StreamResponse updateCrossSectioning
                 * @property {vertexvis.protobuf.stream.IGetStencilBufferResult|null} [stencilBuffer] StreamResponse stencilBuffer
                 * @property {vertexvis.protobuf.stream.IResetViewResult|null} [resetView] StreamResponse resetView
                 * @property {vertexvis.protobuf.stream.IRefreshTokenResult|null} [refreshToken] StreamResponse refreshToken
                 * @property {vertexvis.protobuf.stream.IUpdateInteractionResult|null} [updateInteraction] StreamResponse updateInteraction
                 * @property {vertexvis.protobuf.stream.IUpdateModelViewResult|null} [updateModelView] StreamResponse updateModelView
                 */

                /**
                 * Constructs a new StreamResponse.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StreamResponse.
                 * @implements IStreamResponse
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStreamResponse=} [properties] Properties to set
                 */
                function StreamResponse(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StreamResponse requestId.
                 * @member {google.protobuf.IStringValue|null|undefined} requestId
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.requestId = null;

                /**
                 * StreamResponse error.
                 * @member {vertexvis.protobuf.stream.IError|null|undefined} error
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.error = null;

                /**
                 * StreamResponse startStream.
                 * @member {vertexvis.protobuf.stream.IStartStreamResult|null|undefined} startStream
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.startStream = null;

                /**
                 * StreamResponse updateCamera.
                 * @member {vertexvis.protobuf.stream.IUpdateCameraResult|null|undefined} updateCamera
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateCamera = null;

                /**
                 * StreamResponse beginInteraction.
                 * @member {vertexvis.protobuf.stream.IBeginInteractionResult|null|undefined} beginInteraction
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.beginInteraction = null;

                /**
                 * StreamResponse endInteraction.
                 * @member {vertexvis.protobuf.stream.IEndInteractionResult|null|undefined} endInteraction
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.endInteraction = null;

                /**
                 * StreamResponse gracefulReconnection.
                 * @member {vertexvis.protobuf.stream.IGracefulReconnectionResult|null|undefined} gracefulReconnection
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.gracefulReconnection = null;

                /**
                 * StreamResponse reconnect.
                 * @member {vertexvis.protobuf.stream.IReconnectResult|null|undefined} reconnect
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.reconnect = null;

                /**
                 * StreamResponse hitItems.
                 * @member {vertexvis.protobuf.stream.IHitItemsResult|null|undefined} hitItems
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.hitItems = null;

                /**
                 * StreamResponse drawFrame.
                 * @member {vertexvis.protobuf.stream.IDrawFrameResult|null|undefined} drawFrame
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.drawFrame = null;

                /**
                 * StreamResponse syncTime.
                 * @member {vertexvis.protobuf.stream.ISyncTimeResult|null|undefined} syncTime
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.syncTime = null;

                /**
                 * StreamResponse recordPerformance.
                 * @member {vertexvis.protobuf.stream.IRecordPerformanceResult|null|undefined} recordPerformance
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.recordPerformance = null;

                /**
                 * StreamResponse updateDimensions.
                 * @member {vertexvis.protobuf.stream.IUpdateDimensionsResult|null|undefined} updateDimensions
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateDimensions = null;

                /**
                 * StreamResponse updateStream.
                 * @member {vertexvis.protobuf.stream.IUpdateStreamResult|null|undefined} updateStream
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateStream = null;

                /**
                 * StreamResponse flyTo.
                 * @member {vertexvis.protobuf.stream.IFlyToResult|null|undefined} flyTo
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.flyTo = null;

                /**
                 * StreamResponse loadSceneViewState.
                 * @member {vertexvis.protobuf.stream.ILoadSceneViewStateResult|null|undefined} loadSceneViewState
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.loadSceneViewState = null;

                /**
                 * StreamResponse updateCrossSectioning.
                 * @member {vertexvis.protobuf.stream.IUpdateCrossSectioningResult|null|undefined} updateCrossSectioning
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateCrossSectioning = null;

                /**
                 * StreamResponse stencilBuffer.
                 * @member {vertexvis.protobuf.stream.IGetStencilBufferResult|null|undefined} stencilBuffer
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.stencilBuffer = null;

                /**
                 * StreamResponse resetView.
                 * @member {vertexvis.protobuf.stream.IResetViewResult|null|undefined} resetView
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.resetView = null;

                /**
                 * StreamResponse refreshToken.
                 * @member {vertexvis.protobuf.stream.IRefreshTokenResult|null|undefined} refreshToken
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.refreshToken = null;

                /**
                 * StreamResponse updateInteraction.
                 * @member {vertexvis.protobuf.stream.IUpdateInteractionResult|null|undefined} updateInteraction
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateInteraction = null;

                /**
                 * StreamResponse updateModelView.
                 * @member {vertexvis.protobuf.stream.IUpdateModelViewResult|null|undefined} updateModelView
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                StreamResponse.prototype.updateModelView = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * StreamResponse result.
                 * @member {"startStream"|"updateCamera"|"beginInteraction"|"endInteraction"|"gracefulReconnection"|"reconnect"|"hitItems"|"drawFrame"|"syncTime"|"recordPerformance"|"updateDimensions"|"updateStream"|"flyTo"|"loadSceneViewState"|"updateCrossSectioning"|"stencilBuffer"|"resetView"|"refreshToken"|"updateInteraction"|"updateModelView"|undefined} result
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 */
                Object.defineProperty(StreamResponse.prototype, "result", {
                    get: $util.oneOfGetter($oneOfFields = ["startStream", "updateCamera", "beginInteraction", "endInteraction", "gracefulReconnection", "reconnect", "hitItems", "drawFrame", "syncTime", "recordPerformance", "updateDimensions", "updateStream", "flyTo", "loadSceneViewState", "updateCrossSectioning", "stencilBuffer", "resetView", "refreshToken", "updateInteraction", "updateModelView"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StreamResponse instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamResponse=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StreamResponse} StreamResponse instance
                 */
                StreamResponse.create = function create(properties) {
                    return new StreamResponse(properties);
                };

                /**
                 * Encodes the specified StreamResponse message. Does not implicitly {@link vertexvis.protobuf.stream.StreamResponse.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamResponse} message StreamResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        $root.google.protobuf.StringValue.encode(message.requestId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.vertexvis.protobuf.stream.Error.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.startStream != null && Object.hasOwnProperty.call(message, "startStream"))
                        $root.vertexvis.protobuf.stream.StartStreamResult.encode(message.startStream, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.updateCamera != null && Object.hasOwnProperty.call(message, "updateCamera"))
                        $root.vertexvis.protobuf.stream.UpdateCameraResult.encode(message.updateCamera, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.beginInteraction != null && Object.hasOwnProperty.call(message, "beginInteraction"))
                        $root.vertexvis.protobuf.stream.BeginInteractionResult.encode(message.beginInteraction, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.endInteraction != null && Object.hasOwnProperty.call(message, "endInteraction"))
                        $root.vertexvis.protobuf.stream.EndInteractionResult.encode(message.endInteraction, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.reconnect != null && Object.hasOwnProperty.call(message, "reconnect"))
                        $root.vertexvis.protobuf.stream.ReconnectResult.encode(message.reconnect, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.hitItems != null && Object.hasOwnProperty.call(message, "hitItems"))
                        $root.vertexvis.protobuf.stream.HitItemsResult.encode(message.hitItems, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.drawFrame != null && Object.hasOwnProperty.call(message, "drawFrame"))
                        $root.vertexvis.protobuf.stream.DrawFrameResult.encode(message.drawFrame, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.syncTime != null && Object.hasOwnProperty.call(message, "syncTime"))
                        $root.vertexvis.protobuf.stream.SyncTimeResult.encode(message.syncTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.recordPerformance != null && Object.hasOwnProperty.call(message, "recordPerformance"))
                        $root.vertexvis.protobuf.stream.RecordPerformanceResult.encode(message.recordPerformance, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.updateDimensions != null && Object.hasOwnProperty.call(message, "updateDimensions"))
                        $root.vertexvis.protobuf.stream.UpdateDimensionsResult.encode(message.updateDimensions, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.updateStream != null && Object.hasOwnProperty.call(message, "updateStream"))
                        $root.vertexvis.protobuf.stream.UpdateStreamResult.encode(message.updateStream, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.flyTo != null && Object.hasOwnProperty.call(message, "flyTo"))
                        $root.vertexvis.protobuf.stream.FlyToResult.encode(message.flyTo, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.loadSceneViewState != null && Object.hasOwnProperty.call(message, "loadSceneViewState"))
                        $root.vertexvis.protobuf.stream.LoadSceneViewStateResult.encode(message.loadSceneViewState, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.updateCrossSectioning != null && Object.hasOwnProperty.call(message, "updateCrossSectioning"))
                        $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult.encode(message.updateCrossSectioning, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.stencilBuffer != null && Object.hasOwnProperty.call(message, "stencilBuffer"))
                        $root.vertexvis.protobuf.stream.GetStencilBufferResult.encode(message.stencilBuffer, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.resetView != null && Object.hasOwnProperty.call(message, "resetView"))
                        $root.vertexvis.protobuf.stream.ResetViewResult.encode(message.resetView, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                        $root.vertexvis.protobuf.stream.RefreshTokenResult.encode(message.refreshToken, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.gracefulReconnection != null && Object.hasOwnProperty.call(message, "gracefulReconnection"))
                        $root.vertexvis.protobuf.stream.GracefulReconnectionResult.encode(message.gracefulReconnection, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.updateInteraction != null && Object.hasOwnProperty.call(message, "updateInteraction"))
                        $root.vertexvis.protobuf.stream.UpdateInteractionResult.encode(message.updateInteraction, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.updateModelView != null && Object.hasOwnProperty.call(message, "updateModelView"))
                        $root.vertexvis.protobuf.stream.UpdateModelViewResult.encode(message.updateModelView, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StreamResponse message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StreamResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamResponse} message StreamResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StreamResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StreamResponse} StreamResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StreamResponse();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.requestId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.error = $root.vertexvis.protobuf.stream.Error.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.startStream = $root.vertexvis.protobuf.stream.StartStreamResult.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraResult.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionResult.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionResult.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionResult.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.reconnect = $root.vertexvis.protobuf.stream.ReconnectResult.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.hitItems = $root.vertexvis.protobuf.stream.HitItemsResult.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.drawFrame = $root.vertexvis.protobuf.stream.DrawFrameResult.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.syncTime = $root.vertexvis.protobuf.stream.SyncTimeResult.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformanceResult.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsResult.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamResult.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.flyTo = $root.vertexvis.protobuf.stream.FlyToResult.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStateResult.decode(reader, reader.uint32());
                            break;
                        case 16:
                            message.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.stencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferResult.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.resetView = $root.vertexvis.protobuf.stream.ResetViewResult.decode(reader, reader.uint32());
                            break;
                        case 19:
                            message.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenResult.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionResult.decode(reader, reader.uint32());
                            break;
                        case 22:
                            message.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewResult.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StreamResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StreamResponse} StreamResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StreamResponse message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StreamResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.requestId != null && message.hasOwnProperty("requestId")) {
                        let error = $root.google.protobuf.StringValue.verify(message.requestId);
                        if (error)
                            return "requestId." + error;
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        let error = $root.vertexvis.protobuf.stream.Error.verify(message.error);
                        if (error)
                            return "error." + error;
                    }
                    if (message.startStream != null && message.hasOwnProperty("startStream")) {
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.StartStreamResult.verify(message.startStream);
                            if (error)
                                return "startStream." + error;
                        }
                    }
                    if (message.updateCamera != null && message.hasOwnProperty("updateCamera")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateCameraResult.verify(message.updateCamera);
                            if (error)
                                return "updateCamera." + error;
                        }
                    }
                    if (message.beginInteraction != null && message.hasOwnProperty("beginInteraction")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.BeginInteractionResult.verify(message.beginInteraction);
                            if (error)
                                return "beginInteraction." + error;
                        }
                    }
                    if (message.endInteraction != null && message.hasOwnProperty("endInteraction")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.EndInteractionResult.verify(message.endInteraction);
                            if (error)
                                return "endInteraction." + error;
                        }
                    }
                    if (message.gracefulReconnection != null && message.hasOwnProperty("gracefulReconnection")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.GracefulReconnectionResult.verify(message.gracefulReconnection);
                            if (error)
                                return "gracefulReconnection." + error;
                        }
                    }
                    if (message.reconnect != null && message.hasOwnProperty("reconnect")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ReconnectResult.verify(message.reconnect);
                            if (error)
                                return "reconnect." + error;
                        }
                    }
                    if (message.hitItems != null && message.hasOwnProperty("hitItems")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.HitItemsResult.verify(message.hitItems);
                            if (error)
                                return "hitItems." + error;
                        }
                    }
                    if (message.drawFrame != null && message.hasOwnProperty("drawFrame")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.DrawFrameResult.verify(message.drawFrame);
                            if (error)
                                return "drawFrame." + error;
                        }
                    }
                    if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.SyncTimeResult.verify(message.syncTime);
                            if (error)
                                return "syncTime." + error;
                        }
                    }
                    if (message.recordPerformance != null && message.hasOwnProperty("recordPerformance")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RecordPerformanceResult.verify(message.recordPerformance);
                            if (error)
                                return "recordPerformance." + error;
                        }
                    }
                    if (message.updateDimensions != null && message.hasOwnProperty("updateDimensions")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateDimensionsResult.verify(message.updateDimensions);
                            if (error)
                                return "updateDimensions." + error;
                        }
                    }
                    if (message.updateStream != null && message.hasOwnProperty("updateStream")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateStreamResult.verify(message.updateStream);
                            if (error)
                                return "updateStream." + error;
                        }
                    }
                    if (message.flyTo != null && message.hasOwnProperty("flyTo")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.FlyToResult.verify(message.flyTo);
                            if (error)
                                return "flyTo." + error;
                        }
                    }
                    if (message.loadSceneViewState != null && message.hasOwnProperty("loadSceneViewState")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.LoadSceneViewStateResult.verify(message.loadSceneViewState);
                            if (error)
                                return "loadSceneViewState." + error;
                        }
                    }
                    if (message.updateCrossSectioning != null && message.hasOwnProperty("updateCrossSectioning")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult.verify(message.updateCrossSectioning);
                            if (error)
                                return "updateCrossSectioning." + error;
                        }
                    }
                    if (message.stencilBuffer != null && message.hasOwnProperty("stencilBuffer")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.GetStencilBufferResult.verify(message.stencilBuffer);
                            if (error)
                                return "stencilBuffer." + error;
                        }
                    }
                    if (message.resetView != null && message.hasOwnProperty("resetView")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.ResetViewResult.verify(message.resetView);
                            if (error)
                                return "resetView." + error;
                        }
                    }
                    if (message.refreshToken != null && message.hasOwnProperty("refreshToken")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.RefreshTokenResult.verify(message.refreshToken);
                            if (error)
                                return "refreshToken." + error;
                        }
                    }
                    if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateInteractionResult.verify(message.updateInteraction);
                            if (error)
                                return "updateInteraction." + error;
                        }
                    }
                    if (message.updateModelView != null && message.hasOwnProperty("updateModelView")) {
                        if (properties.result === 1)
                            return "result: multiple values";
                        properties.result = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.UpdateModelViewResult.verify(message.updateModelView);
                            if (error)
                                return "updateModelView." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StreamResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StreamResponse} StreamResponse
                 */
                StreamResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StreamResponse)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StreamResponse();
                    if (object.requestId != null) {
                        if (typeof object.requestId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.requestId: object expected");
                        message.requestId = $root.google.protobuf.StringValue.fromObject(object.requestId);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.error: object expected");
                        message.error = $root.vertexvis.protobuf.stream.Error.fromObject(object.error);
                    }
                    if (object.startStream != null) {
                        if (typeof object.startStream !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.startStream: object expected");
                        message.startStream = $root.vertexvis.protobuf.stream.StartStreamResult.fromObject(object.startStream);
                    }
                    if (object.updateCamera != null) {
                        if (typeof object.updateCamera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateCamera: object expected");
                        message.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraResult.fromObject(object.updateCamera);
                    }
                    if (object.beginInteraction != null) {
                        if (typeof object.beginInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.beginInteraction: object expected");
                        message.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionResult.fromObject(object.beginInteraction);
                    }
                    if (object.endInteraction != null) {
                        if (typeof object.endInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.endInteraction: object expected");
                        message.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionResult.fromObject(object.endInteraction);
                    }
                    if (object.gracefulReconnection != null) {
                        if (typeof object.gracefulReconnection !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.gracefulReconnection: object expected");
                        message.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionResult.fromObject(object.gracefulReconnection);
                    }
                    if (object.reconnect != null) {
                        if (typeof object.reconnect !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.reconnect: object expected");
                        message.reconnect = $root.vertexvis.protobuf.stream.ReconnectResult.fromObject(object.reconnect);
                    }
                    if (object.hitItems != null) {
                        if (typeof object.hitItems !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.hitItems: object expected");
                        message.hitItems = $root.vertexvis.protobuf.stream.HitItemsResult.fromObject(object.hitItems);
                    }
                    if (object.drawFrame != null) {
                        if (typeof object.drawFrame !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.drawFrame: object expected");
                        message.drawFrame = $root.vertexvis.protobuf.stream.DrawFrameResult.fromObject(object.drawFrame);
                    }
                    if (object.syncTime != null) {
                        if (typeof object.syncTime !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.syncTime: object expected");
                        message.syncTime = $root.vertexvis.protobuf.stream.SyncTimeResult.fromObject(object.syncTime);
                    }
                    if (object.recordPerformance != null) {
                        if (typeof object.recordPerformance !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.recordPerformance: object expected");
                        message.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformanceResult.fromObject(object.recordPerformance);
                    }
                    if (object.updateDimensions != null) {
                        if (typeof object.updateDimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateDimensions: object expected");
                        message.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsResult.fromObject(object.updateDimensions);
                    }
                    if (object.updateStream != null) {
                        if (typeof object.updateStream !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateStream: object expected");
                        message.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamResult.fromObject(object.updateStream);
                    }
                    if (object.flyTo != null) {
                        if (typeof object.flyTo !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.flyTo: object expected");
                        message.flyTo = $root.vertexvis.protobuf.stream.FlyToResult.fromObject(object.flyTo);
                    }
                    if (object.loadSceneViewState != null) {
                        if (typeof object.loadSceneViewState !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.loadSceneViewState: object expected");
                        message.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStateResult.fromObject(object.loadSceneViewState);
                    }
                    if (object.updateCrossSectioning != null) {
                        if (typeof object.updateCrossSectioning !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateCrossSectioning: object expected");
                        message.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult.fromObject(object.updateCrossSectioning);
                    }
                    if (object.stencilBuffer != null) {
                        if (typeof object.stencilBuffer !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.stencilBuffer: object expected");
                        message.stencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferResult.fromObject(object.stencilBuffer);
                    }
                    if (object.resetView != null) {
                        if (typeof object.resetView !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.resetView: object expected");
                        message.resetView = $root.vertexvis.protobuf.stream.ResetViewResult.fromObject(object.resetView);
                    }
                    if (object.refreshToken != null) {
                        if (typeof object.refreshToken !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.refreshToken: object expected");
                        message.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenResult.fromObject(object.refreshToken);
                    }
                    if (object.updateInteraction != null) {
                        if (typeof object.updateInteraction !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateInteraction: object expected");
                        message.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionResult.fromObject(object.updateInteraction);
                    }
                    if (object.updateModelView != null) {
                        if (typeof object.updateModelView !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamResponse.updateModelView: object expected");
                        message.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewResult.fromObject(object.updateModelView);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StreamResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @static
                 * @param {vertexvis.protobuf.stream.StreamResponse} message StreamResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StreamResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.requestId = null;
                        object.error = null;
                    }
                    if (message.requestId != null && message.hasOwnProperty("requestId"))
                        object.requestId = $root.google.protobuf.StringValue.toObject(message.requestId, options);
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = $root.vertexvis.protobuf.stream.Error.toObject(message.error, options);
                    if (message.startStream != null && message.hasOwnProperty("startStream")) {
                        object.startStream = $root.vertexvis.protobuf.stream.StartStreamResult.toObject(message.startStream, options);
                        if (options.oneofs)
                            object.result = "startStream";
                    }
                    if (message.updateCamera != null && message.hasOwnProperty("updateCamera")) {
                        object.updateCamera = $root.vertexvis.protobuf.stream.UpdateCameraResult.toObject(message.updateCamera, options);
                        if (options.oneofs)
                            object.result = "updateCamera";
                    }
                    if (message.beginInteraction != null && message.hasOwnProperty("beginInteraction")) {
                        object.beginInteraction = $root.vertexvis.protobuf.stream.BeginInteractionResult.toObject(message.beginInteraction, options);
                        if (options.oneofs)
                            object.result = "beginInteraction";
                    }
                    if (message.endInteraction != null && message.hasOwnProperty("endInteraction")) {
                        object.endInteraction = $root.vertexvis.protobuf.stream.EndInteractionResult.toObject(message.endInteraction, options);
                        if (options.oneofs)
                            object.result = "endInteraction";
                    }
                    if (message.reconnect != null && message.hasOwnProperty("reconnect")) {
                        object.reconnect = $root.vertexvis.protobuf.stream.ReconnectResult.toObject(message.reconnect, options);
                        if (options.oneofs)
                            object.result = "reconnect";
                    }
                    if (message.hitItems != null && message.hasOwnProperty("hitItems")) {
                        object.hitItems = $root.vertexvis.protobuf.stream.HitItemsResult.toObject(message.hitItems, options);
                        if (options.oneofs)
                            object.result = "hitItems";
                    }
                    if (message.drawFrame != null && message.hasOwnProperty("drawFrame")) {
                        object.drawFrame = $root.vertexvis.protobuf.stream.DrawFrameResult.toObject(message.drawFrame, options);
                        if (options.oneofs)
                            object.result = "drawFrame";
                    }
                    if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                        object.syncTime = $root.vertexvis.protobuf.stream.SyncTimeResult.toObject(message.syncTime, options);
                        if (options.oneofs)
                            object.result = "syncTime";
                    }
                    if (message.recordPerformance != null && message.hasOwnProperty("recordPerformance")) {
                        object.recordPerformance = $root.vertexvis.protobuf.stream.RecordPerformanceResult.toObject(message.recordPerformance, options);
                        if (options.oneofs)
                            object.result = "recordPerformance";
                    }
                    if (message.updateDimensions != null && message.hasOwnProperty("updateDimensions")) {
                        object.updateDimensions = $root.vertexvis.protobuf.stream.UpdateDimensionsResult.toObject(message.updateDimensions, options);
                        if (options.oneofs)
                            object.result = "updateDimensions";
                    }
                    if (message.updateStream != null && message.hasOwnProperty("updateStream")) {
                        object.updateStream = $root.vertexvis.protobuf.stream.UpdateStreamResult.toObject(message.updateStream, options);
                        if (options.oneofs)
                            object.result = "updateStream";
                    }
                    if (message.flyTo != null && message.hasOwnProperty("flyTo")) {
                        object.flyTo = $root.vertexvis.protobuf.stream.FlyToResult.toObject(message.flyTo, options);
                        if (options.oneofs)
                            object.result = "flyTo";
                    }
                    if (message.loadSceneViewState != null && message.hasOwnProperty("loadSceneViewState")) {
                        object.loadSceneViewState = $root.vertexvis.protobuf.stream.LoadSceneViewStateResult.toObject(message.loadSceneViewState, options);
                        if (options.oneofs)
                            object.result = "loadSceneViewState";
                    }
                    if (message.updateCrossSectioning != null && message.hasOwnProperty("updateCrossSectioning")) {
                        object.updateCrossSectioning = $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult.toObject(message.updateCrossSectioning, options);
                        if (options.oneofs)
                            object.result = "updateCrossSectioning";
                    }
                    if (message.stencilBuffer != null && message.hasOwnProperty("stencilBuffer")) {
                        object.stencilBuffer = $root.vertexvis.protobuf.stream.GetStencilBufferResult.toObject(message.stencilBuffer, options);
                        if (options.oneofs)
                            object.result = "stencilBuffer";
                    }
                    if (message.resetView != null && message.hasOwnProperty("resetView")) {
                        object.resetView = $root.vertexvis.protobuf.stream.ResetViewResult.toObject(message.resetView, options);
                        if (options.oneofs)
                            object.result = "resetView";
                    }
                    if (message.refreshToken != null && message.hasOwnProperty("refreshToken")) {
                        object.refreshToken = $root.vertexvis.protobuf.stream.RefreshTokenResult.toObject(message.refreshToken, options);
                        if (options.oneofs)
                            object.result = "refreshToken";
                    }
                    if (message.gracefulReconnection != null && message.hasOwnProperty("gracefulReconnection")) {
                        object.gracefulReconnection = $root.vertexvis.protobuf.stream.GracefulReconnectionResult.toObject(message.gracefulReconnection, options);
                        if (options.oneofs)
                            object.result = "gracefulReconnection";
                    }
                    if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                        object.updateInteraction = $root.vertexvis.protobuf.stream.UpdateInteractionResult.toObject(message.updateInteraction, options);
                        if (options.oneofs)
                            object.result = "updateInteraction";
                    }
                    if (message.updateModelView != null && message.hasOwnProperty("updateModelView")) {
                        object.updateModelView = $root.vertexvis.protobuf.stream.UpdateModelViewResult.toObject(message.updateModelView, options);
                        if (options.oneofs)
                            object.result = "updateModelView";
                    }
                    return object;
                };

                /**
                 * Converts this StreamResponse to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StreamResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StreamResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StreamResponse;
            })();

            stream.StartStreamResult = (function() {

                /**
                 * Properties of a StartStreamResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStartStreamResult
                 * @property {vertexvis.protobuf.core.IUuid|null} [streamId] StartStreamResult streamId
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneViewId] StartStreamResult sceneViewId
                 * @property {vertexvis.protobuf.core.IUuid|null} [sessionId] StartStreamResult sessionId
                 * @property {string|null} [jwt] StartStreamResult jwt
                 * @property {vertexvis.protobuf.stream.IOrientation|null} [worldOrientation] StartStreamResult worldOrientation
                 * @property {vertexvis.protobuf.stream.IToken|null} [token] StartStreamResult token
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneId] StartStreamResult sceneId
                 */

                /**
                 * Constructs a new StartStreamResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StartStreamResult.
                 * @implements IStartStreamResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStartStreamResult=} [properties] Properties to set
                 */
                function StartStreamResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartStreamResult streamId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} streamId
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.streamId = null;

                /**
                 * StartStreamResult sceneViewId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneViewId
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.sceneViewId = null;

                /**
                 * StartStreamResult sessionId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sessionId
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.sessionId = null;

                /**
                 * StartStreamResult jwt.
                 * @member {string} jwt
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.jwt = "";

                /**
                 * StartStreamResult worldOrientation.
                 * @member {vertexvis.protobuf.stream.IOrientation|null|undefined} worldOrientation
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.worldOrientation = null;

                /**
                 * StartStreamResult token.
                 * @member {vertexvis.protobuf.stream.IToken|null|undefined} token
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.token = null;

                /**
                 * StartStreamResult sceneId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneId
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 */
                StartStreamResult.prototype.sceneId = null;

                /**
                 * Creates a new StartStreamResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StartStreamResult} StartStreamResult instance
                 */
                StartStreamResult.create = function create(properties) {
                    return new StartStreamResult(properties);
                };

                /**
                 * Encodes the specified StartStreamResult message. Does not implicitly {@link vertexvis.protobuf.stream.StartStreamResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamResult} message StartStreamResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartStreamResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.streamId != null && Object.hasOwnProperty.call(message, "streamId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.streamId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.sceneViewId != null && Object.hasOwnProperty.call(message, "sceneViewId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneViewId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sessionId, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.jwt != null && Object.hasOwnProperty.call(message, "jwt"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.jwt);
                    if (message.worldOrientation != null && Object.hasOwnProperty.call(message, "worldOrientation"))
                        $root.vertexvis.protobuf.stream.Orientation.encode(message.worldOrientation, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        $root.vertexvis.protobuf.stream.Token.encode(message.token, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.sceneId != null && Object.hasOwnProperty.call(message, "sceneId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneId, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StartStreamResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StartStreamResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IStartStreamResult} message StartStreamResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartStreamResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartStreamResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StartStreamResult} StartStreamResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartStreamResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StartStreamResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.streamId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.sceneViewId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.sessionId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.jwt = reader.string();
                            break;
                        case 5:
                            message.worldOrientation = $root.vertexvis.protobuf.stream.Orientation.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.token = $root.vertexvis.protobuf.stream.Token.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.sceneId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartStreamResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StartStreamResult} StartStreamResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartStreamResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartStreamResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartStreamResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.streamId != null && message.hasOwnProperty("streamId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.streamId);
                        if (error)
                            return "streamId." + error;
                    }
                    if (message.sceneViewId != null && message.hasOwnProperty("sceneViewId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneViewId);
                        if (error)
                            return "sceneViewId." + error;
                    }
                    if (message.sessionId != null && message.hasOwnProperty("sessionId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sessionId);
                        if (error)
                            return "sessionId." + error;
                    }
                    if (message.jwt != null && message.hasOwnProperty("jwt"))
                        if (!$util.isString(message.jwt))
                            return "jwt: string expected";
                    if (message.worldOrientation != null && message.hasOwnProperty("worldOrientation")) {
                        let error = $root.vertexvis.protobuf.stream.Orientation.verify(message.worldOrientation);
                        if (error)
                            return "worldOrientation." + error;
                    }
                    if (message.token != null && message.hasOwnProperty("token")) {
                        let error = $root.vertexvis.protobuf.stream.Token.verify(message.token);
                        if (error)
                            return "token." + error;
                    }
                    if (message.sceneId != null && message.hasOwnProperty("sceneId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneId);
                        if (error)
                            return "sceneId." + error;
                    }
                    return null;
                };

                /**
                 * Creates a StartStreamResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StartStreamResult} StartStreamResult
                 */
                StartStreamResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StartStreamResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StartStreamResult();
                    if (object.streamId != null) {
                        if (typeof object.streamId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.streamId: object expected");
                        message.streamId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.streamId);
                    }
                    if (object.sceneViewId != null) {
                        if (typeof object.sceneViewId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.sceneViewId: object expected");
                        message.sceneViewId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneViewId);
                    }
                    if (object.sessionId != null) {
                        if (typeof object.sessionId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.sessionId: object expected");
                        message.sessionId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sessionId);
                    }
                    if (object.jwt != null)
                        message.jwt = String(object.jwt);
                    if (object.worldOrientation != null) {
                        if (typeof object.worldOrientation !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.worldOrientation: object expected");
                        message.worldOrientation = $root.vertexvis.protobuf.stream.Orientation.fromObject(object.worldOrientation);
                    }
                    if (object.token != null) {
                        if (typeof object.token !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.token: object expected");
                        message.token = $root.vertexvis.protobuf.stream.Token.fromObject(object.token);
                    }
                    if (object.sceneId != null) {
                        if (typeof object.sceneId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StartStreamResult.sceneId: object expected");
                        message.sceneId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartStreamResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.StartStreamResult} message StartStreamResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartStreamResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.streamId = null;
                        object.sceneViewId = null;
                        object.sessionId = null;
                        object.jwt = "";
                        object.worldOrientation = null;
                        object.token = null;
                        object.sceneId = null;
                    }
                    if (message.streamId != null && message.hasOwnProperty("streamId"))
                        object.streamId = $root.vertexvis.protobuf.core.Uuid.toObject(message.streamId, options);
                    if (message.sceneViewId != null && message.hasOwnProperty("sceneViewId"))
                        object.sceneViewId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneViewId, options);
                    if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                        object.sessionId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sessionId, options);
                    if (message.jwt != null && message.hasOwnProperty("jwt"))
                        object.jwt = message.jwt;
                    if (message.worldOrientation != null && message.hasOwnProperty("worldOrientation"))
                        object.worldOrientation = $root.vertexvis.protobuf.stream.Orientation.toObject(message.worldOrientation, options);
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = $root.vertexvis.protobuf.stream.Token.toObject(message.token, options);
                    if (message.sceneId != null && message.hasOwnProperty("sceneId"))
                        object.sceneId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneId, options);
                    return object;
                };

                /**
                 * Converts this StartStreamResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StartStreamResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartStreamResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StartStreamResult;
            })();

            stream.UpdateCameraResult = (function() {

                /**
                 * Properties of an UpdateCameraResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateCameraResult
                 * @property {vertexvis.protobuf.stream.ICamera|null} [camera] UpdateCameraResult camera
                 */

                /**
                 * Constructs a new UpdateCameraResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateCameraResult.
                 * @implements IUpdateCameraResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateCameraResult=} [properties] Properties to set
                 */
                function UpdateCameraResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateCameraResult camera.
                 * @member {vertexvis.protobuf.stream.ICamera|null|undefined} camera
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @instance
                 */
                UpdateCameraResult.prototype.camera = null;

                /**
                 * Creates a new UpdateCameraResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateCameraResult} UpdateCameraResult instance
                 */
                UpdateCameraResult.create = function create(properties) {
                    return new UpdateCameraResult(properties);
                };

                /**
                 * Encodes the specified UpdateCameraResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCameraResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraResult} message UpdateCameraResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCameraResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                        $root.vertexvis.protobuf.stream.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateCameraResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCameraResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCameraResult} message UpdateCameraResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCameraResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateCameraResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateCameraResult} UpdateCameraResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCameraResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateCameraResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.camera = $root.vertexvis.protobuf.stream.Camera.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateCameraResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateCameraResult} UpdateCameraResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCameraResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateCameraResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateCameraResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        let error = $root.vertexvis.protobuf.stream.Camera.verify(message.camera);
                        if (error)
                            return "camera." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateCameraResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateCameraResult} UpdateCameraResult
                 */
                UpdateCameraResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateCameraResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateCameraResult();
                    if (object.camera != null) {
                        if (typeof object.camera !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCameraResult.camera: object expected");
                        message.camera = $root.vertexvis.protobuf.stream.Camera.fromObject(object.camera);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateCameraResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateCameraResult} message UpdateCameraResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateCameraResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.camera = null;
                    if (message.camera != null && message.hasOwnProperty("camera"))
                        object.camera = $root.vertexvis.protobuf.stream.Camera.toObject(message.camera, options);
                    return object;
                };

                /**
                 * Converts this UpdateCameraResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateCameraResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateCameraResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateCameraResult;
            })();

            stream.UpdateDimensionsResult = (function() {

                /**
                 * Properties of an UpdateDimensionsResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateDimensionsResult
                 * @property {vertexvis.protobuf.stream.IDimensions|null} [dimensions] UpdateDimensionsResult dimensions
                 */

                /**
                 * Constructs a new UpdateDimensionsResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateDimensionsResult.
                 * @implements IUpdateDimensionsResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsResult=} [properties] Properties to set
                 */
                function UpdateDimensionsResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateDimensionsResult dimensions.
                 * @member {vertexvis.protobuf.stream.IDimensions|null|undefined} dimensions
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @instance
                 */
                UpdateDimensionsResult.prototype.dimensions = null;

                /**
                 * Creates a new UpdateDimensionsResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsResult} UpdateDimensionsResult instance
                 */
                UpdateDimensionsResult.create = function create(properties) {
                    return new UpdateDimensionsResult(properties);
                };

                /**
                 * Encodes the specified UpdateDimensionsResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateDimensionsResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsResult} message UpdateDimensionsResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateDimensionsResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dimensions != null && Object.hasOwnProperty.call(message, "dimensions"))
                        $root.vertexvis.protobuf.stream.Dimensions.encode(message.dimensions, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateDimensionsResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateDimensionsResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateDimensionsResult} message UpdateDimensionsResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateDimensionsResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateDimensionsResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsResult} UpdateDimensionsResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateDimensionsResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateDimensionsResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateDimensionsResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsResult} UpdateDimensionsResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateDimensionsResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateDimensionsResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateDimensionsResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                        let error = $root.vertexvis.protobuf.stream.Dimensions.verify(message.dimensions);
                        if (error)
                            return "dimensions." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateDimensionsResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateDimensionsResult} UpdateDimensionsResult
                 */
                UpdateDimensionsResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateDimensionsResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateDimensionsResult();
                    if (object.dimensions != null) {
                        if (typeof object.dimensions !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateDimensionsResult.dimensions: object expected");
                        message.dimensions = $root.vertexvis.protobuf.stream.Dimensions.fromObject(object.dimensions);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateDimensionsResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateDimensionsResult} message UpdateDimensionsResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateDimensionsResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.dimensions = null;
                    if (message.dimensions != null && message.hasOwnProperty("dimensions"))
                        object.dimensions = $root.vertexvis.protobuf.stream.Dimensions.toObject(message.dimensions, options);
                    return object;
                };

                /**
                 * Converts this UpdateDimensionsResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateDimensionsResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateDimensionsResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateDimensionsResult;
            })();

            stream.BeginInteractionResult = (function() {

                /**
                 * Properties of a BeginInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IBeginInteractionResult
                 */

                /**
                 * Constructs a new BeginInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a BeginInteractionResult.
                 * @implements IBeginInteractionResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IBeginInteractionResult=} [properties] Properties to set
                 */
                function BeginInteractionResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new BeginInteractionResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.BeginInteractionResult} BeginInteractionResult instance
                 */
                BeginInteractionResult.create = function create(properties) {
                    return new BeginInteractionResult(properties);
                };

                /**
                 * Encodes the specified BeginInteractionResult message. Does not implicitly {@link vertexvis.protobuf.stream.BeginInteractionResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionResult} message BeginInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BeginInteractionResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified BeginInteractionResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.BeginInteractionResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IBeginInteractionResult} message BeginInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BeginInteractionResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BeginInteractionResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.BeginInteractionResult} BeginInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BeginInteractionResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.BeginInteractionResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BeginInteractionResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.BeginInteractionResult} BeginInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BeginInteractionResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BeginInteractionResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BeginInteractionResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a BeginInteractionResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.BeginInteractionResult} BeginInteractionResult
                 */
                BeginInteractionResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.BeginInteractionResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.BeginInteractionResult();
                };

                /**
                 * Creates a plain object from a BeginInteractionResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.BeginInteractionResult} message BeginInteractionResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BeginInteractionResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this BeginInteractionResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.BeginInteractionResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BeginInteractionResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BeginInteractionResult;
            })();

            stream.UpdateInteractionResult = (function() {

                /**
                 * Properties of an UpdateInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateInteractionResult
                 */

                /**
                 * Constructs a new UpdateInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateInteractionResult.
                 * @implements IUpdateInteractionResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionResult=} [properties] Properties to set
                 */
                function UpdateInteractionResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new UpdateInteractionResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionResult} UpdateInteractionResult instance
                 */
                UpdateInteractionResult.create = function create(properties) {
                    return new UpdateInteractionResult(properties);
                };

                /**
                 * Encodes the specified UpdateInteractionResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateInteractionResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionResult} message UpdateInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateInteractionResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateInteractionResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateInteractionResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateInteractionResult} message UpdateInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateInteractionResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateInteractionResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionResult} UpdateInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateInteractionResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateInteractionResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateInteractionResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionResult} UpdateInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateInteractionResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateInteractionResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateInteractionResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an UpdateInteractionResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateInteractionResult} UpdateInteractionResult
                 */
                UpdateInteractionResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateInteractionResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.UpdateInteractionResult();
                };

                /**
                 * Creates a plain object from an UpdateInteractionResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateInteractionResult} message UpdateInteractionResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateInteractionResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this UpdateInteractionResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateInteractionResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateInteractionResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateInteractionResult;
            })();

            stream.EndInteractionResult = (function() {

                /**
                 * Properties of an EndInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IEndInteractionResult
                 */

                /**
                 * Constructs a new EndInteractionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an EndInteractionResult.
                 * @implements IEndInteractionResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IEndInteractionResult=} [properties] Properties to set
                 */
                function EndInteractionResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new EndInteractionResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.EndInteractionResult} EndInteractionResult instance
                 */
                EndInteractionResult.create = function create(properties) {
                    return new EndInteractionResult(properties);
                };

                /**
                 * Encodes the specified EndInteractionResult message. Does not implicitly {@link vertexvis.protobuf.stream.EndInteractionResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionResult} message EndInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndInteractionResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified EndInteractionResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.EndInteractionResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IEndInteractionResult} message EndInteractionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndInteractionResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EndInteractionResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.EndInteractionResult} EndInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndInteractionResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.EndInteractionResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EndInteractionResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.EndInteractionResult} EndInteractionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndInteractionResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EndInteractionResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EndInteractionResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an EndInteractionResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.EndInteractionResult} EndInteractionResult
                 */
                EndInteractionResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.EndInteractionResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.EndInteractionResult();
                };

                /**
                 * Creates a plain object from an EndInteractionResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.EndInteractionResult} message EndInteractionResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EndInteractionResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this EndInteractionResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.EndInteractionResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EndInteractionResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EndInteractionResult;
            })();

            stream.ReconnectResult = (function() {

                /**
                 * Properties of a ReconnectResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IReconnectResult
                 * @property {string|null} [jwt] ReconnectResult jwt
                 * @property {vertexvis.protobuf.stream.IToken|null} [token] ReconnectResult token
                 */

                /**
                 * Constructs a new ReconnectResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ReconnectResult.
                 * @implements IReconnectResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IReconnectResult=} [properties] Properties to set
                 */
                function ReconnectResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReconnectResult jwt.
                 * @member {string} jwt
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @instance
                 */
                ReconnectResult.prototype.jwt = "";

                /**
                 * ReconnectResult token.
                 * @member {vertexvis.protobuf.stream.IToken|null|undefined} token
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @instance
                 */
                ReconnectResult.prototype.token = null;

                /**
                 * Creates a new ReconnectResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ReconnectResult} ReconnectResult instance
                 */
                ReconnectResult.create = function create(properties) {
                    return new ReconnectResult(properties);
                };

                /**
                 * Encodes the specified ReconnectResult message. Does not implicitly {@link vertexvis.protobuf.stream.ReconnectResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectResult} message ReconnectResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReconnectResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.jwt != null && Object.hasOwnProperty.call(message, "jwt"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.jwt);
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        $root.vertexvis.protobuf.stream.Token.encode(message.token, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReconnectResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ReconnectResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IReconnectResult} message ReconnectResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReconnectResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReconnectResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ReconnectResult} ReconnectResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReconnectResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ReconnectResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.jwt = reader.string();
                            break;
                        case 2:
                            message.token = $root.vertexvis.protobuf.stream.Token.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReconnectResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ReconnectResult} ReconnectResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReconnectResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReconnectResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReconnectResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.jwt != null && message.hasOwnProperty("jwt"))
                        if (!$util.isString(message.jwt))
                            return "jwt: string expected";
                    if (message.token != null && message.hasOwnProperty("token")) {
                        let error = $root.vertexvis.protobuf.stream.Token.verify(message.token);
                        if (error)
                            return "token." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ReconnectResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ReconnectResult} ReconnectResult
                 */
                ReconnectResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ReconnectResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.ReconnectResult();
                    if (object.jwt != null)
                        message.jwt = String(object.jwt);
                    if (object.token != null) {
                        if (typeof object.token !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.ReconnectResult.token: object expected");
                        message.token = $root.vertexvis.protobuf.stream.Token.fromObject(object.token);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReconnectResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ReconnectResult} message ReconnectResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReconnectResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.jwt = "";
                        object.token = null;
                    }
                    if (message.jwt != null && message.hasOwnProperty("jwt"))
                        object.jwt = message.jwt;
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = $root.vertexvis.protobuf.stream.Token.toObject(message.token, options);
                    return object;
                };

                /**
                 * Converts this ReconnectResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ReconnectResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReconnectResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReconnectResult;
            })();

            stream.HitItemsResult = (function() {

                /**
                 * Properties of a HitItemsResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IHitItemsResult
                 * @property {Array.<vertexvis.protobuf.stream.IHit>|null} [hits] HitItemsResult hits
                 */

                /**
                 * Constructs a new HitItemsResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a HitItemsResult.
                 * @implements IHitItemsResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IHitItemsResult=} [properties] Properties to set
                 */
                function HitItemsResult(properties) {
                    this.hits = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HitItemsResult hits.
                 * @member {Array.<vertexvis.protobuf.stream.IHit>} hits
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @instance
                 */
                HitItemsResult.prototype.hits = $util.emptyArray;

                /**
                 * Creates a new HitItemsResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.HitItemsResult} HitItemsResult instance
                 */
                HitItemsResult.create = function create(properties) {
                    return new HitItemsResult(properties);
                };

                /**
                 * Encodes the specified HitItemsResult message. Does not implicitly {@link vertexvis.protobuf.stream.HitItemsResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsResult} message HitItemsResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemsResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hits != null && message.hits.length)
                        for (let i = 0; i < message.hits.length; ++i)
                            $root.vertexvis.protobuf.stream.Hit.encode(message.hits[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HitItemsResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.HitItemsResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IHitItemsResult} message HitItemsResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HitItemsResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HitItemsResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.HitItemsResult} HitItemsResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemsResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.HitItemsResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.hits && message.hits.length))
                                message.hits = [];
                            message.hits.push($root.vertexvis.protobuf.stream.Hit.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HitItemsResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.HitItemsResult} HitItemsResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HitItemsResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HitItemsResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HitItemsResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hits != null && message.hasOwnProperty("hits")) {
                        if (!Array.isArray(message.hits))
                            return "hits: array expected";
                        for (let i = 0; i < message.hits.length; ++i) {
                            let error = $root.vertexvis.protobuf.stream.Hit.verify(message.hits[i]);
                            if (error)
                                return "hits." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a HitItemsResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.HitItemsResult} HitItemsResult
                 */
                HitItemsResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.HitItemsResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.HitItemsResult();
                    if (object.hits) {
                        if (!Array.isArray(object.hits))
                            throw TypeError(".vertexvis.protobuf.stream.HitItemsResult.hits: array expected");
                        message.hits = [];
                        for (let i = 0; i < object.hits.length; ++i) {
                            if (typeof object.hits[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.stream.HitItemsResult.hits: object expected");
                            message.hits[i] = $root.vertexvis.protobuf.stream.Hit.fromObject(object.hits[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HitItemsResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @static
                 * @param {vertexvis.protobuf.stream.HitItemsResult} message HitItemsResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HitItemsResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.hits = [];
                    if (message.hits && message.hits.length) {
                        object.hits = [];
                        for (let j = 0; j < message.hits.length; ++j)
                            object.hits[j] = $root.vertexvis.protobuf.stream.Hit.toObject(message.hits[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this HitItemsResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.HitItemsResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HitItemsResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HitItemsResult;
            })();

            stream.SyncTimeResult = (function() {

                /**
                 * Properties of a SyncTimeResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ISyncTimeResult
                 * @property {google.protobuf.ITimestamp|null} [replyTime] SyncTimeResult replyTime
                 */

                /**
                 * Constructs a new SyncTimeResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a SyncTimeResult.
                 * @implements ISyncTimeResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ISyncTimeResult=} [properties] Properties to set
                 */
                function SyncTimeResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SyncTimeResult replyTime.
                 * @member {google.protobuf.ITimestamp|null|undefined} replyTime
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @instance
                 */
                SyncTimeResult.prototype.replyTime = null;

                /**
                 * Creates a new SyncTimeResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimeResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.SyncTimeResult} SyncTimeResult instance
                 */
                SyncTimeResult.create = function create(properties) {
                    return new SyncTimeResult(properties);
                };

                /**
                 * Encodes the specified SyncTimeResult message. Does not implicitly {@link vertexvis.protobuf.stream.SyncTimeResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimeResult} message SyncTimeResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SyncTimeResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.replyTime != null && Object.hasOwnProperty.call(message, "replyTime"))
                        $root.google.protobuf.Timestamp.encode(message.replyTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SyncTimeResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.SyncTimeResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ISyncTimeResult} message SyncTimeResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SyncTimeResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SyncTimeResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.SyncTimeResult} SyncTimeResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SyncTimeResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.SyncTimeResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.replyTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SyncTimeResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.SyncTimeResult} SyncTimeResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SyncTimeResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SyncTimeResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SyncTimeResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.replyTime != null && message.hasOwnProperty("replyTime")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.replyTime);
                        if (error)
                            return "replyTime." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SyncTimeResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.SyncTimeResult} SyncTimeResult
                 */
                SyncTimeResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.SyncTimeResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.SyncTimeResult();
                    if (object.replyTime != null) {
                        if (typeof object.replyTime !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.SyncTimeResult.replyTime: object expected");
                        message.replyTime = $root.google.protobuf.Timestamp.fromObject(object.replyTime);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SyncTimeResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @static
                 * @param {vertexvis.protobuf.stream.SyncTimeResult} message SyncTimeResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SyncTimeResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.replyTime = null;
                    if (message.replyTime != null && message.hasOwnProperty("replyTime"))
                        object.replyTime = $root.google.protobuf.Timestamp.toObject(message.replyTime, options);
                    return object;
                };

                /**
                 * Converts this SyncTimeResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.SyncTimeResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SyncTimeResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SyncTimeResult;
            })();

            stream.DrawFrameResult = (function() {

                /**
                 * Properties of a DrawFrameResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IDrawFrameResult
                 * @property {google.protobuf.IDuration|null} [sendToReceiveDuration] DrawFrameResult sendToReceiveDuration
                 */

                /**
                 * Constructs a new DrawFrameResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a DrawFrameResult.
                 * @implements IDrawFrameResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IDrawFrameResult=} [properties] Properties to set
                 */
                function DrawFrameResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DrawFrameResult sendToReceiveDuration.
                 * @member {google.protobuf.IDuration|null|undefined} sendToReceiveDuration
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @instance
                 */
                DrawFrameResult.prototype.sendToReceiveDuration = null;

                /**
                 * Creates a new DrawFrameResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFrameResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.DrawFrameResult} DrawFrameResult instance
                 */
                DrawFrameResult.create = function create(properties) {
                    return new DrawFrameResult(properties);
                };

                /**
                 * Encodes the specified DrawFrameResult message. Does not implicitly {@link vertexvis.protobuf.stream.DrawFrameResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFrameResult} message DrawFrameResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DrawFrameResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sendToReceiveDuration != null && Object.hasOwnProperty.call(message, "sendToReceiveDuration"))
                        $root.google.protobuf.Duration.encode(message.sendToReceiveDuration, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DrawFrameResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.DrawFrameResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IDrawFrameResult} message DrawFrameResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DrawFrameResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DrawFrameResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.DrawFrameResult} DrawFrameResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DrawFrameResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.DrawFrameResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.sendToReceiveDuration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DrawFrameResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.DrawFrameResult} DrawFrameResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DrawFrameResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DrawFrameResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DrawFrameResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sendToReceiveDuration != null && message.hasOwnProperty("sendToReceiveDuration")) {
                        let error = $root.google.protobuf.Duration.verify(message.sendToReceiveDuration);
                        if (error)
                            return "sendToReceiveDuration." + error;
                    }
                    return null;
                };

                /**
                 * Creates a DrawFrameResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.DrawFrameResult} DrawFrameResult
                 */
                DrawFrameResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.DrawFrameResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.DrawFrameResult();
                    if (object.sendToReceiveDuration != null) {
                        if (typeof object.sendToReceiveDuration !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.DrawFrameResult.sendToReceiveDuration: object expected");
                        message.sendToReceiveDuration = $root.google.protobuf.Duration.fromObject(object.sendToReceiveDuration);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DrawFrameResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @static
                 * @param {vertexvis.protobuf.stream.DrawFrameResult} message DrawFrameResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DrawFrameResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.sendToReceiveDuration = null;
                    if (message.sendToReceiveDuration != null && message.hasOwnProperty("sendToReceiveDuration"))
                        object.sendToReceiveDuration = $root.google.protobuf.Duration.toObject(message.sendToReceiveDuration, options);
                    return object;
                };

                /**
                 * Converts this DrawFrameResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.DrawFrameResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DrawFrameResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DrawFrameResult;
            })();

            stream.RecordPerformanceResult = (function() {

                /**
                 * Properties of a RecordPerformanceResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRecordPerformanceResult
                 */

                /**
                 * Constructs a new RecordPerformanceResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a RecordPerformanceResult.
                 * @implements IRecordPerformanceResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRecordPerformanceResult=} [properties] Properties to set
                 */
                function RecordPerformanceResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new RecordPerformanceResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformanceResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.RecordPerformanceResult} RecordPerformanceResult instance
                 */
                RecordPerformanceResult.create = function create(properties) {
                    return new RecordPerformanceResult(properties);
                };

                /**
                 * Encodes the specified RecordPerformanceResult message. Does not implicitly {@link vertexvis.protobuf.stream.RecordPerformanceResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformanceResult} message RecordPerformanceResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordPerformanceResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified RecordPerformanceResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.RecordPerformanceResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRecordPerformanceResult} message RecordPerformanceResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordPerformanceResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordPerformanceResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.RecordPerformanceResult} RecordPerformanceResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordPerformanceResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.RecordPerformanceResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordPerformanceResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.RecordPerformanceResult} RecordPerformanceResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordPerformanceResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordPerformanceResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordPerformanceResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a RecordPerformanceResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.RecordPerformanceResult} RecordPerformanceResult
                 */
                RecordPerformanceResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.RecordPerformanceResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.RecordPerformanceResult();
                };

                /**
                 * Creates a plain object from a RecordPerformanceResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @static
                 * @param {vertexvis.protobuf.stream.RecordPerformanceResult} message RecordPerformanceResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordPerformanceResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this RecordPerformanceResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.RecordPerformanceResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordPerformanceResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordPerformanceResult;
            })();

            stream.UpdateStreamResult = (function() {

                /**
                 * Properties of an UpdateStreamResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateStreamResult
                 */

                /**
                 * Constructs a new UpdateStreamResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateStreamResult.
                 * @implements IUpdateStreamResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateStreamResult=} [properties] Properties to set
                 */
                function UpdateStreamResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new UpdateStreamResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateStreamResult} UpdateStreamResult instance
                 */
                UpdateStreamResult.create = function create(properties) {
                    return new UpdateStreamResult(properties);
                };

                /**
                 * Encodes the specified UpdateStreamResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateStreamResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamResult} message UpdateStreamResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateStreamResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateStreamResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateStreamResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateStreamResult} message UpdateStreamResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateStreamResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateStreamResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateStreamResult} UpdateStreamResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateStreamResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateStreamResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateStreamResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateStreamResult} UpdateStreamResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateStreamResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateStreamResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateStreamResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an UpdateStreamResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateStreamResult} UpdateStreamResult
                 */
                UpdateStreamResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateStreamResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.UpdateStreamResult();
                };

                /**
                 * Creates a plain object from an UpdateStreamResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateStreamResult} message UpdateStreamResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateStreamResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this UpdateStreamResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateStreamResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateStreamResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateStreamResult;
            })();

            stream.FlyToResult = (function() {

                /**
                 * Properties of a FlyToResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IFlyToResult
                 * @property {vertexvis.protobuf.core.IUuid|null} [animationId] FlyToResult animationId
                 */

                /**
                 * Constructs a new FlyToResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a FlyToResult.
                 * @implements IFlyToResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IFlyToResult=} [properties] Properties to set
                 */
                function FlyToResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FlyToResult animationId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} animationId
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @instance
                 */
                FlyToResult.prototype.animationId = null;

                /**
                 * Creates a new FlyToResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.FlyToResult} FlyToResult instance
                 */
                FlyToResult.create = function create(properties) {
                    return new FlyToResult(properties);
                };

                /**
                 * Encodes the specified FlyToResult message. Does not implicitly {@link vertexvis.protobuf.stream.FlyToResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToResult} message FlyToResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FlyToResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.animationId != null && Object.hasOwnProperty.call(message, "animationId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.animationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FlyToResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.FlyToResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IFlyToResult} message FlyToResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FlyToResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FlyToResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.FlyToResult} FlyToResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FlyToResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.FlyToResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.animationId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FlyToResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.FlyToResult} FlyToResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FlyToResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FlyToResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FlyToResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.animationId != null && message.hasOwnProperty("animationId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.animationId);
                        if (error)
                            return "animationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FlyToResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.FlyToResult} FlyToResult
                 */
                FlyToResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.FlyToResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.FlyToResult();
                    if (object.animationId != null) {
                        if (typeof object.animationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.FlyToResult.animationId: object expected");
                        message.animationId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.animationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FlyToResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @static
                 * @param {vertexvis.protobuf.stream.FlyToResult} message FlyToResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FlyToResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.animationId = null;
                    if (message.animationId != null && message.hasOwnProperty("animationId"))
                        object.animationId = $root.vertexvis.protobuf.core.Uuid.toObject(message.animationId, options);
                    return object;
                };

                /**
                 * Converts this FlyToResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.FlyToResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FlyToResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FlyToResult;
            })();

            stream.LoadSceneViewStateResult = (function() {

                /**
                 * Properties of a LoadSceneViewStateResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface ILoadSceneViewStateResult
                 */

                /**
                 * Constructs a new LoadSceneViewStateResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a LoadSceneViewStateResult.
                 * @implements ILoadSceneViewStateResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStateResult=} [properties] Properties to set
                 */
                function LoadSceneViewStateResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new LoadSceneViewStateResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStateResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStateResult} LoadSceneViewStateResult instance
                 */
                LoadSceneViewStateResult.create = function create(properties) {
                    return new LoadSceneViewStateResult(properties);
                };

                /**
                 * Encodes the specified LoadSceneViewStateResult message. Does not implicitly {@link vertexvis.protobuf.stream.LoadSceneViewStateResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStateResult} message LoadSceneViewStateResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoadSceneViewStateResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified LoadSceneViewStateResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.LoadSceneViewStateResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ILoadSceneViewStateResult} message LoadSceneViewStateResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoadSceneViewStateResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LoadSceneViewStateResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStateResult} LoadSceneViewStateResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoadSceneViewStateResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.LoadSceneViewStateResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LoadSceneViewStateResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStateResult} LoadSceneViewStateResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoadSceneViewStateResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LoadSceneViewStateResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LoadSceneViewStateResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a LoadSceneViewStateResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.LoadSceneViewStateResult} LoadSceneViewStateResult
                 */
                LoadSceneViewStateResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.LoadSceneViewStateResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.LoadSceneViewStateResult();
                };

                /**
                 * Creates a plain object from a LoadSceneViewStateResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @static
                 * @param {vertexvis.protobuf.stream.LoadSceneViewStateResult} message LoadSceneViewStateResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LoadSceneViewStateResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this LoadSceneViewStateResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.LoadSceneViewStateResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LoadSceneViewStateResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LoadSceneViewStateResult;
            })();

            stream.ResetViewResult = (function() {

                /**
                 * Properties of a ResetViewResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IResetViewResult
                 */

                /**
                 * Constructs a new ResetViewResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a ResetViewResult.
                 * @implements IResetViewResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IResetViewResult=} [properties] Properties to set
                 */
                function ResetViewResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ResetViewResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.ResetViewResult} ResetViewResult instance
                 */
                ResetViewResult.create = function create(properties) {
                    return new ResetViewResult(properties);
                };

                /**
                 * Encodes the specified ResetViewResult message. Does not implicitly {@link vertexvis.protobuf.stream.ResetViewResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewResult} message ResetViewResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetViewResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ResetViewResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.ResetViewResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IResetViewResult} message ResetViewResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetViewResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ResetViewResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.ResetViewResult} ResetViewResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetViewResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.ResetViewResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ResetViewResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.ResetViewResult} ResetViewResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetViewResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ResetViewResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResetViewResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ResetViewResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.ResetViewResult} ResetViewResult
                 */
                ResetViewResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.ResetViewResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.ResetViewResult();
                };

                /**
                 * Creates a plain object from a ResetViewResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.ResetViewResult} message ResetViewResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResetViewResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ResetViewResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.ResetViewResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResetViewResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ResetViewResult;
            })();

            stream.GetStencilBufferResult = (function() {

                /**
                 * Properties of a GetStencilBufferResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IGetStencilBufferResult
                 * @property {Uint8Array|null} [stencilBuffer] GetStencilBufferResult stencilBuffer
                 * @property {vertexvis.protobuf.stream.IImageAttributes|null} [imageAttributes] GetStencilBufferResult imageAttributes
                 * @property {google.protobuf.IBytesValue|null} [depthBuffer] GetStencilBufferResult depthBuffer
                 */

                /**
                 * Constructs a new GetStencilBufferResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a GetStencilBufferResult.
                 * @implements IGetStencilBufferResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferResult=} [properties] Properties to set
                 */
                function GetStencilBufferResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetStencilBufferResult stencilBuffer.
                 * @member {Uint8Array} stencilBuffer
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @instance
                 */
                GetStencilBufferResult.prototype.stencilBuffer = $util.newBuffer([]);

                /**
                 * GetStencilBufferResult imageAttributes.
                 * @member {vertexvis.protobuf.stream.IImageAttributes|null|undefined} imageAttributes
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @instance
                 */
                GetStencilBufferResult.prototype.imageAttributes = null;

                /**
                 * GetStencilBufferResult depthBuffer.
                 * @member {google.protobuf.IBytesValue|null|undefined} depthBuffer
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @instance
                 */
                GetStencilBufferResult.prototype.depthBuffer = null;

                /**
                 * Creates a new GetStencilBufferResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferResult} GetStencilBufferResult instance
                 */
                GetStencilBufferResult.create = function create(properties) {
                    return new GetStencilBufferResult(properties);
                };

                /**
                 * Encodes the specified GetStencilBufferResult message. Does not implicitly {@link vertexvis.protobuf.stream.GetStencilBufferResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferResult} message GetStencilBufferResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetStencilBufferResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stencilBuffer != null && Object.hasOwnProperty.call(message, "stencilBuffer"))
                        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.stencilBuffer);
                    if (message.imageAttributes != null && Object.hasOwnProperty.call(message, "imageAttributes"))
                        $root.vertexvis.protobuf.stream.ImageAttributes.encode(message.imageAttributes, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.depthBuffer != null && Object.hasOwnProperty.call(message, "depthBuffer"))
                        $root.google.protobuf.BytesValue.encode(message.depthBuffer, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GetStencilBufferResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.GetStencilBufferResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGetStencilBufferResult} message GetStencilBufferResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetStencilBufferResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetStencilBufferResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferResult} GetStencilBufferResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetStencilBufferResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.GetStencilBufferResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.stencilBuffer = reader.bytes();
                            break;
                        case 2:
                            message.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.depthBuffer = $root.google.protobuf.BytesValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetStencilBufferResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferResult} GetStencilBufferResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetStencilBufferResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetStencilBufferResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetStencilBufferResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stencilBuffer != null && message.hasOwnProperty("stencilBuffer"))
                        if (!(message.stencilBuffer && typeof message.stencilBuffer.length === "number" || $util.isString(message.stencilBuffer)))
                            return "stencilBuffer: buffer expected";
                    if (message.imageAttributes != null && message.hasOwnProperty("imageAttributes")) {
                        let error = $root.vertexvis.protobuf.stream.ImageAttributes.verify(message.imageAttributes);
                        if (error)
                            return "imageAttributes." + error;
                    }
                    if (message.depthBuffer != null && message.hasOwnProperty("depthBuffer")) {
                        let error = $root.google.protobuf.BytesValue.verify(message.depthBuffer);
                        if (error)
                            return "depthBuffer." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GetStencilBufferResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.GetStencilBufferResult} GetStencilBufferResult
                 */
                GetStencilBufferResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.GetStencilBufferResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.GetStencilBufferResult();
                    if (object.stencilBuffer != null)
                        if (typeof object.stencilBuffer === "string")
                            $util.base64.decode(object.stencilBuffer, message.stencilBuffer = $util.newBuffer($util.base64.length(object.stencilBuffer)), 0);
                        else if (object.stencilBuffer.length)
                            message.stencilBuffer = object.stencilBuffer;
                    if (object.imageAttributes != null) {
                        if (typeof object.imageAttributes !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.GetStencilBufferResult.imageAttributes: object expected");
                        message.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.fromObject(object.imageAttributes);
                    }
                    if (object.depthBuffer != null) {
                        if (typeof object.depthBuffer !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.GetStencilBufferResult.depthBuffer: object expected");
                        message.depthBuffer = $root.google.protobuf.BytesValue.fromObject(object.depthBuffer);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetStencilBufferResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @static
                 * @param {vertexvis.protobuf.stream.GetStencilBufferResult} message GetStencilBufferResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetStencilBufferResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        if (options.bytes === String)
                            object.stencilBuffer = "";
                        else {
                            object.stencilBuffer = [];
                            if (options.bytes !== Array)
                                object.stencilBuffer = $util.newBuffer(object.stencilBuffer);
                        }
                        object.imageAttributes = null;
                        object.depthBuffer = null;
                    }
                    if (message.stencilBuffer != null && message.hasOwnProperty("stencilBuffer"))
                        object.stencilBuffer = options.bytes === String ? $util.base64.encode(message.stencilBuffer, 0, message.stencilBuffer.length) : options.bytes === Array ? Array.prototype.slice.call(message.stencilBuffer) : message.stencilBuffer;
                    if (message.imageAttributes != null && message.hasOwnProperty("imageAttributes"))
                        object.imageAttributes = $root.vertexvis.protobuf.stream.ImageAttributes.toObject(message.imageAttributes, options);
                    if (message.depthBuffer != null && message.hasOwnProperty("depthBuffer"))
                        object.depthBuffer = $root.google.protobuf.BytesValue.toObject(message.depthBuffer, options);
                    return object;
                };

                /**
                 * Converts this GetStencilBufferResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.GetStencilBufferResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetStencilBufferResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetStencilBufferResult;
            })();

            stream.RefreshTokenResult = (function() {

                /**
                 * Properties of a RefreshTokenResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IRefreshTokenResult
                 * @property {vertexvis.protobuf.stream.IToken|null} [token] RefreshTokenResult token
                 */

                /**
                 * Constructs a new RefreshTokenResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a RefreshTokenResult.
                 * @implements IRefreshTokenResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IRefreshTokenResult=} [properties] Properties to set
                 */
                function RefreshTokenResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RefreshTokenResult token.
                 * @member {vertexvis.protobuf.stream.IToken|null|undefined} token
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @instance
                 */
                RefreshTokenResult.prototype.token = null;

                /**
                 * Creates a new RefreshTokenResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.RefreshTokenResult} RefreshTokenResult instance
                 */
                RefreshTokenResult.create = function create(properties) {
                    return new RefreshTokenResult(properties);
                };

                /**
                 * Encodes the specified RefreshTokenResult message. Does not implicitly {@link vertexvis.protobuf.stream.RefreshTokenResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenResult} message RefreshTokenResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefreshTokenResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        $root.vertexvis.protobuf.stream.Token.encode(message.token, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RefreshTokenResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.RefreshTokenResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IRefreshTokenResult} message RefreshTokenResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RefreshTokenResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RefreshTokenResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.RefreshTokenResult} RefreshTokenResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefreshTokenResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.RefreshTokenResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.token = $root.vertexvis.protobuf.stream.Token.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RefreshTokenResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.RefreshTokenResult} RefreshTokenResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RefreshTokenResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RefreshTokenResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RefreshTokenResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.token != null && message.hasOwnProperty("token")) {
                        let error = $root.vertexvis.protobuf.stream.Token.verify(message.token);
                        if (error)
                            return "token." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RefreshTokenResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.RefreshTokenResult} RefreshTokenResult
                 */
                RefreshTokenResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.RefreshTokenResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.RefreshTokenResult();
                    if (object.token != null) {
                        if (typeof object.token !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.RefreshTokenResult.token: object expected");
                        message.token = $root.vertexvis.protobuf.stream.Token.fromObject(object.token);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RefreshTokenResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @static
                 * @param {vertexvis.protobuf.stream.RefreshTokenResult} message RefreshTokenResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RefreshTokenResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.token = null;
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = $root.vertexvis.protobuf.stream.Token.toObject(message.token, options);
                    return object;
                };

                /**
                 * Converts this RefreshTokenResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.RefreshTokenResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RefreshTokenResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RefreshTokenResult;
            })();

            stream.StreamEvent = (function() {

                /**
                 * Properties of a StreamEvent.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IStreamEvent
                 * @property {vertexvis.protobuf.stream.IAnimationCompletedEvent|null} [animationCompleted] StreamEvent animationCompleted
                 */

                /**
                 * Constructs a new StreamEvent.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a StreamEvent.
                 * @implements IStreamEvent
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IStreamEvent=} [properties] Properties to set
                 */
                function StreamEvent(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StreamEvent animationCompleted.
                 * @member {vertexvis.protobuf.stream.IAnimationCompletedEvent|null|undefined} animationCompleted
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @instance
                 */
                StreamEvent.prototype.animationCompleted = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * StreamEvent event.
                 * @member {"animationCompleted"|undefined} event
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @instance
                 */
                Object.defineProperty(StreamEvent.prototype, "event", {
                    get: $util.oneOfGetter($oneOfFields = ["animationCompleted"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new StreamEvent instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamEvent=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.StreamEvent} StreamEvent instance
                 */
                StreamEvent.create = function create(properties) {
                    return new StreamEvent(properties);
                };

                /**
                 * Encodes the specified StreamEvent message. Does not implicitly {@link vertexvis.protobuf.stream.StreamEvent.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamEvent} message StreamEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamEvent.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.animationCompleted != null && Object.hasOwnProperty.call(message, "animationCompleted"))
                        $root.vertexvis.protobuf.stream.AnimationCompletedEvent.encode(message.animationCompleted, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StreamEvent message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.StreamEvent.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IStreamEvent} message StreamEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StreamEvent.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StreamEvent message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.StreamEvent} StreamEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamEvent.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.StreamEvent();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.animationCompleted = $root.vertexvis.protobuf.stream.AnimationCompletedEvent.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StreamEvent message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.StreamEvent} StreamEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StreamEvent.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StreamEvent message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StreamEvent.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.animationCompleted != null && message.hasOwnProperty("animationCompleted")) {
                        properties.event = 1;
                        {
                            let error = $root.vertexvis.protobuf.stream.AnimationCompletedEvent.verify(message.animationCompleted);
                            if (error)
                                return "animationCompleted." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StreamEvent message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.StreamEvent} StreamEvent
                 */
                StreamEvent.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.StreamEvent)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.StreamEvent();
                    if (object.animationCompleted != null) {
                        if (typeof object.animationCompleted !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.StreamEvent.animationCompleted: object expected");
                        message.animationCompleted = $root.vertexvis.protobuf.stream.AnimationCompletedEvent.fromObject(object.animationCompleted);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StreamEvent message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.StreamEvent} message StreamEvent
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StreamEvent.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.animationCompleted != null && message.hasOwnProperty("animationCompleted")) {
                        object.animationCompleted = $root.vertexvis.protobuf.stream.AnimationCompletedEvent.toObject(message.animationCompleted, options);
                        if (options.oneofs)
                            object.event = "animationCompleted";
                    }
                    return object;
                };

                /**
                 * Converts this StreamEvent to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.StreamEvent
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StreamEvent.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StreamEvent;
            })();

            stream.AnimationCompletedEvent = (function() {

                /**
                 * Properties of an AnimationCompletedEvent.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IAnimationCompletedEvent
                 * @property {vertexvis.protobuf.core.IUuid|null} [animationId] AnimationCompletedEvent animationId
                 */

                /**
                 * Constructs a new AnimationCompletedEvent.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an AnimationCompletedEvent.
                 * @implements IAnimationCompletedEvent
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IAnimationCompletedEvent=} [properties] Properties to set
                 */
                function AnimationCompletedEvent(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AnimationCompletedEvent animationId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} animationId
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @instance
                 */
                AnimationCompletedEvent.prototype.animationId = null;

                /**
                 * Creates a new AnimationCompletedEvent instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationCompletedEvent=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.AnimationCompletedEvent} AnimationCompletedEvent instance
                 */
                AnimationCompletedEvent.create = function create(properties) {
                    return new AnimationCompletedEvent(properties);
                };

                /**
                 * Encodes the specified AnimationCompletedEvent message. Does not implicitly {@link vertexvis.protobuf.stream.AnimationCompletedEvent.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationCompletedEvent} message AnimationCompletedEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnimationCompletedEvent.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.animationId != null && Object.hasOwnProperty.call(message, "animationId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.animationId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AnimationCompletedEvent message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.AnimationCompletedEvent.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.IAnimationCompletedEvent} message AnimationCompletedEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AnimationCompletedEvent.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AnimationCompletedEvent message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.AnimationCompletedEvent} AnimationCompletedEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnimationCompletedEvent.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.AnimationCompletedEvent();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.animationId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AnimationCompletedEvent message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.AnimationCompletedEvent} AnimationCompletedEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AnimationCompletedEvent.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AnimationCompletedEvent message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AnimationCompletedEvent.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.animationId != null && message.hasOwnProperty("animationId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.animationId);
                        if (error)
                            return "animationId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AnimationCompletedEvent message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.AnimationCompletedEvent} AnimationCompletedEvent
                 */
                AnimationCompletedEvent.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.AnimationCompletedEvent)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.AnimationCompletedEvent();
                    if (object.animationId != null) {
                        if (typeof object.animationId !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.AnimationCompletedEvent.animationId: object expected");
                        message.animationId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.animationId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AnimationCompletedEvent message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @static
                 * @param {vertexvis.protobuf.stream.AnimationCompletedEvent} message AnimationCompletedEvent
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AnimationCompletedEvent.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.animationId = null;
                    if (message.animationId != null && message.hasOwnProperty("animationId"))
                        object.animationId = $root.vertexvis.protobuf.core.Uuid.toObject(message.animationId, options);
                    return object;
                };

                /**
                 * Converts this AnimationCompletedEvent to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.AnimationCompletedEvent
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AnimationCompletedEvent.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AnimationCompletedEvent;
            })();

            stream.UpdateCrossSectioningResult = (function() {

                /**
                 * Properties of an UpdateCrossSectioningResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateCrossSectioningResult
                 * @property {vertexvis.protobuf.stream.ICrossSectioning|null} [crossSectioning] UpdateCrossSectioningResult crossSectioning
                 */

                /**
                 * Constructs a new UpdateCrossSectioningResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateCrossSectioningResult.
                 * @implements IUpdateCrossSectioningResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningResult=} [properties] Properties to set
                 */
                function UpdateCrossSectioningResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UpdateCrossSectioningResult crossSectioning.
                 * @member {vertexvis.protobuf.stream.ICrossSectioning|null|undefined} crossSectioning
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @instance
                 */
                UpdateCrossSectioningResult.prototype.crossSectioning = null;

                /**
                 * Creates a new UpdateCrossSectioningResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningResult} UpdateCrossSectioningResult instance
                 */
                UpdateCrossSectioningResult.create = function create(properties) {
                    return new UpdateCrossSectioningResult(properties);
                };

                /**
                 * Encodes the specified UpdateCrossSectioningResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCrossSectioningResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningResult} message UpdateCrossSectioningResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCrossSectioningResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.crossSectioning != null && Object.hasOwnProperty.call(message, "crossSectioning"))
                        $root.vertexvis.protobuf.stream.CrossSectioning.encode(message.crossSectioning, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateCrossSectioningResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateCrossSectioningResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateCrossSectioningResult} message UpdateCrossSectioningResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateCrossSectioningResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateCrossSectioningResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningResult} UpdateCrossSectioningResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCrossSectioningResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateCrossSectioningResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningResult} UpdateCrossSectioningResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateCrossSectioningResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateCrossSectioningResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateCrossSectioningResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning")) {
                        let error = $root.vertexvis.protobuf.stream.CrossSectioning.verify(message.crossSectioning);
                        if (error)
                            return "crossSectioning." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UpdateCrossSectioningResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateCrossSectioningResult} UpdateCrossSectioningResult
                 */
                UpdateCrossSectioningResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult)
                        return object;
                    let message = new $root.vertexvis.protobuf.stream.UpdateCrossSectioningResult();
                    if (object.crossSectioning != null) {
                        if (typeof object.crossSectioning !== "object")
                            throw TypeError(".vertexvis.protobuf.stream.UpdateCrossSectioningResult.crossSectioning: object expected");
                        message.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.fromObject(object.crossSectioning);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UpdateCrossSectioningResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateCrossSectioningResult} message UpdateCrossSectioningResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateCrossSectioningResult.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.crossSectioning = null;
                    if (message.crossSectioning != null && message.hasOwnProperty("crossSectioning"))
                        object.crossSectioning = $root.vertexvis.protobuf.stream.CrossSectioning.toObject(message.crossSectioning, options);
                    return object;
                };

                /**
                 * Converts this UpdateCrossSectioningResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateCrossSectioningResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateCrossSectioningResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateCrossSectioningResult;
            })();

            stream.GracefulReconnectionResult = (function() {

                /**
                 * Properties of a GracefulReconnectionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IGracefulReconnectionResult
                 */

                /**
                 * Constructs a new GracefulReconnectionResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents a GracefulReconnectionResult.
                 * @implements IGracefulReconnectionResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionResult=} [properties] Properties to set
                 */
                function GracefulReconnectionResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new GracefulReconnectionResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionResult} GracefulReconnectionResult instance
                 */
                GracefulReconnectionResult.create = function create(properties) {
                    return new GracefulReconnectionResult(properties);
                };

                /**
                 * Encodes the specified GracefulReconnectionResult message. Does not implicitly {@link vertexvis.protobuf.stream.GracefulReconnectionResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionResult} message GracefulReconnectionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GracefulReconnectionResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified GracefulReconnectionResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.GracefulReconnectionResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IGracefulReconnectionResult} message GracefulReconnectionResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GracefulReconnectionResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GracefulReconnectionResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionResult} GracefulReconnectionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GracefulReconnectionResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.GracefulReconnectionResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GracefulReconnectionResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionResult} GracefulReconnectionResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GracefulReconnectionResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GracefulReconnectionResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GracefulReconnectionResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a GracefulReconnectionResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.GracefulReconnectionResult} GracefulReconnectionResult
                 */
                GracefulReconnectionResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.GracefulReconnectionResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.GracefulReconnectionResult();
                };

                /**
                 * Creates a plain object from a GracefulReconnectionResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @static
                 * @param {vertexvis.protobuf.stream.GracefulReconnectionResult} message GracefulReconnectionResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GracefulReconnectionResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this GracefulReconnectionResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.GracefulReconnectionResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GracefulReconnectionResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GracefulReconnectionResult;
            })();

            stream.UpdateModelViewResult = (function() {

                /**
                 * Properties of an UpdateModelViewResult.
                 * @memberof vertexvis.protobuf.stream
                 * @interface IUpdateModelViewResult
                 */

                /**
                 * Constructs a new UpdateModelViewResult.
                 * @memberof vertexvis.protobuf.stream
                 * @classdesc Represents an UpdateModelViewResult.
                 * @implements IUpdateModelViewResult
                 * @constructor
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewResult=} [properties] Properties to set
                 */
                function UpdateModelViewResult(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new UpdateModelViewResult instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewResult=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewResult} UpdateModelViewResult instance
                 */
                UpdateModelViewResult.create = function create(properties) {
                    return new UpdateModelViewResult(properties);
                };

                /**
                 * Encodes the specified UpdateModelViewResult message. Does not implicitly {@link vertexvis.protobuf.stream.UpdateModelViewResult.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewResult} message UpdateModelViewResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateModelViewResult.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified UpdateModelViewResult message, length delimited. Does not implicitly {@link vertexvis.protobuf.stream.UpdateModelViewResult.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.IUpdateModelViewResult} message UpdateModelViewResult message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UpdateModelViewResult.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UpdateModelViewResult message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewResult} UpdateModelViewResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateModelViewResult.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.stream.UpdateModelViewResult();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UpdateModelViewResult message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewResult} UpdateModelViewResult
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UpdateModelViewResult.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UpdateModelViewResult message.
                 * @function verify
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UpdateModelViewResult.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an UpdateModelViewResult message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.stream.UpdateModelViewResult} UpdateModelViewResult
                 */
                UpdateModelViewResult.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.stream.UpdateModelViewResult)
                        return object;
                    return new $root.vertexvis.protobuf.stream.UpdateModelViewResult();
                };

                /**
                 * Creates a plain object from an UpdateModelViewResult message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @static
                 * @param {vertexvis.protobuf.stream.UpdateModelViewResult} message UpdateModelViewResult
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UpdateModelViewResult.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this UpdateModelViewResult to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.stream.UpdateModelViewResult
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UpdateModelViewResult.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UpdateModelViewResult;
            })();

            return stream;
        })();

        protobuf.core = (function() {

            /**
             * Namespace core.
             * @memberof vertexvis.protobuf
             * @namespace
             */
            const core = {};

            core.Vector2i = (function() {

                /**
                 * Properties of a Vector2i.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector2i
                 * @property {number|null} [x] Vector2i x
                 * @property {number|null} [y] Vector2i y
                 */

                /**
                 * Constructs a new Vector2i.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector2i.
                 * @implements IVector2i
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector2i=} [properties] Properties to set
                 */
                function Vector2i(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector2i x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @instance
                 */
                Vector2i.prototype.x = 0;

                /**
                 * Vector2i y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @instance
                 */
                Vector2i.prototype.y = 0;

                /**
                 * Creates a new Vector2i instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2i=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector2i} Vector2i instance
                 */
                Vector2i.create = function create(properties) {
                    return new Vector2i(properties);
                };

                /**
                 * Encodes the specified Vector2i message. Does not implicitly {@link vertexvis.protobuf.core.Vector2i.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2i} message Vector2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2i.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.y);
                    return writer;
                };

                /**
                 * Encodes the specified Vector2i message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector2i.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2i} message Vector2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2i.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector2i message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector2i} Vector2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2i.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector2i();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.int32();
                            break;
                        case 2:
                            message.y = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector2i message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector2i} Vector2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2i.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector2i message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector2i.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (!$util.isInteger(message.x))
                            return "x: integer expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (!$util.isInteger(message.y))
                            return "y: integer expected";
                    return null;
                };

                /**
                 * Creates a Vector2i message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector2i} Vector2i
                 */
                Vector2i.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector2i)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector2i();
                    if (object.x != null)
                        message.x = object.x | 0;
                    if (object.y != null)
                        message.y = object.y | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Vector2i message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @static
                 * @param {vertexvis.protobuf.core.Vector2i} message Vector2i
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector2i.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = message.y;
                    return object;
                };

                /**
                 * Converts this Vector2i to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector2i
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector2i.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector2i;
            })();

            core.Vector2f = (function() {

                /**
                 * Properties of a Vector2f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector2f
                 * @property {number|null} [x] Vector2f x
                 * @property {number|null} [y] Vector2f y
                 */

                /**
                 * Constructs a new Vector2f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector2f.
                 * @implements IVector2f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector2f=} [properties] Properties to set
                 */
                function Vector2f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector2f x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @instance
                 */
                Vector2f.prototype.x = 0;

                /**
                 * Vector2f y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @instance
                 */
                Vector2f.prototype.y = 0;

                /**
                 * Creates a new Vector2f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector2f} Vector2f instance
                 */
                Vector2f.create = function create(properties) {
                    return new Vector2f(properties);
                };

                /**
                 * Encodes the specified Vector2f message. Does not implicitly {@link vertexvis.protobuf.core.Vector2f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2f} message Vector2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                    return writer;
                };

                /**
                 * Encodes the specified Vector2f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector2f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2f} message Vector2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector2f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector2f} Vector2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector2f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.float();
                            break;
                        case 2:
                            message.y = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector2f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector2f} Vector2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector2f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector2f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    return null;
                };

                /**
                 * Creates a Vector2f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector2f} Vector2f
                 */
                Vector2f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector2f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector2f();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector2f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @static
                 * @param {vertexvis.protobuf.core.Vector2f} message Vector2f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector2f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    return object;
                };

                /**
                 * Converts this Vector2f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector2f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector2f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector2f;
            })();

            core.Vector2d = (function() {

                /**
                 * Properties of a Vector2d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector2d
                 * @property {number|null} [x] Vector2d x
                 * @property {number|null} [y] Vector2d y
                 */

                /**
                 * Constructs a new Vector2d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector2d.
                 * @implements IVector2d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector2d=} [properties] Properties to set
                 */
                function Vector2d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector2d x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @instance
                 */
                Vector2d.prototype.x = 0;

                /**
                 * Vector2d y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @instance
                 */
                Vector2d.prototype.y = 0;

                /**
                 * Creates a new Vector2d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector2d} Vector2d instance
                 */
                Vector2d.create = function create(properties) {
                    return new Vector2d(properties);
                };

                /**
                 * Encodes the specified Vector2d message. Does not implicitly {@link vertexvis.protobuf.core.Vector2d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2d} message Vector2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 1 =*/9).double(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.y);
                    return writer;
                };

                /**
                 * Encodes the specified Vector2d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector2d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector2d} message Vector2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector2d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector2d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector2d} Vector2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector2d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.double();
                            break;
                        case 2:
                            message.y = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector2d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector2d} Vector2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector2d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector2d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector2d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    return null;
                };

                /**
                 * Creates a Vector2d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector2d} Vector2d
                 */
                Vector2d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector2d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector2d();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector2d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @static
                 * @param {vertexvis.protobuf.core.Vector2d} message Vector2d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector2d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    return object;
                };

                /**
                 * Converts this Vector2d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector2d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector2d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector2d;
            })();

            core.Vector3f = (function() {

                /**
                 * Properties of a Vector3f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector3f
                 * @property {number|null} [x] Vector3f x
                 * @property {number|null} [y] Vector3f y
                 * @property {number|null} [z] Vector3f z
                 */

                /**
                 * Constructs a new Vector3f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector3f.
                 * @implements IVector3f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector3f=} [properties] Properties to set
                 */
                function Vector3f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector3f x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @instance
                 */
                Vector3f.prototype.x = 0;

                /**
                 * Vector3f y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @instance
                 */
                Vector3f.prototype.y = 0;

                /**
                 * Vector3f z.
                 * @member {number} z
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @instance
                 */
                Vector3f.prototype.z = 0;

                /**
                 * Creates a new Vector3f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector3f} Vector3f instance
                 */
                Vector3f.create = function create(properties) {
                    return new Vector3f(properties);
                };

                /**
                 * Encodes the specified Vector3f message. Does not implicitly {@link vertexvis.protobuf.core.Vector3f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3f} message Vector3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector3f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                    if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.z);
                    return writer;
                };

                /**
                 * Encodes the specified Vector3f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector3f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3f} message Vector3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector3f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector3f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector3f} Vector3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector3f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector3f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.float();
                            break;
                        case 2:
                            message.y = reader.float();
                            break;
                        case 3:
                            message.z = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector3f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector3f} Vector3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector3f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector3f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector3f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    if (message.z != null && message.hasOwnProperty("z"))
                        if (typeof message.z !== "number")
                            return "z: number expected";
                    return null;
                };

                /**
                 * Creates a Vector3f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector3f} Vector3f
                 */
                Vector3f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector3f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector3f();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    if (object.z != null)
                        message.z = Number(object.z);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector3f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @static
                 * @param {vertexvis.protobuf.core.Vector3f} message Vector3f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector3f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                        object.z = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    if (message.z != null && message.hasOwnProperty("z"))
                        object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                    return object;
                };

                /**
                 * Converts this Vector3f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector3f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector3f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector3f;
            })();

            core.Vector3d = (function() {

                /**
                 * Properties of a Vector3d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector3d
                 * @property {number|null} [x] Vector3d x
                 * @property {number|null} [y] Vector3d y
                 * @property {number|null} [z] Vector3d z
                 */

                /**
                 * Constructs a new Vector3d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector3d.
                 * @implements IVector3d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector3d=} [properties] Properties to set
                 */
                function Vector3d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector3d x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @instance
                 */
                Vector3d.prototype.x = 0;

                /**
                 * Vector3d y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @instance
                 */
                Vector3d.prototype.y = 0;

                /**
                 * Vector3d z.
                 * @member {number} z
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @instance
                 */
                Vector3d.prototype.z = 0;

                /**
                 * Creates a new Vector3d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector3d} Vector3d instance
                 */
                Vector3d.create = function create(properties) {
                    return new Vector3d(properties);
                };

                /**
                 * Encodes the specified Vector3d message. Does not implicitly {@link vertexvis.protobuf.core.Vector3d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3d} message Vector3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector3d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 1 =*/9).double(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.y);
                    if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.z);
                    return writer;
                };

                /**
                 * Encodes the specified Vector3d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector3d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector3d} message Vector3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector3d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector3d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector3d} Vector3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector3d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector3d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.double();
                            break;
                        case 2:
                            message.y = reader.double();
                            break;
                        case 3:
                            message.z = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector3d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector3d} Vector3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector3d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector3d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector3d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    if (message.z != null && message.hasOwnProperty("z"))
                        if (typeof message.z !== "number")
                            return "z: number expected";
                    return null;
                };

                /**
                 * Creates a Vector3d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector3d} Vector3d
                 */
                Vector3d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector3d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector3d();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    if (object.z != null)
                        message.z = Number(object.z);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector3d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @static
                 * @param {vertexvis.protobuf.core.Vector3d} message Vector3d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector3d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                        object.z = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    if (message.z != null && message.hasOwnProperty("z"))
                        object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                    return object;
                };

                /**
                 * Converts this Vector3d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector3d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector3d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector3d;
            })();

            core.Vector4f = (function() {

                /**
                 * Properties of a Vector4f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector4f
                 * @property {number|null} [x] Vector4f x
                 * @property {number|null} [y] Vector4f y
                 * @property {number|null} [z] Vector4f z
                 * @property {number|null} [w] Vector4f w
                 */

                /**
                 * Constructs a new Vector4f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector4f.
                 * @implements IVector4f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector4f=} [properties] Properties to set
                 */
                function Vector4f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector4f x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @instance
                 */
                Vector4f.prototype.x = 0;

                /**
                 * Vector4f y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @instance
                 */
                Vector4f.prototype.y = 0;

                /**
                 * Vector4f z.
                 * @member {number} z
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @instance
                 */
                Vector4f.prototype.z = 0;

                /**
                 * Vector4f w.
                 * @member {number} w
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @instance
                 */
                Vector4f.prototype.w = 0;

                /**
                 * Creates a new Vector4f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector4f} Vector4f instance
                 */
                Vector4f.create = function create(properties) {
                    return new Vector4f(properties);
                };

                /**
                 * Encodes the specified Vector4f message. Does not implicitly {@link vertexvis.protobuf.core.Vector4f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4f} message Vector4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector4f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                    if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.z);
                    if (message.w != null && Object.hasOwnProperty.call(message, "w"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.w);
                    return writer;
                };

                /**
                 * Encodes the specified Vector4f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector4f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4f} message Vector4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector4f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector4f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector4f} Vector4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector4f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector4f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.float();
                            break;
                        case 2:
                            message.y = reader.float();
                            break;
                        case 3:
                            message.z = reader.float();
                            break;
                        case 4:
                            message.w = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector4f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector4f} Vector4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector4f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector4f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector4f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    if (message.z != null && message.hasOwnProperty("z"))
                        if (typeof message.z !== "number")
                            return "z: number expected";
                    if (message.w != null && message.hasOwnProperty("w"))
                        if (typeof message.w !== "number")
                            return "w: number expected";
                    return null;
                };

                /**
                 * Creates a Vector4f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector4f} Vector4f
                 */
                Vector4f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector4f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector4f();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    if (object.z != null)
                        message.z = Number(object.z);
                    if (object.w != null)
                        message.w = Number(object.w);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector4f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @static
                 * @param {vertexvis.protobuf.core.Vector4f} message Vector4f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector4f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                        object.z = 0;
                        object.w = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    if (message.z != null && message.hasOwnProperty("z"))
                        object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                    if (message.w != null && message.hasOwnProperty("w"))
                        object.w = options.json && !isFinite(message.w) ? String(message.w) : message.w;
                    return object;
                };

                /**
                 * Converts this Vector4f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector4f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector4f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector4f;
            })();

            core.Vector4d = (function() {

                /**
                 * Properties of a Vector4d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IVector4d
                 * @property {number|null} [x] Vector4d x
                 * @property {number|null} [y] Vector4d y
                 * @property {number|null} [z] Vector4d z
                 * @property {number|null} [w] Vector4d w
                 */

                /**
                 * Constructs a new Vector4d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Vector4d.
                 * @implements IVector4d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IVector4d=} [properties] Properties to set
                 */
                function Vector4d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Vector4d x.
                 * @member {number} x
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @instance
                 */
                Vector4d.prototype.x = 0;

                /**
                 * Vector4d y.
                 * @member {number} y
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @instance
                 */
                Vector4d.prototype.y = 0;

                /**
                 * Vector4d z.
                 * @member {number} z
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @instance
                 */
                Vector4d.prototype.z = 0;

                /**
                 * Vector4d w.
                 * @member {number} w
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @instance
                 */
                Vector4d.prototype.w = 0;

                /**
                 * Creates a new Vector4d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Vector4d} Vector4d instance
                 */
                Vector4d.create = function create(properties) {
                    return new Vector4d(properties);
                };

                /**
                 * Encodes the specified Vector4d message. Does not implicitly {@link vertexvis.protobuf.core.Vector4d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4d} message Vector4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector4d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                        writer.uint32(/* id 1, wireType 1 =*/9).double(message.x);
                    if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.y);
                    if (message.z != null && Object.hasOwnProperty.call(message, "z"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.z);
                    if (message.w != null && Object.hasOwnProperty.call(message, "w"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.w);
                    return writer;
                };

                /**
                 * Encodes the specified Vector4d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Vector4d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {vertexvis.protobuf.core.IVector4d} message Vector4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Vector4d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Vector4d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Vector4d} Vector4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector4d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Vector4d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.x = reader.double();
                            break;
                        case 2:
                            message.y = reader.double();
                            break;
                        case 3:
                            message.z = reader.double();
                            break;
                        case 4:
                            message.w = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Vector4d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Vector4d} Vector4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Vector4d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Vector4d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Vector4d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.x != null && message.hasOwnProperty("x"))
                        if (typeof message.x !== "number")
                            return "x: number expected";
                    if (message.y != null && message.hasOwnProperty("y"))
                        if (typeof message.y !== "number")
                            return "y: number expected";
                    if (message.z != null && message.hasOwnProperty("z"))
                        if (typeof message.z !== "number")
                            return "z: number expected";
                    if (message.w != null && message.hasOwnProperty("w"))
                        if (typeof message.w !== "number")
                            return "w: number expected";
                    return null;
                };

                /**
                 * Creates a Vector4d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Vector4d} Vector4d
                 */
                Vector4d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Vector4d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Vector4d();
                    if (object.x != null)
                        message.x = Number(object.x);
                    if (object.y != null)
                        message.y = Number(object.y);
                    if (object.z != null)
                        message.z = Number(object.z);
                    if (object.w != null)
                        message.w = Number(object.w);
                    return message;
                };

                /**
                 * Creates a plain object from a Vector4d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @static
                 * @param {vertexvis.protobuf.core.Vector4d} message Vector4d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Vector4d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.x = 0;
                        object.y = 0;
                        object.z = 0;
                        object.w = 0;
                    }
                    if (message.x != null && message.hasOwnProperty("x"))
                        object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                    if (message.y != null && message.hasOwnProperty("y"))
                        object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                    if (message.z != null && message.hasOwnProperty("z"))
                        object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                    if (message.w != null && message.hasOwnProperty("w"))
                        object.w = options.json && !isFinite(message.w) ? String(message.w) : message.w;
                    return object;
                };

                /**
                 * Converts this Vector4d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Vector4d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Vector4d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Vector4d;
            })();

            core.BoundingBox3f = (function() {

                /**
                 * Properties of a BoundingBox3f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBoundingBox3f
                 * @property {number|null} [xmin] BoundingBox3f xmin
                 * @property {number|null} [xmax] BoundingBox3f xmax
                 * @property {number|null} [ymin] BoundingBox3f ymin
                 * @property {number|null} [ymax] BoundingBox3f ymax
                 * @property {number|null} [zmin] BoundingBox3f zmin
                 * @property {number|null} [zmax] BoundingBox3f zmax
                 */

                /**
                 * Constructs a new BoundingBox3f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BoundingBox3f.
                 * @implements IBoundingBox3f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBoundingBox3f=} [properties] Properties to set
                 */
                function BoundingBox3f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BoundingBox3f xmin.
                 * @member {number} xmin
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.xmin = 0;

                /**
                 * BoundingBox3f xmax.
                 * @member {number} xmax
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.xmax = 0;

                /**
                 * BoundingBox3f ymin.
                 * @member {number} ymin
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.ymin = 0;

                /**
                 * BoundingBox3f ymax.
                 * @member {number} ymax
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.ymax = 0;

                /**
                 * BoundingBox3f zmin.
                 * @member {number} zmin
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.zmin = 0;

                /**
                 * BoundingBox3f zmax.
                 * @member {number} zmax
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 */
                BoundingBox3f.prototype.zmax = 0;

                /**
                 * Creates a new BoundingBox3f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBoundingBox3f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BoundingBox3f} BoundingBox3f instance
                 */
                BoundingBox3f.create = function create(properties) {
                    return new BoundingBox3f(properties);
                };

                /**
                 * Encodes the specified BoundingBox3f message. Does not implicitly {@link vertexvis.protobuf.core.BoundingBox3f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBoundingBox3f} message BoundingBox3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BoundingBox3f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.xmin != null && Object.hasOwnProperty.call(message, "xmin"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.xmin);
                    if (message.xmax != null && Object.hasOwnProperty.call(message, "xmax"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.xmax);
                    if (message.ymin != null && Object.hasOwnProperty.call(message, "ymin"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.ymin);
                    if (message.ymax != null && Object.hasOwnProperty.call(message, "ymax"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.ymax);
                    if (message.zmin != null && Object.hasOwnProperty.call(message, "zmin"))
                        writer.uint32(/* id 5, wireType 5 =*/45).float(message.zmin);
                    if (message.zmax != null && Object.hasOwnProperty.call(message, "zmax"))
                        writer.uint32(/* id 6, wireType 5 =*/53).float(message.zmax);
                    return writer;
                };

                /**
                 * Encodes the specified BoundingBox3f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BoundingBox3f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBoundingBox3f} message BoundingBox3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BoundingBox3f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BoundingBox3f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BoundingBox3f} BoundingBox3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BoundingBox3f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BoundingBox3f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.xmin = reader.float();
                            break;
                        case 2:
                            message.xmax = reader.float();
                            break;
                        case 3:
                            message.ymin = reader.float();
                            break;
                        case 4:
                            message.ymax = reader.float();
                            break;
                        case 5:
                            message.zmin = reader.float();
                            break;
                        case 6:
                            message.zmax = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BoundingBox3f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BoundingBox3f} BoundingBox3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BoundingBox3f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BoundingBox3f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BoundingBox3f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.xmin != null && message.hasOwnProperty("xmin"))
                        if (typeof message.xmin !== "number")
                            return "xmin: number expected";
                    if (message.xmax != null && message.hasOwnProperty("xmax"))
                        if (typeof message.xmax !== "number")
                            return "xmax: number expected";
                    if (message.ymin != null && message.hasOwnProperty("ymin"))
                        if (typeof message.ymin !== "number")
                            return "ymin: number expected";
                    if (message.ymax != null && message.hasOwnProperty("ymax"))
                        if (typeof message.ymax !== "number")
                            return "ymax: number expected";
                    if (message.zmin != null && message.hasOwnProperty("zmin"))
                        if (typeof message.zmin !== "number")
                            return "zmin: number expected";
                    if (message.zmax != null && message.hasOwnProperty("zmax"))
                        if (typeof message.zmax !== "number")
                            return "zmax: number expected";
                    return null;
                };

                /**
                 * Creates a BoundingBox3f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BoundingBox3f} BoundingBox3f
                 */
                BoundingBox3f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BoundingBox3f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BoundingBox3f();
                    if (object.xmin != null)
                        message.xmin = Number(object.xmin);
                    if (object.xmax != null)
                        message.xmax = Number(object.xmax);
                    if (object.ymin != null)
                        message.ymin = Number(object.ymin);
                    if (object.ymax != null)
                        message.ymax = Number(object.ymax);
                    if (object.zmin != null)
                        message.zmin = Number(object.zmin);
                    if (object.zmax != null)
                        message.zmax = Number(object.zmax);
                    return message;
                };

                /**
                 * Creates a plain object from a BoundingBox3f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.BoundingBox3f} message BoundingBox3f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BoundingBox3f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.xmin = 0;
                        object.xmax = 0;
                        object.ymin = 0;
                        object.ymax = 0;
                        object.zmin = 0;
                        object.zmax = 0;
                    }
                    if (message.xmin != null && message.hasOwnProperty("xmin"))
                        object.xmin = options.json && !isFinite(message.xmin) ? String(message.xmin) : message.xmin;
                    if (message.xmax != null && message.hasOwnProperty("xmax"))
                        object.xmax = options.json && !isFinite(message.xmax) ? String(message.xmax) : message.xmax;
                    if (message.ymin != null && message.hasOwnProperty("ymin"))
                        object.ymin = options.json && !isFinite(message.ymin) ? String(message.ymin) : message.ymin;
                    if (message.ymax != null && message.hasOwnProperty("ymax"))
                        object.ymax = options.json && !isFinite(message.ymax) ? String(message.ymax) : message.ymax;
                    if (message.zmin != null && message.hasOwnProperty("zmin"))
                        object.zmin = options.json && !isFinite(message.zmin) ? String(message.zmin) : message.zmin;
                    if (message.zmax != null && message.hasOwnProperty("zmax"))
                        object.zmax = options.json && !isFinite(message.zmax) ? String(message.zmax) : message.zmax;
                    return object;
                };

                /**
                 * Converts this BoundingBox3f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BoundingBox3f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BoundingBox3f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BoundingBox3f;
            })();

            core.AffineMatrix4f = (function() {

                /**
                 * Properties of an AffineMatrix4f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineMatrix4f
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisX] AffineMatrix4f basisX
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisY] AffineMatrix4f basisY
                 * @property {vertexvis.protobuf.core.IVector3f|null} [xlate] AffineMatrix4f xlate
                 * @property {number|null} [scale] AffineMatrix4f scale
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisZ] AffineMatrix4f basisZ
                 */

                /**
                 * Constructs a new AffineMatrix4f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineMatrix4f.
                 * @implements IAffineMatrix4f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineMatrix4f=} [properties] Properties to set
                 */
                function AffineMatrix4f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineMatrix4f basisX.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 */
                AffineMatrix4f.prototype.basisX = null;

                /**
                 * AffineMatrix4f basisY.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 */
                AffineMatrix4f.prototype.basisY = null;

                /**
                 * AffineMatrix4f xlate.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} xlate
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 */
                AffineMatrix4f.prototype.xlate = null;

                /**
                 * AffineMatrix4f scale.
                 * @member {number} scale
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 */
                AffineMatrix4f.prototype.scale = 0;

                /**
                 * AffineMatrix4f basisZ.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisZ
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 */
                AffineMatrix4f.prototype.basisZ = null;

                /**
                 * Creates a new AffineMatrix4f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineMatrix4f} AffineMatrix4f instance
                 */
                AffineMatrix4f.create = function create(properties) {
                    return new AffineMatrix4f(properties);
                };

                /**
                 * Encodes the specified AffineMatrix4f message. Does not implicitly {@link vertexvis.protobuf.core.AffineMatrix4f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4f} message AffineMatrix4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineMatrix4f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.xlate != null && Object.hasOwnProperty.call(message, "xlate"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.xlate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.scale != null && Object.hasOwnProperty.call(message, "scale"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.scale);
                    if (message.basisZ != null && Object.hasOwnProperty.call(message, "basisZ"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisZ, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineMatrix4f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineMatrix4f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4f} message AffineMatrix4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineMatrix4f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineMatrix4f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineMatrix4f} AffineMatrix4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineMatrix4f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineMatrix4f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.xlate = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.scale = reader.float();
                            break;
                        case 5:
                            message.basisZ = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineMatrix4f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineMatrix4f} AffineMatrix4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineMatrix4f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineMatrix4f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineMatrix4f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    if (message.xlate != null && message.hasOwnProperty("xlate")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.xlate);
                        if (error)
                            return "xlate." + error;
                    }
                    if (message.scale != null && message.hasOwnProperty("scale"))
                        if (typeof message.scale !== "number")
                            return "scale: number expected";
                    if (message.basisZ != null && message.hasOwnProperty("basisZ")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisZ);
                        if (error)
                            return "basisZ." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineMatrix4f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineMatrix4f} AffineMatrix4f
                 */
                AffineMatrix4f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineMatrix4f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineMatrix4f();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4f.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4f.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisY);
                    }
                    if (object.xlate != null) {
                        if (typeof object.xlate !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4f.xlate: object expected");
                        message.xlate = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.xlate);
                    }
                    if (object.scale != null)
                        message.scale = Number(object.scale);
                    if (object.basisZ != null) {
                        if (typeof object.basisZ !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4f.basisZ: object expected");
                        message.basisZ = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisZ);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineMatrix4f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @static
                 * @param {vertexvis.protobuf.core.AffineMatrix4f} message AffineMatrix4f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineMatrix4f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                        object.xlate = null;
                        object.scale = 0;
                        object.basisZ = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisY, options);
                    if (message.xlate != null && message.hasOwnProperty("xlate"))
                        object.xlate = $root.vertexvis.protobuf.core.Vector3f.toObject(message.xlate, options);
                    if (message.scale != null && message.hasOwnProperty("scale"))
                        object.scale = options.json && !isFinite(message.scale) ? String(message.scale) : message.scale;
                    if (message.basisZ != null && message.hasOwnProperty("basisZ"))
                        object.basisZ = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisZ, options);
                    return object;
                };

                /**
                 * Converts this AffineMatrix4f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineMatrix4f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineMatrix4f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineMatrix4f;
            })();

            core.AffineMatrix4d = (function() {

                /**
                 * Properties of an AffineMatrix4d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineMatrix4d
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisX] AffineMatrix4d basisX
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisY] AffineMatrix4d basisY
                 * @property {vertexvis.protobuf.core.IVector3d|null} [xlate] AffineMatrix4d xlate
                 * @property {number|null} [scale] AffineMatrix4d scale
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisZ] AffineMatrix4d basisZ
                 */

                /**
                 * Constructs a new AffineMatrix4d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineMatrix4d.
                 * @implements IAffineMatrix4d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineMatrix4d=} [properties] Properties to set
                 */
                function AffineMatrix4d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineMatrix4d basisX.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 */
                AffineMatrix4d.prototype.basisX = null;

                /**
                 * AffineMatrix4d basisY.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 */
                AffineMatrix4d.prototype.basisY = null;

                /**
                 * AffineMatrix4d xlate.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} xlate
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 */
                AffineMatrix4d.prototype.xlate = null;

                /**
                 * AffineMatrix4d scale.
                 * @member {number} scale
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 */
                AffineMatrix4d.prototype.scale = 0;

                /**
                 * AffineMatrix4d basisZ.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisZ
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 */
                AffineMatrix4d.prototype.basisZ = null;

                /**
                 * Creates a new AffineMatrix4d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineMatrix4d} AffineMatrix4d instance
                 */
                AffineMatrix4d.create = function create(properties) {
                    return new AffineMatrix4d(properties);
                };

                /**
                 * Encodes the specified AffineMatrix4d message. Does not implicitly {@link vertexvis.protobuf.core.AffineMatrix4d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4d} message AffineMatrix4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineMatrix4d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.xlate != null && Object.hasOwnProperty.call(message, "xlate"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.xlate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.scale != null && Object.hasOwnProperty.call(message, "scale"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.scale);
                    if (message.basisZ != null && Object.hasOwnProperty.call(message, "basisZ"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisZ, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineMatrix4d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineMatrix4d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineMatrix4d} message AffineMatrix4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineMatrix4d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineMatrix4d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineMatrix4d} AffineMatrix4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineMatrix4d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineMatrix4d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.xlate = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.scale = reader.double();
                            break;
                        case 5:
                            message.basisZ = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineMatrix4d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineMatrix4d} AffineMatrix4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineMatrix4d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineMatrix4d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineMatrix4d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    if (message.xlate != null && message.hasOwnProperty("xlate")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.xlate);
                        if (error)
                            return "xlate." + error;
                    }
                    if (message.scale != null && message.hasOwnProperty("scale"))
                        if (typeof message.scale !== "number")
                            return "scale: number expected";
                    if (message.basisZ != null && message.hasOwnProperty("basisZ")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisZ);
                        if (error)
                            return "basisZ." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineMatrix4d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineMatrix4d} AffineMatrix4d
                 */
                AffineMatrix4d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineMatrix4d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineMatrix4d();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4d.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4d.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisY);
                    }
                    if (object.xlate != null) {
                        if (typeof object.xlate !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4d.xlate: object expected");
                        message.xlate = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.xlate);
                    }
                    if (object.scale != null)
                        message.scale = Number(object.scale);
                    if (object.basisZ != null) {
                        if (typeof object.basisZ !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineMatrix4d.basisZ: object expected");
                        message.basisZ = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisZ);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineMatrix4d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @static
                 * @param {vertexvis.protobuf.core.AffineMatrix4d} message AffineMatrix4d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineMatrix4d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                        object.xlate = null;
                        object.scale = 0;
                        object.basisZ = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisY, options);
                    if (message.xlate != null && message.hasOwnProperty("xlate"))
                        object.xlate = $root.vertexvis.protobuf.core.Vector3d.toObject(message.xlate, options);
                    if (message.scale != null && message.hasOwnProperty("scale"))
                        object.scale = options.json && !isFinite(message.scale) ? String(message.scale) : message.scale;
                    if (message.basisZ != null && message.hasOwnProperty("basisZ"))
                        object.basisZ = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisZ, options);
                    return object;
                };

                /**
                 * Converts this AffineMatrix4d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineMatrix4d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineMatrix4d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineMatrix4d;
            })();

            core.IndexedVector3fArray = (function() {

                /**
                 * Properties of an IndexedVector3fArray.
                 * @memberof vertexvis.protobuf.core
                 * @interface IIndexedVector3fArray
                 * @property {Array.<vertexvis.protobuf.core.IVector3f>|null} [values] IndexedVector3fArray values
                 * @property {Array.<number>|null} [indices] IndexedVector3fArray indices
                 */

                /**
                 * Constructs a new IndexedVector3fArray.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an IndexedVector3fArray.
                 * @implements IIndexedVector3fArray
                 * @constructor
                 * @param {vertexvis.protobuf.core.IIndexedVector3fArray=} [properties] Properties to set
                 */
                function IndexedVector3fArray(properties) {
                    this.values = [];
                    this.indices = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IndexedVector3fArray values.
                 * @member {Array.<vertexvis.protobuf.core.IVector3f>} values
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @instance
                 */
                IndexedVector3fArray.prototype.values = $util.emptyArray;

                /**
                 * IndexedVector3fArray indices.
                 * @member {Array.<number>} indices
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @instance
                 */
                IndexedVector3fArray.prototype.indices = $util.emptyArray;

                /**
                 * Creates a new IndexedVector3fArray instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexedVector3fArray=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.IndexedVector3fArray} IndexedVector3fArray instance
                 */
                IndexedVector3fArray.create = function create(properties) {
                    return new IndexedVector3fArray(properties);
                };

                /**
                 * Encodes the specified IndexedVector3fArray message. Does not implicitly {@link vertexvis.protobuf.core.IndexedVector3fArray.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexedVector3fArray} message IndexedVector3fArray message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IndexedVector3fArray.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.values != null && message.values.length)
                        for (let i = 0; i < message.values.length; ++i)
                            $root.vertexvis.protobuf.core.Vector3f.encode(message.values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.indices != null && message.indices.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (let i = 0; i < message.indices.length; ++i)
                            writer.uint32(message.indices[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified IndexedVector3fArray message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.IndexedVector3fArray.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexedVector3fArray} message IndexedVector3fArray message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IndexedVector3fArray.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an IndexedVector3fArray message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.IndexedVector3fArray} IndexedVector3fArray
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IndexedVector3fArray.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.IndexedVector3fArray();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.values && message.values.length))
                                message.values = [];
                            message.values.push($root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.indices && message.indices.length))
                                message.indices = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.indices.push(reader.uint32());
                            } else
                                message.indices.push(reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an IndexedVector3fArray message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.IndexedVector3fArray} IndexedVector3fArray
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IndexedVector3fArray.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an IndexedVector3fArray message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                IndexedVector3fArray.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.values != null && message.hasOwnProperty("values")) {
                        if (!Array.isArray(message.values))
                            return "values: array expected";
                        for (let i = 0; i < message.values.length; ++i) {
                            let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.values[i]);
                            if (error)
                                return "values." + error;
                        }
                    }
                    if (message.indices != null && message.hasOwnProperty("indices")) {
                        if (!Array.isArray(message.indices))
                            return "indices: array expected";
                        for (let i = 0; i < message.indices.length; ++i)
                            if (!$util.isInteger(message.indices[i]))
                                return "indices: integer[] expected";
                    }
                    return null;
                };

                /**
                 * Creates an IndexedVector3fArray message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.IndexedVector3fArray} IndexedVector3fArray
                 */
                IndexedVector3fArray.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.IndexedVector3fArray)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.IndexedVector3fArray();
                    if (object.values) {
                        if (!Array.isArray(object.values))
                            throw TypeError(".vertexvis.protobuf.core.IndexedVector3fArray.values: array expected");
                        message.values = [];
                        for (let i = 0; i < object.values.length; ++i) {
                            if (typeof object.values[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.core.IndexedVector3fArray.values: object expected");
                            message.values[i] = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.values[i]);
                        }
                    }
                    if (object.indices) {
                        if (!Array.isArray(object.indices))
                            throw TypeError(".vertexvis.protobuf.core.IndexedVector3fArray.indices: array expected");
                        message.indices = [];
                        for (let i = 0; i < object.indices.length; ++i)
                            message.indices[i] = object.indices[i] >>> 0;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an IndexedVector3fArray message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @static
                 * @param {vertexvis.protobuf.core.IndexedVector3fArray} message IndexedVector3fArray
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                IndexedVector3fArray.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.values = [];
                        object.indices = [];
                    }
                    if (message.values && message.values.length) {
                        object.values = [];
                        for (let j = 0; j < message.values.length; ++j)
                            object.values[j] = $root.vertexvis.protobuf.core.Vector3f.toObject(message.values[j], options);
                    }
                    if (message.indices && message.indices.length) {
                        object.indices = [];
                        for (let j = 0; j < message.indices.length; ++j)
                            object.indices[j] = message.indices[j];
                    }
                    return object;
                };

                /**
                 * Converts this IndexedVector3fArray to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.IndexedVector3fArray
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                IndexedVector3fArray.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return IndexedVector3fArray;
            })();

            core.Indexed3DTriangleSet = (function() {

                /**
                 * Properties of an Indexed3DTriangleSet.
                 * @memberof vertexvis.protobuf.core
                 * @interface IIndexed3DTriangleSet
                 * @property {vertexvis.protobuf.core.IIndexedVector3fArray|null} [vertices] Indexed3DTriangleSet vertices
                 * @property {vertexvis.protobuf.core.IIndexedVector3fArray|null} [normals] Indexed3DTriangleSet normals
                 */

                /**
                 * Constructs a new Indexed3DTriangleSet.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an Indexed3DTriangleSet.
                 * @implements IIndexed3DTriangleSet
                 * @constructor
                 * @param {vertexvis.protobuf.core.IIndexed3DTriangleSet=} [properties] Properties to set
                 */
                function Indexed3DTriangleSet(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Indexed3DTriangleSet vertices.
                 * @member {vertexvis.protobuf.core.IIndexedVector3fArray|null|undefined} vertices
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @instance
                 */
                Indexed3DTriangleSet.prototype.vertices = null;

                /**
                 * Indexed3DTriangleSet normals.
                 * @member {vertexvis.protobuf.core.IIndexedVector3fArray|null|undefined} normals
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @instance
                 */
                Indexed3DTriangleSet.prototype.normals = null;

                /**
                 * Creates a new Indexed3DTriangleSet instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexed3DTriangleSet=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Indexed3DTriangleSet} Indexed3DTriangleSet instance
                 */
                Indexed3DTriangleSet.create = function create(properties) {
                    return new Indexed3DTriangleSet(properties);
                };

                /**
                 * Encodes the specified Indexed3DTriangleSet message. Does not implicitly {@link vertexvis.protobuf.core.Indexed3DTriangleSet.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexed3DTriangleSet} message Indexed3DTriangleSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Indexed3DTriangleSet.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.vertices != null && Object.hasOwnProperty.call(message, "vertices"))
                        $root.vertexvis.protobuf.core.IndexedVector3fArray.encode(message.vertices, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.normals != null && Object.hasOwnProperty.call(message, "normals"))
                        $root.vertexvis.protobuf.core.IndexedVector3fArray.encode(message.normals, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Indexed3DTriangleSet message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Indexed3DTriangleSet.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {vertexvis.protobuf.core.IIndexed3DTriangleSet} message Indexed3DTriangleSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Indexed3DTriangleSet.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Indexed3DTriangleSet message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Indexed3DTriangleSet} Indexed3DTriangleSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Indexed3DTriangleSet.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Indexed3DTriangleSet();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.vertices = $root.vertexvis.protobuf.core.IndexedVector3fArray.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.normals = $root.vertexvis.protobuf.core.IndexedVector3fArray.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Indexed3DTriangleSet message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Indexed3DTriangleSet} Indexed3DTriangleSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Indexed3DTriangleSet.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Indexed3DTriangleSet message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Indexed3DTriangleSet.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.vertices != null && message.hasOwnProperty("vertices")) {
                        let error = $root.vertexvis.protobuf.core.IndexedVector3fArray.verify(message.vertices);
                        if (error)
                            return "vertices." + error;
                    }
                    if (message.normals != null && message.hasOwnProperty("normals")) {
                        let error = $root.vertexvis.protobuf.core.IndexedVector3fArray.verify(message.normals);
                        if (error)
                            return "normals." + error;
                    }
                    return null;
                };

                /**
                 * Creates an Indexed3DTriangleSet message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Indexed3DTriangleSet} Indexed3DTriangleSet
                 */
                Indexed3DTriangleSet.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Indexed3DTriangleSet)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Indexed3DTriangleSet();
                    if (object.vertices != null) {
                        if (typeof object.vertices !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Indexed3DTriangleSet.vertices: object expected");
                        message.vertices = $root.vertexvis.protobuf.core.IndexedVector3fArray.fromObject(object.vertices);
                    }
                    if (object.normals != null) {
                        if (typeof object.normals !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Indexed3DTriangleSet.normals: object expected");
                        message.normals = $root.vertexvis.protobuf.core.IndexedVector3fArray.fromObject(object.normals);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an Indexed3DTriangleSet message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @static
                 * @param {vertexvis.protobuf.core.Indexed3DTriangleSet} message Indexed3DTriangleSet
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Indexed3DTriangleSet.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.vertices = null;
                        object.normals = null;
                    }
                    if (message.vertices != null && message.hasOwnProperty("vertices"))
                        object.vertices = $root.vertexvis.protobuf.core.IndexedVector3fArray.toObject(message.vertices, options);
                    if (message.normals != null && message.hasOwnProperty("normals"))
                        object.normals = $root.vertexvis.protobuf.core.IndexedVector3fArray.toObject(message.normals, options);
                    return object;
                };

                /**
                 * Converts this Indexed3DTriangleSet to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Indexed3DTriangleSet
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Indexed3DTriangleSet.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Indexed3DTriangleSet;
            })();

            core.Matrix4x4f = (function() {

                /**
                 * Properties of a Matrix4x4f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IMatrix4x4f
                 * @property {vertexvis.protobuf.core.IVector4f|null} [r0] Matrix4x4f r0
                 * @property {vertexvis.protobuf.core.IVector4f|null} [r1] Matrix4x4f r1
                 * @property {vertexvis.protobuf.core.IVector4f|null} [r2] Matrix4x4f r2
                 * @property {vertexvis.protobuf.core.IVector4f|null} [r3] Matrix4x4f r3
                 */

                /**
                 * Constructs a new Matrix4x4f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Matrix4x4f.
                 * @implements IMatrix4x4f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IMatrix4x4f=} [properties] Properties to set
                 */
                function Matrix4x4f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Matrix4x4f r0.
                 * @member {vertexvis.protobuf.core.IVector4f|null|undefined} r0
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @instance
                 */
                Matrix4x4f.prototype.r0 = null;

                /**
                 * Matrix4x4f r1.
                 * @member {vertexvis.protobuf.core.IVector4f|null|undefined} r1
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @instance
                 */
                Matrix4x4f.prototype.r1 = null;

                /**
                 * Matrix4x4f r2.
                 * @member {vertexvis.protobuf.core.IVector4f|null|undefined} r2
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @instance
                 */
                Matrix4x4f.prototype.r2 = null;

                /**
                 * Matrix4x4f r3.
                 * @member {vertexvis.protobuf.core.IVector4f|null|undefined} r3
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @instance
                 */
                Matrix4x4f.prototype.r3 = null;

                /**
                 * Creates a new Matrix4x4f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Matrix4x4f} Matrix4x4f instance
                 */
                Matrix4x4f.create = function create(properties) {
                    return new Matrix4x4f(properties);
                };

                /**
                 * Encodes the specified Matrix4x4f message. Does not implicitly {@link vertexvis.protobuf.core.Matrix4x4f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4f} message Matrix4x4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Matrix4x4f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.r0 != null && Object.hasOwnProperty.call(message, "r0"))
                        $root.vertexvis.protobuf.core.Vector4f.encode(message.r0, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.r1 != null && Object.hasOwnProperty.call(message, "r1"))
                        $root.vertexvis.protobuf.core.Vector4f.encode(message.r1, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.r2 != null && Object.hasOwnProperty.call(message, "r2"))
                        $root.vertexvis.protobuf.core.Vector4f.encode(message.r2, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.r3 != null && Object.hasOwnProperty.call(message, "r3"))
                        $root.vertexvis.protobuf.core.Vector4f.encode(message.r3, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Matrix4x4f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Matrix4x4f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4f} message Matrix4x4f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Matrix4x4f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Matrix4x4f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Matrix4x4f} Matrix4x4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Matrix4x4f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Matrix4x4f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.r0 = $root.vertexvis.protobuf.core.Vector4f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.r1 = $root.vertexvis.protobuf.core.Vector4f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.r2 = $root.vertexvis.protobuf.core.Vector4f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.r3 = $root.vertexvis.protobuf.core.Vector4f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Matrix4x4f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Matrix4x4f} Matrix4x4f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Matrix4x4f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Matrix4x4f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Matrix4x4f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.r0 != null && message.hasOwnProperty("r0")) {
                        let error = $root.vertexvis.protobuf.core.Vector4f.verify(message.r0);
                        if (error)
                            return "r0." + error;
                    }
                    if (message.r1 != null && message.hasOwnProperty("r1")) {
                        let error = $root.vertexvis.protobuf.core.Vector4f.verify(message.r1);
                        if (error)
                            return "r1." + error;
                    }
                    if (message.r2 != null && message.hasOwnProperty("r2")) {
                        let error = $root.vertexvis.protobuf.core.Vector4f.verify(message.r2);
                        if (error)
                            return "r2." + error;
                    }
                    if (message.r3 != null && message.hasOwnProperty("r3")) {
                        let error = $root.vertexvis.protobuf.core.Vector4f.verify(message.r3);
                        if (error)
                            return "r3." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Matrix4x4f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Matrix4x4f} Matrix4x4f
                 */
                Matrix4x4f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Matrix4x4f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Matrix4x4f();
                    if (object.r0 != null) {
                        if (typeof object.r0 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4f.r0: object expected");
                        message.r0 = $root.vertexvis.protobuf.core.Vector4f.fromObject(object.r0);
                    }
                    if (object.r1 != null) {
                        if (typeof object.r1 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4f.r1: object expected");
                        message.r1 = $root.vertexvis.protobuf.core.Vector4f.fromObject(object.r1);
                    }
                    if (object.r2 != null) {
                        if (typeof object.r2 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4f.r2: object expected");
                        message.r2 = $root.vertexvis.protobuf.core.Vector4f.fromObject(object.r2);
                    }
                    if (object.r3 != null) {
                        if (typeof object.r3 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4f.r3: object expected");
                        message.r3 = $root.vertexvis.protobuf.core.Vector4f.fromObject(object.r3);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Matrix4x4f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @static
                 * @param {vertexvis.protobuf.core.Matrix4x4f} message Matrix4x4f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Matrix4x4f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.r0 = null;
                        object.r1 = null;
                        object.r2 = null;
                        object.r3 = null;
                    }
                    if (message.r0 != null && message.hasOwnProperty("r0"))
                        object.r0 = $root.vertexvis.protobuf.core.Vector4f.toObject(message.r0, options);
                    if (message.r1 != null && message.hasOwnProperty("r1"))
                        object.r1 = $root.vertexvis.protobuf.core.Vector4f.toObject(message.r1, options);
                    if (message.r2 != null && message.hasOwnProperty("r2"))
                        object.r2 = $root.vertexvis.protobuf.core.Vector4f.toObject(message.r2, options);
                    if (message.r3 != null && message.hasOwnProperty("r3"))
                        object.r3 = $root.vertexvis.protobuf.core.Vector4f.toObject(message.r3, options);
                    return object;
                };

                /**
                 * Converts this Matrix4x4f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Matrix4x4f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Matrix4x4f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Matrix4x4f;
            })();

            core.Matrix4x4d = (function() {

                /**
                 * Properties of a Matrix4x4d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IMatrix4x4d
                 * @property {vertexvis.protobuf.core.IVector4d|null} [r0] Matrix4x4d r0
                 * @property {vertexvis.protobuf.core.IVector4d|null} [r1] Matrix4x4d r1
                 * @property {vertexvis.protobuf.core.IVector4d|null} [r2] Matrix4x4d r2
                 * @property {vertexvis.protobuf.core.IVector4d|null} [r3] Matrix4x4d r3
                 */

                /**
                 * Constructs a new Matrix4x4d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Matrix4x4d.
                 * @implements IMatrix4x4d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IMatrix4x4d=} [properties] Properties to set
                 */
                function Matrix4x4d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Matrix4x4d r0.
                 * @member {vertexvis.protobuf.core.IVector4d|null|undefined} r0
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @instance
                 */
                Matrix4x4d.prototype.r0 = null;

                /**
                 * Matrix4x4d r1.
                 * @member {vertexvis.protobuf.core.IVector4d|null|undefined} r1
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @instance
                 */
                Matrix4x4d.prototype.r1 = null;

                /**
                 * Matrix4x4d r2.
                 * @member {vertexvis.protobuf.core.IVector4d|null|undefined} r2
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @instance
                 */
                Matrix4x4d.prototype.r2 = null;

                /**
                 * Matrix4x4d r3.
                 * @member {vertexvis.protobuf.core.IVector4d|null|undefined} r3
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @instance
                 */
                Matrix4x4d.prototype.r3 = null;

                /**
                 * Creates a new Matrix4x4d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Matrix4x4d} Matrix4x4d instance
                 */
                Matrix4x4d.create = function create(properties) {
                    return new Matrix4x4d(properties);
                };

                /**
                 * Encodes the specified Matrix4x4d message. Does not implicitly {@link vertexvis.protobuf.core.Matrix4x4d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4d} message Matrix4x4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Matrix4x4d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.r0 != null && Object.hasOwnProperty.call(message, "r0"))
                        $root.vertexvis.protobuf.core.Vector4d.encode(message.r0, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.r1 != null && Object.hasOwnProperty.call(message, "r1"))
                        $root.vertexvis.protobuf.core.Vector4d.encode(message.r1, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.r2 != null && Object.hasOwnProperty.call(message, "r2"))
                        $root.vertexvis.protobuf.core.Vector4d.encode(message.r2, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.r3 != null && Object.hasOwnProperty.call(message, "r3"))
                        $root.vertexvis.protobuf.core.Vector4d.encode(message.r3, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Matrix4x4d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Matrix4x4d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {vertexvis.protobuf.core.IMatrix4x4d} message Matrix4x4d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Matrix4x4d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Matrix4x4d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Matrix4x4d} Matrix4x4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Matrix4x4d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Matrix4x4d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.r0 = $root.vertexvis.protobuf.core.Vector4d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.r1 = $root.vertexvis.protobuf.core.Vector4d.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.r2 = $root.vertexvis.protobuf.core.Vector4d.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.r3 = $root.vertexvis.protobuf.core.Vector4d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Matrix4x4d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Matrix4x4d} Matrix4x4d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Matrix4x4d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Matrix4x4d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Matrix4x4d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.r0 != null && message.hasOwnProperty("r0")) {
                        let error = $root.vertexvis.protobuf.core.Vector4d.verify(message.r0);
                        if (error)
                            return "r0." + error;
                    }
                    if (message.r1 != null && message.hasOwnProperty("r1")) {
                        let error = $root.vertexvis.protobuf.core.Vector4d.verify(message.r1);
                        if (error)
                            return "r1." + error;
                    }
                    if (message.r2 != null && message.hasOwnProperty("r2")) {
                        let error = $root.vertexvis.protobuf.core.Vector4d.verify(message.r2);
                        if (error)
                            return "r2." + error;
                    }
                    if (message.r3 != null && message.hasOwnProperty("r3")) {
                        let error = $root.vertexvis.protobuf.core.Vector4d.verify(message.r3);
                        if (error)
                            return "r3." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Matrix4x4d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Matrix4x4d} Matrix4x4d
                 */
                Matrix4x4d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Matrix4x4d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Matrix4x4d();
                    if (object.r0 != null) {
                        if (typeof object.r0 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4d.r0: object expected");
                        message.r0 = $root.vertexvis.protobuf.core.Vector4d.fromObject(object.r0);
                    }
                    if (object.r1 != null) {
                        if (typeof object.r1 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4d.r1: object expected");
                        message.r1 = $root.vertexvis.protobuf.core.Vector4d.fromObject(object.r1);
                    }
                    if (object.r2 != null) {
                        if (typeof object.r2 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4d.r2: object expected");
                        message.r2 = $root.vertexvis.protobuf.core.Vector4d.fromObject(object.r2);
                    }
                    if (object.r3 != null) {
                        if (typeof object.r3 !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Matrix4x4d.r3: object expected");
                        message.r3 = $root.vertexvis.protobuf.core.Vector4d.fromObject(object.r3);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Matrix4x4d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @static
                 * @param {vertexvis.protobuf.core.Matrix4x4d} message Matrix4x4d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Matrix4x4d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.r0 = null;
                        object.r1 = null;
                        object.r2 = null;
                        object.r3 = null;
                    }
                    if (message.r0 != null && message.hasOwnProperty("r0"))
                        object.r0 = $root.vertexvis.protobuf.core.Vector4d.toObject(message.r0, options);
                    if (message.r1 != null && message.hasOwnProperty("r1"))
                        object.r1 = $root.vertexvis.protobuf.core.Vector4d.toObject(message.r1, options);
                    if (message.r2 != null && message.hasOwnProperty("r2"))
                        object.r2 = $root.vertexvis.protobuf.core.Vector4d.toObject(message.r2, options);
                    if (message.r3 != null && message.hasOwnProperty("r3"))
                        object.r3 = $root.vertexvis.protobuf.core.Vector4d.toObject(message.r3, options);
                    return object;
                };

                /**
                 * Converts this Matrix4x4d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Matrix4x4d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Matrix4x4d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Matrix4x4d;
            })();

            core.Dimension2i = (function() {

                /**
                 * Properties of a Dimension2i.
                 * @memberof vertexvis.protobuf.core
                 * @interface IDimension2i
                 * @property {number|null} [width] Dimension2i width
                 * @property {number|null} [height] Dimension2i height
                 */

                /**
                 * Constructs a new Dimension2i.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Dimension2i.
                 * @implements IDimension2i
                 * @constructor
                 * @param {vertexvis.protobuf.core.IDimension2i=} [properties] Properties to set
                 */
                function Dimension2i(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Dimension2i width.
                 * @member {number} width
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @instance
                 */
                Dimension2i.prototype.width = 0;

                /**
                 * Dimension2i height.
                 * @member {number} height
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @instance
                 */
                Dimension2i.prototype.height = 0;

                /**
                 * Creates a new Dimension2i instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {vertexvis.protobuf.core.IDimension2i=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Dimension2i} Dimension2i instance
                 */
                Dimension2i.create = function create(properties) {
                    return new Dimension2i(properties);
                };

                /**
                 * Encodes the specified Dimension2i message. Does not implicitly {@link vertexvis.protobuf.core.Dimension2i.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {vertexvis.protobuf.core.IDimension2i} message Dimension2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Dimension2i.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.width);
                    if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.height);
                    return writer;
                };

                /**
                 * Encodes the specified Dimension2i message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Dimension2i.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {vertexvis.protobuf.core.IDimension2i} message Dimension2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Dimension2i.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Dimension2i message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Dimension2i} Dimension2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Dimension2i.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Dimension2i();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.width = reader.int32();
                            break;
                        case 2:
                            message.height = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Dimension2i message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Dimension2i} Dimension2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Dimension2i.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Dimension2i message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Dimension2i.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.width != null && message.hasOwnProperty("width"))
                        if (!$util.isInteger(message.width))
                            return "width: integer expected";
                    if (message.height != null && message.hasOwnProperty("height"))
                        if (!$util.isInteger(message.height))
                            return "height: integer expected";
                    return null;
                };

                /**
                 * Creates a Dimension2i message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Dimension2i} Dimension2i
                 */
                Dimension2i.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Dimension2i)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Dimension2i();
                    if (object.width != null)
                        message.width = object.width | 0;
                    if (object.height != null)
                        message.height = object.height | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Dimension2i message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @static
                 * @param {vertexvis.protobuf.core.Dimension2i} message Dimension2i
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Dimension2i.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.width = 0;
                        object.height = 0;
                    }
                    if (message.width != null && message.hasOwnProperty("width"))
                        object.width = message.width;
                    if (message.height != null && message.hasOwnProperty("height"))
                        object.height = message.height;
                    return object;
                };

                /**
                 * Converts this Dimension2i to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Dimension2i
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Dimension2i.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Dimension2i;
            })();

            core.Point2i = (function() {

                /**
                 * Properties of a Point2i.
                 * @memberof vertexvis.protobuf.core
                 * @interface IPoint2i
                 * @property {number|null} [dx] Point2i dx
                 * @property {number|null} [dy] Point2i dy
                 */

                /**
                 * Constructs a new Point2i.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Point2i.
                 * @implements IPoint2i
                 * @constructor
                 * @param {vertexvis.protobuf.core.IPoint2i=} [properties] Properties to set
                 */
                function Point2i(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Point2i dx.
                 * @member {number} dx
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @instance
                 */
                Point2i.prototype.dx = 0;

                /**
                 * Point2i dy.
                 * @member {number} dy
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @instance
                 */
                Point2i.prototype.dy = 0;

                /**
                 * Creates a new Point2i instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {vertexvis.protobuf.core.IPoint2i=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Point2i} Point2i instance
                 */
                Point2i.create = function create(properties) {
                    return new Point2i(properties);
                };

                /**
                 * Encodes the specified Point2i message. Does not implicitly {@link vertexvis.protobuf.core.Point2i.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {vertexvis.protobuf.core.IPoint2i} message Point2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Point2i.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dx != null && Object.hasOwnProperty.call(message, "dx"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dx);
                    if (message.dy != null && Object.hasOwnProperty.call(message, "dy"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dy);
                    return writer;
                };

                /**
                 * Encodes the specified Point2i message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Point2i.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {vertexvis.protobuf.core.IPoint2i} message Point2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Point2i.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Point2i message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Point2i} Point2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Point2i.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Point2i();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dx = reader.int32();
                            break;
                        case 2:
                            message.dy = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Point2i message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Point2i} Point2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Point2i.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Point2i message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Point2i.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.dx != null && message.hasOwnProperty("dx"))
                        if (!$util.isInteger(message.dx))
                            return "dx: integer expected";
                    if (message.dy != null && message.hasOwnProperty("dy"))
                        if (!$util.isInteger(message.dy))
                            return "dy: integer expected";
                    return null;
                };

                /**
                 * Creates a Point2i message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Point2i} Point2i
                 */
                Point2i.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Point2i)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Point2i();
                    if (object.dx != null)
                        message.dx = object.dx | 0;
                    if (object.dy != null)
                        message.dy = object.dy | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a Point2i message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @static
                 * @param {vertexvis.protobuf.core.Point2i} message Point2i
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Point2i.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.dx = 0;
                        object.dy = 0;
                    }
                    if (message.dx != null && message.hasOwnProperty("dx"))
                        object.dx = message.dx;
                    if (message.dy != null && message.hasOwnProperty("dy"))
                        object.dy = message.dy;
                    return object;
                };

                /**
                 * Converts this Point2i to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Point2i
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Point2i.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Point2i;
            })();

            core.BBox2f = (function() {

                /**
                 * Properties of a BBox2f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBBox2f
                 * @property {vertexvis.protobuf.core.IVector2f|null} [min] BBox2f min
                 * @property {vertexvis.protobuf.core.IVector2f|null} [max] BBox2f max
                 */

                /**
                 * Constructs a new BBox2f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BBox2f.
                 * @implements IBBox2f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBBox2f=} [properties] Properties to set
                 */
                function BBox2f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BBox2f min.
                 * @member {vertexvis.protobuf.core.IVector2f|null|undefined} min
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @instance
                 */
                BBox2f.prototype.min = null;

                /**
                 * BBox2f max.
                 * @member {vertexvis.protobuf.core.IVector2f|null|undefined} max
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @instance
                 */
                BBox2f.prototype.max = null;

                /**
                 * Creates a new BBox2f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BBox2f} BBox2f instance
                 */
                BBox2f.create = function create(properties) {
                    return new BBox2f(properties);
                };

                /**
                 * Encodes the specified BBox2f message. Does not implicitly {@link vertexvis.protobuf.core.BBox2f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2f} message BBox2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                        $root.vertexvis.protobuf.core.Vector2f.encode(message.min, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                        $root.vertexvis.protobuf.core.Vector2f.encode(message.max, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BBox2f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BBox2f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2f} message BBox2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BBox2f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BBox2f} BBox2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BBox2f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.min = $root.vertexvis.protobuf.core.Vector2f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.max = $root.vertexvis.protobuf.core.Vector2f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BBox2f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BBox2f} BBox2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BBox2f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BBox2f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.min != null && message.hasOwnProperty("min")) {
                        let error = $root.vertexvis.protobuf.core.Vector2f.verify(message.min);
                        if (error)
                            return "min." + error;
                    }
                    if (message.max != null && message.hasOwnProperty("max")) {
                        let error = $root.vertexvis.protobuf.core.Vector2f.verify(message.max);
                        if (error)
                            return "max." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BBox2f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BBox2f} BBox2f
                 */
                BBox2f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BBox2f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BBox2f();
                    if (object.min != null) {
                        if (typeof object.min !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2f.min: object expected");
                        message.min = $root.vertexvis.protobuf.core.Vector2f.fromObject(object.min);
                    }
                    if (object.max != null) {
                        if (typeof object.max !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2f.max: object expected");
                        message.max = $root.vertexvis.protobuf.core.Vector2f.fromObject(object.max);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BBox2f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @static
                 * @param {vertexvis.protobuf.core.BBox2f} message BBox2f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BBox2f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.min = null;
                        object.max = null;
                    }
                    if (message.min != null && message.hasOwnProperty("min"))
                        object.min = $root.vertexvis.protobuf.core.Vector2f.toObject(message.min, options);
                    if (message.max != null && message.hasOwnProperty("max"))
                        object.max = $root.vertexvis.protobuf.core.Vector2f.toObject(message.max, options);
                    return object;
                };

                /**
                 * Converts this BBox2f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BBox2f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BBox2f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BBox2f;
            })();

            core.BBox2d = (function() {

                /**
                 * Properties of a BBox2d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBBox2d
                 * @property {vertexvis.protobuf.core.IVector2d|null} [min] BBox2d min
                 * @property {vertexvis.protobuf.core.IVector2d|null} [max] BBox2d max
                 */

                /**
                 * Constructs a new BBox2d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BBox2d.
                 * @implements IBBox2d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBBox2d=} [properties] Properties to set
                 */
                function BBox2d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BBox2d min.
                 * @member {vertexvis.protobuf.core.IVector2d|null|undefined} min
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @instance
                 */
                BBox2d.prototype.min = null;

                /**
                 * BBox2d max.
                 * @member {vertexvis.protobuf.core.IVector2d|null|undefined} max
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @instance
                 */
                BBox2d.prototype.max = null;

                /**
                 * Creates a new BBox2d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BBox2d} BBox2d instance
                 */
                BBox2d.create = function create(properties) {
                    return new BBox2d(properties);
                };

                /**
                 * Encodes the specified BBox2d message. Does not implicitly {@link vertexvis.protobuf.core.BBox2d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2d} message BBox2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                        $root.vertexvis.protobuf.core.Vector2d.encode(message.min, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                        $root.vertexvis.protobuf.core.Vector2d.encode(message.max, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BBox2d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BBox2d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2d} message BBox2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BBox2d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BBox2d} BBox2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BBox2d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.min = $root.vertexvis.protobuf.core.Vector2d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.max = $root.vertexvis.protobuf.core.Vector2d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BBox2d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BBox2d} BBox2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BBox2d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BBox2d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.min != null && message.hasOwnProperty("min")) {
                        let error = $root.vertexvis.protobuf.core.Vector2d.verify(message.min);
                        if (error)
                            return "min." + error;
                    }
                    if (message.max != null && message.hasOwnProperty("max")) {
                        let error = $root.vertexvis.protobuf.core.Vector2d.verify(message.max);
                        if (error)
                            return "max." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BBox2d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BBox2d} BBox2d
                 */
                BBox2d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BBox2d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BBox2d();
                    if (object.min != null) {
                        if (typeof object.min !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2d.min: object expected");
                        message.min = $root.vertexvis.protobuf.core.Vector2d.fromObject(object.min);
                    }
                    if (object.max != null) {
                        if (typeof object.max !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2d.max: object expected");
                        message.max = $root.vertexvis.protobuf.core.Vector2d.fromObject(object.max);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BBox2d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @static
                 * @param {vertexvis.protobuf.core.BBox2d} message BBox2d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BBox2d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.min = null;
                        object.max = null;
                    }
                    if (message.min != null && message.hasOwnProperty("min"))
                        object.min = $root.vertexvis.protobuf.core.Vector2d.toObject(message.min, options);
                    if (message.max != null && message.hasOwnProperty("max"))
                        object.max = $root.vertexvis.protobuf.core.Vector2d.toObject(message.max, options);
                    return object;
                };

                /**
                 * Converts this BBox2d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BBox2d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BBox2d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BBox2d;
            })();

            core.BBox2i = (function() {

                /**
                 * Properties of a BBox2i.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBBox2i
                 * @property {vertexvis.protobuf.core.IVector2i|null} [min] BBox2i min
                 * @property {vertexvis.protobuf.core.IVector2i|null} [max] BBox2i max
                 */

                /**
                 * Constructs a new BBox2i.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BBox2i.
                 * @implements IBBox2i
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBBox2i=} [properties] Properties to set
                 */
                function BBox2i(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BBox2i min.
                 * @member {vertexvis.protobuf.core.IVector2i|null|undefined} min
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @instance
                 */
                BBox2i.prototype.min = null;

                /**
                 * BBox2i max.
                 * @member {vertexvis.protobuf.core.IVector2i|null|undefined} max
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @instance
                 */
                BBox2i.prototype.max = null;

                /**
                 * Creates a new BBox2i instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2i=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BBox2i} BBox2i instance
                 */
                BBox2i.create = function create(properties) {
                    return new BBox2i(properties);
                };

                /**
                 * Encodes the specified BBox2i message. Does not implicitly {@link vertexvis.protobuf.core.BBox2i.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2i} message BBox2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2i.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                        $root.vertexvis.protobuf.core.Vector2i.encode(message.min, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                        $root.vertexvis.protobuf.core.Vector2i.encode(message.max, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BBox2i message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BBox2i.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox2i} message BBox2i message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox2i.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BBox2i message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BBox2i} BBox2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2i.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BBox2i();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.min = $root.vertexvis.protobuf.core.Vector2i.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.max = $root.vertexvis.protobuf.core.Vector2i.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BBox2i message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BBox2i} BBox2i
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox2i.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BBox2i message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BBox2i.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.min != null && message.hasOwnProperty("min")) {
                        let error = $root.vertexvis.protobuf.core.Vector2i.verify(message.min);
                        if (error)
                            return "min." + error;
                    }
                    if (message.max != null && message.hasOwnProperty("max")) {
                        let error = $root.vertexvis.protobuf.core.Vector2i.verify(message.max);
                        if (error)
                            return "max." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BBox2i message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BBox2i} BBox2i
                 */
                BBox2i.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BBox2i)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BBox2i();
                    if (object.min != null) {
                        if (typeof object.min !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2i.min: object expected");
                        message.min = $root.vertexvis.protobuf.core.Vector2i.fromObject(object.min);
                    }
                    if (object.max != null) {
                        if (typeof object.max !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox2i.max: object expected");
                        message.max = $root.vertexvis.protobuf.core.Vector2i.fromObject(object.max);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BBox2i message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @static
                 * @param {vertexvis.protobuf.core.BBox2i} message BBox2i
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BBox2i.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.min = null;
                        object.max = null;
                    }
                    if (message.min != null && message.hasOwnProperty("min"))
                        object.min = $root.vertexvis.protobuf.core.Vector2i.toObject(message.min, options);
                    if (message.max != null && message.hasOwnProperty("max"))
                        object.max = $root.vertexvis.protobuf.core.Vector2i.toObject(message.max, options);
                    return object;
                };

                /**
                 * Converts this BBox2i to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BBox2i
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BBox2i.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BBox2i;
            })();

            core.BBox3f = (function() {

                /**
                 * Properties of a BBox3f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBBox3f
                 * @property {vertexvis.protobuf.core.IVector3f|null} [min] BBox3f min
                 * @property {vertexvis.protobuf.core.IVector3f|null} [max] BBox3f max
                 */

                /**
                 * Constructs a new BBox3f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BBox3f.
                 * @implements IBBox3f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBBox3f=} [properties] Properties to set
                 */
                function BBox3f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BBox3f min.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} min
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @instance
                 */
                BBox3f.prototype.min = null;

                /**
                 * BBox3f max.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} max
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @instance
                 */
                BBox3f.prototype.max = null;

                /**
                 * Creates a new BBox3f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BBox3f} BBox3f instance
                 */
                BBox3f.create = function create(properties) {
                    return new BBox3f(properties);
                };

                /**
                 * Encodes the specified BBox3f message. Does not implicitly {@link vertexvis.protobuf.core.BBox3f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3f} message BBox3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox3f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.min, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.max, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BBox3f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BBox3f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3f} message BBox3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox3f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BBox3f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BBox3f} BBox3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox3f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BBox3f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.min = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.max = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BBox3f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BBox3f} BBox3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox3f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BBox3f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BBox3f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.min != null && message.hasOwnProperty("min")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.min);
                        if (error)
                            return "min." + error;
                    }
                    if (message.max != null && message.hasOwnProperty("max")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.max);
                        if (error)
                            return "max." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BBox3f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BBox3f} BBox3f
                 */
                BBox3f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BBox3f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BBox3f();
                    if (object.min != null) {
                        if (typeof object.min !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox3f.min: object expected");
                        message.min = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.min);
                    }
                    if (object.max != null) {
                        if (typeof object.max !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox3f.max: object expected");
                        message.max = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.max);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BBox3f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @static
                 * @param {vertexvis.protobuf.core.BBox3f} message BBox3f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BBox3f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.min = null;
                        object.max = null;
                    }
                    if (message.min != null && message.hasOwnProperty("min"))
                        object.min = $root.vertexvis.protobuf.core.Vector3f.toObject(message.min, options);
                    if (message.max != null && message.hasOwnProperty("max"))
                        object.max = $root.vertexvis.protobuf.core.Vector3f.toObject(message.max, options);
                    return object;
                };

                /**
                 * Converts this BBox3f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BBox3f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BBox3f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BBox3f;
            })();

            core.BBox3d = (function() {

                /**
                 * Properties of a BBox3d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBBox3d
                 * @property {vertexvis.protobuf.core.IVector3d|null} [min] BBox3d min
                 * @property {vertexvis.protobuf.core.IVector3d|null} [max] BBox3d max
                 */

                /**
                 * Constructs a new BBox3d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BBox3d.
                 * @implements IBBox3d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBBox3d=} [properties] Properties to set
                 */
                function BBox3d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BBox3d min.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} min
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @instance
                 */
                BBox3d.prototype.min = null;

                /**
                 * BBox3d max.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} max
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @instance
                 */
                BBox3d.prototype.max = null;

                /**
                 * Creates a new BBox3d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BBox3d} BBox3d instance
                 */
                BBox3d.create = function create(properties) {
                    return new BBox3d(properties);
                };

                /**
                 * Encodes the specified BBox3d message. Does not implicitly {@link vertexvis.protobuf.core.BBox3d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3d} message BBox3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox3d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.min, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.max, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BBox3d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BBox3d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {vertexvis.protobuf.core.IBBox3d} message BBox3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BBox3d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BBox3d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BBox3d} BBox3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox3d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BBox3d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.min = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.max = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BBox3d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BBox3d} BBox3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BBox3d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BBox3d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BBox3d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.min != null && message.hasOwnProperty("min")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.min);
                        if (error)
                            return "min." + error;
                    }
                    if (message.max != null && message.hasOwnProperty("max")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.max);
                        if (error)
                            return "max." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BBox3d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BBox3d} BBox3d
                 */
                BBox3d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BBox3d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BBox3d();
                    if (object.min != null) {
                        if (typeof object.min !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox3d.min: object expected");
                        message.min = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.min);
                    }
                    if (object.max != null) {
                        if (typeof object.max !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BBox3d.max: object expected");
                        message.max = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.max);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BBox3d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @static
                 * @param {vertexvis.protobuf.core.BBox3d} message BBox3d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BBox3d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.min = null;
                        object.max = null;
                    }
                    if (message.min != null && message.hasOwnProperty("min"))
                        object.min = $root.vertexvis.protobuf.core.Vector3d.toObject(message.min, options);
                    if (message.max != null && message.hasOwnProperty("max"))
                        object.max = $root.vertexvis.protobuf.core.Vector3d.toObject(message.max, options);
                    return object;
                };

                /**
                 * Converts this BBox3d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BBox3d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BBox3d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BBox3d;
            })();

            core.LinearTransform2f = (function() {

                /**
                 * Properties of a LinearTransform2f.
                 * @memberof vertexvis.protobuf.core
                 * @interface ILinearTransform2f
                 * @property {vertexvis.protobuf.core.IVector2f|null} [basisX] LinearTransform2f basisX
                 * @property {vertexvis.protobuf.core.IVector2f|null} [basisY] LinearTransform2f basisY
                 */

                /**
                 * Constructs a new LinearTransform2f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a LinearTransform2f.
                 * @implements ILinearTransform2f
                 * @constructor
                 * @param {vertexvis.protobuf.core.ILinearTransform2f=} [properties] Properties to set
                 */
                function LinearTransform2f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinearTransform2f basisX.
                 * @member {vertexvis.protobuf.core.IVector2f|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @instance
                 */
                LinearTransform2f.prototype.basisX = null;

                /**
                 * LinearTransform2f basisY.
                 * @member {vertexvis.protobuf.core.IVector2f|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @instance
                 */
                LinearTransform2f.prototype.basisY = null;

                /**
                 * Creates a new LinearTransform2f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.LinearTransform2f} LinearTransform2f instance
                 */
                LinearTransform2f.create = function create(properties) {
                    return new LinearTransform2f(properties);
                };

                /**
                 * Encodes the specified LinearTransform2f message. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform2f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2f} message LinearTransform2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform2f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector2f.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector2f.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LinearTransform2f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform2f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2f} message LinearTransform2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform2f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinearTransform2f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.LinearTransform2f} LinearTransform2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform2f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.LinearTransform2f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector2f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector2f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinearTransform2f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.LinearTransform2f} LinearTransform2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform2f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinearTransform2f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinearTransform2f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector2f.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector2f.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    return null;
                };

                /**
                 * Creates a LinearTransform2f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.LinearTransform2f} LinearTransform2f
                 */
                LinearTransform2f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.LinearTransform2f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.LinearTransform2f();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform2f.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector2f.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform2f.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector2f.fromObject(object.basisY);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinearTransform2f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.LinearTransform2f} message LinearTransform2f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinearTransform2f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector2f.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector2f.toObject(message.basisY, options);
                    return object;
                };

                /**
                 * Converts this LinearTransform2f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.LinearTransform2f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinearTransform2f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinearTransform2f;
            })();

            core.LinearTransform2d = (function() {

                /**
                 * Properties of a LinearTransform2d.
                 * @memberof vertexvis.protobuf.core
                 * @interface ILinearTransform2d
                 * @property {vertexvis.protobuf.core.IVector2d|null} [basisX] LinearTransform2d basisX
                 * @property {vertexvis.protobuf.core.IVector2d|null} [basisY] LinearTransform2d basisY
                 */

                /**
                 * Constructs a new LinearTransform2d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a LinearTransform2d.
                 * @implements ILinearTransform2d
                 * @constructor
                 * @param {vertexvis.protobuf.core.ILinearTransform2d=} [properties] Properties to set
                 */
                function LinearTransform2d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinearTransform2d basisX.
                 * @member {vertexvis.protobuf.core.IVector2d|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @instance
                 */
                LinearTransform2d.prototype.basisX = null;

                /**
                 * LinearTransform2d basisY.
                 * @member {vertexvis.protobuf.core.IVector2d|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @instance
                 */
                LinearTransform2d.prototype.basisY = null;

                /**
                 * Creates a new LinearTransform2d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.LinearTransform2d} LinearTransform2d instance
                 */
                LinearTransform2d.create = function create(properties) {
                    return new LinearTransform2d(properties);
                };

                /**
                 * Encodes the specified LinearTransform2d message. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform2d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2d} message LinearTransform2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform2d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector2d.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector2d.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LinearTransform2d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform2d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform2d} message LinearTransform2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform2d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinearTransform2d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.LinearTransform2d} LinearTransform2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform2d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.LinearTransform2d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector2d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector2d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinearTransform2d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.LinearTransform2d} LinearTransform2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform2d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinearTransform2d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinearTransform2d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector2d.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector2d.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    return null;
                };

                /**
                 * Creates a LinearTransform2d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.LinearTransform2d} LinearTransform2d
                 */
                LinearTransform2d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.LinearTransform2d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.LinearTransform2d();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform2d.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector2d.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform2d.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector2d.fromObject(object.basisY);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinearTransform2d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.LinearTransform2d} message LinearTransform2d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinearTransform2d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector2d.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector2d.toObject(message.basisY, options);
                    return object;
                };

                /**
                 * Converts this LinearTransform2d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.LinearTransform2d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinearTransform2d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinearTransform2d;
            })();

            core.LinearTransform3f = (function() {

                /**
                 * Properties of a LinearTransform3f.
                 * @memberof vertexvis.protobuf.core
                 * @interface ILinearTransform3f
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisX] LinearTransform3f basisX
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisY] LinearTransform3f basisY
                 * @property {vertexvis.protobuf.core.IVector3f|null} [basisZ] LinearTransform3f basisZ
                 */

                /**
                 * Constructs a new LinearTransform3f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a LinearTransform3f.
                 * @implements ILinearTransform3f
                 * @constructor
                 * @param {vertexvis.protobuf.core.ILinearTransform3f=} [properties] Properties to set
                 */
                function LinearTransform3f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinearTransform3f basisX.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @instance
                 */
                LinearTransform3f.prototype.basisX = null;

                /**
                 * LinearTransform3f basisY.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @instance
                 */
                LinearTransform3f.prototype.basisY = null;

                /**
                 * LinearTransform3f basisZ.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} basisZ
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @instance
                 */
                LinearTransform3f.prototype.basisZ = null;

                /**
                 * Creates a new LinearTransform3f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.LinearTransform3f} LinearTransform3f instance
                 */
                LinearTransform3f.create = function create(properties) {
                    return new LinearTransform3f(properties);
                };

                /**
                 * Encodes the specified LinearTransform3f message. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform3f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3f} message LinearTransform3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform3f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.basisZ != null && Object.hasOwnProperty.call(message, "basisZ"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.basisZ, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LinearTransform3f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform3f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3f} message LinearTransform3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform3f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinearTransform3f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.LinearTransform3f} LinearTransform3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform3f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.LinearTransform3f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.basisZ = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinearTransform3f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.LinearTransform3f} LinearTransform3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform3f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinearTransform3f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinearTransform3f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    if (message.basisZ != null && message.hasOwnProperty("basisZ")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.basisZ);
                        if (error)
                            return "basisZ." + error;
                    }
                    return null;
                };

                /**
                 * Creates a LinearTransform3f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.LinearTransform3f} LinearTransform3f
                 */
                LinearTransform3f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.LinearTransform3f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.LinearTransform3f();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3f.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3f.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisY);
                    }
                    if (object.basisZ != null) {
                        if (typeof object.basisZ !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3f.basisZ: object expected");
                        message.basisZ = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.basisZ);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinearTransform3f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.LinearTransform3f} message LinearTransform3f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinearTransform3f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                        object.basisZ = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisY, options);
                    if (message.basisZ != null && message.hasOwnProperty("basisZ"))
                        object.basisZ = $root.vertexvis.protobuf.core.Vector3f.toObject(message.basisZ, options);
                    return object;
                };

                /**
                 * Converts this LinearTransform3f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.LinearTransform3f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinearTransform3f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinearTransform3f;
            })();

            core.LinearTransform3d = (function() {

                /**
                 * Properties of a LinearTransform3d.
                 * @memberof vertexvis.protobuf.core
                 * @interface ILinearTransform3d
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisX] LinearTransform3d basisX
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisY] LinearTransform3d basisY
                 * @property {vertexvis.protobuf.core.IVector3d|null} [basisZ] LinearTransform3d basisZ
                 */

                /**
                 * Constructs a new LinearTransform3d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a LinearTransform3d.
                 * @implements ILinearTransform3d
                 * @constructor
                 * @param {vertexvis.protobuf.core.ILinearTransform3d=} [properties] Properties to set
                 */
                function LinearTransform3d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinearTransform3d basisX.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisX
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @instance
                 */
                LinearTransform3d.prototype.basisX = null;

                /**
                 * LinearTransform3d basisY.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisY
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @instance
                 */
                LinearTransform3d.prototype.basisY = null;

                /**
                 * LinearTransform3d basisZ.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} basisZ
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @instance
                 */
                LinearTransform3d.prototype.basisZ = null;

                /**
                 * Creates a new LinearTransform3d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.LinearTransform3d} LinearTransform3d instance
                 */
                LinearTransform3d.create = function create(properties) {
                    return new LinearTransform3d(properties);
                };

                /**
                 * Encodes the specified LinearTransform3d message. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform3d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3d} message LinearTransform3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform3d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.basisX != null && Object.hasOwnProperty.call(message, "basisX"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisX, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.basisY != null && Object.hasOwnProperty.call(message, "basisY"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisY, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.basisZ != null && Object.hasOwnProperty.call(message, "basisZ"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.basisZ, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified LinearTransform3d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.LinearTransform3d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.ILinearTransform3d} message LinearTransform3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinearTransform3d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinearTransform3d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.LinearTransform3d} LinearTransform3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform3d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.LinearTransform3d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.basisX = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.basisY = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.basisZ = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinearTransform3d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.LinearTransform3d} LinearTransform3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinearTransform3d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinearTransform3d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinearTransform3d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.basisX != null && message.hasOwnProperty("basisX")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisX);
                        if (error)
                            return "basisX." + error;
                    }
                    if (message.basisY != null && message.hasOwnProperty("basisY")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisY);
                        if (error)
                            return "basisY." + error;
                    }
                    if (message.basisZ != null && message.hasOwnProperty("basisZ")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.basisZ);
                        if (error)
                            return "basisZ." + error;
                    }
                    return null;
                };

                /**
                 * Creates a LinearTransform3d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.LinearTransform3d} LinearTransform3d
                 */
                LinearTransform3d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.LinearTransform3d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.LinearTransform3d();
                    if (object.basisX != null) {
                        if (typeof object.basisX !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3d.basisX: object expected");
                        message.basisX = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisX);
                    }
                    if (object.basisY != null) {
                        if (typeof object.basisY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3d.basisY: object expected");
                        message.basisY = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisY);
                    }
                    if (object.basisZ != null) {
                        if (typeof object.basisZ !== "object")
                            throw TypeError(".vertexvis.protobuf.core.LinearTransform3d.basisZ: object expected");
                        message.basisZ = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.basisZ);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinearTransform3d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.LinearTransform3d} message LinearTransform3d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinearTransform3d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.basisX = null;
                        object.basisY = null;
                        object.basisZ = null;
                    }
                    if (message.basisX != null && message.hasOwnProperty("basisX"))
                        object.basisX = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisX, options);
                    if (message.basisY != null && message.hasOwnProperty("basisY"))
                        object.basisY = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisY, options);
                    if (message.basisZ != null && message.hasOwnProperty("basisZ"))
                        object.basisZ = $root.vertexvis.protobuf.core.Vector3d.toObject(message.basisZ, options);
                    return object;
                };

                /**
                 * Converts this LinearTransform3d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.LinearTransform3d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinearTransform3d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinearTransform3d;
            })();

            core.AffineTransform2f = (function() {

                /**
                 * Properties of an AffineTransform2f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineTransform2f
                 * @property {vertexvis.protobuf.core.ILinearTransform2f|null} [transform] AffineTransform2f transform
                 * @property {vertexvis.protobuf.core.IVector2f|null} [pos] AffineTransform2f pos
                 */

                /**
                 * Constructs a new AffineTransform2f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineTransform2f.
                 * @implements IAffineTransform2f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineTransform2f=} [properties] Properties to set
                 */
                function AffineTransform2f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineTransform2f transform.
                 * @member {vertexvis.protobuf.core.ILinearTransform2f|null|undefined} transform
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @instance
                 */
                AffineTransform2f.prototype.transform = null;

                /**
                 * AffineTransform2f pos.
                 * @member {vertexvis.protobuf.core.IVector2f|null|undefined} pos
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @instance
                 */
                AffineTransform2f.prototype.pos = null;

                /**
                 * Creates a new AffineTransform2f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineTransform2f} AffineTransform2f instance
                 */
                AffineTransform2f.create = function create(properties) {
                    return new AffineTransform2f(properties);
                };

                /**
                 * Encodes the specified AffineTransform2f message. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform2f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2f} message AffineTransform2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform2f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.LinearTransform2f.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pos != null && Object.hasOwnProperty.call(message, "pos"))
                        $root.vertexvis.protobuf.core.Vector2f.encode(message.pos, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineTransform2f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform2f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2f} message AffineTransform2f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform2f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineTransform2f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineTransform2f} AffineTransform2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform2f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineTransform2f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.core.LinearTransform2f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.pos = $root.vertexvis.protobuf.core.Vector2f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineTransform2f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineTransform2f} AffineTransform2f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform2f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineTransform2f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineTransform2f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.LinearTransform2f.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    if (message.pos != null && message.hasOwnProperty("pos")) {
                        let error = $root.vertexvis.protobuf.core.Vector2f.verify(message.pos);
                        if (error)
                            return "pos." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineTransform2f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineTransform2f} AffineTransform2f
                 */
                AffineTransform2f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineTransform2f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineTransform2f();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform2f.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.LinearTransform2f.fromObject(object.transform);
                    }
                    if (object.pos != null) {
                        if (typeof object.pos !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform2f.pos: object expected");
                        message.pos = $root.vertexvis.protobuf.core.Vector2f.fromObject(object.pos);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineTransform2f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @static
                 * @param {vertexvis.protobuf.core.AffineTransform2f} message AffineTransform2f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineTransform2f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.transform = null;
                        object.pos = null;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.LinearTransform2f.toObject(message.transform, options);
                    if (message.pos != null && message.hasOwnProperty("pos"))
                        object.pos = $root.vertexvis.protobuf.core.Vector2f.toObject(message.pos, options);
                    return object;
                };

                /**
                 * Converts this AffineTransform2f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineTransform2f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineTransform2f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineTransform2f;
            })();

            core.AffineTransform2d = (function() {

                /**
                 * Properties of an AffineTransform2d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineTransform2d
                 * @property {vertexvis.protobuf.core.ILinearTransform2d|null} [transform] AffineTransform2d transform
                 * @property {vertexvis.protobuf.core.IVector2d|null} [pos] AffineTransform2d pos
                 */

                /**
                 * Constructs a new AffineTransform2d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineTransform2d.
                 * @implements IAffineTransform2d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineTransform2d=} [properties] Properties to set
                 */
                function AffineTransform2d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineTransform2d transform.
                 * @member {vertexvis.protobuf.core.ILinearTransform2d|null|undefined} transform
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @instance
                 */
                AffineTransform2d.prototype.transform = null;

                /**
                 * AffineTransform2d pos.
                 * @member {vertexvis.protobuf.core.IVector2d|null|undefined} pos
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @instance
                 */
                AffineTransform2d.prototype.pos = null;

                /**
                 * Creates a new AffineTransform2d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineTransform2d} AffineTransform2d instance
                 */
                AffineTransform2d.create = function create(properties) {
                    return new AffineTransform2d(properties);
                };

                /**
                 * Encodes the specified AffineTransform2d message. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform2d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2d} message AffineTransform2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform2d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.LinearTransform2d.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pos != null && Object.hasOwnProperty.call(message, "pos"))
                        $root.vertexvis.protobuf.core.Vector2d.encode(message.pos, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineTransform2d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform2d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform2d} message AffineTransform2d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform2d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineTransform2d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineTransform2d} AffineTransform2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform2d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineTransform2d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.core.LinearTransform2d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.pos = $root.vertexvis.protobuf.core.Vector2d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineTransform2d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineTransform2d} AffineTransform2d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform2d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineTransform2d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineTransform2d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.LinearTransform2d.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    if (message.pos != null && message.hasOwnProperty("pos")) {
                        let error = $root.vertexvis.protobuf.core.Vector2d.verify(message.pos);
                        if (error)
                            return "pos." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineTransform2d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineTransform2d} AffineTransform2d
                 */
                AffineTransform2d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineTransform2d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineTransform2d();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform2d.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.LinearTransform2d.fromObject(object.transform);
                    }
                    if (object.pos != null) {
                        if (typeof object.pos !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform2d.pos: object expected");
                        message.pos = $root.vertexvis.protobuf.core.Vector2d.fromObject(object.pos);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineTransform2d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @static
                 * @param {vertexvis.protobuf.core.AffineTransform2d} message AffineTransform2d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineTransform2d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.transform = null;
                        object.pos = null;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.LinearTransform2d.toObject(message.transform, options);
                    if (message.pos != null && message.hasOwnProperty("pos"))
                        object.pos = $root.vertexvis.protobuf.core.Vector2d.toObject(message.pos, options);
                    return object;
                };

                /**
                 * Converts this AffineTransform2d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineTransform2d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineTransform2d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineTransform2d;
            })();

            core.AffineTransform3f = (function() {

                /**
                 * Properties of an AffineTransform3f.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineTransform3f
                 * @property {vertexvis.protobuf.core.ILinearTransform3f|null} [transform] AffineTransform3f transform
                 * @property {vertexvis.protobuf.core.IVector3f|null} [pos] AffineTransform3f pos
                 */

                /**
                 * Constructs a new AffineTransform3f.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineTransform3f.
                 * @implements IAffineTransform3f
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineTransform3f=} [properties] Properties to set
                 */
                function AffineTransform3f(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineTransform3f transform.
                 * @member {vertexvis.protobuf.core.ILinearTransform3f|null|undefined} transform
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @instance
                 */
                AffineTransform3f.prototype.transform = null;

                /**
                 * AffineTransform3f pos.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} pos
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @instance
                 */
                AffineTransform3f.prototype.pos = null;

                /**
                 * Creates a new AffineTransform3f instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3f=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineTransform3f} AffineTransform3f instance
                 */
                AffineTransform3f.create = function create(properties) {
                    return new AffineTransform3f(properties);
                };

                /**
                 * Encodes the specified AffineTransform3f message. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform3f.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3f} message AffineTransform3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform3f.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.LinearTransform3f.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pos != null && Object.hasOwnProperty.call(message, "pos"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.pos, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineTransform3f message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform3f.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3f} message AffineTransform3f message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform3f.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineTransform3f message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineTransform3f} AffineTransform3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform3f.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineTransform3f();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.core.LinearTransform3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.pos = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineTransform3f message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineTransform3f} AffineTransform3f
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform3f.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineTransform3f message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineTransform3f.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.LinearTransform3f.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    if (message.pos != null && message.hasOwnProperty("pos")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.pos);
                        if (error)
                            return "pos." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineTransform3f message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineTransform3f} AffineTransform3f
                 */
                AffineTransform3f.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineTransform3f)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineTransform3f();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform3f.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.LinearTransform3f.fromObject(object.transform);
                    }
                    if (object.pos != null) {
                        if (typeof object.pos !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform3f.pos: object expected");
                        message.pos = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.pos);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineTransform3f message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @static
                 * @param {vertexvis.protobuf.core.AffineTransform3f} message AffineTransform3f
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineTransform3f.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.transform = null;
                        object.pos = null;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.LinearTransform3f.toObject(message.transform, options);
                    if (message.pos != null && message.hasOwnProperty("pos"))
                        object.pos = $root.vertexvis.protobuf.core.Vector3f.toObject(message.pos, options);
                    return object;
                };

                /**
                 * Converts this AffineTransform3f to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineTransform3f
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineTransform3f.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineTransform3f;
            })();

            core.AffineTransform3d = (function() {

                /**
                 * Properties of an AffineTransform3d.
                 * @memberof vertexvis.protobuf.core
                 * @interface IAffineTransform3d
                 * @property {vertexvis.protobuf.core.ILinearTransform3d|null} [transform] AffineTransform3d transform
                 * @property {vertexvis.protobuf.core.IVector3d|null} [pos] AffineTransform3d pos
                 */

                /**
                 * Constructs a new AffineTransform3d.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an AffineTransform3d.
                 * @implements IAffineTransform3d
                 * @constructor
                 * @param {vertexvis.protobuf.core.IAffineTransform3d=} [properties] Properties to set
                 */
                function AffineTransform3d(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AffineTransform3d transform.
                 * @member {vertexvis.protobuf.core.ILinearTransform3d|null|undefined} transform
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @instance
                 */
                AffineTransform3d.prototype.transform = null;

                /**
                 * AffineTransform3d pos.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} pos
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @instance
                 */
                AffineTransform3d.prototype.pos = null;

                /**
                 * Creates a new AffineTransform3d instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3d=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.AffineTransform3d} AffineTransform3d instance
                 */
                AffineTransform3d.create = function create(properties) {
                    return new AffineTransform3d(properties);
                };

                /**
                 * Encodes the specified AffineTransform3d message. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform3d.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3d} message AffineTransform3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform3d.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.transform != null && Object.hasOwnProperty.call(message, "transform"))
                        $root.vertexvis.protobuf.core.LinearTransform3d.encode(message.transform, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.pos != null && Object.hasOwnProperty.call(message, "pos"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.pos, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AffineTransform3d message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.AffineTransform3d.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.IAffineTransform3d} message AffineTransform3d message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AffineTransform3d.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AffineTransform3d message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.AffineTransform3d} AffineTransform3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform3d.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.AffineTransform3d();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.transform = $root.vertexvis.protobuf.core.LinearTransform3d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.pos = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AffineTransform3d message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.AffineTransform3d} AffineTransform3d
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AffineTransform3d.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AffineTransform3d message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AffineTransform3d.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.transform != null && message.hasOwnProperty("transform")) {
                        let error = $root.vertexvis.protobuf.core.LinearTransform3d.verify(message.transform);
                        if (error)
                            return "transform." + error;
                    }
                    if (message.pos != null && message.hasOwnProperty("pos")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.pos);
                        if (error)
                            return "pos." + error;
                    }
                    return null;
                };

                /**
                 * Creates an AffineTransform3d message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.AffineTransform3d} AffineTransform3d
                 */
                AffineTransform3d.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.AffineTransform3d)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.AffineTransform3d();
                    if (object.transform != null) {
                        if (typeof object.transform !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform3d.transform: object expected");
                        message.transform = $root.vertexvis.protobuf.core.LinearTransform3d.fromObject(object.transform);
                    }
                    if (object.pos != null) {
                        if (typeof object.pos !== "object")
                            throw TypeError(".vertexvis.protobuf.core.AffineTransform3d.pos: object expected");
                        message.pos = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.pos);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AffineTransform3d message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @static
                 * @param {vertexvis.protobuf.core.AffineTransform3d} message AffineTransform3d
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AffineTransform3d.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.transform = null;
                        object.pos = null;
                    }
                    if (message.transform != null && message.hasOwnProperty("transform"))
                        object.transform = $root.vertexvis.protobuf.core.LinearTransform3d.toObject(message.transform, options);
                    if (message.pos != null && message.hasOwnProperty("pos"))
                        object.pos = $root.vertexvis.protobuf.core.Vector3d.toObject(message.pos, options);
                    return object;
                };

                /**
                 * Converts this AffineTransform3d to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.AffineTransform3d
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AffineTransform3d.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AffineTransform3d;
            })();

            core.Plane = (function() {

                /**
                 * Properties of a Plane.
                 * @memberof vertexvis.protobuf.core
                 * @interface IPlane
                 * @property {vertexvis.protobuf.core.IVector3d|null} [normal] Plane normal
                 * @property {number|null} [d] Plane d
                 */

                /**
                 * Constructs a new Plane.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Plane.
                 * @implements IPlane
                 * @constructor
                 * @param {vertexvis.protobuf.core.IPlane=} [properties] Properties to set
                 */
                function Plane(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Plane normal.
                 * @member {vertexvis.protobuf.core.IVector3d|null|undefined} normal
                 * @memberof vertexvis.protobuf.core.Plane
                 * @instance
                 */
                Plane.prototype.normal = null;

                /**
                 * Plane d.
                 * @member {number} d
                 * @memberof vertexvis.protobuf.core.Plane
                 * @instance
                 */
                Plane.prototype.d = 0;

                /**
                 * Creates a new Plane instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {vertexvis.protobuf.core.IPlane=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Plane} Plane instance
                 */
                Plane.create = function create(properties) {
                    return new Plane(properties);
                };

                /**
                 * Encodes the specified Plane message. Does not implicitly {@link vertexvis.protobuf.core.Plane.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {vertexvis.protobuf.core.IPlane} message Plane message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Plane.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.normal != null && Object.hasOwnProperty.call(message, "normal"))
                        $root.vertexvis.protobuf.core.Vector3d.encode(message.normal, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.d != null && Object.hasOwnProperty.call(message, "d"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.d);
                    return writer;
                };

                /**
                 * Encodes the specified Plane message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Plane.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {vertexvis.protobuf.core.IPlane} message Plane message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Plane.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Plane message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Plane} Plane
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Plane.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Plane();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.normal = $root.vertexvis.protobuf.core.Vector3d.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.d = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Plane message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Plane} Plane
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Plane.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Plane message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Plane.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.normal != null && message.hasOwnProperty("normal")) {
                        let error = $root.vertexvis.protobuf.core.Vector3d.verify(message.normal);
                        if (error)
                            return "normal." + error;
                    }
                    if (message.d != null && message.hasOwnProperty("d"))
                        if (typeof message.d !== "number")
                            return "d: number expected";
                    return null;
                };

                /**
                 * Creates a Plane message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Plane} Plane
                 */
                Plane.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Plane)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Plane();
                    if (object.normal != null) {
                        if (typeof object.normal !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Plane.normal: object expected");
                        message.normal = $root.vertexvis.protobuf.core.Vector3d.fromObject(object.normal);
                    }
                    if (object.d != null)
                        message.d = Number(object.d);
                    return message;
                };

                /**
                 * Creates a plain object from a Plane message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Plane
                 * @static
                 * @param {vertexvis.protobuf.core.Plane} message Plane
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Plane.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.normal = null;
                        object.d = 0;
                    }
                    if (message.normal != null && message.hasOwnProperty("normal"))
                        object.normal = $root.vertexvis.protobuf.core.Vector3d.toObject(message.normal, options);
                    if (message.d != null && message.hasOwnProperty("d"))
                        object.d = options.json && !isFinite(message.d) ? String(message.d) : message.d;
                    return object;
                };

                /**
                 * Converts this Plane to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Plane
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Plane.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Plane;
            })();

            core.Uuid = (function() {

                /**
                 * Properties of an Uuid.
                 * @memberof vertexvis.protobuf.core
                 * @interface IUuid
                 * @property {string|null} [hex] Uuid hex
                 */

                /**
                 * Constructs a new Uuid.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an Uuid.
                 * @implements IUuid
                 * @constructor
                 * @param {vertexvis.protobuf.core.IUuid=} [properties] Properties to set
                 */
                function Uuid(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Uuid hex.
                 * @member {string} hex
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @instance
                 */
                Uuid.prototype.hex = "";

                /**
                 * Creates a new Uuid instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Uuid} Uuid instance
                 */
                Uuid.create = function create(properties) {
                    return new Uuid(properties);
                };

                /**
                 * Encodes the specified Uuid message. Does not implicitly {@link vertexvis.protobuf.core.Uuid.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid} message Uuid message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Uuid.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hex != null && Object.hasOwnProperty.call(message, "hex"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.hex);
                    return writer;
                };

                /**
                 * Encodes the specified Uuid message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Uuid.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid} message Uuid message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Uuid.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Uuid message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Uuid} Uuid
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Uuid.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Uuid();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.hex = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Uuid message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Uuid} Uuid
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Uuid.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Uuid message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Uuid.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hex != null && message.hasOwnProperty("hex"))
                        if (!$util.isString(message.hex))
                            return "hex: string expected";
                    return null;
                };

                /**
                 * Creates an Uuid message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Uuid} Uuid
                 */
                Uuid.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Uuid)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Uuid();
                    if (object.hex != null)
                        message.hex = String(object.hex);
                    return message;
                };

                /**
                 * Creates a plain object from an Uuid message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @static
                 * @param {vertexvis.protobuf.core.Uuid} message Uuid
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Uuid.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.hex = "";
                    if (message.hex != null && message.hasOwnProperty("hex"))
                        object.hex = message.hex;
                    return object;
                };

                /**
                 * Converts this Uuid to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Uuid
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Uuid.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Uuid;
            })();

            core.Uuid2l = (function() {

                /**
                 * Properties of an Uuid2l.
                 * @memberof vertexvis.protobuf.core
                 * @interface IUuid2l
                 * @property {number|Long|null} [msb] Uuid2l msb
                 * @property {number|Long|null} [lsb] Uuid2l lsb
                 */

                /**
                 * Constructs a new Uuid2l.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an Uuid2l.
                 * @implements IUuid2l
                 * @constructor
                 * @param {vertexvis.protobuf.core.IUuid2l=} [properties] Properties to set
                 */
                function Uuid2l(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Uuid2l msb.
                 * @member {number|Long} msb
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @instance
                 */
                Uuid2l.prototype.msb = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Uuid2l lsb.
                 * @member {number|Long} lsb
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @instance
                 */
                Uuid2l.prototype.lsb = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new Uuid2l instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid2l=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Uuid2l} Uuid2l instance
                 */
                Uuid2l.create = function create(properties) {
                    return new Uuid2l(properties);
                };

                /**
                 * Encodes the specified Uuid2l message. Does not implicitly {@link vertexvis.protobuf.core.Uuid2l.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid2l} message Uuid2l message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Uuid2l.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.msb != null && Object.hasOwnProperty.call(message, "msb"))
                        writer.uint32(/* id 1, wireType 1 =*/9).sfixed64(message.msb);
                    if (message.lsb != null && Object.hasOwnProperty.call(message, "lsb"))
                        writer.uint32(/* id 2, wireType 1 =*/17).sfixed64(message.lsb);
                    return writer;
                };

                /**
                 * Encodes the specified Uuid2l message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Uuid2l.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {vertexvis.protobuf.core.IUuid2l} message Uuid2l message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Uuid2l.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Uuid2l message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Uuid2l} Uuid2l
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Uuid2l.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Uuid2l();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.msb = reader.sfixed64();
                            break;
                        case 2:
                            message.lsb = reader.sfixed64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Uuid2l message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Uuid2l} Uuid2l
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Uuid2l.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Uuid2l message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Uuid2l.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.msb != null && message.hasOwnProperty("msb"))
                        if (!$util.isInteger(message.msb) && !(message.msb && $util.isInteger(message.msb.low) && $util.isInteger(message.msb.high)))
                            return "msb: integer|Long expected";
                    if (message.lsb != null && message.hasOwnProperty("lsb"))
                        if (!$util.isInteger(message.lsb) && !(message.lsb && $util.isInteger(message.lsb.low) && $util.isInteger(message.lsb.high)))
                            return "lsb: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an Uuid2l message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Uuid2l} Uuid2l
                 */
                Uuid2l.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Uuid2l)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Uuid2l();
                    if (object.msb != null)
                        if ($util.Long)
                            (message.msb = $util.Long.fromValue(object.msb)).unsigned = false;
                        else if (typeof object.msb === "string")
                            message.msb = parseInt(object.msb, 10);
                        else if (typeof object.msb === "number")
                            message.msb = object.msb;
                        else if (typeof object.msb === "object")
                            message.msb = new $util.LongBits(object.msb.low >>> 0, object.msb.high >>> 0).toNumber();
                    if (object.lsb != null)
                        if ($util.Long)
                            (message.lsb = $util.Long.fromValue(object.lsb)).unsigned = false;
                        else if (typeof object.lsb === "string")
                            message.lsb = parseInt(object.lsb, 10);
                        else if (typeof object.lsb === "number")
                            message.lsb = object.lsb;
                        else if (typeof object.lsb === "object")
                            message.lsb = new $util.LongBits(object.lsb.low >>> 0, object.lsb.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an Uuid2l message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @static
                 * @param {vertexvis.protobuf.core.Uuid2l} message Uuid2l
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Uuid2l.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.msb = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.msb = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.lsb = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lsb = options.longs === String ? "0" : 0;
                    }
                    if (message.msb != null && message.hasOwnProperty("msb"))
                        if (typeof message.msb === "number")
                            object.msb = options.longs === String ? String(message.msb) : message.msb;
                        else
                            object.msb = options.longs === String ? $util.Long.prototype.toString.call(message.msb) : options.longs === Number ? new $util.LongBits(message.msb.low >>> 0, message.msb.high >>> 0).toNumber() : message.msb;
                    if (message.lsb != null && message.hasOwnProperty("lsb"))
                        if (typeof message.lsb === "number")
                            object.lsb = options.longs === String ? String(message.lsb) : message.lsb;
                        else
                            object.lsb = options.longs === String ? $util.Long.prototype.toString.call(message.lsb) : options.longs === Number ? new $util.LongBits(message.lsb.low >>> 0, message.lsb.high >>> 0).toNumber() : message.lsb;
                    return object;
                };

                /**
                 * Converts this Uuid2l to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Uuid2l
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Uuid2l.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Uuid2l;
            })();

            core.UuidArray = (function() {

                /**
                 * Properties of an UuidArray.
                 * @memberof vertexvis.protobuf.core
                 * @interface IUuidArray
                 * @property {Array.<number|Long>|null} [msbs] UuidArray msbs
                 * @property {Array.<number|Long>|null} [lsbs] UuidArray lsbs
                 */

                /**
                 * Constructs a new UuidArray.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an UuidArray.
                 * @implements IUuidArray
                 * @constructor
                 * @param {vertexvis.protobuf.core.IUuidArray=} [properties] Properties to set
                 */
                function UuidArray(properties) {
                    this.msbs = [];
                    this.lsbs = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UuidArray msbs.
                 * @member {Array.<number|Long>} msbs
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @instance
                 */
                UuidArray.prototype.msbs = $util.emptyArray;

                /**
                 * UuidArray lsbs.
                 * @member {Array.<number|Long>} lsbs
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @instance
                 */
                UuidArray.prototype.lsbs = $util.emptyArray;

                /**
                 * Creates a new UuidArray instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {vertexvis.protobuf.core.IUuidArray=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.UuidArray} UuidArray instance
                 */
                UuidArray.create = function create(properties) {
                    return new UuidArray(properties);
                };

                /**
                 * Encodes the specified UuidArray message. Does not implicitly {@link vertexvis.protobuf.core.UuidArray.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {vertexvis.protobuf.core.IUuidArray} message UuidArray message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UuidArray.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.msbs != null && message.msbs.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (let i = 0; i < message.msbs.length; ++i)
                            writer.sfixed64(message.msbs[i]);
                        writer.ldelim();
                    }
                    if (message.lsbs != null && message.lsbs.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (let i = 0; i < message.lsbs.length; ++i)
                            writer.sfixed64(message.lsbs[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified UuidArray message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.UuidArray.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {vertexvis.protobuf.core.IUuidArray} message UuidArray message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UuidArray.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UuidArray message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.UuidArray} UuidArray
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UuidArray.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.UuidArray();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.msbs && message.msbs.length))
                                message.msbs = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.msbs.push(reader.sfixed64());
                            } else
                                message.msbs.push(reader.sfixed64());
                            break;
                        case 2:
                            if (!(message.lsbs && message.lsbs.length))
                                message.lsbs = [];
                            if ((tag & 7) === 2) {
                                let end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.lsbs.push(reader.sfixed64());
                            } else
                                message.lsbs.push(reader.sfixed64());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UuidArray message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.UuidArray} UuidArray
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UuidArray.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UuidArray message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UuidArray.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.msbs != null && message.hasOwnProperty("msbs")) {
                        if (!Array.isArray(message.msbs))
                            return "msbs: array expected";
                        for (let i = 0; i < message.msbs.length; ++i)
                            if (!$util.isInteger(message.msbs[i]) && !(message.msbs[i] && $util.isInteger(message.msbs[i].low) && $util.isInteger(message.msbs[i].high)))
                                return "msbs: integer|Long[] expected";
                    }
                    if (message.lsbs != null && message.hasOwnProperty("lsbs")) {
                        if (!Array.isArray(message.lsbs))
                            return "lsbs: array expected";
                        for (let i = 0; i < message.lsbs.length; ++i)
                            if (!$util.isInteger(message.lsbs[i]) && !(message.lsbs[i] && $util.isInteger(message.lsbs[i].low) && $util.isInteger(message.lsbs[i].high)))
                                return "lsbs: integer|Long[] expected";
                    }
                    return null;
                };

                /**
                 * Creates an UuidArray message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.UuidArray} UuidArray
                 */
                UuidArray.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.UuidArray)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.UuidArray();
                    if (object.msbs) {
                        if (!Array.isArray(object.msbs))
                            throw TypeError(".vertexvis.protobuf.core.UuidArray.msbs: array expected");
                        message.msbs = [];
                        for (let i = 0; i < object.msbs.length; ++i)
                            if ($util.Long)
                                (message.msbs[i] = $util.Long.fromValue(object.msbs[i])).unsigned = false;
                            else if (typeof object.msbs[i] === "string")
                                message.msbs[i] = parseInt(object.msbs[i], 10);
                            else if (typeof object.msbs[i] === "number")
                                message.msbs[i] = object.msbs[i];
                            else if (typeof object.msbs[i] === "object")
                                message.msbs[i] = new $util.LongBits(object.msbs[i].low >>> 0, object.msbs[i].high >>> 0).toNumber();
                    }
                    if (object.lsbs) {
                        if (!Array.isArray(object.lsbs))
                            throw TypeError(".vertexvis.protobuf.core.UuidArray.lsbs: array expected");
                        message.lsbs = [];
                        for (let i = 0; i < object.lsbs.length; ++i)
                            if ($util.Long)
                                (message.lsbs[i] = $util.Long.fromValue(object.lsbs[i])).unsigned = false;
                            else if (typeof object.lsbs[i] === "string")
                                message.lsbs[i] = parseInt(object.lsbs[i], 10);
                            else if (typeof object.lsbs[i] === "number")
                                message.lsbs[i] = object.lsbs[i];
                            else if (typeof object.lsbs[i] === "object")
                                message.lsbs[i] = new $util.LongBits(object.lsbs[i].low >>> 0, object.lsbs[i].high >>> 0).toNumber();
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UuidArray message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @static
                 * @param {vertexvis.protobuf.core.UuidArray} message UuidArray
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UuidArray.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.msbs = [];
                        object.lsbs = [];
                    }
                    if (message.msbs && message.msbs.length) {
                        object.msbs = [];
                        for (let j = 0; j < message.msbs.length; ++j)
                            if (typeof message.msbs[j] === "number")
                                object.msbs[j] = options.longs === String ? String(message.msbs[j]) : message.msbs[j];
                            else
                                object.msbs[j] = options.longs === String ? $util.Long.prototype.toString.call(message.msbs[j]) : options.longs === Number ? new $util.LongBits(message.msbs[j].low >>> 0, message.msbs[j].high >>> 0).toNumber() : message.msbs[j];
                    }
                    if (message.lsbs && message.lsbs.length) {
                        object.lsbs = [];
                        for (let j = 0; j < message.lsbs.length; ++j)
                            if (typeof message.lsbs[j] === "number")
                                object.lsbs[j] = options.longs === String ? String(message.lsbs[j]) : message.lsbs[j];
                            else
                                object.lsbs[j] = options.longs === String ? $util.Long.prototype.toString.call(message.lsbs[j]) : options.longs === Number ? new $util.LongBits(message.lsbs[j].low >>> 0, message.lsbs[j].high >>> 0).toNumber() : message.lsbs[j];
                    }
                    return object;
                };

                /**
                 * Converts this UuidArray to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.UuidArray
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UuidArray.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UuidArray;
            })();

            core.RGBAi = (function() {

                /**
                 * Properties of a RGBAi.
                 * @memberof vertexvis.protobuf.core
                 * @interface IRGBAi
                 * @property {number|null} [r] RGBAi r
                 * @property {number|null} [g] RGBAi g
                 * @property {number|null} [b] RGBAi b
                 * @property {number|null} [a] RGBAi a
                 */

                /**
                 * Constructs a new RGBAi.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a RGBAi.
                 * @implements IRGBAi
                 * @constructor
                 * @param {vertexvis.protobuf.core.IRGBAi=} [properties] Properties to set
                 */
                function RGBAi(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RGBAi r.
                 * @member {number} r
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @instance
                 */
                RGBAi.prototype.r = 0;

                /**
                 * RGBAi g.
                 * @member {number} g
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @instance
                 */
                RGBAi.prototype.g = 0;

                /**
                 * RGBAi b.
                 * @member {number} b
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @instance
                 */
                RGBAi.prototype.b = 0;

                /**
                 * RGBAi a.
                 * @member {number} a
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @instance
                 */
                RGBAi.prototype.a = 0;

                /**
                 * Creates a new RGBAi instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBAi=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.RGBAi} RGBAi instance
                 */
                RGBAi.create = function create(properties) {
                    return new RGBAi(properties);
                };

                /**
                 * Encodes the specified RGBAi message. Does not implicitly {@link vertexvis.protobuf.core.RGBAi.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBAi} message RGBAi message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBAi.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.r != null && Object.hasOwnProperty.call(message, "r"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.r);
                    if (message.g != null && Object.hasOwnProperty.call(message, "g"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.g);
                    if (message.b != null && Object.hasOwnProperty.call(message, "b"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.b);
                    if (message.a != null && Object.hasOwnProperty.call(message, "a"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.a);
                    return writer;
                };

                /**
                 * Encodes the specified RGBAi message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.RGBAi.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBAi} message RGBAi message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBAi.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RGBAi message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.RGBAi} RGBAi
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBAi.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.RGBAi();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.r = reader.uint32();
                            break;
                        case 2:
                            message.g = reader.uint32();
                            break;
                        case 3:
                            message.b = reader.uint32();
                            break;
                        case 4:
                            message.a = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RGBAi message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.RGBAi} RGBAi
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBAi.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RGBAi message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RGBAi.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.r != null && message.hasOwnProperty("r"))
                        if (!$util.isInteger(message.r))
                            return "r: integer expected";
                    if (message.g != null && message.hasOwnProperty("g"))
                        if (!$util.isInteger(message.g))
                            return "g: integer expected";
                    if (message.b != null && message.hasOwnProperty("b"))
                        if (!$util.isInteger(message.b))
                            return "b: integer expected";
                    if (message.a != null && message.hasOwnProperty("a"))
                        if (!$util.isInteger(message.a))
                            return "a: integer expected";
                    return null;
                };

                /**
                 * Creates a RGBAi message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.RGBAi} RGBAi
                 */
                RGBAi.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.RGBAi)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.RGBAi();
                    if (object.r != null)
                        message.r = object.r >>> 0;
                    if (object.g != null)
                        message.g = object.g >>> 0;
                    if (object.b != null)
                        message.b = object.b >>> 0;
                    if (object.a != null)
                        message.a = object.a >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a RGBAi message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @static
                 * @param {vertexvis.protobuf.core.RGBAi} message RGBAi
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RGBAi.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.r = 0;
                        object.g = 0;
                        object.b = 0;
                        object.a = 0;
                    }
                    if (message.r != null && message.hasOwnProperty("r"))
                        object.r = message.r;
                    if (message.g != null && message.hasOwnProperty("g"))
                        object.g = message.g;
                    if (message.b != null && message.hasOwnProperty("b"))
                        object.b = message.b;
                    if (message.a != null && message.hasOwnProperty("a"))
                        object.a = message.a;
                    return object;
                };

                /**
                 * Converts this RGBAi to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.RGBAi
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RGBAi.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RGBAi;
            })();

            core.RGBi = (function() {

                /**
                 * Properties of a RGBi.
                 * @memberof vertexvis.protobuf.core
                 * @interface IRGBi
                 * @property {number|null} [r] RGBi r
                 * @property {number|null} [g] RGBi g
                 * @property {number|null} [b] RGBi b
                 */

                /**
                 * Constructs a new RGBi.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a RGBi.
                 * @implements IRGBi
                 * @constructor
                 * @param {vertexvis.protobuf.core.IRGBi=} [properties] Properties to set
                 */
                function RGBi(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RGBi r.
                 * @member {number} r
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @instance
                 */
                RGBi.prototype.r = 0;

                /**
                 * RGBi g.
                 * @member {number} g
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @instance
                 */
                RGBi.prototype.g = 0;

                /**
                 * RGBi b.
                 * @member {number} b
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @instance
                 */
                RGBi.prototype.b = 0;

                /**
                 * Creates a new RGBi instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBi=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.RGBi} RGBi instance
                 */
                RGBi.create = function create(properties) {
                    return new RGBi(properties);
                };

                /**
                 * Encodes the specified RGBi message. Does not implicitly {@link vertexvis.protobuf.core.RGBi.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBi} message RGBi message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBi.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.r != null && Object.hasOwnProperty.call(message, "r"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.r);
                    if (message.g != null && Object.hasOwnProperty.call(message, "g"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.g);
                    if (message.b != null && Object.hasOwnProperty.call(message, "b"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.b);
                    return writer;
                };

                /**
                 * Encodes the specified RGBi message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.RGBi.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBi} message RGBi message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBi.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RGBi message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.RGBi} RGBi
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBi.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.RGBi();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.r = reader.uint32();
                            break;
                        case 2:
                            message.g = reader.uint32();
                            break;
                        case 3:
                            message.b = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RGBi message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.RGBi} RGBi
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBi.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RGBi message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RGBi.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.r != null && message.hasOwnProperty("r"))
                        if (!$util.isInteger(message.r))
                            return "r: integer expected";
                    if (message.g != null && message.hasOwnProperty("g"))
                        if (!$util.isInteger(message.g))
                            return "g: integer expected";
                    if (message.b != null && message.hasOwnProperty("b"))
                        if (!$util.isInteger(message.b))
                            return "b: integer expected";
                    return null;
                };

                /**
                 * Creates a RGBi message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.RGBi} RGBi
                 */
                RGBi.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.RGBi)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.RGBi();
                    if (object.r != null)
                        message.r = object.r >>> 0;
                    if (object.g != null)
                        message.g = object.g >>> 0;
                    if (object.b != null)
                        message.b = object.b >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a RGBi message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @static
                 * @param {vertexvis.protobuf.core.RGBi} message RGBi
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RGBi.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.r = 0;
                        object.g = 0;
                        object.b = 0;
                    }
                    if (message.r != null && message.hasOwnProperty("r"))
                        object.r = message.r;
                    if (message.g != null && message.hasOwnProperty("g"))
                        object.g = message.g;
                    if (message.b != null && message.hasOwnProperty("b"))
                        object.b = message.b;
                    return object;
                };

                /**
                 * Converts this RGBi to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.RGBi
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RGBi.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RGBi;
            })();

            core.RGBf = (function() {

                /**
                 * Properties of a RGBf.
                 * @memberof vertexvis.protobuf.core
                 * @interface IRGBf
                 * @property {number|null} [r] RGBf r
                 * @property {number|null} [g] RGBf g
                 * @property {number|null} [b] RGBf b
                 */

                /**
                 * Constructs a new RGBf.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a RGBf.
                 * @implements IRGBf
                 * @constructor
                 * @param {vertexvis.protobuf.core.IRGBf=} [properties] Properties to set
                 */
                function RGBf(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RGBf r.
                 * @member {number} r
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @instance
                 */
                RGBf.prototype.r = 0;

                /**
                 * RGBf g.
                 * @member {number} g
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @instance
                 */
                RGBf.prototype.g = 0;

                /**
                 * RGBf b.
                 * @member {number} b
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @instance
                 */
                RGBf.prototype.b = 0;

                /**
                 * Creates a new RGBf instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBf=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.RGBf} RGBf instance
                 */
                RGBf.create = function create(properties) {
                    return new RGBf(properties);
                };

                /**
                 * Encodes the specified RGBf message. Does not implicitly {@link vertexvis.protobuf.core.RGBf.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBf} message RGBf message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBf.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.r != null && Object.hasOwnProperty.call(message, "r"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.r);
                    if (message.g != null && Object.hasOwnProperty.call(message, "g"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.g);
                    if (message.b != null && Object.hasOwnProperty.call(message, "b"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.b);
                    return writer;
                };

                /**
                 * Encodes the specified RGBf message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.RGBf.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {vertexvis.protobuf.core.IRGBf} message RGBf message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RGBf.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RGBf message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.RGBf} RGBf
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBf.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.RGBf();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.r = reader.float();
                            break;
                        case 2:
                            message.g = reader.float();
                            break;
                        case 3:
                            message.b = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RGBf message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.RGBf} RGBf
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RGBf.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RGBf message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RGBf.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.r != null && message.hasOwnProperty("r"))
                        if (typeof message.r !== "number")
                            return "r: number expected";
                    if (message.g != null && message.hasOwnProperty("g"))
                        if (typeof message.g !== "number")
                            return "g: number expected";
                    if (message.b != null && message.hasOwnProperty("b"))
                        if (typeof message.b !== "number")
                            return "b: number expected";
                    return null;
                };

                /**
                 * Creates a RGBf message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.RGBf} RGBf
                 */
                RGBf.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.RGBf)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.RGBf();
                    if (object.r != null)
                        message.r = Number(object.r);
                    if (object.g != null)
                        message.g = Number(object.g);
                    if (object.b != null)
                        message.b = Number(object.b);
                    return message;
                };

                /**
                 * Creates a plain object from a RGBf message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @static
                 * @param {vertexvis.protobuf.core.RGBf} message RGBf
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RGBf.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.r = 0;
                        object.g = 0;
                        object.b = 0;
                    }
                    if (message.r != null && message.hasOwnProperty("r"))
                        object.r = options.json && !isFinite(message.r) ? String(message.r) : message.r;
                    if (message.g != null && message.hasOwnProperty("g"))
                        object.g = options.json && !isFinite(message.g) ? String(message.g) : message.g;
                    if (message.b != null && message.hasOwnProperty("b"))
                        object.b = options.json && !isFinite(message.b) ? String(message.b) : message.b;
                    return object;
                };

                /**
                 * Converts this RGBf to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.RGBf
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RGBf.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RGBf;
            })();

            core.MaterialOverride = (function() {

                /**
                 * Properties of a MaterialOverride.
                 * @memberof vertexvis.protobuf.core
                 * @interface IMaterialOverride
                 * @property {vertexvis.protobuf.core.IDefaultMaterial|null} [defaultMaterial] MaterialOverride defaultMaterial
                 * @property {vertexvis.protobuf.core.IColorMaterial|null} [colorMaterial] MaterialOverride colorMaterial
                 */

                /**
                 * Constructs a new MaterialOverride.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a MaterialOverride.
                 * @implements IMaterialOverride
                 * @constructor
                 * @param {vertexvis.protobuf.core.IMaterialOverride=} [properties] Properties to set
                 */
                function MaterialOverride(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MaterialOverride defaultMaterial.
                 * @member {vertexvis.protobuf.core.IDefaultMaterial|null|undefined} defaultMaterial
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @instance
                 */
                MaterialOverride.prototype.defaultMaterial = null;

                /**
                 * MaterialOverride colorMaterial.
                 * @member {vertexvis.protobuf.core.IColorMaterial|null|undefined} colorMaterial
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @instance
                 */
                MaterialOverride.prototype.colorMaterial = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * MaterialOverride sealedValueOptional.
                 * @member {"defaultMaterial"|"colorMaterial"|undefined} sealedValueOptional
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @instance
                 */
                Object.defineProperty(MaterialOverride.prototype, "sealedValueOptional", {
                    get: $util.oneOfGetter($oneOfFields = ["defaultMaterial", "colorMaterial"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MaterialOverride instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {vertexvis.protobuf.core.IMaterialOverride=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.MaterialOverride} MaterialOverride instance
                 */
                MaterialOverride.create = function create(properties) {
                    return new MaterialOverride(properties);
                };

                /**
                 * Encodes the specified MaterialOverride message. Does not implicitly {@link vertexvis.protobuf.core.MaterialOverride.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {vertexvis.protobuf.core.IMaterialOverride} message MaterialOverride message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MaterialOverride.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.defaultMaterial != null && Object.hasOwnProperty.call(message, "defaultMaterial"))
                        $root.vertexvis.protobuf.core.DefaultMaterial.encode(message.defaultMaterial, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.colorMaterial != null && Object.hasOwnProperty.call(message, "colorMaterial"))
                        $root.vertexvis.protobuf.core.ColorMaterial.encode(message.colorMaterial, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MaterialOverride message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.MaterialOverride.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {vertexvis.protobuf.core.IMaterialOverride} message MaterialOverride message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MaterialOverride.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MaterialOverride message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.MaterialOverride} MaterialOverride
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MaterialOverride.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.MaterialOverride();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.defaultMaterial = $root.vertexvis.protobuf.core.DefaultMaterial.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.colorMaterial = $root.vertexvis.protobuf.core.ColorMaterial.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MaterialOverride message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.MaterialOverride} MaterialOverride
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MaterialOverride.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MaterialOverride message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MaterialOverride.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.defaultMaterial != null && message.hasOwnProperty("defaultMaterial")) {
                        properties.sealedValueOptional = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.DefaultMaterial.verify(message.defaultMaterial);
                            if (error)
                                return "defaultMaterial." + error;
                        }
                    }
                    if (message.colorMaterial != null && message.hasOwnProperty("colorMaterial")) {
                        if (properties.sealedValueOptional === 1)
                            return "sealedValueOptional: multiple values";
                        properties.sealedValueOptional = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.ColorMaterial.verify(message.colorMaterial);
                            if (error)
                                return "colorMaterial." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MaterialOverride message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.MaterialOverride} MaterialOverride
                 */
                MaterialOverride.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.MaterialOverride)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.MaterialOverride();
                    if (object.defaultMaterial != null) {
                        if (typeof object.defaultMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.core.MaterialOverride.defaultMaterial: object expected");
                        message.defaultMaterial = $root.vertexvis.protobuf.core.DefaultMaterial.fromObject(object.defaultMaterial);
                    }
                    if (object.colorMaterial != null) {
                        if (typeof object.colorMaterial !== "object")
                            throw TypeError(".vertexvis.protobuf.core.MaterialOverride.colorMaterial: object expected");
                        message.colorMaterial = $root.vertexvis.protobuf.core.ColorMaterial.fromObject(object.colorMaterial);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MaterialOverride message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @static
                 * @param {vertexvis.protobuf.core.MaterialOverride} message MaterialOverride
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MaterialOverride.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.defaultMaterial != null && message.hasOwnProperty("defaultMaterial")) {
                        object.defaultMaterial = $root.vertexvis.protobuf.core.DefaultMaterial.toObject(message.defaultMaterial, options);
                        if (options.oneofs)
                            object.sealedValueOptional = "defaultMaterial";
                    }
                    if (message.colorMaterial != null && message.hasOwnProperty("colorMaterial")) {
                        object.colorMaterial = $root.vertexvis.protobuf.core.ColorMaterial.toObject(message.colorMaterial, options);
                        if (options.oneofs)
                            object.sealedValueOptional = "colorMaterial";
                    }
                    return object;
                };

                /**
                 * Converts this MaterialOverride to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.MaterialOverride
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MaterialOverride.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return MaterialOverride;
            })();

            core.DefaultMaterial = (function() {

                /**
                 * Properties of a DefaultMaterial.
                 * @memberof vertexvis.protobuf.core
                 * @interface IDefaultMaterial
                 */

                /**
                 * Constructs a new DefaultMaterial.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a DefaultMaterial.
                 * @implements IDefaultMaterial
                 * @constructor
                 * @param {vertexvis.protobuf.core.IDefaultMaterial=} [properties] Properties to set
                 */
                function DefaultMaterial(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new DefaultMaterial instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IDefaultMaterial=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.DefaultMaterial} DefaultMaterial instance
                 */
                DefaultMaterial.create = function create(properties) {
                    return new DefaultMaterial(properties);
                };

                /**
                 * Encodes the specified DefaultMaterial message. Does not implicitly {@link vertexvis.protobuf.core.DefaultMaterial.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IDefaultMaterial} message DefaultMaterial message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DefaultMaterial.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified DefaultMaterial message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.DefaultMaterial.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IDefaultMaterial} message DefaultMaterial message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DefaultMaterial.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DefaultMaterial message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.DefaultMaterial} DefaultMaterial
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DefaultMaterial.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.DefaultMaterial();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DefaultMaterial message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.DefaultMaterial} DefaultMaterial
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DefaultMaterial.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DefaultMaterial message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DefaultMaterial.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a DefaultMaterial message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.DefaultMaterial} DefaultMaterial
                 */
                DefaultMaterial.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.DefaultMaterial)
                        return object;
                    return new $root.vertexvis.protobuf.core.DefaultMaterial();
                };

                /**
                 * Creates a plain object from a DefaultMaterial message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.DefaultMaterial} message DefaultMaterial
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DefaultMaterial.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this DefaultMaterial to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.DefaultMaterial
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DefaultMaterial.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DefaultMaterial;
            })();

            core.ColorMaterial = (function() {

                /**
                 * Properties of a ColorMaterial.
                 * @memberof vertexvis.protobuf.core
                 * @interface IColorMaterial
                 * @property {number|null} [d] ColorMaterial d
                 * @property {number|null} [ns] ColorMaterial ns
                 * @property {vertexvis.protobuf.core.IRGBi|null} [ka] ColorMaterial ka
                 * @property {vertexvis.protobuf.core.IRGBi|null} [kd] ColorMaterial kd
                 * @property {vertexvis.protobuf.core.IRGBi|null} [ks] ColorMaterial ks
                 * @property {vertexvis.protobuf.core.IRGBi|null} [ke] ColorMaterial ke
                 */

                /**
                 * Constructs a new ColorMaterial.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a ColorMaterial.
                 * @implements IColorMaterial
                 * @constructor
                 * @param {vertexvis.protobuf.core.IColorMaterial=} [properties] Properties to set
                 */
                function ColorMaterial(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColorMaterial d.
                 * @member {number} d
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.d = 0;

                /**
                 * ColorMaterial ns.
                 * @member {number} ns
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.ns = 0;

                /**
                 * ColorMaterial ka.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} ka
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.ka = null;

                /**
                 * ColorMaterial kd.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} kd
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.kd = null;

                /**
                 * ColorMaterial ks.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} ks
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.ks = null;

                /**
                 * ColorMaterial ke.
                 * @member {vertexvis.protobuf.core.IRGBi|null|undefined} ke
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 */
                ColorMaterial.prototype.ke = null;

                /**
                 * Creates a new ColorMaterial instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterial=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.ColorMaterial} ColorMaterial instance
                 */
                ColorMaterial.create = function create(properties) {
                    return new ColorMaterial(properties);
                };

                /**
                 * Encodes the specified ColorMaterial message. Does not implicitly {@link vertexvis.protobuf.core.ColorMaterial.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterial} message ColorMaterial message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColorMaterial.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.d != null && Object.hasOwnProperty.call(message, "d"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.d);
                    if (message.ns != null && Object.hasOwnProperty.call(message, "ns"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ns);
                    if (message.ka != null && Object.hasOwnProperty.call(message, "ka"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.ka, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.kd != null && Object.hasOwnProperty.call(message, "kd"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.kd, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.ks != null && Object.hasOwnProperty.call(message, "ks"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.ks, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.ke != null && Object.hasOwnProperty.call(message, "ke"))
                        $root.vertexvis.protobuf.core.RGBi.encode(message.ke, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ColorMaterial message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.ColorMaterial.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterial} message ColorMaterial message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColorMaterial.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ColorMaterial message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.ColorMaterial} ColorMaterial
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColorMaterial.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.ColorMaterial();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.d = reader.uint32();
                            break;
                        case 2:
                            message.ns = reader.uint32();
                            break;
                        case 3:
                            message.ka = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.kd = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.ks = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.ke = $root.vertexvis.protobuf.core.RGBi.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ColorMaterial message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.ColorMaterial} ColorMaterial
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColorMaterial.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ColorMaterial message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ColorMaterial.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.d != null && message.hasOwnProperty("d"))
                        if (!$util.isInteger(message.d))
                            return "d: integer expected";
                    if (message.ns != null && message.hasOwnProperty("ns"))
                        if (!$util.isInteger(message.ns))
                            return "ns: integer expected";
                    if (message.ka != null && message.hasOwnProperty("ka")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.ka);
                        if (error)
                            return "ka." + error;
                    }
                    if (message.kd != null && message.hasOwnProperty("kd")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.kd);
                        if (error)
                            return "kd." + error;
                    }
                    if (message.ks != null && message.hasOwnProperty("ks")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.ks);
                        if (error)
                            return "ks." + error;
                    }
                    if (message.ke != null && message.hasOwnProperty("ke")) {
                        let error = $root.vertexvis.protobuf.core.RGBi.verify(message.ke);
                        if (error)
                            return "ke." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ColorMaterial message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.ColorMaterial} ColorMaterial
                 */
                ColorMaterial.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.ColorMaterial)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.ColorMaterial();
                    if (object.d != null)
                        message.d = object.d >>> 0;
                    if (object.ns != null)
                        message.ns = object.ns >>> 0;
                    if (object.ka != null) {
                        if (typeof object.ka !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterial.ka: object expected");
                        message.ka = $root.vertexvis.protobuf.core.RGBi.fromObject(object.ka);
                    }
                    if (object.kd != null) {
                        if (typeof object.kd !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterial.kd: object expected");
                        message.kd = $root.vertexvis.protobuf.core.RGBi.fromObject(object.kd);
                    }
                    if (object.ks != null) {
                        if (typeof object.ks !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterial.ks: object expected");
                        message.ks = $root.vertexvis.protobuf.core.RGBi.fromObject(object.ks);
                    }
                    if (object.ke != null) {
                        if (typeof object.ke !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterial.ke: object expected");
                        message.ke = $root.vertexvis.protobuf.core.RGBi.fromObject(object.ke);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ColorMaterial message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @static
                 * @param {vertexvis.protobuf.core.ColorMaterial} message ColorMaterial
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ColorMaterial.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.d = 0;
                        object.ns = 0;
                        object.ka = null;
                        object.kd = null;
                        object.ks = null;
                        object.ke = null;
                    }
                    if (message.d != null && message.hasOwnProperty("d"))
                        object.d = message.d;
                    if (message.ns != null && message.hasOwnProperty("ns"))
                        object.ns = message.ns;
                    if (message.ka != null && message.hasOwnProperty("ka"))
                        object.ka = $root.vertexvis.protobuf.core.RGBi.toObject(message.ka, options);
                    if (message.kd != null && message.hasOwnProperty("kd"))
                        object.kd = $root.vertexvis.protobuf.core.RGBi.toObject(message.kd, options);
                    if (message.ks != null && message.hasOwnProperty("ks"))
                        object.ks = $root.vertexvis.protobuf.core.RGBi.toObject(message.ks, options);
                    if (message.ke != null && message.hasOwnProperty("ke"))
                        object.ke = $root.vertexvis.protobuf.core.RGBi.toObject(message.ke, options);
                    return object;
                };

                /**
                 * Converts this ColorMaterial to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.ColorMaterial
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ColorMaterial.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ColorMaterial;
            })();

            core.ColorMaterialf = (function() {

                /**
                 * Properties of a ColorMaterialf.
                 * @memberof vertexvis.protobuf.core
                 * @interface IColorMaterialf
                 * @property {number|null} [d] ColorMaterialf d
                 * @property {number|null} [ns] ColorMaterialf ns
                 * @property {vertexvis.protobuf.core.IRGBf|null} [ka] ColorMaterialf ka
                 * @property {vertexvis.protobuf.core.IRGBf|null} [kd] ColorMaterialf kd
                 * @property {vertexvis.protobuf.core.IRGBf|null} [ks] ColorMaterialf ks
                 * @property {vertexvis.protobuf.core.IRGBf|null} [ke] ColorMaterialf ke
                 */

                /**
                 * Constructs a new ColorMaterialf.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a ColorMaterialf.
                 * @implements IColorMaterialf
                 * @constructor
                 * @param {vertexvis.protobuf.core.IColorMaterialf=} [properties] Properties to set
                 */
                function ColorMaterialf(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColorMaterialf d.
                 * @member {number} d
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.d = 0;

                /**
                 * ColorMaterialf ns.
                 * @member {number} ns
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.ns = 0;

                /**
                 * ColorMaterialf ka.
                 * @member {vertexvis.protobuf.core.IRGBf|null|undefined} ka
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.ka = null;

                /**
                 * ColorMaterialf kd.
                 * @member {vertexvis.protobuf.core.IRGBf|null|undefined} kd
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.kd = null;

                /**
                 * ColorMaterialf ks.
                 * @member {vertexvis.protobuf.core.IRGBf|null|undefined} ks
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.ks = null;

                /**
                 * ColorMaterialf ke.
                 * @member {vertexvis.protobuf.core.IRGBf|null|undefined} ke
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 */
                ColorMaterialf.prototype.ke = null;

                /**
                 * Creates a new ColorMaterialf instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterialf=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.ColorMaterialf} ColorMaterialf instance
                 */
                ColorMaterialf.create = function create(properties) {
                    return new ColorMaterialf(properties);
                };

                /**
                 * Encodes the specified ColorMaterialf message. Does not implicitly {@link vertexvis.protobuf.core.ColorMaterialf.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterialf} message ColorMaterialf message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColorMaterialf.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.d != null && Object.hasOwnProperty.call(message, "d"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.d);
                    if (message.ns != null && Object.hasOwnProperty.call(message, "ns"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.ns);
                    if (message.ka != null && Object.hasOwnProperty.call(message, "ka"))
                        $root.vertexvis.protobuf.core.RGBf.encode(message.ka, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.kd != null && Object.hasOwnProperty.call(message, "kd"))
                        $root.vertexvis.protobuf.core.RGBf.encode(message.kd, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.ks != null && Object.hasOwnProperty.call(message, "ks"))
                        $root.vertexvis.protobuf.core.RGBf.encode(message.ks, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.ke != null && Object.hasOwnProperty.call(message, "ke"))
                        $root.vertexvis.protobuf.core.RGBf.encode(message.ke, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ColorMaterialf message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.ColorMaterialf.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {vertexvis.protobuf.core.IColorMaterialf} message ColorMaterialf message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColorMaterialf.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ColorMaterialf message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.ColorMaterialf} ColorMaterialf
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColorMaterialf.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.ColorMaterialf();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.d = reader.float();
                            break;
                        case 2:
                            message.ns = reader.float();
                            break;
                        case 3:
                            message.ka = $root.vertexvis.protobuf.core.RGBf.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.kd = $root.vertexvis.protobuf.core.RGBf.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.ks = $root.vertexvis.protobuf.core.RGBf.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.ke = $root.vertexvis.protobuf.core.RGBf.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ColorMaterialf message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.ColorMaterialf} ColorMaterialf
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColorMaterialf.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ColorMaterialf message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ColorMaterialf.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.d != null && message.hasOwnProperty("d"))
                        if (typeof message.d !== "number")
                            return "d: number expected";
                    if (message.ns != null && message.hasOwnProperty("ns"))
                        if (typeof message.ns !== "number")
                            return "ns: number expected";
                    if (message.ka != null && message.hasOwnProperty("ka")) {
                        let error = $root.vertexvis.protobuf.core.RGBf.verify(message.ka);
                        if (error)
                            return "ka." + error;
                    }
                    if (message.kd != null && message.hasOwnProperty("kd")) {
                        let error = $root.vertexvis.protobuf.core.RGBf.verify(message.kd);
                        if (error)
                            return "kd." + error;
                    }
                    if (message.ks != null && message.hasOwnProperty("ks")) {
                        let error = $root.vertexvis.protobuf.core.RGBf.verify(message.ks);
                        if (error)
                            return "ks." + error;
                    }
                    if (message.ke != null && message.hasOwnProperty("ke")) {
                        let error = $root.vertexvis.protobuf.core.RGBf.verify(message.ke);
                        if (error)
                            return "ke." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ColorMaterialf message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.ColorMaterialf} ColorMaterialf
                 */
                ColorMaterialf.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.ColorMaterialf)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.ColorMaterialf();
                    if (object.d != null)
                        message.d = Number(object.d);
                    if (object.ns != null)
                        message.ns = Number(object.ns);
                    if (object.ka != null) {
                        if (typeof object.ka !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterialf.ka: object expected");
                        message.ka = $root.vertexvis.protobuf.core.RGBf.fromObject(object.ka);
                    }
                    if (object.kd != null) {
                        if (typeof object.kd !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterialf.kd: object expected");
                        message.kd = $root.vertexvis.protobuf.core.RGBf.fromObject(object.kd);
                    }
                    if (object.ks != null) {
                        if (typeof object.ks !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterialf.ks: object expected");
                        message.ks = $root.vertexvis.protobuf.core.RGBf.fromObject(object.ks);
                    }
                    if (object.ke != null) {
                        if (typeof object.ke !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ColorMaterialf.ke: object expected");
                        message.ke = $root.vertexvis.protobuf.core.RGBf.fromObject(object.ke);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ColorMaterialf message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @static
                 * @param {vertexvis.protobuf.core.ColorMaterialf} message ColorMaterialf
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ColorMaterialf.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.d = 0;
                        object.ns = 0;
                        object.ka = null;
                        object.kd = null;
                        object.ks = null;
                        object.ke = null;
                    }
                    if (message.d != null && message.hasOwnProperty("d"))
                        object.d = options.json && !isFinite(message.d) ? String(message.d) : message.d;
                    if (message.ns != null && message.hasOwnProperty("ns"))
                        object.ns = options.json && !isFinite(message.ns) ? String(message.ns) : message.ns;
                    if (message.ka != null && message.hasOwnProperty("ka"))
                        object.ka = $root.vertexvis.protobuf.core.RGBf.toObject(message.ka, options);
                    if (message.kd != null && message.hasOwnProperty("kd"))
                        object.kd = $root.vertexvis.protobuf.core.RGBf.toObject(message.kd, options);
                    if (message.ks != null && message.hasOwnProperty("ks"))
                        object.ks = $root.vertexvis.protobuf.core.RGBf.toObject(message.ks, options);
                    if (message.ke != null && message.hasOwnProperty("ke"))
                        object.ke = $root.vertexvis.protobuf.core.RGBf.toObject(message.ke, options);
                    return object;
                };

                /**
                 * Converts this ColorMaterialf to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.ColorMaterialf
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ColorMaterialf.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ColorMaterialf;
            })();

            core.BasicColor = (function() {

                /**
                 * Properties of a BasicColor.
                 * @memberof vertexvis.protobuf.core
                 * @interface IBasicColor
                 * @property {vertexvis.protobuf.core.IRGBf|null} [baseColor] BasicColor baseColor
                 */

                /**
                 * Constructs a new BasicColor.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a BasicColor.
                 * @implements IBasicColor
                 * @constructor
                 * @param {vertexvis.protobuf.core.IBasicColor=} [properties] Properties to set
                 */
                function BasicColor(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BasicColor baseColor.
                 * @member {vertexvis.protobuf.core.IRGBf|null|undefined} baseColor
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @instance
                 */
                BasicColor.prototype.baseColor = null;

                /**
                 * Creates a new BasicColor instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {vertexvis.protobuf.core.IBasicColor=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.BasicColor} BasicColor instance
                 */
                BasicColor.create = function create(properties) {
                    return new BasicColor(properties);
                };

                /**
                 * Encodes the specified BasicColor message. Does not implicitly {@link vertexvis.protobuf.core.BasicColor.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {vertexvis.protobuf.core.IBasicColor} message BasicColor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BasicColor.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.baseColor != null && Object.hasOwnProperty.call(message, "baseColor"))
                        $root.vertexvis.protobuf.core.RGBf.encode(message.baseColor, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BasicColor message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.BasicColor.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {vertexvis.protobuf.core.IBasicColor} message BasicColor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BasicColor.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BasicColor message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.BasicColor} BasicColor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BasicColor.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.BasicColor();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.baseColor = $root.vertexvis.protobuf.core.RGBf.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BasicColor message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.BasicColor} BasicColor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BasicColor.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BasicColor message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BasicColor.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.baseColor != null && message.hasOwnProperty("baseColor")) {
                        let error = $root.vertexvis.protobuf.core.RGBf.verify(message.baseColor);
                        if (error)
                            return "baseColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BasicColor message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.BasicColor} BasicColor
                 */
                BasicColor.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.BasicColor)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.BasicColor();
                    if (object.baseColor != null) {
                        if (typeof object.baseColor !== "object")
                            throw TypeError(".vertexvis.protobuf.core.BasicColor.baseColor: object expected");
                        message.baseColor = $root.vertexvis.protobuf.core.RGBf.fromObject(object.baseColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BasicColor message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @static
                 * @param {vertexvis.protobuf.core.BasicColor} message BasicColor
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BasicColor.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.baseColor = null;
                    if (message.baseColor != null && message.hasOwnProperty("baseColor"))
                        object.baseColor = $root.vertexvis.protobuf.core.RGBf.toObject(message.baseColor, options);
                    return object;
                };

                /**
                 * Converts this BasicColor to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.BasicColor
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BasicColor.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BasicColor;
            })();

            core.ModelEntity = (function() {

                /**
                 * Properties of a ModelEntity.
                 * @memberof vertexvis.protobuf.core
                 * @interface IModelEntity
                 * @property {number|Long|null} [entityId] ModelEntity entityId
                 * @property {vertexvis.protobuf.core.IUuid|null} [sceneItemId] ModelEntity sceneItemId
                 * @property {Array.<google.protobuf.IAny>|null} [details] ModelEntity details
                 */

                /**
                 * Constructs a new ModelEntity.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a ModelEntity.
                 * @implements IModelEntity
                 * @constructor
                 * @param {vertexvis.protobuf.core.IModelEntity=} [properties] Properties to set
                 */
                function ModelEntity(properties) {
                    this.details = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ModelEntity entityId.
                 * @member {number|Long} entityId
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @instance
                 */
                ModelEntity.prototype.entityId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ModelEntity sceneItemId.
                 * @member {vertexvis.protobuf.core.IUuid|null|undefined} sceneItemId
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @instance
                 */
                ModelEntity.prototype.sceneItemId = null;

                /**
                 * ModelEntity details.
                 * @member {Array.<google.protobuf.IAny>} details
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @instance
                 */
                ModelEntity.prototype.details = $util.emptyArray;

                /**
                 * Creates a new ModelEntity instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {vertexvis.protobuf.core.IModelEntity=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.ModelEntity} ModelEntity instance
                 */
                ModelEntity.create = function create(properties) {
                    return new ModelEntity(properties);
                };

                /**
                 * Encodes the specified ModelEntity message. Does not implicitly {@link vertexvis.protobuf.core.ModelEntity.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {vertexvis.protobuf.core.IModelEntity} message ModelEntity message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ModelEntity.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.entityId != null && Object.hasOwnProperty.call(message, "entityId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.entityId);
                    if (message.sceneItemId != null && Object.hasOwnProperty.call(message, "sceneItemId"))
                        $root.vertexvis.protobuf.core.Uuid.encode(message.sceneItemId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.details != null && message.details.length)
                        for (let i = 0; i < message.details.length; ++i)
                            $root.google.protobuf.Any.encode(message.details[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ModelEntity message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.ModelEntity.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {vertexvis.protobuf.core.IModelEntity} message ModelEntity message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ModelEntity.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ModelEntity message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.ModelEntity} ModelEntity
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ModelEntity.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.ModelEntity();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.entityId = reader.int64();
                            break;
                        case 2:
                            message.sceneItemId = $root.vertexvis.protobuf.core.Uuid.decode(reader, reader.uint32());
                            break;
                        case 3:
                            if (!(message.details && message.details.length))
                                message.details = [];
                            message.details.push($root.google.protobuf.Any.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ModelEntity message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.ModelEntity} ModelEntity
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ModelEntity.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ModelEntity message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ModelEntity.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.entityId != null && message.hasOwnProperty("entityId"))
                        if (!$util.isInteger(message.entityId) && !(message.entityId && $util.isInteger(message.entityId.low) && $util.isInteger(message.entityId.high)))
                            return "entityId: integer|Long expected";
                    if (message.sceneItemId != null && message.hasOwnProperty("sceneItemId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid.verify(message.sceneItemId);
                        if (error)
                            return "sceneItemId." + error;
                    }
                    if (message.details != null && message.hasOwnProperty("details")) {
                        if (!Array.isArray(message.details))
                            return "details: array expected";
                        for (let i = 0; i < message.details.length; ++i) {
                            let error = $root.google.protobuf.Any.verify(message.details[i]);
                            if (error)
                                return "details." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ModelEntity message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.ModelEntity} ModelEntity
                 */
                ModelEntity.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.ModelEntity)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.ModelEntity();
                    if (object.entityId != null)
                        if ($util.Long)
                            (message.entityId = $util.Long.fromValue(object.entityId)).unsigned = false;
                        else if (typeof object.entityId === "string")
                            message.entityId = parseInt(object.entityId, 10);
                        else if (typeof object.entityId === "number")
                            message.entityId = object.entityId;
                        else if (typeof object.entityId === "object")
                            message.entityId = new $util.LongBits(object.entityId.low >>> 0, object.entityId.high >>> 0).toNumber();
                    if (object.sceneItemId != null) {
                        if (typeof object.sceneItemId !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ModelEntity.sceneItemId: object expected");
                        message.sceneItemId = $root.vertexvis.protobuf.core.Uuid.fromObject(object.sceneItemId);
                    }
                    if (object.details) {
                        if (!Array.isArray(object.details))
                            throw TypeError(".vertexvis.protobuf.core.ModelEntity.details: array expected");
                        message.details = [];
                        for (let i = 0; i < object.details.length; ++i) {
                            if (typeof object.details[i] !== "object")
                                throw TypeError(".vertexvis.protobuf.core.ModelEntity.details: object expected");
                            message.details[i] = $root.google.protobuf.Any.fromObject(object.details[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ModelEntity message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @static
                 * @param {vertexvis.protobuf.core.ModelEntity} message ModelEntity
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ModelEntity.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.details = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.entityId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.entityId = options.longs === String ? "0" : 0;
                        object.sceneItemId = null;
                    }
                    if (message.entityId != null && message.hasOwnProperty("entityId"))
                        if (typeof message.entityId === "number")
                            object.entityId = options.longs === String ? String(message.entityId) : message.entityId;
                        else
                            object.entityId = options.longs === String ? $util.Long.prototype.toString.call(message.entityId) : options.longs === Number ? new $util.LongBits(message.entityId.low >>> 0, message.entityId.high >>> 0).toNumber() : message.entityId;
                    if (message.sceneItemId != null && message.hasOwnProperty("sceneItemId"))
                        object.sceneItemId = $root.vertexvis.protobuf.core.Uuid.toObject(message.sceneItemId, options);
                    if (message.details && message.details.length) {
                        object.details = [];
                        for (let j = 0; j < message.details.length; ++j)
                            object.details[j] = $root.google.protobuf.Any.toObject(message.details[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ModelEntity to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.ModelEntity
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ModelEntity.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ModelEntity;
            })();

            core.Instant = (function() {

                /**
                 * Properties of an Instant.
                 * @memberof vertexvis.protobuf.core
                 * @interface IInstant
                 * @property {string|null} [iso] Instant iso
                 */

                /**
                 * Constructs a new Instant.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an Instant.
                 * @implements IInstant
                 * @constructor
                 * @param {vertexvis.protobuf.core.IInstant=} [properties] Properties to set
                 */
                function Instant(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Instant iso.
                 * @member {string} iso
                 * @memberof vertexvis.protobuf.core.Instant
                 * @instance
                 */
                Instant.prototype.iso = "";

                /**
                 * Creates a new Instant instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {vertexvis.protobuf.core.IInstant=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Instant} Instant instance
                 */
                Instant.create = function create(properties) {
                    return new Instant(properties);
                };

                /**
                 * Encodes the specified Instant message. Does not implicitly {@link vertexvis.protobuf.core.Instant.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {vertexvis.protobuf.core.IInstant} message Instant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Instant.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.iso != null && Object.hasOwnProperty.call(message, "iso"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.iso);
                    return writer;
                };

                /**
                 * Encodes the specified Instant message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Instant.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {vertexvis.protobuf.core.IInstant} message Instant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Instant.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Instant message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Instant} Instant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Instant.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Instant();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.iso = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Instant message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Instant} Instant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Instant.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Instant message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Instant.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.iso != null && message.hasOwnProperty("iso"))
                        if (!$util.isString(message.iso))
                            return "iso: string expected";
                    return null;
                };

                /**
                 * Creates an Instant message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Instant} Instant
                 */
                Instant.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Instant)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Instant();
                    if (object.iso != null)
                        message.iso = String(object.iso);
                    return message;
                };

                /**
                 * Creates a plain object from an Instant message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Instant
                 * @static
                 * @param {vertexvis.protobuf.core.Instant} message Instant
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Instant.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.iso = "";
                    if (message.iso != null && message.hasOwnProperty("iso"))
                        object.iso = message.iso;
                    return object;
                };

                /**
                 * Converts this Instant to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Instant
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Instant.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Instant;
            })();

            core.ModelView = (function() {

                /**
                 * Properties of a ModelView.
                 * @memberof vertexvis.protobuf.core
                 * @interface IModelView
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [id] ModelView id
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [partRevisionId] ModelView partRevisionId
                 * @property {string|null} [displayName] ModelView displayName
                 * @property {vertexvis.protobuf.core.ICamera|null} [camera] ModelView camera
                 */

                /**
                 * Constructs a new ModelView.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a ModelView.
                 * @implements IModelView
                 * @constructor
                 * @param {vertexvis.protobuf.core.IModelView=} [properties] Properties to set
                 */
                function ModelView(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ModelView id.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} id
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @instance
                 */
                ModelView.prototype.id = null;

                /**
                 * ModelView partRevisionId.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} partRevisionId
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @instance
                 */
                ModelView.prototype.partRevisionId = null;

                /**
                 * ModelView displayName.
                 * @member {string} displayName
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @instance
                 */
                ModelView.prototype.displayName = "";

                /**
                 * ModelView camera.
                 * @member {vertexvis.protobuf.core.ICamera|null|undefined} camera
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @instance
                 */
                ModelView.prototype.camera = null;

                /**
                 * Creates a new ModelView instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IModelView=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.ModelView} ModelView instance
                 */
                ModelView.create = function create(properties) {
                    return new ModelView(properties);
                };

                /**
                 * Encodes the specified ModelView message. Does not implicitly {@link vertexvis.protobuf.core.ModelView.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IModelView} message ModelView message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ModelView.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.partRevisionId != null && Object.hasOwnProperty.call(message, "partRevisionId"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.partRevisionId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.displayName);
                    if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                        $root.vertexvis.protobuf.core.Camera.encode(message.camera, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ModelView message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.ModelView.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IModelView} message ModelView message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ModelView.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ModelView message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.ModelView} ModelView
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ModelView.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.ModelView();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.partRevisionId = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.displayName = reader.string();
                            break;
                        case 4:
                            message.camera = $root.vertexvis.protobuf.core.Camera.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ModelView message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.ModelView} ModelView
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ModelView.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ModelView message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ModelView.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.id);
                        if (error)
                            return "id." + error;
                    }
                    if (message.partRevisionId != null && message.hasOwnProperty("partRevisionId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.partRevisionId);
                        if (error)
                            return "partRevisionId." + error;
                    }
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        if (!$util.isString(message.displayName))
                            return "displayName: string expected";
                    if (message.camera != null && message.hasOwnProperty("camera")) {
                        let error = $root.vertexvis.protobuf.core.Camera.verify(message.camera);
                        if (error)
                            return "camera." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ModelView message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.ModelView} ModelView
                 */
                ModelView.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.ModelView)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.ModelView();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ModelView.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.id);
                    }
                    if (object.partRevisionId != null) {
                        if (typeof object.partRevisionId !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ModelView.partRevisionId: object expected");
                        message.partRevisionId = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.partRevisionId);
                    }
                    if (object.displayName != null)
                        message.displayName = String(object.displayName);
                    if (object.camera != null) {
                        if (typeof object.camera !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ModelView.camera: object expected");
                        message.camera = $root.vertexvis.protobuf.core.Camera.fromObject(object.camera);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ModelView message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @static
                 * @param {vertexvis.protobuf.core.ModelView} message ModelView
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ModelView.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = null;
                        object.partRevisionId = null;
                        object.displayName = "";
                        object.camera = null;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.id, options);
                    if (message.partRevisionId != null && message.hasOwnProperty("partRevisionId"))
                        object.partRevisionId = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.partRevisionId, options);
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        object.displayName = message.displayName;
                    if (message.camera != null && message.hasOwnProperty("camera"))
                        object.camera = $root.vertexvis.protobuf.core.Camera.toObject(message.camera, options);
                    return object;
                };

                /**
                 * Converts this ModelView to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.ModelView
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ModelView.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ModelView;
            })();

            core.ItemModelView = (function() {

                /**
                 * Properties of an ItemModelView.
                 * @memberof vertexvis.protobuf.core
                 * @interface IItemModelView
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [modelViewId] ItemModelView modelViewId
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [sceneItemId] ItemModelView sceneItemId
                 */

                /**
                 * Constructs a new ItemModelView.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an ItemModelView.
                 * @implements IItemModelView
                 * @constructor
                 * @param {vertexvis.protobuf.core.IItemModelView=} [properties] Properties to set
                 */
                function ItemModelView(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ItemModelView modelViewId.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} modelViewId
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @instance
                 */
                ItemModelView.prototype.modelViewId = null;

                /**
                 * ItemModelView sceneItemId.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} sceneItemId
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @instance
                 */
                ItemModelView.prototype.sceneItemId = null;

                /**
                 * Creates a new ItemModelView instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IItemModelView=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.ItemModelView} ItemModelView instance
                 */
                ItemModelView.create = function create(properties) {
                    return new ItemModelView(properties);
                };

                /**
                 * Encodes the specified ItemModelView message. Does not implicitly {@link vertexvis.protobuf.core.ItemModelView.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IItemModelView} message ItemModelView message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemModelView.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.modelViewId != null && Object.hasOwnProperty.call(message, "modelViewId"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.modelViewId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.sceneItemId != null && Object.hasOwnProperty.call(message, "sceneItemId"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.sceneItemId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ItemModelView message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.ItemModelView.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {vertexvis.protobuf.core.IItemModelView} message ItemModelView message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ItemModelView.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ItemModelView message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.ItemModelView} ItemModelView
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemModelView.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.ItemModelView();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.sceneItemId = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ItemModelView message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.ItemModelView} ItemModelView
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ItemModelView.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ItemModelView message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ItemModelView.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.modelViewId != null && message.hasOwnProperty("modelViewId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.modelViewId);
                        if (error)
                            return "modelViewId." + error;
                    }
                    if (message.sceneItemId != null && message.hasOwnProperty("sceneItemId")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.sceneItemId);
                        if (error)
                            return "sceneItemId." + error;
                    }
                    return null;
                };

                /**
                 * Creates an ItemModelView message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.ItemModelView} ItemModelView
                 */
                ItemModelView.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.ItemModelView)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.ItemModelView();
                    if (object.modelViewId != null) {
                        if (typeof object.modelViewId !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ItemModelView.modelViewId: object expected");
                        message.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.modelViewId);
                    }
                    if (object.sceneItemId != null) {
                        if (typeof object.sceneItemId !== "object")
                            throw TypeError(".vertexvis.protobuf.core.ItemModelView.sceneItemId: object expected");
                        message.sceneItemId = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.sceneItemId);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ItemModelView message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @static
                 * @param {vertexvis.protobuf.core.ItemModelView} message ItemModelView
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ItemModelView.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.modelViewId = null;
                        object.sceneItemId = null;
                    }
                    if (message.modelViewId != null && message.hasOwnProperty("modelViewId"))
                        object.modelViewId = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.modelViewId, options);
                    if (message.sceneItemId != null && message.hasOwnProperty("sceneItemId"))
                        object.sceneItemId = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.sceneItemId, options);
                    return object;
                };

                /**
                 * Converts this ItemModelView to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.ItemModelView
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ItemModelView.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ItemModelView;
            })();

            core.PmiAnnotation = (function() {

                /**
                 * Properties of a PmiAnnotation.
                 * @memberof vertexvis.protobuf.core
                 * @interface IPmiAnnotation
                 * @property {vertexvis.protobuf.core.IUuid2l|null} [id] PmiAnnotation id
                 * @property {string|null} [displayName] PmiAnnotation displayName
                 */

                /**
                 * Constructs a new PmiAnnotation.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a PmiAnnotation.
                 * @implements IPmiAnnotation
                 * @constructor
                 * @param {vertexvis.protobuf.core.IPmiAnnotation=} [properties] Properties to set
                 */
                function PmiAnnotation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PmiAnnotation id.
                 * @member {vertexvis.protobuf.core.IUuid2l|null|undefined} id
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @instance
                 */
                PmiAnnotation.prototype.id = null;

                /**
                 * PmiAnnotation displayName.
                 * @member {string} displayName
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @instance
                 */
                PmiAnnotation.prototype.displayName = "";

                /**
                 * Creates a new PmiAnnotation instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {vertexvis.protobuf.core.IPmiAnnotation=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.PmiAnnotation} PmiAnnotation instance
                 */
                PmiAnnotation.create = function create(properties) {
                    return new PmiAnnotation(properties);
                };

                /**
                 * Encodes the specified PmiAnnotation message. Does not implicitly {@link vertexvis.protobuf.core.PmiAnnotation.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {vertexvis.protobuf.core.IPmiAnnotation} message PmiAnnotation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        $root.vertexvis.protobuf.core.Uuid2l.encode(message.id, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                    return writer;
                };

                /**
                 * Encodes the specified PmiAnnotation message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.PmiAnnotation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {vertexvis.protobuf.core.IPmiAnnotation} message PmiAnnotation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PmiAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PmiAnnotation message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.PmiAnnotation} PmiAnnotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.PmiAnnotation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = $root.vertexvis.protobuf.core.Uuid2l.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.displayName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PmiAnnotation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.PmiAnnotation} PmiAnnotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PmiAnnotation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PmiAnnotation message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PmiAnnotation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id")) {
                        let error = $root.vertexvis.protobuf.core.Uuid2l.verify(message.id);
                        if (error)
                            return "id." + error;
                    }
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        if (!$util.isString(message.displayName))
                            return "displayName: string expected";
                    return null;
                };

                /**
                 * Creates a PmiAnnotation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.PmiAnnotation} PmiAnnotation
                 */
                PmiAnnotation.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.PmiAnnotation)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.PmiAnnotation();
                    if (object.id != null) {
                        if (typeof object.id !== "object")
                            throw TypeError(".vertexvis.protobuf.core.PmiAnnotation.id: object expected");
                        message.id = $root.vertexvis.protobuf.core.Uuid2l.fromObject(object.id);
                    }
                    if (object.displayName != null)
                        message.displayName = String(object.displayName);
                    return message;
                };

                /**
                 * Creates a plain object from a PmiAnnotation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @static
                 * @param {vertexvis.protobuf.core.PmiAnnotation} message PmiAnnotation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PmiAnnotation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = null;
                        object.displayName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = $root.vertexvis.protobuf.core.Uuid2l.toObject(message.id, options);
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        object.displayName = message.displayName;
                    return object;
                };

                /**
                 * Converts this PmiAnnotation to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.PmiAnnotation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PmiAnnotation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PmiAnnotation;
            })();

            core.PerspectiveCamera = (function() {

                /**
                 * Properties of a PerspectiveCamera.
                 * @memberof vertexvis.protobuf.core
                 * @interface IPerspectiveCamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [position] PerspectiveCamera position
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] PerspectiveCamera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] PerspectiveCamera up
                 * @property {google.protobuf.IFloatValue|null} [fovY] PerspectiveCamera fovY
                 */

                /**
                 * Constructs a new PerspectiveCamera.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a PerspectiveCamera.
                 * @implements IPerspectiveCamera
                 * @constructor
                 * @param {vertexvis.protobuf.core.IPerspectiveCamera=} [properties] Properties to set
                 */
                function PerspectiveCamera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PerspectiveCamera position.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} position
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.position = null;

                /**
                 * PerspectiveCamera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.lookAt = null;

                /**
                 * PerspectiveCamera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.up = null;

                /**
                 * PerspectiveCamera fovY.
                 * @member {google.protobuf.IFloatValue|null|undefined} fovY
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @instance
                 */
                PerspectiveCamera.prototype.fovY = null;

                /**
                 * Creates a new PerspectiveCamera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IPerspectiveCamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.PerspectiveCamera} PerspectiveCamera instance
                 */
                PerspectiveCamera.create = function create(properties) {
                    return new PerspectiveCamera(properties);
                };

                /**
                 * Encodes the specified PerspectiveCamera message. Does not implicitly {@link vertexvis.protobuf.core.PerspectiveCamera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IPerspectiveCamera} message PerspectiveCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerspectiveCamera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.position, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.fovY != null && Object.hasOwnProperty.call(message, "fovY"))
                        $root.google.protobuf.FloatValue.encode(message.fovY, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PerspectiveCamera message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.PerspectiveCamera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IPerspectiveCamera} message PerspectiveCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerspectiveCamera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PerspectiveCamera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.PerspectiveCamera} PerspectiveCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerspectiveCamera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.PerspectiveCamera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.position = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.fovY = $root.google.protobuf.FloatValue.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PerspectiveCamera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.PerspectiveCamera} PerspectiveCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerspectiveCamera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PerspectiveCamera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PerspectiveCamera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.position != null && message.hasOwnProperty("position")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.position);
                        if (error)
                            return "position." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.fovY != null && message.hasOwnProperty("fovY")) {
                        let error = $root.google.protobuf.FloatValue.verify(message.fovY);
                        if (error)
                            return "fovY." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PerspectiveCamera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.PerspectiveCamera} PerspectiveCamera
                 */
                PerspectiveCamera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.PerspectiveCamera)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.PerspectiveCamera();
                    if (object.position != null) {
                        if (typeof object.position !== "object")
                            throw TypeError(".vertexvis.protobuf.core.PerspectiveCamera.position: object expected");
                        message.position = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.position);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.core.PerspectiveCamera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.core.PerspectiveCamera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.fovY != null) {
                        if (typeof object.fovY !== "object")
                            throw TypeError(".vertexvis.protobuf.core.PerspectiveCamera.fovY: object expected");
                        message.fovY = $root.google.protobuf.FloatValue.fromObject(object.fovY);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PerspectiveCamera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @static
                 * @param {vertexvis.protobuf.core.PerspectiveCamera} message PerspectiveCamera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PerspectiveCamera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.position = null;
                        object.lookAt = null;
                        object.up = null;
                        object.fovY = null;
                    }
                    if (message.position != null && message.hasOwnProperty("position"))
                        object.position = $root.vertexvis.protobuf.core.Vector3f.toObject(message.position, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.fovY != null && message.hasOwnProperty("fovY"))
                        object.fovY = $root.google.protobuf.FloatValue.toObject(message.fovY, options);
                    return object;
                };

                /**
                 * Converts this PerspectiveCamera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.PerspectiveCamera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PerspectiveCamera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PerspectiveCamera;
            })();

            core.OrthographicCamera = (function() {

                /**
                 * Properties of an OrthographicCamera.
                 * @memberof vertexvis.protobuf.core
                 * @interface IOrthographicCamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [viewVector] OrthographicCamera viewVector
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] OrthographicCamera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] OrthographicCamera up
                 * @property {number|null} [fovHeight] OrthographicCamera fovHeight
                 */

                /**
                 * Constructs a new OrthographicCamera.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents an OrthographicCamera.
                 * @implements IOrthographicCamera
                 * @constructor
                 * @param {vertexvis.protobuf.core.IOrthographicCamera=} [properties] Properties to set
                 */
                function OrthographicCamera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OrthographicCamera viewVector.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} viewVector
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.viewVector = null;

                /**
                 * OrthographicCamera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.lookAt = null;

                /**
                 * OrthographicCamera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.up = null;

                /**
                 * OrthographicCamera fovHeight.
                 * @member {number} fovHeight
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @instance
                 */
                OrthographicCamera.prototype.fovHeight = 0;

                /**
                 * Creates a new OrthographicCamera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IOrthographicCamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.OrthographicCamera} OrthographicCamera instance
                 */
                OrthographicCamera.create = function create(properties) {
                    return new OrthographicCamera(properties);
                };

                /**
                 * Encodes the specified OrthographicCamera message. Does not implicitly {@link vertexvis.protobuf.core.OrthographicCamera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IOrthographicCamera} message OrthographicCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrthographicCamera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.viewVector != null && Object.hasOwnProperty.call(message, "viewVector"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.viewVector, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.fovHeight != null && Object.hasOwnProperty.call(message, "fovHeight"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.fovHeight);
                    return writer;
                };

                /**
                 * Encodes the specified OrthographicCamera message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.OrthographicCamera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.core.IOrthographicCamera} message OrthographicCamera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OrthographicCamera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OrthographicCamera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.OrthographicCamera} OrthographicCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrthographicCamera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.OrthographicCamera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.viewVector = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.fovHeight = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OrthographicCamera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.OrthographicCamera} OrthographicCamera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OrthographicCamera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OrthographicCamera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OrthographicCamera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.viewVector != null && message.hasOwnProperty("viewVector")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.viewVector);
                        if (error)
                            return "viewVector." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.fovHeight != null && message.hasOwnProperty("fovHeight"))
                        if (typeof message.fovHeight !== "number")
                            return "fovHeight: number expected";
                    return null;
                };

                /**
                 * Creates an OrthographicCamera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.OrthographicCamera} OrthographicCamera
                 */
                OrthographicCamera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.OrthographicCamera)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.OrthographicCamera();
                    if (object.viewVector != null) {
                        if (typeof object.viewVector !== "object")
                            throw TypeError(".vertexvis.protobuf.core.OrthographicCamera.viewVector: object expected");
                        message.viewVector = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.viewVector);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.core.OrthographicCamera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.core.OrthographicCamera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.fovHeight != null)
                        message.fovHeight = Number(object.fovHeight);
                    return message;
                };

                /**
                 * Creates a plain object from an OrthographicCamera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @static
                 * @param {vertexvis.protobuf.core.OrthographicCamera} message OrthographicCamera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OrthographicCamera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.viewVector = null;
                        object.lookAt = null;
                        object.up = null;
                        object.fovHeight = 0;
                    }
                    if (message.viewVector != null && message.hasOwnProperty("viewVector"))
                        object.viewVector = $root.vertexvis.protobuf.core.Vector3f.toObject(message.viewVector, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.fovHeight != null && message.hasOwnProperty("fovHeight"))
                        object.fovHeight = options.json && !isFinite(message.fovHeight) ? String(message.fovHeight) : message.fovHeight;
                    return object;
                };

                /**
                 * Converts this OrthographicCamera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.OrthographicCamera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OrthographicCamera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OrthographicCamera;
            })();

            core.Camera = (function() {

                /**
                 * Properties of a Camera.
                 * @memberof vertexvis.protobuf.core
                 * @interface ICamera
                 * @property {vertexvis.protobuf.core.IVector3f|null} [position] Camera position
                 * @property {vertexvis.protobuf.core.IVector3f|null} [lookAt] Camera lookAt
                 * @property {vertexvis.protobuf.core.IVector3f|null} [up] Camera up
                 * @property {vertexvis.protobuf.core.IPerspectiveCamera|null} [perspective] Camera perspective
                 * @property {vertexvis.protobuf.core.IOrthographicCamera|null} [orthographic] Camera orthographic
                 */

                /**
                 * Constructs a new Camera.
                 * @memberof vertexvis.protobuf.core
                 * @classdesc Represents a Camera.
                 * @implements ICamera
                 * @constructor
                 * @param {vertexvis.protobuf.core.ICamera=} [properties] Properties to set
                 */
                function Camera(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Camera position.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} position
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Camera.prototype.position = null;

                /**
                 * Camera lookAt.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} lookAt
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Camera.prototype.lookAt = null;

                /**
                 * Camera up.
                 * @member {vertexvis.protobuf.core.IVector3f|null|undefined} up
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Camera.prototype.up = null;

                /**
                 * Camera perspective.
                 * @member {vertexvis.protobuf.core.IPerspectiveCamera|null|undefined} perspective
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Camera.prototype.perspective = null;

                /**
                 * Camera orthographic.
                 * @member {vertexvis.protobuf.core.IOrthographicCamera|null|undefined} orthographic
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Camera.prototype.orthographic = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * Camera type.
                 * @member {"perspective"|"orthographic"|undefined} type
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 */
                Object.defineProperty(Camera.prototype, "type", {
                    get: $util.oneOfGetter($oneOfFields = ["perspective", "orthographic"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Camera instance using the specified properties.
                 * @function create
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {vertexvis.protobuf.core.ICamera=} [properties] Properties to set
                 * @returns {vertexvis.protobuf.core.Camera} Camera instance
                 */
                Camera.create = function create(properties) {
                    return new Camera(properties);
                };

                /**
                 * Encodes the specified Camera message. Does not implicitly {@link vertexvis.protobuf.core.Camera.verify|verify} messages.
                 * @function encode
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {vertexvis.protobuf.core.ICamera} message Camera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Camera.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.position, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.lookAt != null && Object.hasOwnProperty.call(message, "lookAt"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.lookAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.up != null && Object.hasOwnProperty.call(message, "up"))
                        $root.vertexvis.protobuf.core.Vector3f.encode(message.up, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.perspective != null && Object.hasOwnProperty.call(message, "perspective"))
                        $root.vertexvis.protobuf.core.PerspectiveCamera.encode(message.perspective, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.orthographic != null && Object.hasOwnProperty.call(message, "orthographic"))
                        $root.vertexvis.protobuf.core.OrthographicCamera.encode(message.orthographic, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Camera message, length delimited. Does not implicitly {@link vertexvis.protobuf.core.Camera.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {vertexvis.protobuf.core.ICamera} message Camera message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Camera.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Camera message from the specified reader or buffer.
                 * @function decode
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {vertexvis.protobuf.core.Camera} Camera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Camera.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.vertexvis.protobuf.core.Camera();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.position = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.lookAt = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.up = $root.vertexvis.protobuf.core.Vector3f.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.perspective = $root.vertexvis.protobuf.core.PerspectiveCamera.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.orthographic = $root.vertexvis.protobuf.core.OrthographicCamera.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Camera message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {vertexvis.protobuf.core.Camera} Camera
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Camera.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Camera message.
                 * @function verify
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Camera.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.position != null && message.hasOwnProperty("position")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.position);
                        if (error)
                            return "position." + error;
                    }
                    if (message.lookAt != null && message.hasOwnProperty("lookAt")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.lookAt);
                        if (error)
                            return "lookAt." + error;
                    }
                    if (message.up != null && message.hasOwnProperty("up")) {
                        let error = $root.vertexvis.protobuf.core.Vector3f.verify(message.up);
                        if (error)
                            return "up." + error;
                    }
                    if (message.perspective != null && message.hasOwnProperty("perspective")) {
                        properties.type = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.PerspectiveCamera.verify(message.perspective);
                            if (error)
                                return "perspective." + error;
                        }
                    }
                    if (message.orthographic != null && message.hasOwnProperty("orthographic")) {
                        if (properties.type === 1)
                            return "type: multiple values";
                        properties.type = 1;
                        {
                            let error = $root.vertexvis.protobuf.core.OrthographicCamera.verify(message.orthographic);
                            if (error)
                                return "orthographic." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Camera message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {vertexvis.protobuf.core.Camera} Camera
                 */
                Camera.fromObject = function fromObject(object) {
                    if (object instanceof $root.vertexvis.protobuf.core.Camera)
                        return object;
                    let message = new $root.vertexvis.protobuf.core.Camera();
                    if (object.position != null) {
                        if (typeof object.position !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Camera.position: object expected");
                        message.position = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.position);
                    }
                    if (object.lookAt != null) {
                        if (typeof object.lookAt !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Camera.lookAt: object expected");
                        message.lookAt = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.lookAt);
                    }
                    if (object.up != null) {
                        if (typeof object.up !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Camera.up: object expected");
                        message.up = $root.vertexvis.protobuf.core.Vector3f.fromObject(object.up);
                    }
                    if (object.perspective != null) {
                        if (typeof object.perspective !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Camera.perspective: object expected");
                        message.perspective = $root.vertexvis.protobuf.core.PerspectiveCamera.fromObject(object.perspective);
                    }
                    if (object.orthographic != null) {
                        if (typeof object.orthographic !== "object")
                            throw TypeError(".vertexvis.protobuf.core.Camera.orthographic: object expected");
                        message.orthographic = $root.vertexvis.protobuf.core.OrthographicCamera.fromObject(object.orthographic);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Camera message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof vertexvis.protobuf.core.Camera
                 * @static
                 * @param {vertexvis.protobuf.core.Camera} message Camera
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Camera.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.position = null;
                        object.lookAt = null;
                        object.up = null;
                    }
                    if (message.position != null && message.hasOwnProperty("position"))
                        object.position = $root.vertexvis.protobuf.core.Vector3f.toObject(message.position, options);
                    if (message.lookAt != null && message.hasOwnProperty("lookAt"))
                        object.lookAt = $root.vertexvis.protobuf.core.Vector3f.toObject(message.lookAt, options);
                    if (message.up != null && message.hasOwnProperty("up"))
                        object.up = $root.vertexvis.protobuf.core.Vector3f.toObject(message.up, options);
                    if (message.perspective != null && message.hasOwnProperty("perspective")) {
                        object.perspective = $root.vertexvis.protobuf.core.PerspectiveCamera.toObject(message.perspective, options);
                        if (options.oneofs)
                            object.type = "perspective";
                    }
                    if (message.orthographic != null && message.hasOwnProperty("orthographic")) {
                        object.orthographic = $root.vertexvis.protobuf.core.OrthographicCamera.toObject(message.orthographic, options);
                        if (options.oneofs)
                            object.type = "orthographic";
                    }
                    return object;
                };

                /**
                 * Converts this Camera to JSON.
                 * @function toJSON
                 * @memberof vertexvis.protobuf.core.Camera
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Camera.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Camera;
            })();

            /**
             * SceneElementTypeMask enum.
             * @name vertexvis.protobuf.core.SceneElementTypeMask
             * @enum {number}
             * @property {number} SCENE_ELEMENT_TYPE_MASK_INVALID=0 SCENE_ELEMENT_TYPE_MASK_INVALID value
             * @property {number} SCENE_ELEMENT_TYPE_MASK_SCENE_ITEMS=1 SCENE_ELEMENT_TYPE_MASK_SCENE_ITEMS value
             * @property {number} SCENE_ELEMENT_TYPE_MASK_ANNOTATION_PRIMITIVES=2 SCENE_ELEMENT_TYPE_MASK_ANNOTATION_PRIMITIVES value
             */
            core.SceneElementTypeMask = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SCENE_ELEMENT_TYPE_MASK_INVALID"] = 0;
                values[valuesById[1] = "SCENE_ELEMENT_TYPE_MASK_SCENE_ITEMS"] = 1;
                values[valuesById[2] = "SCENE_ELEMENT_TYPE_MASK_ANNOTATION_PRIMITIVES"] = 2;
                return values;
            })();

            return core;
        })();

        return protobuf;
    })();

    return vertexvis;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Any = (function() {

            /**
             * Properties of an Any.
             * @memberof google.protobuf
             * @interface IAny
             * @property {string|null} [type_url] Any type_url
             * @property {Uint8Array|null} [value] Any value
             */

            /**
             * Constructs a new Any.
             * @memberof google.protobuf
             * @classdesc Represents an Any.
             * @implements IAny
             * @constructor
             * @param {google.protobuf.IAny=} [properties] Properties to set
             */
            function Any(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Any type_url.
             * @member {string} type_url
             * @memberof google.protobuf.Any
             * @instance
             */
            Any.prototype.type_url = "";

            /**
             * Any value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.Any
             * @instance
             */
            Any.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new Any instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny=} [properties] Properties to set
             * @returns {google.protobuf.Any} Any instance
             */
            Any.create = function create(properties) {
                return new Any(properties);
            };

            /**
             * Encodes the specified Any message. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny} message Any message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Any.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type_url != null && Object.hasOwnProperty.call(message, "type_url"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type_url);
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
                return writer;
            };

            /**
             * Encodes the specified Any message, length delimited. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.IAny} message Any message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Any.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Any message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Any.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Any();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type_url = reader.string();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Any message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Any.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Any message.
             * @function verify
             * @memberof google.protobuf.Any
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Any.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type_url != null && message.hasOwnProperty("type_url"))
                    if (!$util.isString(message.type_url))
                        return "type_url: string expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                return null;
            };

            /**
             * Creates an Any message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Any
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Any} Any
             */
            Any.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Any)
                    return object;
                let message = new $root.google.protobuf.Any();
                if (object.type_url != null)
                    message.type_url = String(object.type_url);
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length)
                        message.value = object.value;
                return message;
            };

            /**
             * Creates a plain object from an Any message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Any
             * @static
             * @param {google.protobuf.Any} message Any
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Any.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.type_url = "";
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                }
                if (message.type_url != null && message.hasOwnProperty("type_url"))
                    object.type_url = message.type_url;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                return object;
            };

            /**
             * Converts this Any to JSON.
             * @function toJSON
             * @memberof google.protobuf.Any
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Any.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Any;
        })();

        protobuf.Duration = (function() {

            /**
             * Properties of a Duration.
             * @memberof google.protobuf
             * @interface IDuration
             * @property {number|Long|null} [seconds] Duration seconds
             * @property {number|null} [nanos] Duration nanos
             */

            /**
             * Constructs a new Duration.
             * @memberof google.protobuf
             * @classdesc Represents a Duration.
             * @implements IDuration
             * @constructor
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             */
            function Duration(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Duration seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Duration nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Duration
             * @instance
             */
            Duration.prototype.nanos = 0;

            /**
             * Creates a new Duration instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration=} [properties] Properties to set
             * @returns {google.protobuf.Duration} Duration instance
             */
            Duration.create = function create(properties) {
                return new Duration(properties);
            };

            /**
             * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.IDuration} message Duration message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Duration.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Duration message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Duration message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Duration
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Duration} Duration
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Duration.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Duration message.
             * @function verify
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Duration.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Duration message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Duration} Duration
             */
            Duration.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Duration)
                    return object;
                let message = new $root.google.protobuf.Duration();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Duration message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Duration
             * @static
             * @param {google.protobuf.Duration} message Duration
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Duration.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Duration to JSON.
             * @function toJSON
             * @memberof google.protobuf.Duration
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Duration.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Duration;
        })();

        protobuf.DoubleValue = (function() {

            /**
             * Properties of a DoubleValue.
             * @memberof google.protobuf
             * @interface IDoubleValue
             * @property {number|null} [value] DoubleValue value
             */

            /**
             * Constructs a new DoubleValue.
             * @memberof google.protobuf
             * @classdesc Represents a DoubleValue.
             * @implements IDoubleValue
             * @constructor
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             */
            function DoubleValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DoubleValue value.
             * @member {number} value
             * @memberof google.protobuf.DoubleValue
             * @instance
             */
            DoubleValue.prototype.value = 0;

            /**
             * Creates a new DoubleValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             * @returns {google.protobuf.DoubleValue} DoubleValue instance
             */
            DoubleValue.create = function create(properties) {
                return new DoubleValue(properties);
            };

            /**
             * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.value);
                return writer;
            };

            /**
             * Encodes the specified DoubleValue message, length delimited. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DoubleValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DoubleValue message.
             * @function verify
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DoubleValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.DoubleValue} DoubleValue
             */
            DoubleValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DoubleValue)
                    return object;
                let message = new $root.google.protobuf.DoubleValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.DoubleValue} message DoubleValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DoubleValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this DoubleValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.DoubleValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DoubleValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DoubleValue;
        })();

        protobuf.FloatValue = (function() {

            /**
             * Properties of a FloatValue.
             * @memberof google.protobuf
             * @interface IFloatValue
             * @property {number|null} [value] FloatValue value
             */

            /**
             * Constructs a new FloatValue.
             * @memberof google.protobuf
             * @classdesc Represents a FloatValue.
             * @implements IFloatValue
             * @constructor
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             */
            function FloatValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FloatValue value.
             * @member {number} value
             * @memberof google.protobuf.FloatValue
             * @instance
             */
            FloatValue.prototype.value = 0;

            /**
             * Creates a new FloatValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             * @returns {google.protobuf.FloatValue} FloatValue instance
             */
            FloatValue.create = function create(properties) {
                return new FloatValue(properties);
            };

            /**
             * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
                return writer;
            };

            /**
             * Encodes the specified FloatValue message, length delimited. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FloatValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FloatValue message.
             * @function verify
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FloatValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FloatValue} FloatValue
             */
            FloatValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FloatValue)
                    return object;
                let message = new $root.google.protobuf.FloatValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.FloatValue} message FloatValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FloatValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this FloatValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.FloatValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FloatValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FloatValue;
        })();

        protobuf.Int64Value = (function() {

            /**
             * Properties of an Int64Value.
             * @memberof google.protobuf
             * @interface IInt64Value
             * @property {number|Long|null} [value] Int64Value value
             */

            /**
             * Constructs a new Int64Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int64Value.
             * @implements IInt64Value
             * @constructor
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             */
            function Int64Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.Int64Value
             * @instance
             */
            Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Int64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.Int64Value} Int64Value instance
             */
            Int64Value.create = function create(properties) {
                return new Int64Value(properties);
            };

            /**
             * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int64Value message, length delimited. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int64Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int64Value message.
             * @function verify
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int64Value} Int64Value
             */
            Int64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int64Value)
                    return object;
                let message = new $root.google.protobuf.Int64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = false;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.Int64Value} message Int64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber() : message.value;
                return object;
            };

            /**
             * Converts this Int64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int64Value;
        })();

        protobuf.UInt64Value = (function() {

            /**
             * Properties of a UInt64Value.
             * @memberof google.protobuf
             * @interface IUInt64Value
             * @property {number|Long|null} [value] UInt64Value value
             */

            /**
             * Constructs a new UInt64Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt64Value.
             * @implements IUInt64Value
             * @constructor
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             */
            function UInt64Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.UInt64Value
             * @instance
             */
            UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new UInt64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt64Value} UInt64Value instance
             */
            UInt64Value.create = function create(properties) {
                return new UInt64Value(properties);
            };

            /**
             * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt64Value message, length delimited. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt64Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt64Value message.
             * @function verify
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt64Value} UInt64Value
             */
            UInt64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt64Value)
                    return object;
                let message = new $root.google.protobuf.UInt64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.UInt64Value} message UInt64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
                return object;
            };

            /**
             * Converts this UInt64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt64Value;
        })();

        protobuf.Int32Value = (function() {

            /**
             * Properties of an Int32Value.
             * @memberof google.protobuf
             * @interface IInt32Value
             * @property {number|null} [value] Int32Value value
             */

            /**
             * Constructs a new Int32Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int32Value.
             * @implements IInt32Value
             * @constructor
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             */
            function Int32Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int32Value value.
             * @member {number} value
             * @memberof google.protobuf.Int32Value
             * @instance
             */
            Int32Value.prototype.value = 0;

            /**
             * Creates a new Int32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.Int32Value} Int32Value instance
             */
            Int32Value.create = function create(properties) {
                return new Int32Value(properties);
            };

            /**
             * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int32Value message, length delimited. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int32Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int32Value message.
             * @function verify
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int32Value} Int32Value
             */
            Int32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int32Value)
                    return object;
                let message = new $root.google.protobuf.Int32Value();
                if (object.value != null)
                    message.value = object.value | 0;
                return message;
            };

            /**
             * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.Int32Value} message Int32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this Int32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int32Value;
        })();

        protobuf.UInt32Value = (function() {

            /**
             * Properties of a UInt32Value.
             * @memberof google.protobuf
             * @interface IUInt32Value
             * @property {number|null} [value] UInt32Value value
             */

            /**
             * Constructs a new UInt32Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt32Value.
             * @implements IUInt32Value
             * @constructor
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             */
            function UInt32Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt32Value value.
             * @member {number} value
             * @memberof google.protobuf.UInt32Value
             * @instance
             */
            UInt32Value.prototype.value = 0;

            /**
             * Creates a new UInt32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt32Value} UInt32Value instance
             */
            UInt32Value.create = function create(properties) {
                return new UInt32Value(properties);
            };

            /**
             * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt32Value message, length delimited. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt32Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt32Value message.
             * @function verify
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt32Value} UInt32Value
             */
            UInt32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt32Value)
                    return object;
                let message = new $root.google.protobuf.UInt32Value();
                if (object.value != null)
                    message.value = object.value >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.UInt32Value} message UInt32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this UInt32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt32Value;
        })();

        protobuf.BoolValue = (function() {

            /**
             * Properties of a BoolValue.
             * @memberof google.protobuf
             * @interface IBoolValue
             * @property {boolean|null} [value] BoolValue value
             */

            /**
             * Constructs a new BoolValue.
             * @memberof google.protobuf
             * @classdesc Represents a BoolValue.
             * @implements IBoolValue
             * @constructor
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             */
            function BoolValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BoolValue value.
             * @member {boolean} value
             * @memberof google.protobuf.BoolValue
             * @instance
             */
            BoolValue.prototype.value = false;

            /**
             * Creates a new BoolValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             * @returns {google.protobuf.BoolValue} BoolValue instance
             */
            BoolValue.create = function create(properties) {
                return new BoolValue(properties);
            };

            /**
             * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                return writer;
            };

            /**
             * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BoolValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BoolValue message.
             * @function verify
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BoolValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "boolean")
                        return "value: boolean expected";
                return null;
            };

            /**
             * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BoolValue} BoolValue
             */
            BoolValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BoolValue)
                    return object;
                let message = new $root.google.protobuf.BoolValue();
                if (object.value != null)
                    message.value = Boolean(object.value);
                return message;
            };

            /**
             * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.BoolValue} message BoolValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BoolValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = false;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this BoolValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BoolValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BoolValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BoolValue;
        })();

        protobuf.StringValue = (function() {

            /**
             * Properties of a StringValue.
             * @memberof google.protobuf
             * @interface IStringValue
             * @property {string|null} [value] StringValue value
             */

            /**
             * Constructs a new StringValue.
             * @memberof google.protobuf
             * @classdesc Represents a StringValue.
             * @implements IStringValue
             * @constructor
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             */
            function StringValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StringValue value.
             * @member {string} value
             * @memberof google.protobuf.StringValue
             * @instance
             */
            StringValue.prototype.value = "";

            /**
             * Creates a new StringValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             * @returns {google.protobuf.StringValue} StringValue instance
             */
            StringValue.create = function create(properties) {
                return new StringValue(properties);
            };

            /**
             * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                return writer;
            };

            /**
             * Encodes the specified StringValue message, length delimited. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.StringValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StringValue message.
             * @function verify
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StringValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                return null;
            };

            /**
             * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.StringValue} StringValue
             */
            StringValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.StringValue)
                    return object;
                let message = new $root.google.protobuf.StringValue();
                if (object.value != null)
                    message.value = String(object.value);
                return message;
            };

            /**
             * Creates a plain object from a StringValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.StringValue} message StringValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StringValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.value = "";
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this StringValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.StringValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StringValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StringValue;
        })();

        protobuf.BytesValue = (function() {

            /**
             * Properties of a BytesValue.
             * @memberof google.protobuf
             * @interface IBytesValue
             * @property {Uint8Array|null} [value] BytesValue value
             */

            /**
             * Constructs a new BytesValue.
             * @memberof google.protobuf
             * @classdesc Represents a BytesValue.
             * @implements IBytesValue
             * @constructor
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             */
            function BytesValue(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BytesValue value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.BytesValue
             * @instance
             */
            BytesValue.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new BytesValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             * @returns {google.protobuf.BytesValue} BytesValue instance
             */
            BytesValue.create = function create(properties) {
                return new BytesValue(properties);
            };

            /**
             * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                return writer;
            };

            /**
             * Encodes the specified BytesValue message, length delimited. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BytesValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BytesValue message.
             * @function verify
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BytesValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                return null;
            };

            /**
             * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BytesValue} BytesValue
             */
            BytesValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BytesValue)
                    return object;
                let message = new $root.google.protobuf.BytesValue();
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length)
                        message.value = object.value;
                return message;
            };

            /**
             * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.BytesValue} message BytesValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BytesValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                return object;
            };

            /**
             * Converts this BytesValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BytesValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BytesValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BytesValue;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

export { $root as default };
